import React, { memo } from 'react';

import { InfoBlock, Icon, Button } from '@picsio/ui';
import pluralize from 'pluralize';
import {
  Question, Warning, CheckMark, Info, Web, ShareList,
} from '@picsio/icons';

import Tag from '../components/Tag';
import { navigate } from '../helpers/history';
import picsioConfig from '../../../../config';

const appName = picsioConfig.isPim ? 'Toriut.com' : 'Pics.io';
const supportEmail = picsioConfig.isPim ? 'support@toriut.com' : 'support@pics.io';

const getStorageTitle = (storageName) => {
  if (storageName === 'gd') {
    return 'Google Drive';
  }

  if (storageName === 's3') {
    return 'Amazon S3';
  }

  return `${appName} Storage`;
};

const getTextErrorGDOne = (onClick, titleStorage) => (
  <>
    <p>
      You have a limited access to this file in Google Drive, which means you can't rename it in {appName} either.
    </p>
    <p>
      Tired of these limitations from {titleStorage === 'Picsio' ? `${appName} Storage` : ' Google Drive?'} Switch to
      <span aria-label="link to storage" className="dialogLink" role="presentation" onClick={onClick}> {appName} storage</span>.
    </p>
  </>
);

const getTextErrorGDBulk = (onClick) => (
  <>
    <p>
      Tired of these limitations from Google Drive? Switch to
      <span aria-label="link to storage" className="dialogLink" role="presentation" onClick={onClick}> {appName} storage</span>.
    </p>
  </>
);

export default {
  ARCHIVE_TREE: {
    PLACEHOLDER: {
      TITLE: 'Archive',
      DESCRIPTION: 'This will display the collection tree of archived assets',
    },
  },
  RETRY: 'Retry',
  OPEN_COLLECTIONS_DIALOG: 'Open collections dialog',
  CHOOSE_COLLECTION: 'Choose collection',
  COLLECTION_SELECTION_EXCEEDED: 'Max 10 collections can be selected',
  APP_START: {
    ERROR_WORKINGFOLDER_ADMIN: `${appName} cannot access the working folder within the cloud storage associated with your account. Please make sure it is still accessible and hasn’t been deleted. You’re welcome to contact ${supportEmail} if you need any help from our side.`,
    ERROR_WORKINGFOLDER_TEAMMATE: `${appName} cannot access your account storage. Please contact your {txtAdminsList} about the issue. You’re also welcome to contact ${supportEmail} if you need any help from our side.`,
    ERROR_CONNECTING_GDRIVE: `${appName} cannot access your cloud storage. Please make sure it’s accessible (e.g. check your billing status) and refresh the page. If the error persists, contact us at ${supportEmail}.`,
    ERROR_LOADING_USERDATA: `Sorry, ${appName} couldn’t load some data from your user profile. Please try to refresh the page. If the problem persists, contact us at ${supportEmail}`,
    DEFAULT_ERROR: `Cannot start ${appName} application. Try refreshing the browser tab. If the problem persists, contact us at <a href="mailto:${supportEmail}" target="_blank">${supportEmail}</a>.`,
  },
  STORAGE_FOLDER_NOT_FOUND: `${appName} folder not found`,
  STORAGE_FILES_NOT_FOUND: `${appName} folder is empty`,
  STORAGE_CANT_TRASH_FILE: "Can't trash file",
  DISCLAIMER_PATTERN: `<b>Hold up there, %name%.</b><br/><br/>You’re getting access to the really early version of ${appName}.<br/><br/><b>It's an alpha.</b><br/><br/>I bet you've got it - it doesn't work more often than it works. Sometimes it delivers weird results only Andy Warhol would be satisfied.<br/><br/>We are big fans of rapid delivery so you will see small changes almost every day. Please let me know if you see that something goes wrong using our Helpdesk, Twitter or email.<br/><br/>Love,<br/>Vlad from TopTechPhoto`,
  STORAGE_GDRIVE_NOT_CONNECTED: `Looks like your <b>${appName}</b> account is not connected to your<b>cloud storage</b> or you are not logged in!`,
  LOGOUT_QUESTION:
    '<center>You are going to <b>logout</b>.<br/><br/> Continue?</center>',
  GOBACK_FROM_DEVELOP_QUESTION:
    '<center>If you return to catalog your adjustments <b>will be lost</b>.<br/><br/>Return to catalog?</center>',
  DELETE_IMAGE_QUESTION:
    '<center>Are you sure you want to <b>delete</b> asset from your cloud storage?<br/><br/>If you are using cloud storage item will be placed to trash.</center>',
  RESETPASSWORD_QUESTION:
    '<center>You are going to <b>reset your password</b>.<br/>We will send you an <b>email</b> with instructions.<br/><br/> Continue?</center>',
  RESETPASSWORD_SUCCESS_MESSAGE:
    "<center>Reset password instructions sent to <b>%email%</b>. Don't forget to log in after changing password. =)</center>",
  NOT_IMPLEMENTED_YET:
    "<center><b>Coming soon...</b><br/><br/>Feature is not ready yet, and we are working hard on it.<br/><br/>If you have any suggestions or ideas, just <a href='javascript:app.openSupport()'>let us now</a>.</center>",
  FORMAT_NOT_SUPPORTED_YET:
    "<center><b>Coming soon...</b><br/><br/>Editing of this raw format is not available yet, and we are working hard on it.<br/><br/>If you have any suggestions or ideas, just <a href='javascript:app.openSupport()'>let us now</a>.</center>",
  IMPORT_FORMAT_NOT_SUPPORTED_YET: {
    title: 'Unsupported format',
    text: `It seems that you've dropped a file that ${appName} doesn't support yet.<br /><br />You can find supported formats list <a href="https://blog.pics.io/the-most-complete-list-of-pics-io-features-d9073d0c5034#.vgnlz9clz" target="_blank">here</a>.`,
    OK_TEXT: 'Ok',
  },
  NO_PHOTO_IN_COLLECTION:
    "<div>This collection is empty... for now.</div><span>To add files, use Upload button, or select and drag'n'drop assets from other collections.</span>",
  NO_PHOTO_IN_COLLECTION_RECURSIVE:
    '<div>This collection is empty.</div><span>Try to switch the yellow toggle above to see if there are any assets in nested collections.</span>',
  NO_PHOTO_IN_COLLECTION_WITHOUT_UPLOAD:
    '<div>There are no files in this collection</div>',
  NO_PHOTO_IN_PROOFING_TEMPLATE:
    "<div>There are no files on this site.</div><span>Please use <a href='https://pics.io/' target='_blank'>pics.io</a> to add files.</span>",
  NO_PHOTO_IN_PROOFING_COLLECTION:
    '<div>There are no files in this collection.</div>',
  NO_PHOTO_IN_FILTER:
    '<div>No files match the filter</div><span>Try to change filtering options or reset filters</span>',

  SELECTED_ASSETS_EMPTY: {
    TITLE: () => (
      <>
        There are no files in collection <span className="act">Selection</span>.
        <br />
      </>
    ),
    TEXT: 'Please select any asset from you library.',
  },
  NO_PHOTO_IN_SEARCH: '<div>Your search did not match any files.',
  NO_PHOTO_IN_SMART_COLLECTION:
    '<div>There are no files in this collection</div>',
  NO_PHOTO_IN_LIGHTBOARD:
    "<div>Your personal lightboard is empty... for now.</div><span>To add files, use Upload, or select and drag'n'drop assets from other collections.</span>",

  NO_PERMISSION_TO_ACCESS:
    'Team administrator disabled access to this feature for your user account. Contact them to get this permission',
  NO_COLLECTION_PERMISSION_TO_ACCESS: (processingName) => `Some assets in your selection have restricted permissions to ${processingName}. They will be skipped. Please contact your team administrator for access.`,
  CSV_IMPORT: {
    importingError: 'Importing error',
    close: 'Close',
    importNewCsv: 'Import new csv',
    importNewCsvError: 'Import CSV access error',
    downloadReport: 'Download CSV report',
    takingTooLong:
      'This file is taking longer to process, once it’s done, we will send you a report about this import operation to email',
    done: 'Refresh and close',
    importTitle: 'Import your CSV file',
    learnMore: 'Learn more',
    dragnDrop: 'Drag and drop your CSV file here',
    or: 'or',
    browse: 'Browse',
    import: 'Import',
    validationDialogTitle: 'Incorrect type or size',
    validationDialogText:
      'File must be of CSV format, larger than 0MB and smaller than 20MB',
    textUploadCsv: 'Upload csv',
    canUploadOnlyOneFileDialogText: 'You can upload only one csv file',
    canUploadOnlyOneFileDialogTitle: 'Upload error',
    hasNoAccessDialogTitle:
      'You have no access to upload a CSV. Contact your team manager',
    refreshText:
      'Close this page and refresh the browser tab to see the imported metadata on assets',
    helpText: 'How to import metadata',

    importText: () => (
      <>
        <p>
          Importing a CSV allows you to add new metadata to assets in {appName}.
          If a picsioId field in your CSV matches an existing asset in {appName}
          , it will be updated with the mapped values. Once the import is
          finished, you will get a CSV file where each row that failed to import
          contains an error reason.
        </p>
        <b>IMPORTANT:</b> CSV file must contain a picsioId column with IDs of
        assets you want to add new metadata to
      </>
    ),
  },

  IMPORT_PRODUCTS: {
    importAccessErrorTitle: 'Import products access error',
    hasNoAccessDialogTitle:
      'You have no access to import products. Contact your team manager',
    toolbarTitle: 'Import CSV',
    leaveImportDialog: {
      title: 'Leave import process?',
      text:
        'Are you sure you want to exit? Your product data hasn\'t been imported yet, '
        + 'and leaving will discard your current progress. '
        + 'No changes will be made to your catalog.',
      textBtnCancel: 'Continue import',
      textBtnOk: 'Leave and discard',
    },
    fileHeadersInvalidDialog: {
      title: 'File can’t be imported yet',
      description:
        'Some column headers need to be fixed before this file can be imported.',
      issuesFoundLabel: 'Issues found:',
      duplicateTitle: 'Duplicate column names',
      duplicateText:
        'Some columns have the same name. Rename them so each column has a unique name.',
      unnamedTitle: 'Unnamed columns',
      unnamedText: 'Some columns don’t have a name. Add a name to every column.',
      textBtnClose: 'Close',
    },
    fileIssuesDialog: {
      title: 'File can’t be imported yet',
      description: 'Some issues need to be fixed before this file can be imported.',
      issuesFoundLabel: 'Issues found:',
      fileExceedsSizeTitle: 'File exceeds size limit',
      fileExceedsSizeText: (actualSizeLabel, maxSizeLabel) => (
        <>
          This file is <span className="highlight">{actualSizeLabel}</span>, but the maximum
          supported size is <span className="highlight">{maxSizeLabel}</span>. Choose a smaller
          file or split it into multiple files.
        </>
      ),
      fileExceedsRowsTitle: 'File exceeds row limit',
      fileExceedsRowsText: (maxRowsLabel) => (
        <>
          This file contains more than{' '}
          <span className="highlight">{maxRowsLabel}</span>
          {' '}data rows, excluding the header. Split it into smaller files to continue.
        </>
      ),
      preparedExceedsSizeTitle: 'Import data exceeds size limit',
      preparedExceedsSizeText: (actualSizeLabel, maxSizeLabel) => (
        <>
          After processing, this import contains <span className="highlight">{actualSizeLabel}</span>
          {' '}of prepared data, exceeding the <span className="highlight">{maxSizeLabel}</span> limit.
          {' '}Reduce the amount of data in the file or split it into smaller
          files before trying again.
        </>
      ),
      splitHint:
        'If you split the file, keep each parent product and its variants together.',
      contactSupportFilePrefix: 'Need help splitting your file? ',
      contactSupportPreparedPrefix: 'Need help? ',
      contactSupportLink: 'Contact support.',
      duplicateTitle: 'Duplicate column names',
      duplicateText:
        'Some columns have the same name. Rename them so each column has a unique name.',
      unnamedTitle: 'Unnamed columns',
      unnamedText: 'Some columns don’t have a name. Add a name to every column.',
      textBtnClose: 'Close',
      textBtnChooseAnotherFile: 'Choose another file',
    },
    largeFileSupportMessage:
      'Hi, I’m having trouble importing a large product file into Toriut. '
      + 'Could you help me split or prepare it for import?',
    concurrentImportBanner:
      'Another product import is currently running for your team. '
      + 'You can start this import once the previous one is finished.',
    concurrentImportToast:
      'Another product import is already running. '
      + 'You can start this import once it finishes.',
    intercomDefaultMessage: 'Hi Toriut support team, I\'m encountering the "Import validation required" message. Please assist further.',
    columnSeparator: 'Column separator',
    textDelimiter: 'Text delimiter',
    charset: 'Charset',
    scanningFile: 'Scanning file...',
    browseFile: 'Click to browse your file',
    validationInfo:
      'Import paused - some columns in your file don\'t align with your Toriut product schema. Contact Support to map the fields and resume the upload.',
    chatWithSupport: 'Chat with support',
    downloadSampleCsv: 'Download sample',
    copyPrompt: 'Copy prompt',
    copiedPrompt: 'Copied!',
    sampleCsvTooltip: 'You can try the import operation using our product schema sample file',
    sampleCsvHelpText: 'Ensure a smooth import by using a sample template or an AI prompt to format your file.',
    btnPrevious: 'Previous',
    btnNext: 'Next',
    chooseAnotherFile: 'Replace',
    removeFile: 'Remove file',
    fileParseError: 'We could not read this file. Check that it is a valid CSV or XLSX.',
    previewEmptyBody: 'No additional rows in this preview.',
    filePreviewSubtitle: (fileSizeLabel, rowCount, columnCount) => `${fileSizeLabel} - ${rowCount} rows × ${columnCount} columns detected`,
    previewHint: (rowCount) => `Preview (First ${rowCount} rows)`,
    mappingInfoBlockText: (onCustomFieldsClick) => (
      <>
        Unmapped fields will be skipped during import. If you need to map data to a field that
        doesn't exist yet, you must first create it in{' '}
        <a
          className="picsioLink"
          href="/customfields#productAttributes"
          onClick={onCustomFieldsClick}
        >
          Custom product attributes
        </a>
        .
      </>
    ),
    mappingColumnUnmapped: 'Unmapped',
    mappingUnmappedToriutColumnsWarning: (columns) => (
      `${columns.length} column${columns.length === 1 ? '' : 's'} not recognized and will be skipped: ${columns.join(', ')}.`
    ),
    roundTripStructurallyModifiedTitle: 'This Toriut export has been structurally modified',
    roundTripStructurallyModifiedBody:
      'Some columns no longer match the original Toriut export. Round-trip updates currently support editing values only. Restore the original column names and remove any added columns before continuing.',
    roundTripUnrecognizedColumnsTitle: 'Unrecognized columns',
    mappingCsvSchemaLoadError:
      'Could not load Toriut column headers. Collision-safe auto-mapping is unavailable until this succeeds.',
    mappingCsvSchemaRetry: 'Retry',
    mappingColumnSample: (valuesText) => `Sample: ${valuesText}`,
    mappingSelectPlaceholder: 'Find a matching attribute...',
    mappingSelectSkipColumnLabel: 'Skip column',
    mappingSelectNoMatches: 'No matches found',
    mappingTargetAttributeLabel: 'Toriut target attribute',
    emptyCellBehaviorLabel: 'Empty cell behavior',
    emptyCellBehaviorSkipLabel: 'Skip empty cells',
    emptyCellBehaviorEraseLabel: 'Erase existing',
    emptyCellBehaviorAddLabel: 'Add new',
    emptyCellBehaviorOverwriteLabel: 'Overwrite existing',
    mappingOptionAlreadyMappedTooltip: (otherColumn) => (
      `This attribute is already mapped to the file column "${otherColumn}".`
    ),
    mappingBuiltinTitleLabel: 'Title',
    mappingBuiltinSkuLabel: 'SKU',
    mappingBuiltinDescriptionHtmlLabel: 'Description (HTML)',
    mappingBuiltinVendorLabel: 'Vendor',
    mappingBuiltinProductTypeLabel: 'Product type',
    mappingBuiltinKeywordsLabel: 'Keywords',
    mappingBuiltinHandleLabel: 'Handle',
    mappingBuiltinSeoTitleLabel: 'SEO Title',
    mappingBuiltinSeoDescriptionLabel: 'SEO Description',
    mappingBuiltinCategoryLabel: 'Category',
    mappingBuiltinTemplateSuffixLabel: 'Theme template',
    mappingBuiltinStatusLabel: 'Status',
    mappingBuiltinPriceLabel: 'Price',
    mappingBuiltinCompareAtPriceLabel: 'Compare at price',
    mappingBuiltinUnitCostLabel: 'Unit cost',
    mappingBuiltinBarcodeLabel: 'Barcode',
    mappingBuiltinInventoryPolicyLabel: 'Inventory policy',
    mappingBuiltinWeightLabel: 'Weight',
    mappingBuiltinTaxCodeLabel: 'Tax code',
    mappingBuiltinAvailableForSaleLabel: 'Available for sale',
    mappingBuiltinDescriptionLabel: 'Description',
    mappingBuiltinTaxableLabel: 'Taxable',
    mappingBuiltinTrackedLabel: 'Tracked',
    mappingBuiltinRequiresShippingLabel: 'Requires shipping',
    mappingBuiltinCountryCodeOfOriginLabel: 'Country of origin',
    mappingBuiltinHarmonizedSystemCodeLabel: 'Harmonized system code',
    mappingGroupSystemAttributes: 'System attributes',
    mappingGroupCustomProductAttributes: 'Custom product attributes',
    mappingGroupCustomVariantAttributes: 'Custom variant attributes',
    mappingCreateProductAttribute: '+ Create product attribute',
    mappingCreateVariantAttribute: '+ Create variant attribute',
    mappingCreateAttributeDialogTitle: (scope) => (
      scope === 'variant'
        ? 'Create variant attribute'
        : 'Create product attribute'
    ),
    mappingCompositeValueLabel: (fieldTitle) => `${fieldTitle} (value)`,
    mappingCompositeUnitLabel: (fieldTitle) => `${fieldTitle} (unit)`,
    mappingCompositeCurrencyLabel: (fieldTitle) => `${fieldTitle} (currency)`,
    mappingAuxUnitSourceLabel: 'Unit source',
    mappingAuxCurrencySourceLabel: 'Currency source',
    mappingAuxNameSourceLabel: 'Name source',
    mappingAuxSourceDefault: 'Use default value',
    mappingAuxSourceColumn: 'Use column from file',
    mappingAuxSourceFromUrl: 'Derive name from URL',
    mappingAuxDefaultValueLabel: 'Default value',
    mappingAuxColumnLabel: 'File column',
    mappingAuxColumnPlaceholder: 'Select column…',
    auxColumnUsedForUnit: (fieldTitle) => `Unit for "${fieldTitle}"`,
    auxColumnUsedForCurrency: (fieldTitle) => `Currency for "${fieldTitle}"`,
    auxColumnUsedForName: (fieldTitle) => `Name for "${fieldTitle}"`,
    validationErrDimensionUnitRequired: (fieldTitle) => (
      `Unit is required for field "${fieldTitle}" when using a file column`
    ),
    validationErrMoneyCurrencyRequired: (fieldTitle) => (
      `Currency is required for field "${fieldTitle}" when using a file column`
    ),
    validationErrMediaNameRequired: (fieldTitle) => (
      `Name is required for field "${fieldTitle}" when using a file column`
    ),
    mappingColumnsMappedSubtitle: (mappedCount, totalCount) => (
      `${mappedCount} of ${totalCount} columns mapped`
    ),
    variantImportModeTitle: 'Does your file contain product variants?',
    variantImportModeNoneLabel: 'No variants in file',
    variantImportModeNoneDescription: 'Each row is a separate, simple product',
    variantImportModeWithVariantsLabel: 'File contains variants',
    variantImportModeWithVariantsDescription:
      'Parent products and variants are linked together using a specific column (e.g., Parent SKU).',
    variantParentSkuColumnLabel: 'Parent identifier column',
    variantParentSkuColumnPlaceholder: 'Select column',
    variantParentSkuColumnHint:
      'Select the column that links variant rows to their parent product.',
    variantOptionColumnsLabel: 'Variant option columns',
    variantOptionColumnsHint:
      'Select up to 100 columns that define your variants. '
      + 'The column headers will be used as option names (e.g., Color, Size). '
      + 'Each product can have up to 3 options.',
    variantOptionColumnsMaxReached: 'You can select up to 100 option columns.',
    mappingVariantColumnUsageLabel: 'Used for',
    variantColumnUsedForParentSku: 'Parent SKU (links variant rows to parent products)',
    variantColumnUsedForParentRecordId:
      'Toriut Parent Record ID (links variant rows to parent products)',
    variantColumnUsedForOption: (optionName) => `Product option "${optionName}"`,
    variantStepTitleReady: 'Variant configuration complete',
    variantStepTitleIncomplete: 'Configure variant settings',
    variantImportDisabledTooltip:
      'Variant import is not available yet. Review validation results and error reports below.',
    variantModeLockedTooltip:
      'This Toriut CSV already defines whether it contains variants.',
    variantOptionsLockedInfo:
      'Product Options are fixed for this Toriut CSV. Option columns and their values can’t be changed during import.',
    validationTableRowType: 'Type',
    validationTableParentSku: 'Parent SKU',
    validationTableOptions: 'Options',
    validationRowTypeParent: 'Parent',
    validationRowTypeVariant: 'Variant',
    validationErrParentSkuOnParentRow: 'Parent SKU must be empty on parent product rows',
    validationErrParentSkuRequired: 'Parent SKU is required on variant rows',
    validationErrOptionRequired: (columnName) => (
      `Option "${columnName}" is required on variant rows`
    ),
    validationErrOptionValueRequired: 'Variant must have at least one option value',
    validationErrTooManyProductOptions: (max) => (
      `Product can have at most ${max} options`
    ),
    validationErrIncompleteProductOptions: (parentSku) => (
      `All variants for parent SKU "${parentSku}" must include every product option`
    ),
    validationErrParentSkuNotFound: (parentSku) => (
      `No parent product row found with SKU "${parentSku}"`
    ),
    validationErrParentRecordIdNotFound: (parentRecordId) => (
      `No parent product row found with Toriut Record ID "${parentRecordId}"`
    ),
    validationErrParentProductInvalid: 'Parent product is invalid',
    validationNoValidProductsToImport:
      'No valid products to import. Fix the errors above to continue.',
    validationErrDuplicateSku: (sku) => `Duplicate SKU "${sku}" in file`,
    validationErrDuplicateOptionCombo: (parentSku) => (
      `Duplicate option combination for parent SKU "${parentSku}"`
    ),
    VARIANT_IMPORT_MODE_OPTIONS: [
      {
        value: 'none',
        label: 'No variants in file',
        description: 'Each row is a separate, simple product',
      },
      {
        value: 'withVariants',
        label: 'File contains variants',
        description:
          'Parent products and variants are linked together using a specific column (e.g., Parent SKU).',
      },
    ],
    STEPS: {
      1: {
        stepTitle: 'Upload + Preview',
        title: 'Upload and preview',
        subTitle: <>CSV or XLSX file, up to <strong>95 MB</strong> and <strong>50,000 data rows</strong>.</>,
        btnNext: 'Continue to import',
        btnNextDisabledTooltip: 'Upload a CSV or XLSX file to continue',
      },
      2: {
        stepTitle: 'Import settings',
        title: 'Import settings',
        subTitle: 'Configure how Toriut handles the incoming data.',
        btnNext: 'Continue to variants',
        btnPrevious: 'Back',
      },
      3: {
        stepTitle: 'Variants',
        title: 'Variant configuration complete',
        titleIncomplete: 'Configure variant settings',
        subTitle:
          'Specify how parent products and their variants are structured in your file.',
        btnNext: 'Continue to mapping',
        btnPrevious: 'Back',
      },
      4: {
        stepTitle: 'Mapping',
        title: 'Required fields mapped',
        titleWarning: 'SKU and Title are required to proceed',
        titleWarningAddAndUpdate: 'SKU and Title, or Toriut Record ID, are required to proceed',
        titleWarningUpdate: 'SKU or Toriut Record ID is required to proceed',
        btnNext: 'Review & Import',
        btnPrevious: 'Back',
      },
      5: {
        stepTitle: 'Review & Import',
        title: 'Pre-import report',
        subTitle: 'Review the validation results below before importing.',
        btnNext: 'Import valid rows',
        btnPrevious: 'Back',
      },
    },
    FORMAT_OPTIONS: [
      { value: 'csv', label: 'CSV', icon: 'Csv' },
      { value: 'json', label: 'JSON', icon: 'Json' },
      { value: 'xml', label: 'XML', icon: 'Xml' },
      { value: 'xlsx', label: 'XLSX', icon: 'Excel' },
    ],
    TARGET_LAYER_TITLE: 'Import target layer',
    targetLayerDisabledTooltip:
      'Direct imports to store layers are under development. '
      + 'For now, please import your data to the Master layer and sync it to your stores.',
    IMPORT_TARGET_OPTIONS: [
      {
        value: 'master',
        label: 'Master only',
        description: 'Updates core product data. Stores are not affected.',
      },
      {
        value: 'masterAndStores',
        label: 'Master + Store(s)',
        description: 'Updates core and specific store overrides.',
      },
      {
        value: 'stores',
        label: 'Store(s) only',
        description: 'Updates store data. Master records are not affected.',
      },
    ],
    IMPORT_MODE_OPTIONS_TITLE: 'Import mode',
    IMPORT_MODE_OPTIONS: [
      {
        value: 'addAndUpdate',
        label: 'Add & Update',
        description: 'Default behavior. Adds new, updates existing.',
      },
      {
        value: 'add',
        label: 'Add only',
        description: 'Ignores existing SKUs.',
      },
      {
        value: 'update',
        label: 'Update only',
        description: 'Ignores new SKUs.',
      },
    ],
    SEPARATOR_OPTIONS: [
      { value: ',', title: 'Comma (,)', _id: 'Comma' },
      { value: ';', title: 'Semicolon (;)', _id: 'Semicolon' },
      { value: ':', title: 'Colon (:)', _id: 'Colon' },
      { value: '\t', title: 'Tab (↹)', _id: 'Tab' },
    ],
    DELIMITER_OPTIONS: [
      { value: '"', title: 'Double quote (")', _id: 'DoubleQuote' },
      { value: "'", title: "Single quote (')", _id: 'SingleQuote' },
      { value: '`', title: 'Back-tick (`)', _id: 'BackTick' },
      { value: '', title: 'None', _id: 'None' },
    ],
    // ── Validation step (Step 4) ──────────────────────────────────────────
    validationScanningFile: 'Validating your file…',
    validationParseErrorTitle: 'Could not read the file',
    validationParseErrorText: 'Please go back and check your file and parsing settings.',
    validationSummary: (total, filename) => (
      <>Processed {total} rows from <strong>{filename}</strong></>
    ),
    validationSummaryProducts: (productCount, variantCount, filename) => (
      <>Processed {productCount} products ({variantCount} variants) from <strong>{filename}</strong></>
    ),
    validationAllRowsValid: 'All rows are valid and ready to import.',
    validationAllProductsValid: 'All products are valid and ready to import.',
    downloadErrorReport: 'Download error report',
    validationShowAllRows: 'Show all rows',
    validationShowAllProducts: 'Show all products',
    validationShowErrorsOnly: 'Show errors only',
    validationRowsCount: (count) => `${count} rows`,
    validationProductsCount: (count) => `${count} products`,
    validationErrorRowsCount: (count) => `${count} error rows`,
    validationErrorProductsCount: (count) => `${count} products with errors`,
    validationTableRowNum: '#',
    validationTableSku: 'SKU',
    validationTableStatus: 'Status',
    validationTableErrors: 'Errors',
    validationStatusValid: 'Valid',
    validationStatusValidWithWarnings: 'Valid with warnings',
    validationStatusError: 'Error',
    validationWarningsTitle: 'Normalization warnings',
    validationWarningsSubtitle: (count) => (
      `${count} row(s) contain values that will be adjusted during import`
    ),
    validationWarningsSubtitleProducts: (count) => (
      `${count} product(s) contain values that will be adjusted during import`
    ),
    validationShowWarningsOnly: 'Show warnings only',
    validationWarningRowsCount: (count) => `${count} warning rows`,
    validationWarningProductsCount: (count) => `${count} products with warnings`,
    validationTableWarnings: 'Warnings',
    downloadWarningsReport: 'Download warnings report',
    // Success / post-import report state
    validationSuccessTitle: 'Import complete',
    validationPartialTitle: 'Import completed with issues',
    validationFailedTitle: 'Import failed',
    validationBackgroundTitle: 'Import started',
    validationBackgroundText: 'Your import is running in the background. You will be notified when it finishes.',
    validationSuccessText: (imported, skipped) => (
      skipped > 0
        ? `${imported} products imported. ${skipped} rows were skipped due to errors.`
        : `${imported} products imported successfully.`
    ),
    validationImportSummaryText: (summary = {}, warningCount = 0, skippedColumnCount = 0) => {
      const parts = [
        `${summary.created || 0} created`,
        `${summary.updated || 0} updated`,
        `${summary.errors || 0} errors`,
      ];
      if (warningCount > 0) {
        parts.push(`${warningCount} with warnings`);
      }
      if (skippedColumnCount > 0) {
        parts.push(`${skippedColumnCount} columns skipped`);
      }
      return `${parts.join('. ')}.`;
    },
    validationUnmappedToriutColumnsTitle: 'Unrecognized columns',
    importResultStatusCreated: 'Created',
    importResultStatusUpdated: 'Updated',
    importResultStatusError: 'Error',
    importResultTableDetails: 'Details',
    importResultAllSucceeded: 'All rows imported successfully.',
    importResultAllProductsSucceeded: 'All products imported successfully.',
    importResultWarningsTitle: 'Import warnings',
    importResultWarningsSubtitle: (count) => (
      `${count} row(s) completed with warnings`
    ),
    importResultWarningsSubtitleProducts: (count) => (
      `${count} product(s) completed with warnings`
    ),
    validationGoToProducts: 'Go to products',
    validationStartNewImport: 'Start new import',
    // Cell validation error messages
    validationErrSkuRequired: 'SKU is required',
    validationErrSkuOrRecordIdRequired: 'SKU or Toriut Record ID is required',
    validationErrTitleRequired: 'Title is required',
    validationErrFieldMaxLength: (field, maxLen) => (
      `${field} must be at most ${maxLen} characters`
    ),
    validationErrCompositeTwoParts: (type) => (
      `Invalid format for "${type}" — expected two parts separated by a space`
    ),
    validationErrUnknownAttribute: (fieldTitle) => (
      `Unknown product attribute "${fieldTitle}"`
    ),
    validationErrExpectedInt: (val) => `Expected integer, got "${val}"`,
    validationErrExpectedNumber: (val) => `Expected number, got "${val}"`,
    validationErrUnknownDimensionUnit: (unit, type) => (
      `Unknown unit "${unit}" for field type "${type}"`
    ),
    validationWarnDimensionDefaultUnit: (fieldTitle, defaultUnitLabel) => (
      `Unit not mapped or empty for "${fieldTitle}" — "${defaultUnitLabel}" will be used`
    ),
    validationErrUnknownCurrency: (code) => `Unknown currency "${code}"`,
    validationWarnMoneyDefaultCurrency: (fieldTitle, currency) => (
      `Currency not mapped or empty for "${fieldTitle}" — "${currency}" will be used`
    ),
    validationErrExpectedDate: (val) => `Expected date, got "${val}"`,
    validationErrExpectedDatetime: (val) => `Expected datetime, got "${val}"`,
    validationErrExpectedBoolean: (val) => `Expected true or false, got "${val}"`,
    validationErrUnsupportedStatus: (
      'Unsupported status value. Use Draft, Active, Archived, or Unlisted.'
    ),
    validationWarnSkuTrimmed: (original, normalized) => (
      `SKU will be trimmed from "${original}" to "${normalized}"`
    ),
    validationWarnTextNormalized: (original, normalized) => (
      `Value will change from "${original}" to "${normalized}"`
    ),
    validationWarnTextTruncated: (maxLen) => (
      `Value will be truncated to ${maxLen} characters`
    ),
    validationWarnIntClamped: (original, normalized) => (
      `Integer will be adjusted from "${original}" to "${normalized}"`
    ),
    validationWarnRatingClamped: (original, normalized, min, max) => (
      `Rating will be adjusted from "${original}" to "${normalized}" (allowed ${min}–${max})`
    ),
    validationWarnDateNormalized: (original, normalized) => (
      `Date will be stored as "${normalized}" (from "${original}")`
    ),
    validationWarnBooleanNormalized: (original, normalized) => (
      `Boolean will be stored as ${normalized} (from "${original}")`
    ),
    validationWarnJsonNormalized: (original, normalized) => (
      `JSON will be normalized to: ${normalized}`
    ),
    validationWarnEnumNewOptions: (options) => (
      `New enum option(s) will be added: ${options}`
    ),
    validationWarnKeywordsNormalized: (original, normalized) => (
      `Keywords will be stored as: ${normalized} (from "${original}")`
    ),
    validationWarnWrongScopeField: (columnName, fieldLabel, rowTypeLabel) => (
      `Column "${columnName}" is mapped to "${fieldLabel}" but the row is a ${rowTypeLabel} row; value will be ignored`
    ),
    validationWarnCompositeParsed: (type, original, normalized) => (
      `"${type}" value "${original}" will be parsed as ${normalized}`
    ),
    validationWarnHandleEmpty: (original) => (
      `Handle "${original}" cannot be converted to a URL slug and will be stored empty`
    ),
    validationWarnHandleNormalized: (original, normalized) => (
      `Handle will change from "${original}" to "${normalized}"`
    ),
    validationErrExpectedUrl: (val) => `Expected valid URL, got "${val}"`,
    validationErrExpectedColor: (val) => `Expected #RRGGBB color, got "${val}"`,
    validationErrExpectedJson: () => 'Expected valid JSON',
    validationErrExpectedEnum: (val) => `"${val}" is not a valid option`,
    validationErrExpectedRating: (val, min, max) => (
      `Expected value between ${min} and ${max}, got "${val}"`
    ),
    validationErrExpectedMeasurement: (val) => (
      `Expected a number (optionally followed by a unit), got "${val}"`
    ),
    CHARSET_OPTIONS: [
      { value: 'utf-8', title: 'UTF-8', _id: 'UTF8' },
      { value: 'windows-1252', title: 'Windows-1252', _id: 'Windows1252' },
      { value: 'iso-8859-1', title: 'ISO-8859-1', _id: 'ISO88591' },
    ],
  },

  BULK_MEDIA_MATCH: {
    CONFIRM_ADDITION_OF_MEDIA_FILES: {
      TITLE: 'Confirm addition of media files',
      TEXT: (count) => (
        <>
          You are about to add {count} selected media files to the suggested
          products.
          <br />
          <br />
          This operation will run in the background, and changes may take some
          time to appear.
          <br />
          <br />
          Do you want to proceed?
          <br />
          <br />
          <InfoBlock>
            For variants that already have media, suggested matches won't
            overwrite the existing file. Instead, they'll be added to the
            product's main media.
          </InfoBlock>
        </>
      ),
      BTN_CANCEL: 'Cancel',
      BTN_OK: 'Confirm',
    },
    REQUEST_FULL_ACCESS_BULK_MEDIA_MATCH: {
      title: 'Request full access',
      text: () => (
        <>
          <span>
            With free beta access, you're limited to 10 assets per selection.
            Request full access to remove this limitation
          </span>
          <br />
          <br />
          <span>
            Our support team will help you enable these options. Would you like
            to start a chat?
          </span>
        </>
      ),
      cancel: 'Cancel',
      ok: 'Proceed to chat',
    },
    BTN_APPROVE_MATCHES: 'Approve matches',
    BTN_OPEN_PLUGIN: 'Bulk Media Match',
    TOAST_MATCHING_IN_PROCESS:
      'Adding media to products according to the selected matches. This may take a moment.',
    TEXT_INFO_BLOCK: () => (
      <>
        Bulk Media Match automatically associates new media with products. By
        naming files to match product SKUs, suggested matches will appear in the
        feed below.
        <br />
        Review the suggestions and approve them using the bottom toolbar.
      </>
    ),
    LINK_INFO_BLOCK: 'Read the full guide',
    TITLE_PLACEHOLDER: 'No matches found',
    TEXT_PLACEHOLDER:
      'It seems there are no new media files matching your product SKUs. Start by renaming files to match SKUs, and they’ll appear here.',
  },
  DIALOGS: {
    VISUAL_SEARCH: {
      TITLE: 'Enable Visual & Similar Images Search for Your Team',
      TEXT: (permissionText, adminRoles) => (
        <>
          <p>
            Make your media library AI-searchable with two powerful features:
          </p>
          <p>
            <strong className="f-w-5">Similar Images Search</strong> – Find
            visually related assets by analyzing composition, colors, and
            patterns.
            <br />
            <strong className="f-w-5">Visual Search</strong> – Search using
            natural language descriptions like "sunset over ocean" or "group
            meeting in office," or use an example image to find similar ones.
          </p>
          <p>Two versions available:</p>
          <p>
            <strong className="f-w-5">Basic</strong> – Analyzes visual data only
            (composition, color, visual features) for context-free similarity
            matching.
            <br />
            <strong className="f-w-5">Pro</strong> – Combines visual and text
            embeddings with metadata for semantic understanding and more precise
            results.
          </p>
          <span className="visual-search-benefits">{permissionText}</span>
          {adminRoles && <div>{adminRoles}</div>}
        </>
      ),
      CANCEL_TEXT: 'Cancel',
      OK_BUTTON_TEXTS: {
        ENABLE_VISUAL_SEARCH: 'Enable Visual Search',
        PROCEED_TO_CHAT: 'Proceed to Chat',
        OK: 'Ok',
      },
      PERMISSION_TEXTS: {
        FULL_ACCESS:
          'To enable these features, all assets in your library need to be indexed.',
        PARTIAL_ACCESS:
          'Request activation for your media library by contacting our support team.',
        NO_ACCESS:
          'Request activation for your media library by contacting your Pics.io team admins:',
      },
      SUPPORT_MESSAGE:
        'Hello Support Team, I’m interested in trying out the Visual Search feature for my Pics.io library. Please guide me through the process.',
    },
    SUGGEST_IMPROVEMENT: {
      TITLE: 'Suggest improvement',
      TEXT:
        'Got an idea, improvement, or bug to report?\n Share it below — your message goes straight to our product team.',
      PLACEHOLDER: 'I think Pics.io would be even better if...',
      BTN_OK: 'Send',
      BTN_CANCEL: 'Cancel',
      PLACEHOLDER_TORIUT: 'I think Toriut.com would be even better if...',
    },
    EDIT_TRANSCRIPT_SPEAKER: {
      TITLE: 'Rename speaker',
      RADIO_LABEL_ONE: 'Rename speaker for this segment only',
      RADIO_LABEL_ALL: 'Rename speaker across the entire transcript',
      CHECKBOX_LABEL: "Don't show again",
      BTN_OK: 'Save',
      BTN_CANCEL: 'Cancel',
    },
    ADD_WATERMARK: {
      TITLE: 'Upgrade required!',
      TEXT:
        'Creating watermarks from images and logos is only available for plans starting from Small. Upgrade to Small or higher to enable custom watermarks.',
      BTN_OK: 'See all plans',
    },
    SYNC_PRODUCTS_ERROR: {
      TITLE: 'Product sync unavailable',
      TEXT:
        'Full sync is temporarily unavailable because a background operation is managing media attachments. Once it finishes, you can safely run the sync.',
      BTN_OK: 'Ok',
    },
    PULL_PRODUCTS: {
      SYNC_IN_PROGRESS:
        'Sync in progress: fetching the latest products and attributes from Shopify. This may take a few moments',
      SYNC_FAILED:
        'Sync failed: unable to update products and attributes from Shopify. Please check your connection or try again',
      BTN_TRY_AGAIN: 'Try again',
    },
    UNSAVED_CHANGES_DETECTED: {
      TITLE: 'Unsaved changes detected',
      TEXT: (
        <>
          Leaving now will discard any unsaved changes.
          <br />
          Click <span className="highlight">Save Changes</span> to keep them or{' '}
          <span className="highlight">Discard</span> to exit.
          <br />
          <br />
          How do you want to proceed?
        </>
      ),
      BTN_CANCEL: 'Discard',
      BTN_OK: 'Save Changes',
    },
    UNSUPPORTED_MEDIA_DIALOG: {
      TITLE: 'Unsupported Media Detected',
      TEXT: (errorAssetsCount, allAssetCount) => `${errorAssetsCount} out of ${allAssetCount} media items can’t be added to products or their variants due to the following reasons:`,
      SUB_TEXT:
        'For more information on Shopify’s media requirements, refer to Shopify’s media guidelines.',
      BTN_OK: 'Ok',
    },
    KEEP_MEDIA_CONSISTENT: {
      TITLE: 'Keep media consistent across product records?',
      DESCRIPTION: (
        <>
          You&apos;re adding media directly to a Shopify listing.
          <br />
          <br />
          For cleaner product data, add this media to the Master Product too.
          Master media acts as the shared source for channel listings, while
          listing-only media creates a channel-specific override.
          <br />
          <br />
          Use listing-only media when this asset should be different for this
          Shopify listing.
        </>
      ),
      DONT_SHOW_AGAIN: "Don't suggest this again for listing media",
      BTN_LISTING_AND_MASTER: 'Add to Listing and Master',
      BTN_LISTING_ONLY: 'Add to Listing only',
      BTN_CANCEL: 'Cancel',
    },
    PREPARE_MEDIA_FOR_SHOPIFY: {
      TITLE: 'Prepare media for Shopify',
      DESCRIPTION: (count) => {
        const isPlural = count !== 1;
        const itsTheir = isPlural ? 'their' : 'its';
        const isAre = isPlural ? "aren't" : "isn't";
        const thisThese = isPlural ? 'these' : 'this';
        const thatThose = isPlural ? 'those' : 'that';
        return (
          <>
            <span className="highlight">{count}</span>
            {' '}
            selected media
            {' '}
            {pluralize('item', count)}
            {' '}
            can&apos;t be uploaded to Shopify as original product media because
            {' '}
            {itsTheir}
            {' '}
            {pluralize('format', count)}
            {' '}
            {isAre}
            {' '}
            supported.
            <br />
            <br />
            To publish this listing, Toriut can prepare a Shopify-compatible
            {' '}
            {pluralize('version', count)}
            {' '}
            from
            {' '}
            {thisThese}
            {' '}
            selected
            {' '}
            {pluralize('asset', count)}
            {' '}
            and upload
            {' '}
            {thatThose}
            {' '}
            {pluralize('version', count)}
            {' '}
            to Shopify instead. The original
            {' '}
            {pluralize('asset', count)}
            {' '}
            will stay unchanged in Toriut.
            <br />
            <br />
            If you want to control the crop, dimensions, or output format, customize
            {' '}
            {thisThese}
            {' '}
            selected
            {' '}
            {pluralize('asset', count)}
            {' '}
            in Asset Copy before publishing.
          </>
        );
      },
      ISSUE_LABEL: 'Issue',
      ISSUE_UNSUPPORTED_FORMAT: 'Unsupported format',
      FILE_LABEL: 'File',
      BTN_PREPARE: 'Prepare Shopify version',
      BTN_ASSET_COPY: 'Customize in Asset Copy',
      BTN_CANCEL: 'Cancel',
    },
    DELETE_FACE_REGION: {
      TITLE: 'Delete face region',
      TEXT: 'Face region will be deleted on this asset',
      BTN_OK: 'Delete',
      BTN_CANCEL: 'Cancel',
    },
    ADD_ADDON_NOT_PERMISSION: {
      TITLE: 'Not enough permissions',
      TEXT:
        'You do not have permissions to add more (inboxes, websites, teammates) than included in your team’s subscription plan. Ask you team admin to do that for you.',
      BTN_OK: 'Ok',
    },
    INVALID_SAVED_SEARCH: {
      TITLE: 'This saved search is not valid',
      TEXT: (invalidEntities) => {
        const invalidEntityTypes = invalidEntities.map((invalidEntity) => {
          if (invalidEntity.type === 'collections') {
            return `${pluralize('collection', invalidEntity.ids.length)}`;
          }
          if (invalidEntity.type === 'lightboard') {
            return 'lightboard';
          }
          if (invalidEntity.type === 'inbox') {
            return 'inbox';
          }
          if (invalidEntity.type === 'keywords') {
            return `${pluralize('keyword', invalidEntity.ids.length)}`;
          }
          if (invalidEntity.type === 'faces') {
            return `${pluralize('face', invalidEntity.ids.length)}`;
          }
          if (invalidEntity.type === 'customFields') {
            return `${pluralize('customField', invalidEntity.ids.length)}`;
          }
          return '';
        });
        return `The saved search refers to a deleted ${invalidEntityTypes.join(
          ', ',
        )} and is no longer valid. Do you want to delete the <b>Irrelevant search</b>?`;
      },
      OK_TEXT: 'Delete this search',
      CANCEL_TEXT: 'Cancel',
    },
    SAVED_SEARCH_DOES_NOT_EXIST: {
      TITLE: 'This saved search is not valid',
      TEXT: 'Saved search does not exist',
    },
    SELECT_TO_IMPORT: {
      TITLE: 'Select collection to import',
      TEXT: (isMobileApp = false) => `Select an existing collection ${
        !isMobileApp ? 'or create a new one' : ''
      } to proceed with uploading assets`,
      OK_TEXT: 'Import',
      CANCEL_TEXT: 'Cancel',
    },
    CANNOT_REMOVE_ADDON: (featureName) => {
      const defaultName = featureName.replace('Limit', '');
      switch (featureName) {
      case 'teammatesLimit':
        return {
          TITLE: 'Can’t remove teammates',
          TEXT: (hideDialog) => (
            <span>
              To be able to remove teammates, you need to first delete those
              extra user seats in{' '}
              <span
                aria-hidden="true"
                className="dialogLink"
                onClick={() => {
                  navigate('/teammates');
                  hideDialog();
                }}
              >
                Teammates tab
              </span>
              . Once it’s done, come back here and remove extra seats from
              your plan.
            </span>
          ),
          BTN_OK: 'OK',
        };
      case 'inboxesLimit':
        return {
          TITLE: 'Can’t remove inboxes',
          TEXT: (
            hideDialog,
            { firstIndoxId, openedTree, handleChangeTree },
          ) => (
            <span>
              To be able to remove inboxes, you need to first delete those
              extra inboxes in{' '}
              <span
                aria-hidden="true"
                className="dialogLink"
                onClick={() => {
                  if (openedTree !== 'inbox') handleChangeTree('inbox');
                  navigate(`/search?inboxId=${firstIndoxId}`);
                  hideDialog();
                }}
              >
                Inboxes tab
              </span>
              . Once it’s done, come back here and remove extra inboxes from
              your plan.
            </span>
          ),
          BTN_OK: 'OK',
        };
      case 'websitesLimit':
        return {
          TITLE: 'Can’t remove websites',
          TEXT: (
            hideDialog,
            { firstWebsiteId, openedTree, handleChangeTree },
          ) => (
            <span>
              To be able to remove websites, you need to first delete those
              extra websites in{' '}
              <span
                aria-hidden="true"
                className="dialogLink"
                onClick={() => {
                  if (openedTree !== 'collections') handleChangeTree('collections');
                  navigate(`/search?collectionIds=${firstWebsiteId}`);
                  hideDialog();
                }}
              >
                Websites tab
              </span>
              . Once it’s done, come back here and remove extra websites from
              your plan.
            </span>
          ),
          BTN_OK: 'OK',
        };
      default:
        return {
          TITLE: `Can’t remove ${defaultName}`,
          TEXT: () => (
            <span>
              To be able to remove {defaultName}, you need to first delete
              those extra user seats. Once it’s done, come back here and
              remove extra seats from your plan.
            </span>
          ),
          BTN_OK: 'OK',
        };
      }
    },
    DELETE_ASSETS: {
      TITLE: (deleteWithoutTrash, idsLength) => (deleteWithoutTrash
        ? `Delete ${pluralize('file', idsLength, false)}`
        : 'Delete forever'),
      TEXT: (deleteWithoutTrash, idsLength) => (deleteWithoutTrash
        ? `<div>This operation will remove ${idsLength} assets from your connected cloud storage and ${appName}.</div>`
        : `<div>This operation will remove ${idsLength} assets from your connected cloud storage and ${appName} trash.</div>`),
    },
    DROPBOX_CONNECTION_ERROR: {
      TITLE: "We weren't able to connect to that account",
      TEXT: `It looks like you didn't give ${appName} permission to access your Dropbox files. Try connecting your account again making sure you allow access.`,
      BTN_OK: 'OK',
    },
    UNSUPPORTED_FILE: {
      TITLE: 'Unsupported file format',
      TEXT: 'Document editing is not supported yet',
    },
    DOWNLOAD_DUPLICATES: {
      TITLE: (duplicates) => `${pluralize('file', duplicates.length, false)} already added`,
      TEXT: (duplicates) => (
        <>
          The following {duplicates.length}{' '}
          {pluralize('file', duplicates.length, false)} are already added for
          downloading:
          <ul>
            {duplicates.map((file) => (
              <li className="dialog-item">{file.name}</li>
            ))}
          </ul>
          {duplicates.length > 1 && (
            <p>Press OK to skip these files and proceed with downloading</p>
          )}
        </>
      ),
    },
    DOWNLOAD_ERROR: {
      TITLE: 'Download failed',
      TEXT: 'Failed to download. Check your internet connection.',
    },
    ERROR_RESOLVE_DUPLICATE: {
      TITLE: '',
      TEXT: (duplicateItemName, duplicateItemId) => `Cannot resolve duplicate for file ${duplicateItemName} (${duplicateItemId})`,
    },
    ENABLE_CONTROLLED_VOCABULARY: {
      TITLE: 'Enable Сontrolled vocabulary',
      TEXT:
        "Controlled Vocabulary ensures team members use an approved list of keywords, preventing any unauthorized keyword modifications. Teammates without 'Add keywords outside of controlled vocabulary' permission can't edit, delete, or add new keywords.",
      BTN_CANCEL: 'Cancel',
      BTN_OK: 'Enable',
    },
    DISABLE_CONTROLLED_VOCABULARY: {
      TITLE: 'Disable Сontrolled vocabulary',
      TEXT:
        'Controlled Vocabulary ensures team members use an approved list of keywords, preventing any unauthorized keyword modifications. After disabling all teammates can edit, delete, or add new keywords.',
      BTN_CANCEL: 'Cancel',
      BTN_OK: 'Disable',
    },
    COLLECTION_DELETE_ERROR: {
      TITLE: 'Error',
      TEXT: (displayName, collectionName) => (
        <>
          {displayName} has just deleted "{collectionName}" collection.
        </>
      ),
      BTN_OK: 'Ok',
    },
    AUTOGENERATE_KEYWORDS: {
      TITLE: 'Confirm action',
      TEXT: 'Do you want to have keywords generated by AI for all new assets?',
      BTN_OK: 'Confirm',
      BTN_CANCEL: 'Cancel',
    },
    DELETE_FACE: {
      TITLE: 'Delete face',
      TEXT:
        'This face will be removed from all images where it was recognized previously. Continue?',
      BTN_OK: 'Delete',
      BTN_CANCEL: 'Cancel',
    },
    BILLING_DOWNGRADE: {
      TITLE: 'Request sent',
      TEXT: (action) => (
        <>
          We’ve received your {action} request. Our Support Team will contact
          you shortly.
        </>
      ),
    },
    IMPORT_WARNING_ADDED_DUPLICATES: {
      TITLE: 'Files already in uploading batch',
      TEXT: (localDuplicates) => `The following ${
        localDuplicates.length
      } files are already in the uploading batch: <ul>${localDuplicates
        .map((file) => `<li>${file.name}</li>`)
        .join(
          '',
        )}</ul><p>Press Skip to skip these files and proceed with uploading</p>`,
      BTN_OK: 'Skip',
    },
    KEYWORDS_GENERATION_ASSETS_NOT_FOUND: {
      TITLE: 'Keyword generation error',
      TEXT: () => (
        <>
          <InfoBlock icon={() => <Warning />} iconColor="warning">
            The collection you selected is currently empty or contains
            unsupported asset types for keyword generation
          </InfoBlock>
          <br />
          <p>
            Please select a different collection or add assets to the selected
            one before using the Keyword Generation feature.
          </p>
        </>
      ),
      BTN_OK: 'Ok',
    },
    FACE_RECOGNITION_ASSETS_NOT_FOUND: {
      TITLE: 'Face recognition error',
      TEXT: () => (
        <>
          <InfoBlock icon={() => <Warning />} iconColor="warning">
            The collection you selected is currently empty or contains
            unsupported asset types for face recognition
          </InfoBlock>
          <br />
          <p>
            Please select a different collection or add assets to the selected
            one before using the Face Recognition feature.
          </p>
        </>
      ),
      BTN_OK: 'Ok',
    },
    IMPORT_WARNING_FILES_EXCEEDS: {
      TITLE: 'Files size exceed 40GB',
      TEXT: (largeFiles) => `The following ${
        largeFiles.length
      } files are too large for upload: <ul>${largeFiles
        .map((file) => `<li>${file.name}</li>`)
        .join(
          '',
        )}</ul><p>Press ok to skip these files and proceed with upload.</p>`,
      BTN_OK: 'Ok',
    },
    UPLOAD_ERROR: {
      TITLE: 'Not enough space in your storage.',
      TEXT: 'Cannot upload an asset',
    },
    DOWNLOAD_LIMIT: {
      TITLE: 'Download',
      TEXT:
        'If you download more than 50 assets at a time, they can only be downloaded as an archive',
    },
    DOWNLOAD_PROOFING_AS_ZIP: {
      TITLE: (countLimit) => `Cannot download more than ${countLimit} files`,
      TEXT: (countLimit) => `This website contains more than ${countLimit} files. Due to technical limitations, downloading files as an archive is not available for this number of files.<br />You can still select and download individual assets if you like.`,
    },
    CHECK_FOR_RESTRICTED_ASSETS: {
      TITLE: 'Restricted assets detected',
      TEXT:
        'Please note that you are about to publish the collection with restricted assets inside.',
      BTN_OK: 'Ok',
      BTN_CANCEL: 'Cancel',
    },
    SCREEN_PLAN_CANCELLATION: {
      TITLE: 'Cancellation request sent',
      TEXT:
        'We’ve received your cancellation request. Our Support Team will contact you shortly.',
    },
    MERGE_FACE: {
      CANCEL_TEXT: 'Cancel',
      OK: 'Merge',
    },
    INBOX: {
      TITLE: 'Select inbox',
      TEXT:
        'Select an existing inbox or create a new one to provide link to external users for uploading assets',
      OK_TEXT: 'Create inbox',
      CANCEL_TEXT: 'Cancel',
    },
    LIMIT_CHECK_DUPLICATES: {
      TITLE: 'Exceeded assets selection limit',
      TEXT:
        'You have selected more than 10 000 assets. The system cannot check for duplicates at that number of assets. Please reduce the number of selected assets and try again.',
      CANCEL_TEXT: 'Ok',
    },
    // WRONG_GOOGLE_ACCOUNT: {
    // 	TITLE: 'Wrong Cloud Storage Account',
    // 	TEXT_TPL:
    // 		"Note that you're authorized to <b style='color:#FC0'>{authorized}</b>.<br/><br/>Previously you've connected <b style='color:#FC0'>{saved}</b> to pics.io. <br><br>You won't see any files from your original Cloud Storage Account. You might want to login to your original Cloud Storage Account before.",
    // 	OK_TEXT: 'Ok, got it',
    // 	CANCEL_TEXT: 'Cancel',
    // },
    ERROR_PLAN_LIMIT: {
      TITLE: 'Plan limit reached',
      TEXT:
        'On Solo you can share only 10 assets. To get unlimited single-shared assets, you should upgrade to Micro plan or higher.',
      OK_TEXT: 'See all plans',
    },
    DUPLICATE_ASSET_TO: {
      TITLE: 'Select collection to place a copy',
      OK: 'Duplicate',
      CANCEL: 'Cancel',
    },
    HAS_WORKER_BUT_NO_CONTROLLER: {
      TITLE: 'Attention!',
      TEXT: `New version of ${appName} is available. Refresh the browser tab to see the updates.`,
      OK_TEXT: 'Refresh',
      CANCEL_TEXT: 'Cancel',
    },
    MOVE_TO_TRASH: {
      TITLE: 'Move to trash',
      TEXT: (count, name) => (
        <div>
          You are about to delete{' '}
          <span className="highlight">
            {name || count} {count !== 1 ? 'assets' : ''}
          </span>
          {count === 1 ? ' asset' : ''}. This will delete {name ? 'it' : 'them'}{' '}
          from all associated collections.
        </div>
      ),
      INFO_BLOCK: (count) => `If you would like to remove ${
        count === 1 ? 'it' : 'them'
      } from specific collections only, use “Remove from collection” instead`,
      BTN_OK: 'Delete',
    },
    ERROR_TRASH_DIALOG: {
      TITLE: 'Error',
      TEXT_ASSET_BULK_OPERATION: (successful, failed, onClick) => (
        <>
          <p>
            {pluralize('asset', successful, true)} will be moved to trash,{' '}
            {pluralize('asset', failed, true)} cannot be trashed because you
            have a limited access to the files in Google Drive.
          </p>
          {getTextErrorGDBulk(onClick)}
        </>
      ),
      TEXT_ASSET_ONE_OPERATION: (onClick) => getTextErrorGDOne(onClick),
    },
    ERROR_UNTRASH_DIALOG: {
      TITLE: 'Error',
      TEXT_ASSET_BULK_OPERATION: (successful, failed, onClick) => (
        <>
          <p>
            {pluralize('asset', successful, true)} will be restored from trash,{' '}
            {pluralize('asset', failed, true)} cannot be restored because you
            have a limited access to the files in Google Drive.
          </p>
          {getTextErrorGDBulk(onClick)}
        </>
      ),
      TEXT_ASSET_ONE_OPERATION: (onClick) => getTextErrorGDOne(onClick),
    },
    SELECT_COLLECTION_FOR_GENERATE_KEYWORD: {
      TITLE: 'Select collection',
      TEXT:
        'AI will automatically generate and add new keywords to assets within the selected collection.',
      BTN_OK: 'Generate keywords',
    },
    ERROR_DOWNLOAD_ASSET: {
      TITLE: 'Error',
      TEXT: (onClick) => getTextErrorGDOne(onClick),
    },
    UNABLE_TO_RENAME_ASSET: {
      TITLE: 'This name already taken',
      TEXT:
        'This name is used by the original file. Pick a different name for this duplicate',
    },
    ERROR_RENAME_ASSET: {
      TITLE: 'Error',
      TEXT: (onClick) => getTextErrorGDOne(onClick),
    },
    ERROR_COPY_ASSET: {
      TITLE: (titleStorage) => (titleStorage === 'Picsio'
        ? 'Not enough storage space'
        : 'Not enough  space in Google Drive'),
      TEXT: (titleStorage) => (
        <p>
          {titleStorage === 'Picsio'
            ? 'Duplicating all of the selected assets will require more space than is available in your storage. You can either select fewer assets or buy more storage'
            : 'Duplicating all of the selected assets will require more space than is available in your Google Drive. You can either select fewer assets or buy more storage with Google.'}
        </p>
      ),
    },
    ERROR_DELETE_DIALOG: {
      TITLE: 'Error',
      TEXT_ASSET_BULK_OPERATION: (successful, failed, onClick) => (
        <>
          <p>
            {pluralize('asset', successful, true)} will be moved to trash,{' '}
            {pluralize('asset', failed, true)} cannot be trashed because you
            have a limited access to the files in Google Drive.
          </p>
          {getTextErrorGDBulk(onClick)}
        </>
      ),
      TEXT_ASSET_ONE_OPERATION: (onClick) => getTextErrorGDOne(onClick),
    },
    ATTENTION_DIALOG: {
      TITLE: 'Attention!',
      TEXT: `You're going to cancel your subscription. This will block an access to ${appName} services to you and all your teammates. Continue?`,
      OK_TEXT: 'Yes',
      CANCEL_TEXT: 'No',
    },
    LOGOUT_DIALOG: {
      TITLE: 'Confirm logout',
      TEXT: (
        <span>
          You are going to <b>logout</b>. Continue?
        </span>
      ),
      OK_TEXT: 'Ok',
      CANCEL_TEXT: 'Cancel',
    },
    SAVE_EDITOR_CHANGES_DIALOG: {
      TITLE: 'Warning',
      TEXT: 'Want to close editor without saving changes?',
      OK_TEXT: 'Continue editing',
      CANCEL_TEXT: 'Close',
    },
    EDITOR_SAVE_AS_REVISION: {
      TITLE: 'Save changes',
      TEXT: 'Want to save the edited file as a new revision?',
      OK_TEXT: 'Save',
      CANCEL_TEXT: 'Continue editing',
    },
    EDITOR_CANT_SAVE_AS_REVISION: {
      TITLE: 'Warning',
      TEXT: (
        fileExtension,
        isRevisionsAllowed,
      ) => `Editor won’t be able to save your modified ${fileExtension.toUpperCase()} file back to ${appName}.</br>
         You will have to <b>download</b> the edited file on your device${
  isRevisionsAllowed
    ? ` and <b>upload it manually</b> as a new revision to ${appName}`
    : ''
}.`,
      LABEL: (fileExtension) => `Do not show this warning about ${fileExtension.toUpperCase()} again`,
    },
    DRAG_AND_DROP_ONLY_ASSETS: {
      TITLE: 'Error',
      TEXT: 'Please note that  drag and drop will work only for assets here',
      TEXT_CANCEL: 'Ok',
      TEXT_OK: null,
    },
    GENERATING_KEYWORDS: {
      title: 'Unsupported Assets Detected',
      text:
        'Some non-image items were detected in the current selection and will not be processed. AI keywording works only with image assets.  Your AI asset processing limit will remain unaffected.',
      textError:
        'All selected assets have unsupported format and cannot be sent to processing by our AI.',
      TEXT_OK: 'Ok',
    },
    GENERATING_FACES: {
      title: 'Unsupported Assets Detected',
      text:
        'Some non-image items were detected in the current selection and will not be processed. Face Recognition works only with image assets.  Your AI asset processing limit will remain unaffected.',
      TEXT_OK: 'Ok',
    },
    INCORRECT_EXTENSION_ERROR: 'Unsupported formats',
    EDITOR_CANT_DOWNLOAD_FILE: {
      TITLE: 'Error',
      TEXT: `For some reason, Editor can’t get access to this file. Here’s what you can do:<ul><li>Refresh this page and try again later</li><li>Check if this file is still available in your Cloud Storage</li><li>Contact us at <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}</a> and we’ll see what we can do</li></ul>`,
    },
    CHANGE_GOOGLE_DRIVE: {
      TITLE: 'Attention! Storage reset!',
      TEXT: `By changing your cloud storage account, you will lose all the changes you made in ${appName}. Do you confirm?`,
      OK_TEXT: 'Confirm',
      CANCEL_TEXT: 'Cancel',
    },
    CHANGE_WORKING_FOLDER: {
      TITLE: 'Warning! Storage reset!',
      TEXT: (storageType) => (storageType === 's3'
        ? `You are about to destroy all the information about your assets and the library itself in your ${appName} account. When you are changing your working folder all the changes you’ve made in ${appName} will be lost. This operation is not reversible and we will not be able to restore your information. Please note that your assets will remain in your Amazon S3 Bucket working folder.<br><br> If you are not sure about this action please contact <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}</a> and we will help you with the issue. If you are sure to proceed, please type “erase all data in my library”`
        : `You are about to destroy all the information about your assets and the library itself in your ${appName} account. When you are changing your working folder all the changes you’ve made in ${appName} will be lost. This operation is not reversible and we will not be able to restore your information. Please note that your assets will remain in your Google Drive working folder.<br><br> If you are not sure about this action please contact <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}</a> and we will help you with the issue. If you are sure to proceed, please type “erase all data in my library”`),
      OK_TEXT: 'Confirm',
      CANCEL_TEXT: 'Cancel',
    },
    SOMETHING_WENT_WRONG: {
      TITLE: 'Oops! Something went wrong',
      TEXT: `<p>It seems you've come across a bug we've been hunting for a long time. Please, send an email to <a href="mailto:${supportEmail}?subject=\${subject}&body=\${body}">${supportEmail}</a> to inform us about this. We'll really appreciate if you could tell us how you got here. Also, please copy and paste this information in your email:</p><code>\${code}</code><p>It's a rare error indeed, so refreshing your browser should probably help. Thanks for your patience!</p>`,
      OK_TEXT: 'Refresh page',
      CANCEL_TEXT: 'Close',
    },
    WAIT_AND_RETRY: {
      TITLE: 'Too many requests',
      TEXT: ({ subject, body, code }) => (
        <>
          <p>
            It seems that you\'ve sent too many requests to your cloud storage.
            Please wait for a few minutes and press "Retry" button. In case this
            error persists, please email us at{' '}
            <a href={`mailto:${supportEmail}?subject=${subject}&body=${body}`}>
              {supportEmail}
            </a>
            . We'll really appreciate if you told us how you got here. Also,
            please copy and paste this information in your email:
          </p>
          <code>{code}</code>
          <p>
            It's a rare error indeed, so refreshing your browser should probably
            help. Thanks for your patience!
          </p>
        </>
      ),
      OK_TEXT: 'Retry',
      CANCEL_TEXT: 'Close',
    },
    FILE_DELETED_FROM_GD: {
      TITLE: 'Cannot access the file',
      TEXT: `It seems that the file you're trying to access was deleted from your cloud storage. Please check if the file is still there. If the file is OK, please tell us about the problem at <a href="mailto:${supportEmail}?subject=The file is not here">${supportEmail}</a>`,
      OK_TEXT: 'Ok',
    },
    LIGHTBOARD_FOLDER_NOT_FOUND_IN_GD: {
      TITLE: 'Cannot access the lightboard',
      TEXT: `It seems that the folder you're trying to access was deleted from your cloud storage. Please check if the folder is still there. If the folder is OK, please tell us about the problem at <a href="mailto:${supportEmail}?subject=Lightboards folder is not found in your cloud storage">${supportEmail}</a>`,
      OK_TEXT: 'Ok',
    },
    NO_SPACE_LEFT: {
      TITLE: 'Storage disk space used up',
      TEXT:
        "It seems that your cloud storage is full. Please make sure that you have enough disk space. You can delete something you don't need or just buy more space",
      OK_TEXT: 'Ok',
      CANCEL_TEXT: 'Close',
    },
    /** Google Drive refused the upload because the account is out of storage space */
    GD_STORAGE_QUOTA_EXCEEDED: {
      TITLE: 'Google Drive is out of space',
    },
    /** Google Drive refused the upload because the rolling 24h upload cap was reached */
    GD_DAILY_UPLOAD_LIMIT: {
      TITLE: 'Google Drive daily upload limit reached',
    },
    NO_SIZE_LEFT: {
      TITLE: 'Storage is used up',
      TEXT: `Your storage has reached its limit, so ${appName} cannot upload any more files. Contact as at <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}<a> to purchase more GBs for your account.`,
    },
    SLOW_CONNECTION: {
      TITLE: 'Your connections is slow',
      TEXT: `<p>Seems that you have a slow or unstable internet connection. Please check your connection and retry.</p><p><a href="https://help.pics.io/pics-io-settings/optimization-for-slow-internet-connection" target="_blank">Here</a> you can find some advice on how to optimize your work in ${appName} for slow internet connection</p>`,
      OK_TEXT: 'Retry',
      CANCEL_TEXT: 'Ok',
    },
    UPLOAD_QUEUE_BUSY: {
      TITLE: 'Not so fast, please!',
      TEXT: `We are already uploading assets to ${appName}. Please wait until this process if finished, then add more assets.`,
    },
    btnYes: 'Yes',
    btnNo: 'No',
    btnOk: 'Ok',
    btnCreate: 'Create',
    btnCancel: 'Cancel',
    btnClose: 'Close',
    btnConfirm: 'Confirm',
    btnDelete: 'Delete',
    btnRemove: 'Remove',
    btnBuyMore: 'Buy more',
    btnSubscribe: 'Go to Billing',
    btnNotNow: 'Not now',
    btnReinstall: 'Reinstall',
    btnRestore: 'Restore',
    REQUIRED_COMMENT: {
      TITLE: 'Add a comment',
      TEXT:
        'According to team policy, you are required to add a comment every time you upload a new revision.',
      TEXTEXPLAIN: 'Let your teammates know what has changed in this revision.',
    },
    FILES_NOT_SELECTED: {
      TITLE: 'Ooops! Files were not selected',
      TEXT:
        'Please press OK and take one step back to select file(s) for uploading.',
    },
    WARNING_ALLOWED_COLLECTION: {
      TITLE: 'Warning',
      TEXT: `<p>You are about to deny access to all collections in ${appName}. Teammates with this role will not see any of your assets.</p><p>Are you sure you want to continue?</p>`,
    },
    WARNING_EDIT_ASSET_COLLECTIONS: {
      TITLE: 'Warning',
      TEXT:
        'It seems that you don’t have permission to manage collections for some of the selected assets. Please contact your team owner for further assistance.',
    },
    WARNING_EDIT_ASSET_KEYWORDS: {
      TITLE: 'Warning',
      TEXT:
        'It seems that you don’t have permission to attach/detach keywords to some of the selected assets. Please contact your team owner for further assistance.',
    },
    WARNING_EDIT_ASSET_DESCRIPTION: {
      TITLE: 'Warning',
      TEXT:
        'It seems that you don’t have permission to change description to some of the selected assets. Please contact your team owner for further assistance.',
    },
    WARNING_CHANGE_ASSETS_ORDER: {
      TITLE: 'Warning',
      TEXT:
        'Custom sorting mode is already applied to this collection. Do you want to proceed and change the current sorting mode?',
      OK_TEXT: 'Yes, change the order',
      CANCEL_TEXT: 'No, I don’t',
    },
    WARNING_COLLECTION_NAME_LENGTH: {
      TITLE: 'Create new collection error',
      TEXT:
        'Collection cannot be created. <br> It’s name is too long. Maximum allowed length is 500 characters. Shorten the name and try again.',
      OK_TEXT: 'Ok',
    },
    MOVE_COLLECTION_DIALOG: {
      TITLE: (collectionName) => `Move '${collectionName}' collection`,
      OK_TEXT: 'Move',
      CANCEL_TEXT: 'Cancel',
    },
    COPY_COLLECTIONS_TREE_DIALOG: {
      TITLE: 'Select collection to place a copy',
      OK_TEXT: 'Duplicate',
      CANCEL_TEXT: 'Cancel',
    },
    COPY_COLLECTION_RADIO_DIALOG: {
      TITLE: 'Duplicate Collection',
      COPY_ONE: 'Duplicate only selected collection',
      COPY_ALL: 'Duplicate selected collection and it’s sub-collections',
      OK: 'Duplicate',
      CANCEL: 'Cancel',
      DESCRIPTION: 'Files WILL NOT be duplicated, only collections structure',
    },
    COPY_COLLECTION_ERRORS: {
      SOMETHING_WENT_WRONG: {
        TITLE: 'Something went wrong',
        TEXT: `<p>Please try again. Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.</p>`,
      },
      LIMIT_EXCEEDED: {
        TITLE: 'Cannot duplicate collections',
        TEXT:
          'Only less than 100 collections can be copied in one go. Choose fewer collections and try again.',
      },
    },
    MOVE_ASSETS_DIALOG: {
      TITLE: 'Asset organization options',
      TEXT: (count) => (
        <>
          Specify the action you'd like to perform on{' '}
          <span className="highlight">
            {count} selected {pluralize('asset', count)}
          </span>
          :
        </>
      ),
      COPY_RADIO: {
        LABEL: (collectionName) => `Add to <span class="highlight">${collectionName}</span>`,
        DESCRIPTION:
          "Place the same asset in multiple collections. Assets added to multiple collections aren't moved or duplicated, they represent original files with the same metadata.",
      },
      MOVE_RADIO: {
        LABEL: (collectionName) => `Move to <span class="highlight">${collectionName}</span>`,
        DESCRIPTION:
          'Remove the asset from all current collections and relocate it exclusively to the selected one.',
      },
      CHECKBOX_LABEL: "Don't show it again",
      OK_TEXT: 'Confirm',
      CANCEL_TEXT: 'Cancel',
    },
    VIDEO_ERRORS: {
      TITLE: 'Error',
      SOMETHING_WENT_WRONG: {
        TITLE: 'Something went wrong',
        TEXT: `<p>Please try again. Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.</p>`,
      },
      UNABLE_TO_PROCESS:
        'Sorry, your cloud storage does not allow us to process this type of file. Please try to open it in your storage web interface.',
      NO_PERMISSION_TO_ACCESS:
        "Sorry, you don't have permission to access this video.",
      MAX_PLAYBACKS_EXCEEDED:
        'Sorry, video cannot be played because the maximum number of views has been exceeded.',
      OK_TEXT: 'Ok',
      CANCEL_TEXT: '',
    },
    DISALLOW_COLLECTION: {
      TITLE: 'Change permissions',
      TEXT:
        'You are about to change permissions for collection. Please note that some assets from this collection will be still available in the Lightboards of your teammates.',
      OK_TEXT: 'Continue',
      CANCEL_TEXT: 'Cancel',
    },
    ASSIGN_ROLE_WARNING: {
      TITLE: 'Change roles',
      TEXT:
        'You are about to change the role of your teammate. As a result his permissions on some collections will change. But, please note that some assets within these collections will be still available in the Lightboards of your teammate.',
      TEXT_MULTIPLE:
        'You are about to change the roles of your teammates. As a result, their permissions on some collections will change.',
      OK_TEXT: 'Confirm',
      CANCEL_TEXT: 'Cancel',
    },
    CAPTCHA: {
      TITLE: 'Suspicious traffic from your network',
      TEXT: (text) => `Our system has detected an unusual traffic from your network. Please pass our robot test to prove that you are a human. Solve the following puzzle: ${text}.`,
      OK_TEXT: 'Confirm',
    },
    CAPTCHA_ERROR: {
      TEXT: 'Please try again later',
    },
    FILE_TO_LARGE: {
      TITLE: 'File upload limit',
      TEXT: (maxSize, currentSize) => `The maximum upload file size is <strong>${maxSize}</strong>.<br/> The size of the file you are uploading is <strong>${currentSize}</strong>.<br/>Please reduce the file size and upload it again.`,
      TEXT_IN_GENERAL:
        'Maximum file size exceeded.<br/>Please reduce the file size and upload it again.',
    },
    CANNOT_UPLOAD_FILE: 'Cannot upload file',
    INVALID_FILE_TYPE: {
      TITLE: 'File format is invalid',
      TEXT: (extension) => `You can upload the files in the following formats: .jpeg, .jpg, .png, .gif. The file you are uploading is in ${extension} format. Please use the supported file format and try again.`,
      TEXT_IN_GENERAL:
        'File format is invalid.<br/> Please use supported file format and try again.',
    },
    ASSETS_LIMIT: {
      TITLE: 'Assets limit during trial exceeded',
      TEXT:
        'You’ve reached a 50 000 assets limit on a trial period. You can purchase a subscription to upload as many assets as you need.',
    },
    DOWNLOAD_CONSENT: {
      TITLE: (title) => title,
      TEXT: (text) => text,
      LABEL: "Don't show again",
      OK_TEXT: 'Confirm',
      CANCEL_TEXT: 'Reject',
    },
    UNDERSTAND: 'I understand',
    CANCEL: 'Cancel',
    EDIT: 'Edit',
    DOWNLOAD_ASSETS_QUANTITY_LIMITATIONS: {
      TITLE: 'Too many files',
      TEXT: (countLimit) => `More than ${countLimit} files are selected for download. Please unselect a few files and try again.`,
    },
    DOWNLOAD_ASSETS_SIZE_LIMITATIONS: {
      TITLE: 'Archive size limit exceeded',
      TEXT: (sizeLimit) => `You have created an archive exceeding ${sizeLimit}. Unselect a few assets in your selection and try downloading again.`,
    },
    DOWNLOAD_COLLECTION_EMPTY: {
      TITLE: 'Download is not possible',
      TEXT: 'Collection is empty. Download is not possible.',
    },
    DOWNLOAD_COLLECTION_RESTRICTED: {
      TITLE: 'Download is restricted',
      TEXT:
        'You do not have permissions to download assets from these collections. Please contact your team managers for support.',
    },
    DOWNLOAD_COLLECTION_LIMITED: {
      TITLE: 'Limited download permissions',
      TEXT:
        'Some assets within these collections are restricted for download. Please check your download permissions and try again or continue without these assets.',
      OK_TEXT: 'Continue',
      CANCEL_TEXT: 'Discard',
    },
    SELECT_COLLECTION: {
      TITLE: 'Select collection to restore',
      OK: 'Confirm',
      CANCEL: 'Cancel',
    },
    UPLOAD_KEYWORDS_PERMISSION: {
      TITLE: 'No permission for keywords',
      TEXT:
        'You do not have a permission to manage keywords fields. Contact the team manager, if you need this permission.',
      OK_TEXT: 'Ok',
    },
    ARCHIVE_COLLECTION_DIALOG: {
      TITLE: 'Confirm archiving',
      TEXT: (name, websites) => `You are about to archive the following items: <span class="highlight">${name}</span> with all the nested collections and assets. <br/> This action requires confirmation. ${
        websites.length
          ? `<br/><br/> <span class="highlight">Attention!</span> This operation will also remove the website: ${websites.map(
            (website) => `<br/> <a href='${website}' target='_blank'>${website}</a>`,
          )}`
          : ''
      }`,
      OK: 'Confirm',
      CANCEL: 'Cancel',
    },
    UNARCHIVE_COLLECTION_DIALOG: {
      TITLE: 'Confirm unarchiving',
      TEXT: (name, parentNames) => `You are about to unarchive the following items: <span class="highlight">${name}</span> with all the nested collections and assets. <br/> This action requires confirmation. ${
        parentNames.length
          ? `<br/><br/> <span class="highlight">Attention!</span> The following parent collection(s) will be also unarchived: <span class="highlight">${parentNames}</span>`
          : ''
      }`,
      OK: 'Confirm',
      CANCEL: 'Cancel',
    },
    ARCHIVE_ASSET_DIALOG: {
      TITLE: 'Confirm archiving',
      TEXT: (name, link) => `You are about to archive the following items: <span class="highlight">${name}</span>. <br/> This action requires confirmation. ${
        link
          ? `<br/><br/> <span class="highlight">Attention!</span> After this operation, the asset will become inaccessible via the following link: <a href="${link}" target="_blank">${link}</a>`
          : ''
      }`,
      OK: 'Confirm',
      CANCEL: 'Cancel',
    },
    ARCHIVE_ASSETS_DIALOG: {
      TITLE: 'Confirm archiving',
      TEXT: (assets, count, sharedAssets) => `You are about to archive the following items: ${assets}${
        count > 0 ? ` and <span class="highlight">${count}</span> more.` : '.'
      } <br/> This action requires confirmation. ${
        sharedAssets.length
          ? `<br/><br/> <span class="highlight">Attention!</span> Some assets from those you want to archive are shared. After this operation, they will become inaccessible via the following links: ${sharedAssets.map(
            (link) => `<br/> <a href='${link}' target='_blank'>${link}</a>`,
          )}`
          : ''
      }`,
      OK: 'Confirm',
      CANCEL: 'Cancel',
    },
    ARCHIVE_ALL_ASSETS_DIALOG: {
      TITLE: 'Confirm archiving',
      TEXT: (collectionName) => `You are going to archive all assets in the <span class=""highlight"">${collectionName}</span> collection. <br/> Do you want to archive the <span class=""highlight"">${collectionName}</span> collection?`,
      OK: 'Confirm',
      CANCEL: 'Cancel',
    },
    UNARCHIVE_ASSETS_DIALOG: {
      TITLE: 'Confirm unarchiving',
      TEXT: (assets, count) => `You are about to unarchive the following items: ${assets}${
        count > 0 ? ` and <span class="highlight">${count}</span> more.` : '.'
      } <br/> This action requires confirmation.`,
      OK: 'Confirm',
      CANCEL: 'Cancel',
    },
    UNARCHIVE_ALL_ASSETS_DIALOG: {
      TITLE: 'Confirm unarchiving',
      TEXT: (collectionName) => `You are going to unarchive all assets in the <span class=""highlight"">${collectionName}</span> collection. Do you want to unarchive the <span class=""highlight"">${collectionName}</span> collection?`,
      OK: 'Confirm',
      CANCEL: 'Cancel',
    },
    UNARCHIVE_ASSETS_TO: {
      TITLE: 'Select collection to restore to',
      OK: 'Restore',
      CANCEL: 'Cancel',
    },
    TEAMMATE_ARCHIVED_COLLECTION: {
      TITLE: 'Collection archived',
      TEXT: (initiator, name) => `${initiator} archived the <span class="highlight">${name}</span> collection.`,
    },
    TEAMMATE_UNARCHIVED_COLLECTION: {
      TITLE: 'Collection unarchived',
      TEXT: (initiator, name) => `${initiator} unarchived the <span class="highlight">${name}</span> collection.`,
    },
    TEAMMATE_DELETED_ARCHIVED_COLLECTION: {
      TITLE: 'Collection deleted',
      TEXT: (initiator, name) => `${initiator} deleted the <span class="highlight">${name}</span> collection.`,
    },
    TEAMMATE_ARCHIVED_ASSET: {
      TITLE: 'Asset archived',
      TEXT: (initiator, name) => `${initiator} archived the <span class="highlight">${name}</span> asset.`,
    },
    TEAMMATE_UNARCHIVED_ASSET: {
      TITLE: 'Asset unarchived',
      TEXT: (initiator, name) => `${initiator} unarchived the <span class="highlight">${name}</span> asset.`,
    },
    ASSETS_LIMIT_APP: {
      TITLE: 'Assets limit reached',
      TEXT: (assetsLimit, isTrialUser = false) => `You have reached a ${assetsLimit} assets limit for ${
        isTrialUser ? 'a trial period' : 'your plan'
      }. To continue adding more assets, consider subscribing to one of our plans on Billing page.`,
      TEXT_OK: 'Go to Billing',
    },
    ASSETS_LIMIT_INBOX: {
      TITLE: 'Inbox has reached files limit',
      TEXT: () => 'The inbox has reached its limit. You can notify its owner so they address this issue.',
      TEXT_OK: 'Notify inbox owner',
      TEXT_CANCEL: 'Cancel',
      TEXT_SUCCESS: 'Notification sent to the inbox owner',
    },
    ROLES_LIMIT_APP: {
      TITLE: 'Roles limit reached',
      TEXT: (rolesLimit, isTrialUser = false) => `You have reached ${rolesLimit} roles limit for ${
        isTrialUser ? 'a trial period' : 'your plan'
      }. To continue adding more roles, consider subscribing to one of our plans on Billing page.`,
      TEXT_OK: 'Go to Billing',
    },
    KEYWORDS_MERGE: {
      TITLE: 'Choose merge-to keyword.',
      OK: 'Merge',
      CANCEL: 'Cancel',
    },
    KEYWORDS_MERGE_ALL_SELECTED: {
      TITLE: "Can't merge keywords",
      TEXT:
        'To merge a keyword, at least one other keyword must be unselected. Try deselecting one or more keywords and repeat the operation.',
      OK: 'Ok',
    },
    KEYWORDS_MERGE_CONFIRM: {
      TITLE: (count) => `Merge ${pluralize('keyword', count)}`,
      TEXT: (count) => `You're going to merge ${pluralize(
        'keyword',
        count,
      )}. The operation is not reversible. Continue?`,
      OK: 'Merge',
      CANCEL: 'Cancel',
    },
    KEYWORDS_NOT_IN_ROOT: {
      TITLE: (count) => `Merge ${pluralize('keyword', count)}`,
      TEXT: (keywords) => `Merging is possible only for keywords that are not sub-keywords of other keywords. The following keywords are sub-keywords: ${keywords} <br/> By continuing this merge process, you merge all selected keywords except the above mentioned.<br/>`,
      OK: 'Continue',
      CANCEL: 'Cancel',
    },
    KEYWORDS_MERGE_ONLY_ROOT: {
      TITLE: (count) => `Merge ${pluralize('keyword', count)}`,
      TEXT:
        'Only root-keywords merge is possible. All of the selected keywords are attached to other keywords. Detach them and try merging again.',
      OK: 'Ok',
    },
    KEYWORDS_DELETE_LIMIT: {
      TITLE: (count) => `Delete ${count} ${pluralize('keyword', count)}`,
      TEXT: (limit) => `It is not possible to delete more than <span class="highlight">${limit}</span> keywords in one batch due to processing speed limitations.<br />Select fewer keywords and try again.`,
      CANCEL: 'Ok',
    },
    KEYWORDS_DELETE: {
      TITLE: (count, isDeleteAll) => `Delete ${isDeleteAll ? 'ALL' : ''} ${pluralize('keyword', count)}${
        isDeleteAll ? '?' : ''
      }`,
      TEXT: (name, count, isParent) => (
        <>
          <Choose>
            <When condition={name}>
              You're about to delete <span className="highlight">{name}</span>.
              This action cannot be undone and will remove this keyword from all
              assets it's added to.
            </When>
            <Otherwise>
              You're about to delete{' '}
              <span className="highlight">
                {pluralize('keyword', count, true)}
              </span>
              . This action cannot be undone and will remove these keywords from
              all assets it's added to.
            </Otherwise>
          </Choose>
          <If condition={isParent}>
            <br />
            <br />
            <InfoBlock>
              To delete the parent keyword without affecting nested
              sub-keywords, move it out of the hierarchy by dragging it to the
              root level,then delete it as a separate keyword
            </InfoBlock>
          </If>
        </>
      ),
      OK: 'Delete',
      CANCEL: 'Cancel',
    },
    PRODUCT_TYPE_DELETE: {
      TITLE: (title) => `Delete ${title}?`,
      TEXT: () => (
        <>
          <p>This product type will be permanently removed from your list.</p>
          <ul className="p-l-15">
            <li>
              <strong className="f-w-5 white-text">Master &amp; Draft layers:</strong>{' '}
              The product type will be cleared on all associated products.
            </li>
            <li>
              <strong className="f-w-5 white-text">Published layers:</strong>{' '}
              The product type will remain visible on live channels.
            </li>
          </ul>
          <p>This action cannot be undone.</p>
        </>
      ),
      OK: 'Delete',
      CANCEL: 'Cancel',
    },
    PRODUCT_TYPE_RENAME: {
      TITLE: (oldTitle, newTitle) => `Rename "${oldTitle}" to "${newTitle}"?`,
      TEXT: 'The product type name will be updated in your list. For any associated products, this field will be updated on Master and Draft layers, but will remain unchanged on Published layers.',
      OK: 'Rename',
      CANCEL: 'Cancel',
    },
    PRODUCT_VENDOR_DELETE: {
      TITLE: (title) => `Delete ${title}?`,
      TEXT: () => (
        <>
          <p>This vendor will be permanently removed from your list.</p>
          <ul className="p-l-15">
            <li>
              <strong className="f-w-5 white-text">Master &amp; Draft layers:</strong>{' '}
              The vendor field will be cleared on all associated products.
            </li>
            <li>
              <strong className="f-w-5 white-text">Published layers:</strong>{' '}
              The vendor will remain visible on live channels.
            </li>
          </ul>
          <p>This action cannot be undone.</p>
        </>
      ),
      OK: 'Delete',
      CANCEL: 'Cancel',
    },
    PRODUCT_VENDOR_RENAME: {
      TITLE: (oldTitle, newTitle) => `Rename "${oldTitle}" to "${newTitle}"?`,
      TEXT: 'The vendor name will be updated in your list. For any associated products, this field will be updated on Master and Draft layers, but will remain unchanged on Published layers.',
      OK: 'Rename',
      CANCEL: 'Cancel',
    },
    RESTRICTED_ASSET_DETECTED: {
      TITLE: 'Restricted asset detected',
      TEXT:
        'Please note that you are about to make the restricted assets public and shared. Are you sure you want to continue?',
      BTN_OK: 'Ok',
      BTN_CANCEL: 'Cancel',
    },
    CHANGE_IMAGE_ORDER: {
      TITLE: 'Reorder this media?',
      TEXT: () => (
        <>
          You are about to update the display order of the product's media.
          Changing the order places the selected media in the required position,
          shifting the others to new positions.
          <div className="reorderInfo">
            <Icon size="md">
              <Info />
            </Icon>
            To set a new main image, move it to the first position.
          </div>
        </>
      ),
      textBtnOk: 'Confirm',
      textBtnCancel: 'No',
      checkboxLabel: "Don't show it again",
    },
    ASSET_TARGETS: {
      TITLE_ATTACH: 'Choose where to attach media',
      SUBTITLE: () => (
        <>
          Select product galleries or specific variants.
          {' '}<br />
          <b>Note:</b>
          {' '}
          Replaced variant media isn't deleted, it is moved to the product gallery.
        </>
      ),
      MASTER_BADGE: 'Master',
      MASTER_GALLERY: 'Master product gallery',
      LISTING_GALLERY: (channelLabel) => `${channelLabel} product gallery`,
      MODE_DRAFT: 'Draft',
      MODE_PUBLISH: 'Published',
      MODE_PUBLISH_DISABLED_TOOLTIP: "This listing hasn't been published yet.",
      LISTING_VARIANT_ONE_ASSET: 'Select one asset to attach to a listing variant',
      SELECT_TARGET_TOOLTIP: 'Select at least one target',
      LOADING_PRODUCT: 'Loading product details...',
      BTN_ATTACH: 'Attach media',
      BTN_CANCEL: 'Cancel',
    },
    ERROR_CREATING_THUMBNAIL: `Cannot create custom thumbnail.<br> Please try again later or contact <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}<a>.`,
    ADD_ASSETS_FROM_URLS: {
      TITLE: 'Add assets from URLs',
      TOTAL: 'Total URLs',
      LABEL:
        'Only publicly shared links can be displayed within your library as external links. Make sure that a link you’re about to paste here is shared and not private.',
      PLACEHOLDER: 'Paste URL with "https://" here',
      OK: 'Add',
      CANCEL: 'Cancel',
    },
    WARNING_ADDON_UPGRADE: {
      TITLE: 'Upgrade subscription with add-on',
      TEXT: (name, count) => `You are about to add <b>${pluralize(
        name,
        count,
        true,
      )}</b> to your subscription.`,
      OK: 'Upgrade',
      CANCEL: 'Cancel',
    },
    PUBLISH_WEBSITE: {
      TITLE: 'Publish website',
      TEXT: 'Select one of the available presets or create new custom settings',
      PUBLISH: 'Publish',
      CANCEL: 'Cancel',
      CONTINUE: 'Continue',
      DEFAULT_PRESET: 'Create custom settings for publishing',
      CHECKBOX_LABEL: 'Skip this step next time',
      SPINNER: 'Loading presets...',
    },
    SAVE_PRESET: {
      TITLE: 'Save preset',
      TEXT: 'Create name for new preset',
      OK: 'Save',
      INPUT_LABEL: 'Name new preset',
      INPUT_PLACEHOLDER: 'Type preset name',
      INPUT_ERROR: 'This name is already used!',
    },
    DELETE_PRESET: {
      TITLE: 'Delete preset',
      TEXT: (name) => `You are about to delete <b>preset<b><br><br><b>${name}<b>`,
      OK: 'Delete',
    },
    RENAME_PRESET: {
      TITLE: 'Rename preset',
      OK: 'Save',
      INPUT_LABEL: 'Preset name',
      INPUT_PLACEHOLDER: 'Type preset new name',
      INPUT_ERROR: 'This name is already used!',
    },
    APPLY_PRESET: {
      TITLE: 'Switch to another preset',
      TEXT:
        'You are about to apply new preset. Your previous settings will be lost.',
      OK: 'Continue',
    },
    RESTORE_ASSETS: {
      title: (count) => `Restore asset${count > 1 ? 's' : ''}`,
      text: (count) => `You are about to restore ${
        count > 1 ? `${count} deleted assets` : 'a deleted asset'
      }. Select the location for restoration`,
      previousCollectionRadioLabel: 'Restore to previous collection(s)',
      selectCollectionRadioLabel: 'Select collection(s) to restore',
    },
    REMOVE_FROM_COLLECTIONS: {
      TITLE: 'Remove from collection',
      TEXT: (name) => (
        <>
          The asset <span className="highlight">{name}</span> is added to the
          following collections:
        </>
      ),
      TEXT_NO_COLLECTIONS: "The asset doesn't belong to any collection",
      INFO_BLOCK:
        'If you would like to entirely delete it from the library, use “Move to trash” instead',
      CHECKBOX:
        "Don't show this window and remove assets from selected collection only next time",
      OK: 'Remove from all collections',
      CANCEL: 'Close',
    },
    REMOVE_FROM_ALL_COLLECTIONS: {
      TITLE: 'Remove from all collections',
      TEXT: (name) => (
        <p>
          You are about remove <span className="highlight">{name}</span> asset
          from all collections and moved it to root collection
        </p>
      ),
      OK: 'Confirm',
      ERROR: `Cannot remove all collections from the asset.<br> Please try again later or contact <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}<a>.`,
    },
    GENERATING_DESCRIPTION_UNSUPPORTED: {
      title: 'Unsupported Assets Detected',
      text:
        'Some non-image items were detected in the current selection and will not be processed. Image Captioning works only with image assets.  Your AI asset processing limit will remain unaffected.',
      textError:
        'All selected assets have unsupported format and cannot be sent to processing by our AI.',
      TEXT_OK: 'Ok',
    },
    GENERATING_DESCRIPTION_CHOOSE_OPTION: {
      title: 'Update Your Asset Description',
      text:
        'Our AI can help enhance your asset descriptions. Choose how you want to proceed:',
      margeDescriptionLabel:
        'Combine the existing description with the new AI-generated content',
      replaceDescriptionLabel:
        'Replace the existing description entirely with the new AI-generated text',
      okName: 'Confirm',
      cancelName: 'Cancel',
      checkboxLabel: 'Don’t show it again',
    },
    DETACH_SEVERAL_KEYWORDS: {
      TITLE: 'Confirm Keyword Removal',
      TEXT: (keywordCount, assetCount) => (
        <>
          You are about to remove {keywordCount} keywords from {assetCount}{' '}
          selected {pluralize('asset', assetCount)}.<br />
          Are you sure you want to proceed?
        </>
      ),
      CHECKBOX: "Don't show it again",
    },
    RETRY_IMPORT_ASSETS: {
      TITLE: 'Retry Import',
      TEXT:
        'It looks like some other assets in this collection also failed to import. You can either retry importing just this asset or attempt to import all failed assets in the collection.',
      RADIO_LABEL_ONE: 'Retry This Asset',
      RADIO_LABEL_ALL: 'Retry All Failed Assets',
    },
    ERROR_ADD_MEDIA_TO_PRODUCT: {
      TITLE: 'Error adding media to product',
      TEXT_UNSUPPORTED_FORMAT: () => (
        <>
          <p>
            The system encountered the following error while trying to associate
            the selected media with your products:
          </p>
          <p>
            <span className="highlight">Unsupported File Format</span>
          </p>
          <p>Please ensure that:</p>
          <p>
            - Images are in <span className="highlight">JPEG</span>,{' '}
            <span className="highlight">PNG</span>,{' '}
            <span className="highlight">WEBP</span>,{' '}
            <span className="highlight">HEIC</span>, and{' '}
            <span className="highlight">GIF</span> formats.
            <br />- Videos are <span className="highlight">MOV</span>,{' '}
            <span className="highlight">MP4</span>, and{' '}
            <span className="highlight">WEBM</span> or embedded from YouTube or
            Vimeo.
            <br />- 3D Models are in <span className="highlight">
              GLB
            </span> or <span className="highlight">USDZ</span> formats.
            <br />
          </p>
          <p>
            For more details on file size limits and supported formats, visit
            our{' '}
            <a
              className="picsioLink"
              href="https://help.toriut.com"
              target="_blank"
              rel="noreferrer"
            >
              Help Center
            </a>{' '}
            for a full guide on media asset requirements.
          </p>
        </>
      ),
      TEXT_UNSUPPORTED_FILE_SIZE: () => (
        <>
          <p>
            The system encountered the following error while trying to associate
            the selected media with your products:
          </p>
          <p>
            <strong>File size exceeds the supported limit</strong>
          </p>
          <p>Please ensure that:</p>
          <p>
            - Images are no larger than{' '}
            <span className="highlight">4472 x 4472 px</span>,{' '}
            <span className="highlight">20MP</span> or{' '}
            <span className="highlight">20 MBs</span>.<br />- Videos are no
            longer than <span className="highlight">10 minutes</span> and under{' '}
            <span className="highlight">1 GB</span> in size.
            <br />- 3D Models are in <span className="highlight">
              GLB
            </span> or <span className="highlight">USDZ</span> formats, and
            under 500 MB.
            <br />
          </p>
          <p>
            For more details on file size limits and supported formats, visit
            our{' '}
            <a
              className="picsioLink"
              href="https://help.toriut.com"
              target="_blank"
              rel="noreferrer"
            >
              Help Center
            </a>{' '}
            for a full guide on media asset requirements.
          </p>
        </>
      ),
      TEXT_UNSUPPORTED_FORMAT_AND_FILE_SIZE: () => (
        <>
          <p>
            The system encountered the following error while trying to associate
            the selected media with your products:
          </p>
          <p>
            <span className="highlight">
              File size exceeds the supported limit + Unsupported file format
            </span>
          </p>
          <p>Please ensure that:</p>
          <p>
            - Images are in <span className="highlight">JPEG</span>,{' '}
            <span className="highlight">PNG</span>,{' '}
            <span className="highlight">WEBP</span>,{' '}
            <span className="highlight">HEIC</span>,{' '}
            <span className="highlight">GIF</span> formats and no larger than{' '}
            <span className="highlight">4472 x 4472 px</span>,{' '}
            <span className="highlight">20MP</span> or{' '}
            <span className="highlight">20 MBs</span>.<br />- Videos are{' '}
            <span className="highlight">MOV</span>,{' '}
            <span className="highlight">MP4</span>,{' '}
            <span className="highlight">WEBM</span> or hosted on YouTube/Vimeo,
            less than <span className="highlight">10 minutes</span> and under{' '}
            <span className="highlight">1 GB</span>.<br />- 3D Models are{' '}
            <span className="highlight">GLB</span> or{' '}
            <span className="highlight">USDZ</span> formats, and under{' '}
            <span className="highlight">500 MB</span>.<br />
          </p>
          <p>
            For more details on file size limits and supported formats, visit
            our{' '}
            <a
              className="picsioLink"
              href="https://help.toriut.com"
              target="_blank"
              rel="noreferrer"
            >
              Help Center
            </a>{' '}
            for a full guide on media asset requirements.
          </p>
        </>
      ),
    },
    MIGRATION_ASSISTANCE: {
      title: 'Manual Migration Assistance',
      titleForDAM: 'Assisted Migration from a DAM Platform',
      getContent: (cloudName) => (
        <Choose>
          <When condition={cloudName === 'an external DAM provider'}>
            <>
              <p>
                Importing from external DAM systems requires manual help at this
                stage.
              </p>
              <p>
                Our team can help you migrate your files, including asset
                transfer, metadata mapping, and folder structure replication.
              </p>
              <p>
                Would you like to start the process by chatting with support?
              </p>
              <br />
            </>
          </When>
          <Otherwise>
            <>
              <p>
                ‘Import from {cloudName}’ feature isn’t fully implemented in the
                app yet. However, our support team can assist you in completing
                this migration manually.
              </p>
              <p>
                Would you like to proceed and open a chat with our support team
                to get started?
              </p>
              <br />
            </>
          </Otherwise>
        </Choose>
      ),
      textBtnOk: 'Proceed to chat',
      getMessage: (cloudName) => `Hi, I'd like to import my data from ${cloudName} to ${appName}. Could you guide me through the process?`,
    },
    BULK_CDN_PUBLISH: {
      title: 'Bulk publish to CDN',
      text: (
        <div>
          <div>
            You are about to process the selected assets to publish to CDN.
          </div>
          <br />
          <div>
            Some assets in your selection{' '}
            <span className="f-w-5">may not be compatible</span> to publish.
            Only supported assets will be processed, while
            <span className="f-w-5">
              {' '}
              unsupported file types will be skipped.
            </span>
          </div>
          <br />
          <div>
            This operation will run in the background, and changes may take some
            time to appear.
          </div>
          <br />
          <InfoBlock>
            <span>
              Publish to CDN functionality is in beta now. Only supported{' '}
              <b>.jpg, .jpeg, .png, .bmp, .svg, .webp.</b> More info in our help
              center article
            </span>
          </InfoBlock>
          <br />
        </div>
      ),
      textBtnCancel: 'Cancel',
      textBtnOk: 'Confirm',
      checkboxLabel: 'Don’t show it again',
    },
    CDN_OVERWRITE_REVISION: {
      checkboxLabel: 'Don’t show it again',
      title: 'CDN Content Update',
      text: (
        <div>
          <div>This asset is already published through a CDN link.</div>
          <div>
            Uploading a new revision will <b>set it as the current version</b>,
            and the same link will start serving the new file after cache
            refresh
            <br /> (≈ 15 min).
          </div>
          <br />
          <div>
            If you need the link to keep showing the existing content, either:
          </div>
          <div>
            <ul>
              <li>upload this file as a separate asset, or</li>
              <li>
                upload the revision first and then switch the previous revision
                back to current.
              </li>
            </ul>
          </div>
        </div>
      ),
      textBtnOk: 'Ok',
    },
    BULK_CDN_UNPUBLISH: {
      title: 'Unpublish from CDN',
      text: (
        <div>
          <div>
            You are about to unpublish selected assets from CDN. After this
            action, the{' '}
            <span className="f-w-5">CDN links will become inactive</span>
          </div>
          <br />
          <div>Would you like to proceed?</div>
        </div>
      ),
      textBtnCancel: 'Cancel',
      textBtnOk: 'Confirm',
      checkboxLabel: 'Don’t show it again',
    },
    BULK_CDN_PUBLISH_LIMIT: {
      title: 'Bulk publish to CDN',
      text:
        'Currently you can publish only 200 assets at once. Please select fewer assets and try again.',
      textBtnCancel: 'Cancel',
      textBtnOk: 'Confirm',
      checkboxLabel: 'Don’t show it again',
    },
    BULK_SAS_UNPUBLISH: {
      title: 'Unpublish',
      text: (
        <div>
          <div>
            You are about to unpublish selected assets. After this action, the{' '}
            <span className="f-w-5">shared links will become inactive</span>
          </div>
          <br />
          <div>Would you like to proceed?</div>
        </div>
      ),
      textBtnCancel: 'Cancel',
      textBtnOk: 'Confirm',
      checkboxLabel: 'Don’t show it again',
    },
    BULK_AI_PROCESSING: {
      title: 'Bulk AI Processing',
      text: (label) => (
        <div>
          <div>
            Analyze selected assets to enrich them with{' '}
            <span className="f-w-5"> {label}.</span>
          </div>
          <br />
          <div>
            Some assets in your selection{' '}
            <span className="f-w-5">may not be compatible</span> with certain AI
            services. Only supported assets will be processed, while
            <span className="f-w-5">
              {' '}
              unsupported file types will be skipped.
            </span>
          </div>
          <br />
          <div>
            This operation will run in the background, and changes may take some
            time to appear.
          </div>
          <br />
          <InfoBlock>
            <div>
              AI processing will not be applied to unsupported file formats, and
              your AI processing balance will not be deducted for these skipped
              files.
            </div>
            <br />
            <div>
              If the number of selected assets isn’t covered by your available
              processing limit, we’ll automatically upgrade you to the next AI
              Tier to complete operations.
            </div>
          </InfoBlock>
        </div>
      ),
      textBtnCancel: 'Cancel',
      textBtnOk: 'Confirm',
      checkboxLabel: 'Don’t show it again',
    },
    BULK_AI_PROCESSING_LIMIT_REACHED: {
      title: 'Al Processing Limit Reached',
      text: (
        <div>
          You reached the limit of assets / minutes available for Al processing.
          Click "Subscribe" below to add the <span>Al Kit</span> to your plan
          and continue using Face Recognition, Transcription, Al Keywording, and
          Image Captioning.
        </div>
      ),
      textBtnOk: 'Subscribe',
    },
    BILLING_ACCESS_REQUIRED: {
      title: 'Billing Access Required',
      text: (adminRoles) => (
        <div>
          <span>
            You don’t have permission to manage billing settings. For
            billing-related changes, please contact your team\'s billing admins:
          </span>
          {adminRoles && <div>{adminRoles}</div>}
        </div>
      ),
      textBtnOk: 'Ok',
    },
    TEAM_ACCESS_REQUIRED: {
      title: 'Teammate Access Required',
      text: (adminRoles) => (
        <div>
          <span>
            You don’t have permission to manage team settings. For team-related
            changes, please contact your team's admins:
          </span>
          {adminRoles && <div>{adminRoles}</div>}
        </div>
      ),
      textBtnOk: 'Ok',
    },
    UPGRADE_AI_FEATURES: {
      TITLE: 'Upgrade to Use AI Features',
      TEXT: (
        <div>
          <span>
            The AI feature you’ve tried to use is part of our AI Kit add-on,
            which is available starting from the Micro plan. Upgrade to Micro or
            higher plans to enable:
          </span>
          <p className="f-w-6">Image Intelligence</p>
          <ul className="p-l-15">
            <li>
              Find assets instantly with auto-generated keywords and captions.
            </li>
            <li>Organize photos faster with AI-powered face recognition.</li>
            <li>
              Use Visual & Similar Images Search to find images by describing
              what’s in them.
            </li>
          </ul>
          <p className="f-w-6">Video & Audio Intelligence</p>
          <ul className="p-l-15">
            <li>
              Make your videos searchable with transcription and recognized
              on-screen text.
            </li>
            <li>
              Get more from video and audio with AI-generated keywords,
              chapters, actions, and video summary.
            </li>
          </ul>
          <div>
            You can activate{' '}
            <strong className="f-w-6">
              Image Intelligence, Video & Audio Intelligence
            </strong>
            , or <strong className="f-w-6">both</strong> for a complete AI
            experience.
          </div>
        </div>
      ),
      BTN_OK: 'Go to Billing',
      BTN_CANCEL: 'Not now',
    },
    UPGRADE_AI_KIT_TO_UNLOCK_NEW_FEATURES: {
      TITLE: 'Upgrade AI Kit to unlock new features',
      TEXT: (
        <div>
          <span>
            To use these features, you need the updated AI Kit add-on, available
            starting from the Micro plan. Upgrade your version to enable:
          </span>
          <p className="f-w-6">Image Intelligence</p>
          <ul className="p-l-15">
            <li>
              Find assets instantly with auto-generated keywords and captions.
            </li>
            <li>Organize photos faster with AI-powered face recognition.</li>
            <li>
              Use Visual & Similar Images Search to find images by describing
              what’s in them.
            </li>
          </ul>
          <p className="f-w-6">Video & Audio Intelligence</p>
          <ul>
            <li>
              Make your videos searchable with transcription and recognized
              on-screen text.
            </li>
            <li>
              Get more from video and audio with AI-generated keywords,
              chapters, actions, and video summary.
            </li>
          </ul>
          <div>
            You are using a <span className="f-w-6">legacy AI Kit</span>{' '}
            restricted to transcription only. Update to enable the new AI
            capabilities listed above.
          </div>
        </div>
      ),
      BTN_OK: 'Go to Billing',
      BTN_CANCEL: 'Transcribe',
      CHECKBOX_LABEL: 'Don’t show it again',
    },

    ADD_COLLECTION_FOR_VISUAL_SEARCH: {
      TITLE: 'Enable AI Search for This Collection',
      TEXT:
        "This will enable Similar Images Search and Visual Search for all compatible images in this collection. The action is permanent and will count toward your AI Kit tier's coverage.",
      BTN_OK: 'Index Collection',
    },
    ADD_COLLECTION_FOR_VISUAL_SEARCH_LIMIT_ERROR: {
      TITLE: 'Collection exceeds search coverage',
      TEXT:
        'This collection cannot be enabled for AI Search because its asset count exceeds the search coverage included in your current AI Kit tier. Upgrade your AI Kit tier to expand search coverage or choose a smaller collection to enable AI Search.',
      BTN_OK: 'Go to Billing',
    },
    SELECT_SHARING_METHOD: {
      TITLE: 'Select sharing method',
      ITEMS: [
        {
          key: 'website',
          icon: (
            <Icon size="xxxl">
              <Web />
            </Icon>
          ),
          text: 'Create shared collection',
          subtext: 'Single collection link',
          eventName: 'SharingMethodCreateSharedCollectionClicked',
          testId: 'create-shared-collection-option',
        },
        {
          key: 'sas',
          icon: (
            <Icon size="xxxl">
              <ShareList />
            </Icon>
          ),
          text: 'Share multiple assets',
          subtext: 'List of asset links',
          eventName: 'SharingMethodModalShareMultipleClicked',
          disabledTooltip: (
            <>
              You can share up to {picsioConfig.bulkShareAsSasAssetsLimit}{' '}
              assets at once.
              <br />
              Please select fewer items to continue.
            </>
          ),
          testId: 'share-multiple-assets-option',
        },
      ],
    },
    OVERDUE_INVOICE: {
      title: 'Your Pics.io subscription is about to expire',
      text: (dueDate) => `<p>Your current Pics.io invoice will become overdue on ${dueDate}.</p><p>Please complete the payment before this date to prevent suspension of access for your entire team. You can review and pay the invoice in your Billing section.</p>`,
      textBtnCancel: 'Cancel',
      textBtnOk: 'Go to Billing',
    },
    PRODUCT_DIALOGS: {
      CONNECT_CHANNEL: {
        TITLE: 'Choose what to sync',
        SUBTITLE: 'Select active variants to sync. At least one variant is required.',
        UPDATE_EXISTING: {
          TITLE: 'Choose what to update',
          SUBTITLE: 'Select the main product and any variants you want to update. Updating variants is optional.',
          SELECT_TARGET_TOOLTIP: 'Select the main product or at least one variant to continue.',
          BTN_CANCEL: 'Cancel',
          BTN_CONTINUE: 'Update',
        },
        BTN_CANCEL: 'Cancel',
        BTN_CONTINUE: 'Continue',
        ALREADY_LISTED: {
          TITLE: 'Overwrite existing draft?',
          TEXT: (channel) => `<span class="white-text f-w-5">${channel}</span> already has an active draft. Overwriting it will discard your unsaved changes and pull fresh data from the <span class="white-text f-w-5">Master</span> record.`,
          BTN_OK: 'Overwrite draft',
          BTN_CANCEL: 'Cancel',
        },
        ALREADY_LISTED_MULTIPLE: {
          TITLE: 'Overwrite existing drafts?',
          TEXT: (channels) => `The selected channels (<span class="white-text f-w-5">${channels}</span>) already have active drafts. Overwriting them will discard any unsaved changes and pull fresh data from the <span class="white-text f-w-5">Master</span> record.`,
          BTN_OK: 'Overwrite drafts',
          BTN_CANCEL: 'Cancel',
        },
        ALREADY_LISTED_PARTIAL: {
          TITLE: 'Existing drafts found',
          TEXT: (channels) => `Some of the selected channels (<span class="white-text f-w-5">${channels}</span>) already have active drafts. Overwriting will discard their unsaved changes and pull fresh data from the <span class="white-text f-w-5">Master</span> record.`,
          BTN_OK: 'Overwrite all',
          BTN_SKIP: 'Skip existing',
          BTN_CANCEL: 'Cancel',
        },
        CREATE_LISTING: {
          TITLE: 'Create listing?',
          TEXT: (channel) => `This product is not listed in ${channel} yet.`,
          BTN_CANCEL: 'Cancel',
          BTN_OK: 'Create staging',
        },
        CHANNEL_SELECT_TITLE: 'Select channels to sync',
        SETUP_PUBLISHING_SCOPE: {
          TITLE: 'Set up publishing scope',
          DESCRIPTION: 'Choose where to push your product data and specify exactly what should be updated on the storefronts.',
          TARGET_CHANNELS_TITLE: 'Target channels',
          DATA_TO_SYNCHRONIZE_TITLE: 'Data to synchronize',
          DRAFT_ACTION_LABEL: 'Draft',
          PUBLISHED_ACTION_LABEL: 'Published',
          NOT_PUBLISHED_YET: 'Not published yet',
          CONNECTION_LOST: 'Connection lost',
          CONNECTION_LOST_TOOLTIP:
            'Connection lost because the Toriut app was removed from this channel. Reconnect it in My Team → Channels.',
          EXISTING_DRAFT_WILL_BE_REPLACED: 'Existing draft will be replaced',
          EXISTING_LIVE_WILL_BE_REPLACED: 'Existing live listing will be replaced',
        },
        OVERRIDE_EXISTING_LABEL: 'Override existing data on channels if conflicts occur',
        BTN_PROCEED_TO_MEDIA: 'Proceed to media selection',
        SELECT_CHANNEL_TOOLTIP: 'Please select at least one target channel to proceed',
        SELECT_SCOPE_TOOLTIP: 'Select text attributes, media, or both to sync',
        SELECT_CHANNEL_AND_SCOPE_TOOLTIP: 'Please select at least one target channel to proceed; Select text attributes, media, or both to sync',
        SELECT_VARIANT_TOOLTIP: 'A product requires at least one active variant to be synced.',
        VARIANT_NOTE: 'Note: Syncing this variant will automatically add its parent product to the channel.',
        BTN_NEXT: 'Next',
        BTN_PREVIOUS: 'Previous',
        BTN_PROCEED: 'Proceed',
        BTN_OK: 'Publish directly',
        BTN_ADDITION_APPLY: 'Create draft',
        BTN_CREATE_DRAFT: 'Create draft',
        BTN_CONFIRM_MEDIA: 'Confirm media selection',
        BTN_CONFIRM_VARIANT_MEDIA: 'Confirm & proceed',
        SYNC_TO_CHANNEL_TITLE: (channel) => `Sync to ${channel}`,
        SYNC_TO_CHANNEL_DESCRIPTION: 'Prepare a draft for further editing, or push the product live immediately.',
        PUBLISHING_SCOPE: {
          TITLE: 'Select publishing scope',
          DESCRIPTION: 'Choose whether you want to synchronize product details, media assets, or both. Unselected data types will remain unchanged on the channel.',
          TEXT_ATTRIBUTES_TITLE: 'Text attributes',
          TEXT_ATTRIBUTES_DESCRIPTION: 'Titles, descriptions, SKUs, pricing, and custom text fields.',
          MEDIA_ATTRIBUTES_TITLE: 'Media attributes',
          MEDIA_ATTRIBUTES_DESCRIPTION: 'Main images, gallery videos, variant-specific photos, and Alt text.',
          MEDIA_NO_ASSETS_TOOLTIP: 'Attach at least one media asset to the product before syncing media.',
          EMPTY_SELECTION_TOOLTIP: 'Please select at least one data type to synchronize.',
        },
        CHOOSE_PUBLISHING_ACTION: {
          TITLE: 'Choose publishing action',
          DESCRIPTION: 'Prepare drafts for further editing, or push the product and media live immediately to your selected channels.',
          PUBLISH_DISABLED_TOOLTIP: 'Optimized media versions are currently being prepared. Direct publishing will be available once they are ready.',
        },
        MEDIA_VALIDATION: {
          STATUS_NEEDS_PREPARE:
            'Unsupported format — a Shopify-compatible version can be prepared',
          STATUS_THUMBNAIL_PROCESSING: 'Still being prepared for this channel',
          STATUS_THUMBNAIL_FAILED: 'Thumbnail preparation failed',
          STATUS_THUMBNAIL_MISSING: 'Missing a Shopify-compatible version',
          STATUS_UNSUPPORTED_MEDIA_TYPE: 'Unsupported by Shopify',
          CONFIRM_DISABLED_MEDIA_PROCESSING: (count) => (
            count > 1
              ? `${count} selected media files are still being prepared. Remove them or wait before publishing live.`
              : 'Selected media is still being prepared. Remove it or wait before publishing live.'
          ),
          CONFIRM_DISABLED_MEDIA_FAILED: (count) => (
            count > 1
              ? `${count} selected media files failed preparation and cannot be synced. Remove them to continue.`
              : 'Selected media failed preparation and cannot be synced. Remove it to continue.'
          ),
          CONFIRM_DISABLED_MEDIA_MISSING: (count) => (
            count > 1
              ? `${count} selected media files are missing a Shopify-compatible version. Remove them to continue.`
              : 'Selected media is missing a Shopify-compatible version. Remove it to continue.'
          ),
          CONFIRM_DISABLED_MEDIA_UNSUPPORTED: (count) => (
            count > 1
              ? `${count} selected media files are unsupported by Shopify. Remove them to continue.`
              : 'Selected media is unsupported by Shopify. Remove it to continue.'
          ),
        },
        PRODUCT_MEDIA: {
          TITLE_SINGLE: (channelLabel) => `Map product media to ${channelLabel}`,
          TITLE_MULTI: 'Map product media to channels',
          DESCRIPTION_SINGLE: (channelLabel) => `Select the media assets you want to synchronize for ${channelLabel}.`,
          DESCRIPTION_MULTI: 'Select the media assets you want to synchronize for each channel. Use the tabs below to configure them individually.',
          COUNTER: (selectedCount, totalCount, channelLabel) => `${selectedCount} of ${totalCount} selected for ${channelLabel}`,
          EMPTY_SELECTION_TOOLTIP: 'No media assets have been selected for sync. Please select at least one asset to proceed.',
        },
        VARIANT_MEDIA: {
          TITLE_SINGLE: (channelLabel) => `Map product media to variants on ${channelLabel}`,
          TITLE_MULTI: 'Map product media to variants',
          DESCRIPTION_SINGLE: 'Assign the selected media assets to specific variants. Variants without assigned images will default to using the main product media.',
          DESCRIPTION_MULTI: 'Assign media assets to specific variants. Use the tabs below to configure mappings for each channel individually.',
          COUNTER: (assignedCount, totalCount) => `${assignedCount} of ${totalCount} variants assigned`,
          COUNTER_TOOLTIP: 'Choose which assets to assign to variants for publishing or saving as a draft.',
          RESET_ALL: 'Reset all',
          NOT_ASSIGNED: 'Not assigned',
          ASSETS_ASSIGNED: (count) => `${count} ${pluralize('asset', count)} assigned`,
          VARIANT_PLACEHOLDER: 'Select variant',
          VARIANT_DISABLED_TOOLTIP: 'This variant is already assigned to another image',
          INCOMPLETE_TOOLTIP: 'Please assign media to all variants before proceeding.',
        },
        ALT_CONFLICTS: {
          TITLE: 'Resolve Alt text conflicts',
          DESCRIPTION: 'Shopify supports only one Alt text per asset within a listing. Choose which Alt text to use for the selected media.',
          SOURCE_PREFIX: 'Source:',
          SOURCE_PRODUCT: 'Product',
          NO_ALT_TEXT: 'No alt text',
          SOURCE_LABEL: (sourceLabels) => `Source: ${sourceLabels.join(', ')}`,
          INCOMPLETE_TOOLTIP: 'Choose an Alt text value for each media item before proceeding.',
          BTN_BACK: 'Back',
          BTN_CONFIRM: 'Apply & sync',
        },
        ALREADY_PUBLISHED: {
          TITLE: 'Update published listing?',
          TEXT: (channel) => `<span class="white-text f-w-5">${channel}</span> already has a published listing. This action will overwrite its current live data with values from the <span class="white-text f-w-5">Master</span> record.`,
          BTN_OK: 'Publish and overwrite',
          BTN_CANCEL: 'Cancel',
        },
        ALREADY_PUBLISHED_MULTIPLE: {
          TITLE: 'Update published listings?',
          TEXT: (channels) => `The selected channels (<span class="white-text f-w-5">${channels}</span>) already have published listings. Overwriting them will discard any unsaved changes and pull fresh data from the <span class="white-text f-w-5">Master</span> record.`,
          BTN_OK: 'Publish and overwrite',
          BTN_CANCEL: 'Cancel',
        },
        ALREADY_PUBLISHED_PARTIAL: {
          TITLE: 'Existing published listings found',
          TEXT: (channels) => `Some of the selected channels (<span class="white-text f-w-5">${channels}</span>) already have published listings. Overwriting them will replace their current live data with fresh data from the <span class="white-text f-w-5">Master</span> record.`,
          BTN_OK: 'Overwrite all',
          BTN_SKIP: 'Skip existing',
          BTN_CANCEL: 'Cancel',
        },
      },
      ADD_VARIANT_TO_CHANNEL: {
        BTN_ADD: 'Add to channel',
        TOOLTIP_DISABLED: 'Add the parent product to this channel first',
      },
      REMOVE_VARIANT_FROM_CHANNEL: {
        TITLE: (channelName) => `Remove draft variant from ${channelName}?`,
        TEXT: (channelName) => `Are you sure you want to remove this draft? This will permanently erase all unpublished changes for this variant in <span class="white-text f-w-5">${channelName}</span>. Your master data is not affected.`,
        LAST_DRAFT_VARIANT_NOTE: 'Note: Deleting the last draft variant will also remove its parent product draft from this channel.',
        BTN_OK: 'Delete draft',
        BTN_CANCEL: 'Cancel',
      },
      UNPUBLISH_VARIANT_FROM_CHANNEL: {
        TITLE: (channelName) => `Unpublish variant from ${channelName}?`,
        TEXT: (channelName) => `This will remove the live variant from your <span class="white-text f-w-5">${channelName}</span> storefront. Your unpublished draft and Master data for this variant will remain safely in Toriut.`,
        VARIANT_NOTE: 'Note: Unpublishing this variant will automatically unpublish its parent product from the channel.',
        BTN_OK: 'Unpublish from channel',
        BTN_CANCEL: 'Cancel',
      },
      STATE_LAYERS: {
        ACTIONS: {
          PUBLISH_TO_CHANNEL: 'Publish to channel',
          PROCESSING: 'Processing...',
          EDIT_ATTRIBUTES: 'Edit attributes',
          SAVING_CHANGES: 'Saving changes...',
          EDIT_ATTRIBUTES_TOOLTIP: 'Override Master-inherited values for this channel record only. Changes won\'t affect the Master Product or other channels.',
          OPEN_IN_SHOPIFY_ADMIN: 'Open in shopify admin',
          PUBLISH_DISABLED_MEDIA_PROCESSING: (count) => (
            count > 1
              ? `${count} media files are still being prepared for this channel. You can publish once processing is complete.`
              : 'Some media is still being prepared for this channel. You can publish once processing is complete.'
          ),
          PUBLISH_DISABLED_MEDIA_FAILED:
            'Some media could not be prepared for this channel. Fix or remove the failed media before publishing.',
          PUBLISH_DISABLED_MEDIA_MISSING:
            'Some media is missing a Shopify-compatible version. Prepare or remove it before publishing.',
          PUBLISH_DISABLED_MEDIA_UNSUPPORTED:
            'Some media cannot be published to this channel. Remove unsupported files before publishing.',
        },
        PUBLISH_FAILED: {
          TITLE: 'Publish failed',
          INTRO: 'We couldn\'t publish this listing because some fields have invalid values or missing mappings. Please review the details below and try again.',
          BTN_CANCEL: 'Cancel',
          BTN_OK: 'Ok',
          SINGLE_ERROR: (fieldName, detail) => (
            fieldName
              ? `Publish failed. "${fieldName}" does not meet Shopify validation rules. ${detail}`
              : detail
          ),
          ERROR_MAPPING: (fieldName, classNames = {}) => (
            <span className={classNames.errorText}>
              <span className={classNames.errorFieldName}>{fieldName}:</span>
              {' The mapped Shopify metafield is no longer available. Please update the channel mapping.'}
            </span>
          ),
          ERROR_VALIDATION: (fieldName, value, detail, classNames = {}) => (
            <span className={classNames.errorText}>
              <span className={classNames.errorFieldName}>{fieldName}:</span>
              {' Value '}
              <span className={classNames.errorValue}>{`"${value}"`}</span>
              {' '}
              {detail}
            </span>
          ),
        },
        PUBLISH_VARIANT_MEDIA_WARNING: {
          TITLE: 'Published with media warnings',
          INTRO: 'The product was published, but some variant images could not be attached to Shopify. Review the details below.',
          BTN_CANCEL: 'Close',
          BTN_OK: 'Ok',
        },
        STAGE_LAYER: {
          REMOVE_CHANGES: {
            TITLE: (channel) => `Remove from ${channel}?`,
            TEXT: (channel) => `All unsaved configurations will be permanently lost, and the <span class="white-text f-w-5">${channel}</span> tab will be removed for this product. Your <span class="white-text f-w-5">Master</span> data is not affected.`,
            TEXT_VARIANTS: (channel) => `All unsaved configurations and product variants will be permanently lost, and the <span class="white-text f-w-5">${channel}</span> tab will be removed for this product. Your <span class="white-text f-w-5">Master</span> data is not affected.`,
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Remove from channel',
          },
          REMOVE_DRAFT: {
            TITLE: (channel) => `Remove draft from ${channel}?`,
            TEXT: (channel) => `All unsaved configurations will be lost, and the <span class="white-text f-w-5">${channel}</span> tab will be removed for this product. Your <span class="white-text f-w-5">Master</span> data will not be affected.`,
            TEXT_VARIANTS: (channel) => `All unsaved configurations for this product and its variants will be lost. The <span class="white-text f-w-5">${channel}</span> tab will be removed. Your <span class="white-text f-w-5">Master</span> data will not be affected.`,
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Remove draft',
            BTN_OK_VARIANTS: 'Remove drafts',
          },
          DISCARD_DRAFT: {
            TITLE: 'Delete draft version?',
            TEXT: 'This will permanently erase all unpublished changes. The channel will revert to its current Published state.',
            TEXT_VARIANTS: 'This will permanently erase all unpublished changes for this product and its variants. The channel will revert to its current Published state.',
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Delete draft',
            BTN_OK_VARIANTS: 'Delete drafts',
          },
          CREATE_DRAFT_FROM_MASTER: {
            TITLE: 'Overwrite existing draft?',
            TEXT: (channel) => `<span class="white-text f-w-5">${channel}</span> already has an active draft. Overwriting it will discard your unsaved changes and pull fresh data from the <span class="white-text f-w-5">Master</span> record.`,
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Overwrite draft',
          },
          CREATE_DRAFT_FROM_PUBLISHED: {
            TITLE: 'Overwrite existing draft?',
            TEXT: (channel) => `<span class="white-text f-w-5">${channel}</span> already has an active draft. Overwriting it will discard your unsaved changes and pull fresh data from the <span class="white-text f-w-5">Published</span> record.`,
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Overwrite draft',
          },
          PUBLISH_CHANGES: {
            TITLE_SINGLE: 'Publish with unmapped fields?',
            TITLE_MULTI: (unmappedCount, totalCount) => `${unmappedCount} of ${totalCount} channels have unmapped fields`,
            DESCRIPTION: 'All required fields are mapped, so you can proceed. However, any unmapped custom fields will be skipped during this sync.',
            FULLY_MAPPED_SUMMARY: (count) => (
              count === 1
                ? '1 channel is fully mapped and ready.'
                : `${count} channels are fully mapped and ready.`
            ),
            UNMAPPED_FIELDS_COUNT: (count) => `${count} unmapped fields`,
            FIX_MAPPING: 'Fix mapping',
            BTN_CANCEL: 'Cancel',
            BTN_PROCEED: 'Proceed without mapping',
            DONT_SHOW_AGAIN: 'Don\'t show it again',
            FIX_MAPPING_ARROW: '→',
          },
          PUBLISH_CHANGES_LIVE_ACTIVE: {
            TITLE: (channel) => `Update published product on ${channel}?`,
            TEXT: (channel) => `This will overwrite the current published data on <span class="white-text f-w-5">${channel}</span> with your new draft changes. The store will be updated immediately.`,
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Publish updates',
          },
          PUBLISH_VARIANTS: {
            TITLE: 'Choose what to publish',
            SUBTITLE: 'Select at least one draft variant to publish this product. The list shows only variants currently in the Draft state for this channel.',
            SELECT_VARIANT_TOOLTIP: 'Select at least one variant to publish.',
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Publish selected',
          },
          PUBLISH_NEW_VARIANTS: {
            TITLE: 'Choose variants to publish',
            SUBTITLE: 'Select master variants to add to draft and publish. At least one variant is required.',
            UPDATE_EXISTING: {
              TITLE: 'Choose what to update',
              SUBTITLE: 'Select the main product and any variants you want to update. Updating variants is optional.',
              SELECT_TARGET_TOOLTIP: 'Select the main product or at least one variant to continue.',
              BTN_CANCEL: 'Cancel',
              BTN_OK: 'Update',
            },
            SELECT_VARIANT_TOOLTIP: 'Select at least one variant to publish.',
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Publish selected',
          },
          PUBLISH_VARIANT_TO_CHANNEL: {
            TITLE: 'Publish variant to channel?',
            TEXT: (channel) => `This will publish the selected variant to <span class="white-text f-w-5">${channel}</span>.`,
          },
        },
        LIVE_LAYER: {
          REMOVE_PRODUCT: {
            TITLE: (channel) => `Delete product from ${channel}?`,
            TITLE_VARIANTS: (channel) => `Delete product & variants from ${channel}?`,
            TEXT: (channel) => `This will permanently delete the live product from your <span class="white-text f-w-5">${channel}</span> storefront and remove the channel tab in Toriut. Your <span class="white-text f-w-5">Master</span> data remains safe.`,
            TEXT_WITH_STAGING: (channel) => `This will permanently delete the live product from your <span class="white-text f-w-5">${channel}</span> storefront. Your unpublished draft and <span class="white-text f-w-5">Master</span> data will remain safely in Toriut.`,
            TEXT_VARIANTS: (channel) => `This will permanently delete the live product and all its variants from your <span class="white-text f-w-5">${channel}</span> storefront. The channel tab will also be removed in Toriut. Your <span class="white-text f-w-5">Master</span> data remains safe.`,
            TEXT_VARIANTS_WITH_STAGING: (channel) => `This will permanently delete the live product and all its variants from your <span class="white-text f-w-5">${channel}</span> storefront. Your unpublished draft and <span class="white-text f-w-5">Master</span> data will remain safely in Toriut.`,
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Delete from channel',
          },
          REPLACE: {
            TITLE: 'Overwrite existing draft?',
            TEXT: (channel) => `<span class="white-text f-w-5">${channel}</span> already has an active draft. Overwriting it will discard your unsaved changes and pull fresh data from the <span class="white-text f-w-5">Published</span> record.`,
            BTN_CANCEL: 'Cancel',
            BTN_OK: 'Overwrite draft',
          },
        },
      },
      DELETE_VARIANT: {
        TITLE: 'Are you sure?',
        TEXT: (title) => `You are about to delete variant "${title}". This action cannot be undone.`,
        TEXT_WITH_CHANNELS: (title, channels) => `You are about to delete variant "${title}". It will also be removed from: ${channels.join(', ')}. This action cannot be undone.`,
        BTN_CANCEL: 'Cancel',
        BTN_OK: 'Delete',
      },
      DELETE_LISTING_VARIANT: {
        TITLE: 'Are you sure?',
        TEXT: (title) => `You are about to delete variant "${title}". This action cannot be undone.`,
        TEXT_LIVE: (title) => `You are about to delete variant "${title}". This will also remove it from Shopify. This action cannot be undone.`,
        BTN_CANCEL: 'Cancel',
        BTN_OK: 'Delete',
      },
      CREATE_MASTER_PRODUCT: {
        TITLE: 'Create master product',
        TITLE_LABEL: 'Product title*',
        SKU_LABEL: 'SKU*',
        STATUS_LABEL: 'Product status',
        TITLE_PLACEHOLDER: 'e.g., City Light Backpack',
        SKU_PLACEHOLDER: 'e.g., BKPK-CTY-001',
        BTN_CREATE: 'Create',
        BTN_CANCEL: 'Cancel',
        CREATE_DISABLED_TOOLTIP: 'Product title and SKU are required',
        TITLE_REQUIRED: 'Product title is required',
        SKU_REQUIRED: 'SKU is required',
        TITLE_DUPLICATE_WARNING: 'A product with this title already exists',
        SKU_DUPLICATE: 'SKU already exists',
        SUCCESS_TOAST: 'Master product created',
        TITLE_MAX_LENGTH: (max) => `Product title must be ${max} characters or fewer.`,
      },
      DELETE_MASTER_PRODUCT: {
        TITLE: 'Delete master product?',
        TEXT: (count) => `This product is currently linked to ${count} active channel${
          count === 1 ? '' : 's'
        }. Deleting it will permanently remove the master record from Toriut. Please choose how to handle the connected channels:`,
        TEXT_NO_CHANNELS:
          'This will permanently remove the master record from Toriut. This action cannot be undone.',
        RADIO_TORIUT_ONLY: 'Delete from Toriut only',
        RADIO_TORIUT_ONLY_DESCRIPTION: 'The product will remain on your channels but stop syncing',
        RADIO_TORIUT_AND_CHANNELS: 'Delete from Toriut and selected channels',
        RADIO_TORIUT_AND_CHANNELS_DESCRIPTION: 'Permanently removes the product from selected storefronts',
        BTN_CANCEL: 'Cancel',
        BTN_OK: 'Delete',
      },
      DELETE_MASTER_VARIANT: {
        TITLE: 'Delete master variant?',
        TEXT: (count) => `This variant is part of a product family published to ${count} active channel${
          count === 1 ? '' : 's'
        }. Deleting it will permanently remove it from Toriut. Please choose how to handle the connected channels:`,
        TEXT_NO_CHANNELS:
          'This will permanently remove this variant from Toriut. This action cannot be undone.',
        TEXT_WITH_CHANNELS: (title, channels) => `You are about to delete variant "${title}". It is the last live variant on: ${channels.join(', ')}. This action cannot be undone.`,
        LAST_LIVE_VARIANT_NOTE: 'Note: Deleting this variant will automatically unpublish its parent product from the channel.',
        RADIO_TORIUT_ONLY: 'Delete from Toriut only',
        RADIO_TORIUT_ONLY_DESCRIPTION: 'The variant will remain on your channels but stop syncing',
        RADIO_TORIUT_AND_CHANNELS: 'Delete from Toriut and selected channels',
        RADIO_TORIUT_AND_CHANNELS_DESCRIPTION: 'Permanently removes this variant from selected storefronts',
        BTN_CANCEL: 'Cancel',
        BTN_OK: 'Delete',
      },
      DELETE_MASTER_OPTION: {
        TITLE_PUBLISHED: 'Delete option and associated variants',
        TITLE_PUBLISHED_VALUE: 'Delete option value and associated variants',
        TEXT_PUBLISHED: (name, count) => `Deleting this option ${name} will permanently remove it and all its generated variants from Toriut. Since these variants are currently published to ${count} active channel${count === 1 ? '' : 's'}, please choose how to handle them externally:`,
        TEXT_PUBLISHED_VALUE: (name, count) => `Deleting this value ${name} will permanently remove it and all generated variants from Toriut. Since these variants are currently published to ${count} active channel${count === 1 ? '' : 's'}, please choose how to handle them externally:`,
        TEXT_LAST_LIVE_OPTION: (name, channels) => `You are about to delete option "${name}". Its variants are the last live variants on: ${channels.join(', ')}. This action cannot be undone.`,
        TEXT_LAST_LIVE_VALUE: (name, channels) => `You are about to delete option value "${name}". Its variants are the last live variants on: ${channels.join(', ')}. This action cannot be undone.`,
        LAST_LIVE_VARIANTS_NOTE: 'Note: Deleting these variants will automatically unpublish their parent product from the selected channel.',
        RADIO_TORIUT_ONLY: 'Delete from Toriut only',
        RADIO_TORIUT_ONLY_DESCRIPTION: 'The variant will remain on your channels but stop syncing',
        RADIO_TORIUT_AND_CHANNELS: 'Delete from Toriut and selected channels',
        RADIO_TORIUT_AND_CHANNELS_DESCRIPTION: 'Permanently removes these variants from selected storefronts',
        BTN_CANCEL: 'Cancel',
        BTN_OK: 'Delete',
        TITLE_CONFIRM: (name) => `Delete option "${name}"`,
        TITLE_CONFIRM_VALUE: (name) => `Delete option value "${name}"`,
        TEXT_CONFIRM: 'Are you sure you want to delete this option? All active variants associated with it will be permanently removed.',
        TEXT_CONFIRM_VALUE: 'Are you sure you want to delete this option value? All active variants associated with it will be permanently removed.',
        DONT_SHOW_AGAIN: "Don't show it again",
      },
      ADD_ASSETS_TO_MASTER_GALLERY: {
        TITLE: 'Add assets to Master gallery?',
        TEXT: (count, name) => (
          `You are about to add <span class="white-text f-w-5">${count}</span> `
          + 'assets to the Master layer gallery of '
          + `<span class="white-text f-w-5">${name}</span>.`
        ),
        DONT_SHOW_AGAIN: "Don't show it again",
        BTN_CONFIRM: 'Confirm',
        BTN_CANCEL: 'Cancel',
      },
    },
  },

  SPINNERS: {
    GENERATING_THUMBNAIL: 'Generating thumbnail...',
    STARTING_APPLICATION: `Starting ${appName}...`,
    LOADING_LIBRARY: 'Loading library...',
    LOADING_COLLECTIONS: 'Loading collections...',
    LOADING_KEYWORDS: 'Loading keywords...',
    CONNECTING_STORAGES: (storageName) => (storageName === 'picsioStorage'
      ? `Connecting ${appName} storage...`
      : storageName === 's3'
        ? 'Connecting Amazon S3...'
        : 'Connecting Google Drive...'),
    CHECKING_SUBSCRIPTION: 'Checking subscription...',
    SEARCHING: 'Searching...',
    LOADING: 'Loading...',
    DOWNLOADING: 'Downloading...',
    CHECKING_DOWNLOAD_PERMISSIONS: 'Checking download permissions...',
  },

  TOAST: {
    COPYING_ASSETS_FAILED: (assets) => `Copying ${pluralize('asset', assets.length, true)} failed`,
    WARNING_COLLECTION_ALREADY_EXISTS: {
      TEXT: 'Collection with this name already exists',
    },
    WARNING_BUSY_COLLECTION: {
      TITLE: 'Incomplete operations error',
      TEXT:
        'This collection is still processing. Please wait a moment and try again',
    },
    PUBLISH_CDN_START: (assetsCount) => (assetsCount === 1
      ? 'CDN publishing started'
      : 'Publishing selected assets to CDN started'),
    PUBLISH_CDN_SUCCESS: (assetsCount) => (assetsCount === 1
      ? 'Publishing to CDN completed'
      : 'Selected assets are published to CDN'),
    PUBLISH_CDN_ERROR:
      'Something went wrong while publishing. Please try again.',
    PUBLISH_CDN_PARTIAL_SUCCESS: (failedCount, totalCount) => `Publishing completed with errors. ${failedCount} out of ${totalCount} assets couldn't be published to the CDN.`,
    PUBLISH_CDN_SIZE_LIMIT:
      'Asset size exceeds the allowed limit for publishing.',
    UNPUBLISH_CDN_START: (assetsCount) => (assetsCount === 1
      ? 'CDN unpublishing started'
      : 'Unpublishing selected assets to CDN started'),
    UNPUBLISH_CDN_SUCCESS: (assetsCount) => (assetsCount === 1
      ? 'Unpublishing from CDN completed'
      : 'Selected assets have been unpublished from CDN'),
    UNPUBLISH_CDN_ERROR:
      'Something went wrong while unpublishing. Please try again.',
    UNPUBLISH_CDN_PARTIAL_SUCCESS: (failedCount, totalCount) => `Unpublishing completed with errors. ${failedCount} out of ${totalCount} assets couldn't be unpublished from the CDN.`,
    UPGRADE_ADDON_SUCCESS: (featureName) => (
      <>
        <b>{featureName}</b> added to your subscription
      </>
    ),
    PUBLISHED_TO_CHANNEL: (channelLabel) => `Successfully published to ${channelLabel}`,
    PUBLISHED_TO_CHANNELS: (channelLabels) => `Successfully published to [${channelLabels.join(', ')}]`,
    DRAFT_FOR_CHANNEL: (channelLabel) => `Draft for ${channelLabel} created`,
    DRAFT_FOR_CHANNELS: (channelLabels) => `Drafts for [${channelLabels.join(', ')}] created`,
    SHOPIFY_PRODUCT_DELETED_SHOWING_DRAFT:
      'Product was deleted on Shopify. Displaying local draft instead.',
    SHOPIFY_VARIANT_DELETED_SHOWING_DRAFT:
      'Variant was deleted on Shopify. Displaying local draft instead.',
    PUBLISHING_SERVER_ERROR: 'Publishing failed due to a server error',
    PUBLISHING_TRY_AGAIN: 'Try again',
    COLLECTION_ARCHIVED: (collectionName) => `Collection "${collectionName}" archived`,
    COLLECTION_COPIED: (collectionName) => `Collection "${collectionName}" duplicated`,
    COLLECTION_UNARCHIVED: (collectionName) => `Collection "${collectionName}" unarchived`,
    ASSETS_ARCHIVED: (assetsCount) => `${pluralize('asset', assetsCount, true)} archived`,
    ASSETS_UNARCHIVED: (assetsCount) => `${pluralize('asset', assetsCount, true)} unarchived`,
    COLLECTION_REMOVED: (collectionName) => `Collection "${collectionName}" moved to trash`,
    WARNING_THUMBNAIL_GENERATING:
      'Your custom thumbnail is on the way. It may take a couple of minutes.',
    REVISION_UPLOADED: 'Revision uploaded',
    NOT_COPIED: 'URL not copied',
    SYSTEM_MESSAGE: 'New version is released! Refresh page to see updates',
    FACE_RECOGNIZING_COMPLETE: (countAssets, countFaces) => `${pluralize('asset', countAssets, true)} recognized<br />${pluralize(
      'face',
      countFaces,
      true,
    )} have been found`,
    FACE_RECOGNIZING_COLLECTION_COMPLETE: (countAssets) => `${pluralize(
      'asset',
      countAssets,
      true,
    )} will be recognized in background`,
    FACE_RECOGNIZING_REJECTED:
      'Face recognition is not supported for this file format',
    ADD_TO_FAVORITES_SUCCESS: (collectionName, actionText) => `"${collectionName}" ${actionText} favorites`,
    SAVED_SEARCHES_FAVORITE: (name, value) => `"${name}" ${value ? 'added to' : 'removed from'} "Favorites"`,
    UPDATE_USER_SEARCH_SETTINGS: () => (
      <>User search settings cannot be updated. Refresh and try again</>
    ),
    SEND_TO_RECOGNIZE_ONE: (countFaces) => `1 asset recognized<br>${pluralize(
      'face',
      countFaces,
      true,
    )} have been found`,
    SEND_TO_RECOGNIZE_ONE_BUTTON: 'See faces',
    SEND_TO_RECOGNIZE: (assetsCount) => `${pluralize(
      'asset',
      assetsCount,
      true,
    )} will be recognized in background`,
    PERSON_DELETED: 'Person deleted',
    PERSON_RENAMED: 'Person renamed',
    API_KEY: {
      CREATE: 'Can not create api key',
      GET: 'Can not get api keys',
      REMOVE: 'Can not remove api key',
    },
    REQUIRED_FIELDS: {
      ADD: 'Can not add required field',
      REMOVE: 'Can not remove required field',
      UPDATE: 'Can not update required field',
    },
    hiddenFields: {
      update: 'Can not update hidden fields',
    },
    HOT_KEY: (key) => `Useful hot keys: "${key} + mouse click" - selects a file<br />&mdash; "shift + mouse click" - selects a files range<br />&mdash; "${key} + A" - selects all files in current filter`,
    HOT_KEY_BUTTON: "Don't show it again",
    NAME_CAN_NOT_INCLUDE_SLASH:
      'Asset name can not include "/"(forward slash) character !',
    CANNOT_MOVE_COLLECTION: 'Can not move collection',
    CANNOT_MOVE_COLLECTION_INTO_ITSELF:
      'Cannot move a collection into itself. Please choose a different destination',
    IMPORTING_ASSETS_COMPLETE: (countAssets) => `Import complete: ${pluralize('file', countAssets, true)} ${
      countAssets > 1 ? 'have' : 'has'
    } been successfully added`,
    IMPORTING_ASSETS_FAILED: (assets) => `Import failed: ${pluralize('file', assets.length, true)} ${
      assets.length > 1 ? 'were' : 'was'
    } not added`,
    IMPORTING_COLLECTION_COMPLETE: (folderName) => `Import complete: '${folderName}' folder has been successfully added`,
    IMPORTING_COLLECTION_FAILED: (collectionPaths) => `Import failed: ${pluralize('folder', collectionPaths.length, true)} ${
      collectionPaths.length > 1 ? 'were' : 'was'
    } not added`,
    BATCH_IMPORT_SUCCESS: ({ total, created, updated }) => (
      `Import complete: ${total} rows processed (${created} created, ${updated} updated).`
    ),
    BATCH_IMPORT_PARTIAL: ({
      total, created, updated, errors,
    }) => (
      `Import partially complete: ${total} rows processed (${created} created, ${updated} updated, ${errors} errors).`
    ),
    BATCH_IMPORT_FAILED: ({ total, errors }) => (
      `Import failed: ${total} rows processed, ${errors} errors. No products were added or updated.`
    ),
    BATCH_IMPORT_FAILED_JOB: (error) => (
      `Import failed: ${error}`
    ),
    BATCH_IMPORT_SAVED_SEARCH_FAILED:
      'Products were imported, but the import saved search could not be created. '
      + 'You can still find imported products by import job id.',
    ATTACHING_ASSETS_TO_PRODUCT_COMPLETE:
      'Media attachment complete. Selected media has been added to the products.',
    ATTACHING_ASSETS_TO_PRODUCT_FAILED:
      'Media attachment failed. Check your connection or try again later.',
    ATTACHING_ASSETS_TO_PRODUCT_SENT:
      'Adding selected media. This may take a moment.',
    ASSETS_FOR_RETRY_NOT_FOUND: 'Assets for retry import not found',
    RETRY_IMPORT_ASSETS_FAILED: (assetCount) => `Retry ${pluralize('asset', assetCount)} import failed`,
    RETRY_IMPORT_COLLECTION_FAILED: 'Retry import failed for collection',
    ERROR_SEND_SUGGESTION_FOR_IMPROVEMENT: () => (
      <>
        Cannot send suggestion for improvement. Please, contact{' '}
        <a className="picsioLink" href={`mailto:${supportEmail}`}>
          support
        </a>
        .
      </>
    ),
    SUCCESS_SEND_SUGGESTION_FOR_IMPROVEMENT: () => (
      <>
        Suggestion for improvement sent successfully. Thank you for your
        feedback!
      </>
    ),
  },

  COLLECTION_IS_EXISTED_AND_ARCHIVED:
    'There is an archived collection with the same name. Try using a different name. ',
  COLLECTION_NAME_INVALID_CHARS:
    'A collection name can’t contain the following characters: <span class="highlight">/ \\ | ~ [ ] { } "</span> or curly quotes. Please remove them and try again.',
  COLLECTION_NAME_INVALID_CHARS_TOOLTIP:
    'A collection name can’t start with a dot or contain: / \\ | ~ [ ] { } " or curly quotes.',
  UNABLE_TO_CREATE_COLLECTION: `Cannot create collection. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">support</a>.`,
  UNABLE_TO_RENAME_COLLECTION: `Cannot rename collection. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">support</a>.`,
  UNABLE_TO_REMOVE_COLLECTION: `Cannot remove collection. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">support</a>.`,
  UNABLE_TO_REMOVE_COLLECTION_NO_GD_PERMISSIONS: `<p>The collection was <span class="highlight">not deleted</span> from ${appName}.<br />The user does not have sufficient <span class="highlight">permissions to delete</span> this folder from Cloud Storage Account.</p><p>Check permissions in Cloud Storage Account to perform the removal.<br />Consult our <a href="https://help.pics.io/en/articles/1269158-deleting-assets-from-pics-io" target="_blank">HelpCenter</a> for details.</p>`,
  UNABLE_TO_MOVE_COLLECTION: `Unable to move collection.<br /> Try again and contact <a class="picsioLink" href="mailto:${supportEmail}">support</a> if mistake persists.`,
  TargetCollectionInsideApiError:
    'Can not move nested collection into parent. Select a different target location',
  UNABLE_TO_CHANGE_COLLECTION_COLOR: `Cannot change collection color. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">support</a>.`,
  UNABLE_TO_CHANGE_COLLECTION_DESCRIPTION: `Cannot change collection description. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">support</a>.`,
  UNABLE_TO_REMOVE_IMAGE: `Unable to remove asset. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">support</a>`,
  THUMBNAIL_GENERATE_SUCCESS: 'Thumbnail generated',
  UNABLE_TO_GENERATE_THUMBNAIL: `Unable to generate thumbnail. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">support</a>`,
  textBtnUndo: 'Undo',

  FOLDER_SYNC: {
    syncAlreadyRunningErrorTitle: 'Folder sync is not available now',
    syncAlreadyRunningErrorText:
      'Wait a sec, please. It seems that sync is already running.',
    syncHasStartedTitle: 'Sync started',
    syncHasStartedText: `We have started syncing files in this collection with your storage, this operation will be running in background. You can continue using ${appName}`,
  },

  FILES_ARE_REMOVED: 'Files are removed',
  FILES_WERENT_REMOVED: "Files weren't removed. Please, try again later",

  ERROR_UPDATING_ASSET: `Error updating asset. Please try again. Contact us at <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support if the error repeats.`,
  ERROR_GETTING_AGGREGATED_DATA: `Error retrieving assets data. Please try again. Contact us at <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support if the error repeats.`,
  ERROR_ADD_REACTION: `Please try again. Contact <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support, if the error persists.`,

  TAGLIST: {
    errorItemNotValid: 'The {type} is not valid.',
    errorItemsNotValid: 'The {types} not valid.',
    errorItemIsEmpty: 'The field is empty.',
    errorItemAlreadyAdded: 'This {type} is already added.',
  },

  ACCOUNT: {
    title: 'My account',

    tabTitleProfile: 'Profile',
    tabTitleSettings: 'Settings',
    tabTitleNotifications: 'Notifications',
    tabTitleSecurity: 'Security',
    tabTitleLegal: 'Legal',

    errorName: 'Should always exists.',
    errorBlog: 'The link is not valid.',
    errorLinkStartURL: 'Link should start with',
    errorLinkNotValid: 'The link is not valid.',
    placeholderEnterEmail: 'Enter email address(es) to receive notifications',

    titleProfile: 'Profile',
    inputLabelEmail: 'Email',
    linkResetPassword: 'Reset password',
    inputLabelName: 'Full name',
    inputPlaceholderName: 'Full name',
    inputLabelPosition: 'Position',
    inputPlaceholderPosition: 'Position',
    inputPhotoButtonText: 'Add your photo',
    inputPhotoDescription:
      'Please use small square images 125-250 pixels in a transparent background: PNG or GIF. You can also use small progressive JPG. Image size should not exceed 1 MB.',
    inputLabelPhone: 'Phone',
    inputLabelBlogURL: 'Blog url',
    inputLabelAbout: 'About',
    inputLabelContacts: 'Contacts',
    titleChangePassword: 'Change password',
    inputLabelCurrentPassword: 'Current password',
    inputLabelNewPassword: 'New password',
    inputLabelConfirmNewPassword: 'Confirm new password',

    sectionNameNetwork: 'Network',
    timeZone: 'Time zone',
    sectionPreviewLabel: 'Image size on preview screen',
    sectionUploadLabel: 'Upload one asset at a time',
    sectionTimeZoneLabel: 'Set time zone automatically',
    sectionUploadText: `If this option is set ${appName} will upload only one asset at a time. Useful for slow connections and heavy assets.`,

    sectionNameLocale: 'Date and time format',
    sectionLocaleText: `Change of this option affects date and time format in ${appName}.`,

    sectionNameScheme: 'UI color scheme',
    sectionSchemeLabelDark: 'Dark',
    sectionSchemeLabelLight: 'Light',

    noteSlackConnected: (teamName) => (
      <>
        {appName} bot connected to{' '}
        <a
          className="picsioLink"
          href="https://slack.com/apps/manage"
          rel="noreferrer"
          target="_blank"
        >
          {teamName}
        </a>{' '}
        Slack team.
        <br />
        <br />
        To receive notifications, you need to invite bot to one of channels by
        sending message <b className="msgInvPicsio">/invite @picsio</b> to that
        channel.
        <br />
      </>
    ),
    noteSlackNotConnected: `${appName} is not connected to Slack.`,
    noteAskOwner: ' Ask your team owner to connect to Slack',
    noteNotificationWillSent: 'Notifications will be sent to',

    titleYouCan: 'You can also do the following:',

    linkSeeAllData: 'See all personal data',
    textSeeAllData:
      'You can see all personal information about yourself that you entered in your User Profile (name, email, role, userpic, position in your team, etc.)',

    linkDownloadAllData: 'Download all personal data',
    textDownloadAllData:
      'You can download all personal information about yourself that you entered in your User Profile (name, email, role, userpic, position in your team, etc.). The information will appear as a .js file in the downloads folder of your browser.',

    linkDeleteAllData: 'Delete all personal data',
    textDeleteAllData: `You can delete all personal information about yourself that you used during registration in ${appName}. This is an irreversible action, after which you will not be able to use ${appName} service. To regain access, you will have to register again.`,
    titleDeleteAllData: 'Delete all personal data',
    warningDeleteAllData: `Warning! You’re going to delete all your personal data from ${appName}!`,
    contentDeleteAllData: (
      <span>
        You have the right to delete all information about yourself from{' '}
        {appName} and our partners’ databases, such as your name, email, role,
        userpic, position in your team, etc.
        <br />
        <br />
        Please note that this action is irreversible. After you choose to delete
        all your personal information from {appName} database, {appName} team
        will not be able to help you restore it. And you will no longer be able
        to use {appName} service unless you register again.
        <br />
        <br />
        {appName} team will delete all your personal data manually and beyond
        retrieval within the next 30 days. A notification will be sent to you
        when it is done. <br />
        <br />
        Please enter your email and password, and tick the box “I understand” to
        proceed with deleting.
      </span>
    ),
    labelDeleteAllData: 'I understand',
    buttonDeleteAllData: 'Delete',
    dailogTextDeleteAllData: `Ok, we respect your decision. ${appName} team will delete all your personal data manually and beyond retrieval within the next 30 days. Upon completion, an email notification will be sent to you.`,

    linkRestrictProcessing: 'Restrict processing',
    textRestrictProcessing: `With this irreversible action you can prevent ${appName} team from using your email address and other personal information, which is necessary to provide you with technical support and identify you as a user. You will be able to use ${appName}, but without any support from ${appName} team.`,
    titleRestrictProcessing: 'Restrict processing',
    warningRestrictProcessing: `Warning! You’re going to restrict ${appName} from using your personal information!`,
    contentRestrictProcessing: (
      <span>
        You have the right to restrict {appName} from using your personal
        information. However, with this irreversible action you will prevent{' '}
        {appName} team from providing you with technical support and identify
        you as a system user. You will be able to use {appName} service, but{' '}
        {appName} team will not be able to help you restore your password in
        case you forget it or render any other technical assistance if you need
        it.
        <br />
        <br />
        {appName} team will perform this action manually and beyond retrieval
        within the next 30 days. A notification will be sent to you when it is
        done.
        <br />
        <br />
        Please enter your email and password, and tick the box “I understand” to
        proceed with restricting.
      </span>
    ),
    labelRestrictProcessing: 'I understand',
    buttonRestrictProcessing: 'Restrict',
    restricted: 'Processing restricted',

    linkUnsubscribe: 'Unsubscribe',
    textUnsubscribe: `You can choose not to receive any onboarding information, newsletters, and other marketing materials from ${appName} to your email.`,

    linkRevokeConsents: 'Revoke consent',
    textRevokeConsents: `You have the right not to agree with our Terms of Service / Privacy Policy. If you revoke your consent, you will not be able to access ${appName} service.`,
    titleRevokeConsents: 'Revoke consent',
    warningRevokeConsents:
      'Warning! You’re going to revoke your consent to our Terms of Service and Privacy Policy',
    contentRevokeConsents: (
      <span>
        Your consent to our Terms of Service and Privacy Policy is the necessary
        condition so that {appName} could deliver any services to you. You will
        not be able to use {appName} until you accept them.
        <br />
        <br />
        If you are sure about revoking your consent, please enter your email and
        password, and tick the box “I understand” to proceed with this action.
      </span>
    ),
    labelRevokeConsents: 'I understand',
    buttonRevokeConsents: 'Revoke',

    titleSecurity: 'Security',

    helpText: 'Learn how to edit your account info',
    labelAuthentication: 'Enable Two-factor authentication (2FA)',
    labelAuthenticationTooltip:
      'Switch on the Two-factor authentication (2FA) for your account',
    setup2FANow: 'Set up Two-factor authentication (2FA) now',
  },

  TWO_FACTOR_AUTH: {
    scan:
      'Scan this image with your authenticator app. You will see a 6-digit code on your screen. Enter the code below to verify your phone.',
    inCase:
      'In case of emergency, the code below will be necessary to disable your Two-factor authentication (2FA) and access your account.',
    save: 'Store this code in safe place',
    input: 'Please input the code below:',
    complete: 'Two-factor authentication (2FA) enabled',
    error: `Something went wrong. Please try again. Contact <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support if the error repeats.`,
    termsTitle: 'Two-factor authentication (2FA) terms of use.',
    upgradeTooltip: () => (
      <>
        Two-factor authentication (2FA)n functionality is available on Small,
        Medium and Enterprise plan. <br /> Click to Subscribe now.
      </>
    ),
    planRestriction: (onClick) => (
      <p>
        Two-factor authentication (2FA) functionality is available on Small,
        Medium and Enterprise plan.{' '}
        <span className="picsioLink" role="presentation" onClick={onClick}>
          Subscribe now
        </span>{' '}
        to keep using it after trial expires.
      </p>
    ),
    myAccountTextEnabled: 'You have enabled Two-factor authentication (2FA).',
    myTeamTextEnabled: () => (
      <span>
        You have activated Two-factor authentication (2FA) login for all
        teammates.
        <br /> Each one of them has received a notification to set up the second
        step for their account.
      </span>
    ),
    setupNow: 'Set up Two-factor authentication (2FA) now',
  },

  SET_NEW_PASSWORD: {
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    success: 'New password set',
    fail: () => <>New password cannot be set. Refresh and try again</>,
    emptyPasswordError: 'Password cannot be empty',
    passwordLengthError: 'Password needs to be at least 8 characters long',
    passwordsAreNotEqualError: 'Passwords are not equal',
    save: 'Save',
  },

  TWO_FACTOR_SCREEN: {
    recoveryTitle:
      'Use the recovery code to access your account and reconfigure Two-factor authentication (2FA)',
    useApp: (handleClick) => (
      <p>
        Or use{' '}
        <span className="picsioLink" role="presentation" onClick={handleClick}>
          app for a authentication
        </span>
      </p>
    ),
    enterCodeTitleApp:
      'Enter the six-digit code for authentication from Google authentication app',
    enterCodeTitleEmail: `Input 6-digit code to proceed to ${appName}`,
    enterCodeLabelApp:
      'Enter the six-digit code from Google authentication app',
    enterCodeLabelEmail: 'Enter the six-digit code from email',
    resendButton: 'Resend code',
    useRecovery: (handleClick) => (
      <>
        <span className="picsioLink" role="presentation" onClick={handleClick}>
          Recovery code
        </span>
      </>
    ),
    verify: 'Verify',
    clear: 'Clear',
  },

  CONFIRM: {
    placeholderLogin: 'Login',
    placeholderPassword: 'Password',
    emailInvalid: 'Email is invalid',
    passwordInvalid: 'Password is empty',
    checkboxInvalid: 'Should be checked',
    serverError: 'Email or password is incorrect',
  },

  KEYWORDS: {
    alertCantAddKeyword: () => (
      <div>Keyword cannot be added. Refresh and try again</div>
    ),
    alreadyExists: 'A keyword with this name already exists in this workspace.',
    nameEmpty: 'Keyword name can\'t be empty.',
    alreadyExistsInWorkspace: 'A keyword with this name already exists in this workspace.',
    nameContainsDelimiter: 'Keyword name can\'t contain the "→" character.',
    errorLoading:
      'Keywords has not loaded. Try refreshing the page to see them',
    errorLoadingSomeKeywords:
      'Some keywords has not loaded. Try refreshing the page to see them.',
  },
  PRODUCT_TYPES: {
    alreadyExists: 'Product type with this name already exists',
    createFailed: 'Product type is not created. Refresh and try again',
  },
  PRODUCT_VENDORS: {
    alreadyExists: 'Vendor with this name already exists',
  },
  mainImageTooltip: 'Media position in product gallery',
  ALT_TEXT: {
    placeholderEditable: 'Type image alt text',
    placeholderReadOnlyEmpty: 'No alt text',
    publishedAltReadOnlyTooltip: 'Published alt text can\'t be edited directly. Create or edit a draft to change it.',
    sharedLabel: 'Shared Shopify Alt text',
    sharedFieldTooltip: 'It is shared alt text across the product and its variants in this channel',
    alsoUsedBy: (usagesText) => `Also used by ${usagesText}`,
    unpublishedChangesTooltip: 'Unpublished changes',
    pendingInDraft: (draftName) => `Alt text has unpublished changes in ${draftName}`,
    UPDATE_SHARED: {
      TITLE: 'Update shared Alt text?',
      DESCRIPTION: (productTitle) => (
        <>
          This media asset is used across multiple contexts within
          {' '}
          <span className="white-text f-w-5">{productTitle}</span>
          . Shopify supports only one Alt text per asset per listing, so any changes to this value will apply to all affected usages when published.
        </>
      ),
      AFFECTED_USAGES: 'Affected usages:',
      BTN_OK: 'Update Alt text',
      BTN_CANCEL: 'Cancel',
      DONT_SHOW_AGAIN: "Don't show it again",
    },
    CLEAR_SHARED: {
      TITLE: 'Clear shared Alt text?',
      TEXT: (productTitle) => (
        <>
          Clearing this Alt text will remove it everywhere this media is used within
          {' '}
          <span className="white-text f-w-5">{productTitle}</span>
          {' '}
          in Shopify.
        </>
      ),
      BTN_OK: 'Clear Alt text',
      BTN_CANCEL: 'Cancel',
    },
    productGallery: 'Product gallery',
    defaultAltLabel: 'Default alt text',
    detailsChannelTooltip: 'Shopify uses one shared Alt text per media within each product listing',
  },
  AUDIT: {
    title: 'Audit trail',
    logsTab: 'Logs',
    login: 'User logins',
    logout: 'User logouts',
    analyticsTab: 'Analytics',

    tabTitleUser: 'Any user',
    tabTitleEvent: 'Any event',

    linkWebsite: 'website',
    linkTeam: 'your team',

    downloadCSV: 'Download CSV',

    textNothingFound:
      'Nothing found. Please try again with some different keywords.',
    textNoRecords: 'There are no records yet.',

    syncToStart: 'started sync operation to your cloud storage',
    syncToSuccess: 'Sync operation to your cloud storage finished',
    syncToFail: 'Sync operation to your connected cloud storage failed',
    syncFromStart: 'started sync operation from your cloud storage',
    syncFromSuccess: 'Sync operation from your cloud storage finished',
    syncFromFail: 'Sync operation from your cloud storage failed',

    timeOptionsAny: 'Anytime',
    timeOptionsToday: 'Today',
    timeOptionsYesterday: 'Yesterday',
    timeOptionsLast7: 'Last 7 days',
    timeOptionsLast30: 'Last 30 days',
    timeOptionsLast90: 'Last 90 days',
    timeOptionsCustomized: 'Customized',

    tagImageAdded: 'Asset uploaded to collection',
    tagImageImported: 'Asset imported to collection',
    tagAssetTranscribed: 'Asset transcribed',
    tagAssetAnalyzed: 'Video & Audio Intelligence completed',
    tagAssetAnalyzeFailed: 'Video & Audio Intelligence failed',
    tagAssetTranscriptDeleted: 'Asset transcript deleted',
    tagImageDeleted: 'Asset deleted',
    tagImageTrashed: 'Asset trashed',
    tagCommentAdded: 'Comment added',
    tagCommentDeleted: 'Comment deleted',
    tagAssetDownloaded: 'Asset downloaded',
    tagRevisionCreate: 'Revision created',
    tagRatingChanged: 'Rating changed',
    tagFlagChanged: 'Flag changed',
    tagColorChanged: 'Color changed',
    tagAssetsUploaded: 'Assets uploaded',
    tagAssetsAttached: 'Assets attached',
    tagAssetsDetached: 'Assets detached',
    tagAssetsMoved: 'Assets moved',
    tagAssetsKeywordAttached: 'Keywords attached',
    tagAssetsKeywordDetached: 'Keyword detached',
    tagAssetsKeywordsDetached: 'Keywords detached',
    tagAssetsMetadataChanged: 'Metadata changed',
    tagCollectionCreated: 'Collection created',
    tagCollectionDeleted: 'Collection deleted',
    tagCollectionMoved: 'Collection moved',
    tagCollectionRenamed: 'Collection renamed',
    tagCollectionShared: 'Collection shared',
    tagCollectionUnshared: 'Collection unshared',
    tagCollectionColorChanged: 'Collection color changed',
    tagCollectionDescriptionChanged: 'Collection description changed',
    tagFacesCreated: 'Face created',
    tagFaceRenamed: 'Face renamed',
    tagFaceDeletedForPerson: 'Face deleted for a person',
    tagFaceMergedForPerson: 'Face merged for a person',
    tagAssetsFacesRecognized: 'Recognized faces',
    tagAssetsFaceDeleted: 'Face deleted from an asset',
    tagTeammateInvited: 'Teammate invited',
    tagTeammateConfirmed: 'Teammate confirmed',
    tagTeammateRejected: 'Teammate rejected',
    tagRoleChanged: 'Role changed',
    tagTeammateRemoved: 'Teammate removed',
    tagSyncToStart: `Sync from ${appName} to GD started`,
    tagSyncToSuccess: `Sync from ${appName} to GD finished`,
    tagSyncToFail: `Sync ${appName} to GD failed`,
    tagSyncFromStart: `Sync from GD to ${appName} started`,
    tagSyncFromSuccess: `Sync from GD to ${appName} finished`,
    tagSyncFromFail: `Sync GD to ${appName} failed`,
    metadatingFailed: 'Extracting metadata failed',
    replicationFailed: 'Saving assets metadata to your cloud storage failed',
    contentingFailed: 'Content extracting failed',
    keywordingFailed: 'Autokeywording failed',
    workingFolderChanged: 'Working folder changed',
    You: 'You',
    changedWorkingFolder: 'changed working folder',
    changedWorkingFolderTo: 'changed working folder to',
    trialExpires: 'Trial expires',
    trialExpiresIn2Days: 'Trial expires in 2 days',
    trialExpiresIn5Days: 'Trial expires in 5 days',

    MedatataExtractingFailedFor: 'Metadata extracting failed for',
    SavingAssetsMetadataToYourStorageFailedFor:
      'Saving assets metadata to your cloud storage failed for',
    AutogenerateKeywordsFailedFor: 'Autogenerate keywords failed for',
    ContentExtractingFailedFor: 'Content extracting failed for',
    assetApproved: 'Asset approved',
    assetDisapproved: 'Asset disapproved',
    assetsAssigned: 'Assets assigned',
    assetsUnassigned: 'Assets unassigned',
    approved: 'approved',
    disapproved: 'disapproved',
    asset: 'asset',
    revision: 'revision',
    and: 'and',
    more: 'more',
    websitePresetCreated: 'Website preset created',
    websitePresetDeleted: 'Website preset deleted',
    websitePresetRenamed: 'Website preset renamed',

    helpText: {
      audit: 'Learn more about Audit Trail log',
      analytics: `Explore how to work with ${appName} analytics & reporting`,
    },
  },

  UPGRADE_PLAN_BLOCK: {
    persons: {
      title: 'Persons',
      description:
        'Discover a revolutionary new way of embracing your digital content by recognizing people in your assets.',
      helperText: 'Learn more about Face recognition',
    },
    inboxes: {
      title: 'Inboxes',
      description: `An Inbox is a place that allows non-${appName} users to upload files to your library for further review.`,
      helperText: 'Learn more about Inboxes',
    },
    branding: {
      title: 'Branding',
      description:
        'Add logo, favicon, custom domains to your websites, inboxes, and sign-in page for teammates.',
      helperText: `Learn how to customize your ${appName} experience`,
    },
    watermarking: {
      title: 'Watermarking',
      description: `Create image or text watermarks to protect your assets shared outside of ${appName}.`,
      helperText: 'Learn more about watermarks',
    },
    roles: {
      title: 'Roles',
      description:
        'Create custom set of permissions for different groups of users.',
      helperText: 'Learn how to assign roles to teammates',
    },
    okta: {
      title: 'Okta SSO',
      description: 'Single Sign-On (SSO) through Okta',
      helperText: 'Learn more about Okta',
    },
    twoFactorAuth: {
      title: 'Two-factor authentication (2FA)',
      description: `Protect your ${appName} account with Two-factor authentication (2FA)`,
      helperText: 'Learn how to set up Two-factor authentication (2FA)',
    },
    comments: {
      title: 'Commenting and marking',
      description: `${appName} as one more useful channel of communication with your team`,
      helperText: 'Learn how to comment and add markers to assets',
    },
    customFields: {
      title: 'Custom fields schema',
      description: 'Create custom fields to build your own metadata taxonomy.',
      helperText: 'Learn how to manage your custom fields',
    },
    transcript: {
      title: 'Transcript',
      description:
        'Here you will see a speech-to-text transcription of an audio track of current asset',
      helperText: 'Learn more about Video & Audio Intelligence',
    },
    assetAnalytics: {
      title: 'Asset analytics',
      description:
        'Control your team activity and report on library efficiency.',
      helperText: 'Learn more about analytics',
    },
    teamAnalytics: {
      title: 'Teammates analytics',
      description:
        'Control your team activity and report on library efficiency.',
      helperText: 'Learn more about analytics',
    },
    websiteAnalytics: {
      title: 'Website analytics',
      description:
        'Control your team activity and report on library efficiency.',
      helperText: 'Learn more about analytics',
    },
    auditTrail: {
      title: 'Library analytics',
      description: `To get the full picture of what is happening in your ${appName} account, we have library-level analytics.`,
      helperText: 'Learn more about analytics',
    },
    WARNING_ADDON_UPGRADE: {
      TITLE: 'Upgrade subscription with add-on',
      TEXT: (addonName) => `You are about to add <b>${addonName}</b> to your subscription.`,
      OK: 'Upgrade',
      CANCEL: 'Cancel',
    },
    authFlows: {
      title: 'Allowed authentication methods',
      description: 'Select authentication methods for your teammates Sign In',
    },
  },

  BILLING: {
    billingOldPlanInfo(
      activePlanPrice,
      activePlanInterval,
      periodEndDateFormatted,
    ) {
      return `<span style="color: #FF6B00">You are subscribed to a plan that was discontinued, but your price remains the same: $${activePlanPrice}/${activePlanInterval}, next payment ${periodEndDateFormatted}.`;
    },
    title: 'Billing',
    logoutText: 'Logout',

    tabTitleOverview: 'Overview',
    tabTitleInfo: 'Info',
    tabTitleInvoices: 'Invoices',
    tabTitleCard: 'Card',
    titlePlan: 'Plan',
    titleBestOffer: 'Best offer',
    textPlanMonth: 'Monthly',
    textPlanYear: 'Yearly',
    textPlanAnnually: 'Annually',
    textPlanDiscount: 'save 10%',
    discountTooltipText:
      'One-time indexing fee is charged for AI Kit teams on monthly plans when enabling Visual & Similar Images Search, to analyze and index existing assets. Not charged on yearly plans.',

    stateInvoices: 'Fetching invoices...',

    textCantValidateCard: `Can't validate card. Your card WON'T be charged. This indicates technical problems. Please contact ${supportEmail}.`,
    textEmptyCoupon: "Empty coupon can't be applied",
    textCoupon: 'Coupon',
    textCouponCant: "can't be applied to your account.",
    textCouponCant2: "can't be applied",
    textCouponSuccess: (coupon) => <>Coupon {coupon} applied</>,
    textCardErrorReason: (reason) => <>Reason: {reason}</>,
    textCouponApplying: 'Applying coupon...',
    textCouponDialogTitle: 'Enter your coupon here',
    textCardDetailsLoading: 'Loading card details...',
    textCardCantCheck: `Can't check card status! Please try again later or contact ${supportEmail}.`,
    textCardSaving: 'Saving card details...',
    textCardChanged: 'Card details updated',
    textCardCantChange: `Can't change card! Please try again later or contact ${supportEmail}.`,
    textPaymentLoadingDetails: 'Loading payment details...',
    textPaymentFinishing: 'Finishing payment...',
    textPlanChangedSuccess: 'Subscription plan updated',
    textPaymentCantFinishing: `Can't finish payment! Please try again later or contact ${supportEmail}.`,
    textDetailsSaving: 'Saving subscription details...',
    textDetailsLoading: 'Loading subscription details...',
    textSubscriptionCancelled: 'Subscription cancelled',
    textSubscriptionCantCancel: `Can't cancel subscription! Please try again later or contact ${supportEmail}.`,
    textSubscriptionCantUpdate:
      `Can't update subscription! Please try again later or contact ${supportEmail}.`,
    textTitleThanks: 'Subscription updated',
    textTextSubcriptionUpdated: `Your subscription has been updated.<br>Thank you for choosing ${appName} DAM service.`,
    textActivateVisualSearch:
      'To start using AI-powered features, you’ll need to configure them in your AI settings first.',
    textRemovalImageAiKit: (
      <div>
        <span>
          Due to the removal of the Image Intelligence add-on from your
          subscription, the following features will no longer be available:
        </span>
        <ul className="p-l-15">
          <li>
            <strong className="f-w-5">Visual & Similar Images Search:</strong>{' '}
            Fast content discovery and visual-based search — including natural
            language and similarity search — will be disabled.
          </li>
          <li>
            <strong className="f-w-5">Metadata Enrichment:</strong> Automated
            enrichment of asset metadata, including Face Recognition,
            Auto-keywording, Image & Video Captioning, and Transcription, will
            be removed.
          </li>
        </ul>
        <p>
          As a result, content discovery will be slower, tagging will be manual,
          and video processing will be less efficient.To restore these features,
          please update your subscription and re-enable the AI Kit add-on.
        </p>
      </div>
    ),
    textRemovalVideoAiKit: (
      <div>
        <span>
          Due to the removal of the Video Intelligence add-on from your
          subscription, the following features for video & audio assets will no
          longer be available:
        </span>
        <ul className="p-l-15">
          <li>
            <strong className="f-w-5">AI Summary:</strong> Automatic short
            summaries of video and audio content.
          </li>
          <li>
            <strong className="f-w-5">Transcript:</strong> Full AI-generated
            transcripts of spoken content.
          </li>
          <li>
            <strong className="f-w-5">Actions & Chapters:</strong> Automatically
            detected key moments and chapter markers.
          </li>
          <li>
            <strong className="f-w-5">Recognized text (OCR):</strong> Text
            detected in video frames.
          </li>
          <li>
            <strong className="f-w-5">AI Keywords:</strong> Automatically
            generated keywords based on audio and video analysis.
          </li>
        </ul>
        <p>
          As a result, analyzing video and audio content will become manual and
          more time-consuming, and new uploads will no longer be processed by
          Video Intelligence. To restore these features, please update your
          subscription and re-enable the Video Intelligence add-on.
        </p>
      </div>
    ),
    textRemovalBothAiKit: (
      <div>
        <p>
          Due to the removal of the Image Intelligence and Video Intelligence
          add-ons, AI-powered features such as Visual & Similar Images Search,
          automatic keywording and face recognition, AI descriptions, video
          summaries, transcripts, actions/chapters, OCR, and AI video keywords
          are no longer available.
        </p>
        <p>
          As a result, search, tagging, and video analysis will become more
          manual and time-consuming. To restore these capabilities, please
          update your subscription and re-enable the AI Kit add-ons.
        </p>
      </div>
    ),
    textBtnGoToLibrary: 'Go to My Library',
    textBtnSkipForNow: 'Skip for now',
    textBtnOk: 'Ok',
    textBtnGoToEnableVisualSearch: 'Go to AI Settings',
    textBillingSubscribed1: "You're subscribed to",
    textBillingSubscribed2:
      'plan that is discontinued. You may upgrade to our new plans or stay with your current subscription.',
    textYourSubscription1: 'Your subscription to',
    textYourSubscription2: 'plan',
    textYourSubscription3: 'Will cancel at',
    textYourSubscribed1: 'You are subscribed to',
    textYourSubscribed2: 'plan',
    textYourSubscribed3: 'Next payment at',
    textYourTrial1: 'You are on trial period that',
    textYourTrial2: 'will end at',
    textYourTrial3:
      'You can use all the functionality without any restrictions. <br/> Except for a number of assets, you have a limit of 50,000 files during the Trial period.',
    textYourTrialEnded:
      'Please subscribe to any plan to continue using our app.',

    stripeCardErrors: {
      revocation_of_all_authorizations:
        'The card was declined for an unknown reason.',
      revocation_of_authorization:
        'The card was declined for an unknown reason.',
      security_violation: 'The card was declined for an unknown reason.',
      service_not_allowed: 'The card was declined for an unknown reason.',
      stolen_card:
        'The payment was declined because the card is reported stolen.',
      stop_payment_order: 'The card was declined for an unknown reason.',
      testmode_decline: 'A Stripe test card number was used.',
      transaction_not_allowed: 'The card was declined for an unknown reason.',
      try_again_later: 'The card was declined for an unknown reason.',
      withdrawal_count_limit_exceeded:
        'The customer has exceeded the balance or credit limit available on their card.',
      invalid_amount:
        "The payment amount is invalid, or exceeds the amount that's allowed.",
      invalid_cvc: 'The CVC number is incorrect.',
      invalid_expiry_month: 'The expiration month is invalid.',
      invalid_expiry_year: 'The expiration year is invalid.',
      invalid_number: 'The card number is incorrect.',
      invalid_pin: 'The PIN entered is incorrect.',
      issuer_not_available:
        "The card issuer couldn't be reached, so the payment couldn't be authorized.",
      lost_card: 'The payment was declined because the card is reported lost.',
      merchant_blacklist:
        "The payment was declined because it matches a value on the Stripe user's block list.",
      new_account_information_available:
        'The card, or account the card is connected to, is invalid.',
      no_action_taken: 'The card was declined for an unknown reason.',
      not_permitted: 'The payment isn’t permitted.',
      offline_pin_required: 'The card was declined because it requires a PIN.',
      online_or_offline_pin_required:
        'The card was declined as it requires a PIN.',
      pickup_card:
        "The customer can't use this card to make this payment (it's possible it was reported lost or stolen).",
      pin_try_exceeded: 'The allowable number of PIN tries was exceeded.',
      processing_error: 'An error occurred while processing the card.',
      reenter_transaction:
        "The payment couldn't be processed by the issuer for an unknown reason.",
      restricted_card:
        "The customer can't use this card to make this payment (it's possible it was reported lost or stolen).",
      authentication_required:
        'The card was declined because the transaction requires authentication such as 3D Secure.',
      approve_with_id: 'The payment can’t be authorized.',
      call_issuer: 'The card was declined for an unknown reason.',
      card_not_supported: 'The card does not support this type of purchase.',
      card_velocity_exceeded:
        'The customer has exceeded the balance, credit limit, or transaction amount limit available on their card.',
      currency_not_supported:
        'The card does not support the specified currency.',
      do_not_honor: 'The card was declined for an unknown reason.',
      do_not_try_again: 'The card was declined for an unknown reason.',
      duplicate_transaction:
        'A transaction with identical amount and credit card information was submitted very recently.',
      expired_card: 'The card has expired.',
      fraudulent:
        'The payment was declined because Stripe suspects that it’s fraudulent.',
      generic_decline:
        'The card was declined for an unknown reason or Stripe Radar blocked the payment.',
      incorrect_number: 'The card number is incorrect.',
      incorrect_cvc: 'The CVC number is incorrect.',
      incorrect_pin:
        'The PIN entered is incorrect. This decline code only applies to payments made with a card reader.',
      incorrect_zip: 'The postal code is incorrect.',
      insufficient_funds:
        'The card has insufficient funds to complete the purchase.',
      invalid_account:
        'The card, or account the card is connected to, is invalid.',
      default: `The card was declined for an unknown reason. Please try again later or contact <a class='picsioLink' href='mailto:${supportEmail}'>${supportEmail}</a>.`,
    },

    textInfo: () => (
      <span>
        See our{' '}
        <a
          href="https://pics.io/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="picsioLink"
        >
          privacy policy
        </a>
        <br />
        for details.
      </span>
    ),

    inputLabelCompany: 'Company name',
    inputLabelName: 'Name',
    inputLabelSurname: 'Surname',
    inputLabelStreetAdress: 'Street address',
    inputLabelCity: 'City',
    inputLabelPostalCode: 'Postal code',
    selectLabelCountry: 'Country',
    inputLabelState: 'State',
    inputLabelEmail: 'Email',
    inputLabelInformation: 'Information',

    inputPlaceholderCompany: 'Company',
    inputPlaceholderName: 'John',
    inputPlaceholderSurname: 'Doe',
    inputPlaceholderStreetAdress: 'Street address',
    inputPlaceholderCity: 'Los Angeles',
    inputPlaceholderPostalCode: '123456',
    inputPlaceholderState: 'California',
    inputPlaceholderEmail: 'johndoe@mail.com',
    inputPlaceholderInformation:
      'Additional information, i. e. full name of the company. This is information will appear in all invoices and receipts. Do not enter any confidential financial information here.',

    invoiceThDate: 'Date',
    invoiceThAmount: 'Amount',
    invoiceThDescription: 'Description',
    invoiceThStatus: 'Status',
    invoiceNone: 'No invoices',
    invoiceSubscriptionTo: 'Subscription to',
    invoiceInvoiceFrom: 'Invoice from',
    titleInfo: 'Info',
    titleInvoices: 'Invoices',

    titleCredits: 'Credits',
    titleFeatures: 'Features',
    titleIncluded: 'Included',
    titleAdditional: 'Additional',
    titlePrice: 'Price',
    textFeatureNumberLabel: (featureAmount, featureTitle) => `${featureAmount} per ${pluralize.singular(featureTitle)}`,
    textStartsFrom: 'Starts from',
    textFeatureBoolenLabel: 'Add feature for',
    textMaxGBOptionLabel: `(to decrease storage, contact ${appName} Support)`,
    textCreditsBuy: 'Buy',
    textSelectPlan: 'Select plan',
    textDowngradePlan: 'Downgrade plan',
    textUpgradePlan: 'Upgrade plan',
    textAddToPlan: 'Add to plan',
    textUpdatePlan: 'Update plan',
    textPurchase: 'Purchase',
    btnUpdatePlan: 'Update plan',
    btnCancel: 'Cancel',
    textIncluded: (planName) => `included in ${planName}`,
    textUnsubscribe: 'Unsubscribe',
    CANCELLATION_FLOW: {
      overlayBackdropAriaLabel: 'Close dialog',
      WARNING: {
        title: 'Cancel subscription',
        intro: 'Canceling your subscription is permanent. Please review the data and access you will lose immediately upon cancellation:',
        dataLoss: {
          title: 'Data & Assets permanently deleted',
          accent: ({ assetsCount = 0, customFieldsCount = 0, keywordsCount = 0 } = {}) => `${assetsCount} assets, ${customFieldsCount} custom fields, ${keywordsCount} keywords, and all system data`,
          tail: ' (settings, comments, and profiles) will be erased without possibility of restoration.',
        },
        teamAccess: {
          title: 'Team access removed',
          textBefore: 'Your account and ',
          accent: ({ teammatesCount = 0 } = {}) => `${teammatesCount} teammates`,
          textAfter: ' will lose access to the system immediately.',
        },
        websites: {
          title: 'Websites taken offline',
          textBefore: 'Your ',
          accent: ({ websitesCount = 0 } = {}) => `${websitesCount} active websites`,
          textAfter: ' will stop working once the subscription is canceled.',
        },
        pricing: {
          title: 'Current pricing lost',
          description: 'You will forfeit your current billing rate and be subject to future price increases if you return.',
        },
        supportNoteBefore: 'We strongly recommend contacting us at ',
        supportNoteAfter: ' before making your final decision.',
        continueCta: 'Continue to cancellation',
        keepCta: 'Keep subscription',
      },
      REASONS: {
        title: "We're sorry to see you go",
        subtitle: 'Please let us know why your team is leaving (feel free to select multiple reasons).',
        adminNote: 'Note: By requesting cancellation, you confirm that you have approval from your Team Owner or Admin.',
        tooltipMaxReasons: 'You can select up to 3 reasons. Uncheck one to select another.',
        feedbackLabel: 'Tell us more (Optional)',
        feedbackPlaceholder: 'Please share any additional details, feature requests, or the name of the tool you are switching to...',
        backCta: 'Back',
        submitCta: 'Request subscription cancellation',
        closeAriaLabel: 'Close',
        options: {
          too_expensive: { main: 'Too expensive', hint: null },
          too_difficult: { main: 'Too difficult to use', hint: null },
          missing_features: { main: 'Missing necessary features', hint: null },
          storage_sync: { main: 'Issues with storage sync', hint: ' (Google Drive / Amazon S3)' },
          performance: { main: 'Performance issues', hint: null },
          switching_tool: { main: 'Switching to another tool', hint: null },
          no_longer_need_dam: { main: 'No longer need a DAM', hint: null },
          other: { main: 'Other reasons', hint: ' (Please specify below)' },
        },
      },
      OFFERS: {
        discount_monthly: {
          title: "Let's make it work for your budget.",
          description: "We don't want price to be the reason you leave. Claim a one-time 10% discount for the next 3 months.",
          cta: 'Apply 10% Discount',
        },
        discount_yearly: {
          title: "Let's make it work for your budget.",
          description: "We don't want price to be the reason you leave. Claim a one-time 20% discount for the next billing cycle.",
          cta: 'Apply 20% Discount',
        },
        setup_call: {
          title: 'Let us do the heavy lifting:',
          description: 'Setting up a DAM shouldn\'t be a headache. Book a free, 30-minute session with our Customer Success expert. We\'ll configure your workspace and show you the best workflows for your team.',
          cta: 'Book a Free Setup Call',
        },
        product_call: {
          title: 'We might already be building it!',
          description: 'Before you go, check out our product roadmap or talk to our team. The feature you need might be rolling out next week, or we can suggest a quick workaround.',
          cta: 'Book a call with Product Team',
        },
        tech_support: {
          title: 'Sync issues are frustrating. Let us fix it:',
          description: 'Storage sync can sometimes be tricky depending on your Google/AWS permissions. Our tech team can resolve this for you in minutes. Let\'s get it sorted before you give up.',
          cta: 'Chat with Tech Support',
        },
        account_manager: {
          title: 'Before you make the switch...',
          description: 'Migrating data is a pain. Let\'s talk about why the other tool caught your eye. We might be able to match their offer or show you a better way to do it in Pics.io.',
          cta: 'Talk to an Account Manager',
        },
      },
      SUCCESS_TOAST: {
        title: 'Cancellation request received.',
        description: 'We\'ll process it shortly and reach out if we need any confirmation from you.',
      },
      ERROR_TOAST: {
        title: 'Request subscription cancellation',
        description: 'Something went wrong. Please try again or contact support@pics.io.',
      },
    },
    titleCard: 'Card',
    titleCardAndCoupon: 'Card and coupon',
    textRedeemCoupon: 'Redeem coupon',
    textAddCoupon: 'Add coupon',
    textTotal: 'Total',
    month: 'mo',
    year: 'yr',
    textPoweredBy: 'Powered by',
    textPaymentNote: `${appName} does not store any credit card information. All payments are processed in Stripe.`,

    planIndividualsText: 'Perfect for individuals',
    planIndividualsWebsites: 'Websites',
    planIndividualsTeammates: 'Teammates',
    textMonth: 'month',
    textUsers: 'Up to <b>{value}</b> users in your team',
    textFreeWebsites: 'free websites',
    textEditCard: 'Edit card',
    textAddCard: 'Add card',
    textCardChange: 'Change card',
    textCardNoAdded: 'No card added',
    textCardAdd: 'Add new card',
    textValidate: 'Validate',
    addCardDetails: 'Add card details',
    editCardDetails: 'Edit card details',
    cardForm: {
      cardNumber: 'Card number',
      expirationDate: 'Expiration date',
      securityCode: 'Security code',
      cardNumberPlaceholder: '0000 0000 0000 0000',
      expirationDatePlaceholder: 'MM / YY',
      securityCodePlaceholder: 'CVC',
    },

    textAppliedCoupon: (id, off, duration) => (
      <span>
        Applied coupon <span>{id}</span> <br /> -{off} {duration}{' '}
      </span>
    ),
    updateAiKitVersionTitle: 'Update AI Kit version',
    updateAiKitVersionText: (
      <div>
        <span>
          You’re using the legacy version of AI Kit.We’ve expanded Video
          Intelligence and introduced a new version of AI Kit with a modular
          structure, so teams can enable only the capabilities they need:
        </span>
        <ul className="p-l-15">
          <li className="f-w-5 white-text">Image Intelligence</li>
          <li>
            <span className="f-w-5 white-text">
              Video & Audio Intelligence Kit
            </span>{' '}
            (transcription plus extended video analysis)
          </li>
        </ul>
        <div>
          You can activate one or both add-ons.Switching to the new AI Kit will
          replace your current add-on and apply a new pricing.
        </div>
        <br />
        <InfoBlock>
          This is a one-way migration. After switching, the legacy AI Kit will
          be permanently removed and cannot be restored.
        </InfoBlock>
      </div>
    ),
    updateAiKitVersionOkBtn: 'Switch to new AI Kit',
    checkoutSubscribe: 'Subscribe',
    proceedButton: 'Proceed',
    confirmAiKitPurchaseTitle: 'Complete Your AI Kit Purchase',
    confirmAiKitTierTitle: 'Confirm AI Kit Monthly purchase',
    confirmAiKitTierText: () => (
      <div>
        <p>
          You are subscribing to the{' '}
          <strong className="f-w-5">AI Kit Monthly</strong> add-on.
        </p>
        <p>
          To enable{' '}
          <strong className="f-w-5">Visual & Similar Images Search</strong>,
          your current library requires a one-time indexing.
        </p>
        <ul>
          <li>
            <strong className="f-w-5">AI Kit Monthly: </strong> Indexing costs{' '}
            <strong className="f-w-5">$0.016 per asset</strong> (e.g., $160 for
            10k assets).
          </li>
          <li>
            <strong className="f-w-5">AI Kit Yearly: </strong> Initial indexing
            is <strong className="f-w-5">included for free.</strong>
          </li>
        </ul>
      </div>
    ),
    confirmAiKitTierTextMontlyImportant: () => (
      <>
        <strong>Important:</strong> You won't be charged the fee now. Contact
        support when you are ready to index your existing assets. Future uploads
        are indexed automatically at no cost.
      </>
    ),
    btnSwitchToYearly: 'Switch to Yearly',
    btnContinueWithAIKitMonthly: 'Continue with Monthly',
    confirmAiKitPurchaseText: (planName, payDate) => `Since you're adding the AI Kit after subscribing to the Pics.io <b>${planName}</b>, we've aligned its renewal date with your plan to make billing easier.<br><br> This means both the AI Kit and your main subscription will renew on the same date, and any unused assets or minutes will reset at that time.<br><br> Your Pics.io <b>${planName}</b> is set to renew on ${payDate}, along with all associated add-ons.`,
    confirmationChangeTitle: 'Change subscription plan',
    confirmationUpdateTitle: 'Update subscription',
    confirmationDowngradeAiKitTitle: 'Confirm AI Kit tier downgrade',
    confirmationDowngradeAiKitText: (currentTierName, selectedTierName) => (
      <div>
        <p>
          You’re about to downgrade your AI Kit add-on from Tier{' '}
          <strong className="f-w-5">{currentTierName}</strong> to Tier{' '}
          <strong className="f-w-5">{selectedTierName}</strong>. With this
          change, you’ll lose access to the Pro version of Visual & Similar
          Images Search and keep only the Basic version:
        </p>
        <InfoBlock>
          <div>
            <strong className="f-w-5">Basic:</strong> Finds visually similar
            images by matching patterns, colors, and shapes.
          </div>
          <br />
          <div>
            <strong className="f-w-5">Pro:</strong> Finds visually and
            semantically related images by using AI to understand the meaning of
            an image by its metadata and visuals.
          </div>
        </InfoBlock>
        <p>
          After the downgrade, Visual & Similar Images Search will work only in
          Basic mode, and you won’t be able to use the Pro capabilities.
        </p>
      </div>
    ),
    btnKeepCurrentTier: 'Keep current tier',
    btnPurchaseTierAnyway: (tierNumber) => `Purchase Tier ${tierNumber} anyway`,
    confirmationChangePlan: (planName) => `You are about to change your plan to <b>${planName}</b>.<br><br> Confirm that action`,
    confirmationUpdatePlan: (addedAddons, removedAddons) => (
      <div>
        <p>You are about to update your subscription with add-ons</p>
        {addedAddons.length > 0 && (
          <p>
            <b>Added:</b> {addedAddons.join(', ')}
          </p>
        )}
        {removedAddons.length > 0 && (
          <p>
            <b>Removed:</b> {removedAddons.join(', ')}
          </p>
        )}
      </div>
    ),

    textEnterAmount: 'Please enter amount you want to buy (USD)',
    placeholderNumber: 'Number',
    textBuy: 'Buy',

    titleTransactionComplete: 'Transaction complete',
    textYouBought: (amountValue) => `You bought ${amountValue} credits. Your balance is now`,

    titleTransactionFailed: 'Transaction failed',
    textTryAgain: 'Error, please try again later',
    textBuyAiCreditsFailed: `Can't buy AI credits. Please try again later or contact <a class='picsioLink' href='mailto:${supportEmail}'>${supportEmail}</a>.`,

    statusPaid: 'Paid',
    statusUnpaid: 'Unpaid',
    statusUpcoming: 'Upcoming',

    storageDisabledByPlan: 'Available starting with<br />Solo',
    storageDisabledBySize:
      'The amount of data exceeds the<br />capacity of the plan.',
    storageSizeUserUsing: (amount, unit) => `You are using ${amount} ${unit}`,
    textRequestMoreStorage: 'Request more storage',
    textProcessingRequest: 'Processing request...',
    DIALOG_LIMITS_EXCEEDED: {
      title: 'Limit exceeded',
      text:
        'On your current plan you have more teammates or websites than is included into the price of the plan you want to upgrade to. Ask our support team to add extra teammates or websites to your account on a target plan',
      btnOk: 'Write to support',
    },
    textStorageRequest:
      'Request for additional storage sent. Our support team will contact you shortly',
    titlePlanTotalAccount: (planName) => `${planName} plan`,
    titleStorageTotalAccount: (storageName) => `${storageName} ${appName} storage`,
    titleTrial: 'Trial',
    titleDiscount: 'Discount',
    tooltipAddonLimitations:
      'Please note that this functionality is available as add-on',
    helpText: `Learn how to set up billings in ${appName}`,
    couponPlaceholderText: 'Add coupon',
    couponButtonText: 'Apply discount code',
    discountModalTitle: 'Apply discount',
    discountModalDescription: 'Enter your code below to apply a discount to your plan',
    discountModalInputPlaceholder: 'Enter code',
    discountModalApply: 'Apply',
    discountModalError: 'This code is invalid or expired',
    aiAssetsLimit: 'AI assets limit',
    aiMinutesLimit: 'AI minutes limit',
    similarImageAndVisualSearch: 'Similar Images & Visual Search',
    tierProgression: 'Tier progression',
    tierFeatureCurrentTier: 'Current tier',
    tierFeatureAssetLimit: 'AI Assets limit',
    tierFeatureTranscriptionLimit: 'AI Minutes limit',
    tierFeatureVisualSearch: () => <>Visual Search</>,
    tierFeatureAddonCost: <>Add-on cost</>,
    aiKitTooltipText:
      'The AI assets and minutes included in your selected tier are available only during the paid billing cycle. Unused amounts will not be carried over and will reset at the end of each billing period.',
    aiKitUsedAssetsLabel: 'AI Assets limit',
    aiKitUsedAssetsSubLabel: '(assets)',
    aiKitUsedMinutesLabel: 'AI Minutes limit',
    aiKitUsedMinutesSubLabel: '(minutes)',
    aiKitIntercomMsg: `Hello ${appName} Support Team, I am interested in exploring a custom pricing option for the AI Kit add-on that better suits my specific needs`,
    aiKitIntercomDowngradeMsg: `Hello ${appName} Support Team, I would like to request a downgrade for my current AI Kit add-on tier. Could you please guide me through the process of making this change?`,
    aiKitUpgradeToastText:
      'Your AI Kit has been upgraded to the next tier as you’ve exceeded your current limit.',
    aiKitImageIntelligenceUpgradeToastText:
      'Your Image Intelligence Kit has been upgraded to the next tier as you’ve exceeded your current limit.',
    aiKitVideoIntelligenceUpgradeToastText:
      'Your Video & Audio Intelligence Kit has been upgraded to the next tier as you’ve exceeded your current limit.',
    btnSeeDetails: 'See details',
    aiKitImageIntelligenceLabel: 'AI assets limit',
    aiKitVideoIntelligenceLabel: 'AI minutes limit',
    aiKitInfoVisualSearch: () => (
      <>
        <a
          href="https://help.pics.io/en/articles/9969917-pics-io-visual-search"
          target="_blank"
          rel="noreferrer"
          tabIndex="0"
          aria-label="https://help.pics.io/en/articles/9969917-pics-io-visual-search"
          className="picsioLink"
        >
          Visual Search
        </a>{' '}
        availability: This feature is included from Tier 3 onwards.
      </>
    ),
    aiKitInfoText: (onClick) => (
      <>
        If none of the presented tiers meet your needs, you can{' '}
        <span className="picsioLink" onClick={onClick}>
          request a custom AI Kit
        </span>{' '}
        tailored to include only the specific services you require.
      </>
    ),
    aiKitTierTooltipText: (tierName, assetsCount, minutes, frequency) => (
      <div>
        <div>Each AI Kit tier includes a shared pool of AI assets</div>
        <div>
          limit for image-based services and AI Minutes for audio/video
          transcription
        </div>
        <br />
        <div className="tierFeature__tooltipHeader">
          AI Kit {tierName} offers:
        </div>
        <ul className="tierFeature__tooltipList">
          <li>
            {assetsCount} AI Assets / {frequency} — shared across keyword &
            description generation, face recognition
          </li>
          <li>
            {minutes} AI Minutes / {frequency} — for transcribing video and
            audio
          </li>
        </ul>
        <br />
        <div>Notes:</div>
        <ul>
          <li>
            One AI asset = one task performed by any image-based AI service
          </li>
          <li>AI minute = one minute of audio/video transcribed</li>
          <li>
            Visual & Similar Images Search availability: included at no cost
            with yearly subscriptions; requires a library size-based one-time
            search indexing fee on monthly subscriptions
          </li>
        </ul>
        <br />
        <div>
          Once the number of performed AI actions / minutes exceeds the
          allocated limit, the system will automatically upgrade you to the next
          tier for a seamless workflow.
        </div>
      </div>
    ),
    aiKitTierImageTooltipText: (tierName, assetsCount, frequency) => (
      <div className="p-10">
        <div className="tierFeature__tooltipHeader">
          AI Kit Tier {tierName} offers:
        </div>
        <ul className="tierFeature__tooltipList">
          <li>
            {assetsCount} AI assets / {frequency} — shared across keyword &
            description generation, and face recognition.
          </li>
        </ul>
        <div>Notes:</div>
        <ul className="tierFeature__tooltipList">
          <li>
            One AI asset = one task performed by any image-based AI service.
          </li>
          <li>
            Visual & Similar Images Search availability: included at no cost
            with yearly subscriptions, requires a library size-based one-time
            search indexing fee on monthly subscriptions.
          </li>
        </ul>
        <div>
          Once your usage exceeds the allocated limit, the system will
          automatically upgrade you to the next tier for a seamless workflow.
        </div>
      </div>
    ),
    aiKitTierVideoTooltipText: (tierName, minutes, frequency) => (
      <div className="p-10">
        <div className="tierFeature__tooltipHeader">
          AI Kit Tier {tierName} offers:
        </div>
        <ul className="tierFeature__tooltipList">
          <li>
            {minutes} AI minutes / {frequency} — for transcribing video and
            audio.
          </li>
        </ul>
        <ul className="tierFeature__tooltipList">
          <li>One AI minute = one minute of transcribed audio/video.</li>
        </ul>
        <div>
          Once your usage exceeds the allocated limit, the system will
          automatically upgrade you to the next tier for a seamless workflow.
        </div>
      </div>
    ),
    updatePlanBanner: {
      title: 'Your plan is discontinued',
      collapseTitleOpen: 'Expand to see key changes',
      collapseTitleClose: 'Close the detailed comparison',
      description: (actualSubscribedPrice) => (
        <span>
          While you are subscribed to a legacy plan and the price will stay the
          same as long as you keep this plan ({actualSubscribedPrice}), note
          that it does not contain the latest features available in our updated
          plans.
        </span>
      ),
      compareText: <span> Below are the key features you're missing:</span>,
      buttonText: 'Update plan',
      headerContent: {
        keyFeatures: 'Key features',
        currentVersionOfPlan: 'Current version of the plan',
        updatedVersionOfPlan: 'Updated version of the plan',
      },
      planRowLabels: {
        CSVImport: 'CSV import add-on',
        oktaSSO: 'Okta SSO add-on',
        watermarks: 'Number of watermarks',
        apiAddon: 'API add-on',
        websites: 'Number of websites',
        branding: 'Branding add-on cost',
        aiKit: 'AI Kit add-on',
        visualSearch: 'Visual Search',
        faceRecognizing: 'Face Recognition',
        autoKeywording: 'Auto-Keywording',
        imageCaptioning: 'Image Captioning',
        audioVideoTranscription: 'Audio/Video Transcription',
        advancedFilterPanel: 'Advanced filter panel',
        storageQuota: 'Storage quota',
      },
    },
    updateAIKitBanner: {
      title: 'Your AI Kit add-on is discontinued',
      collapseTitleOpen: 'Open the detailed comparison',
      collapseTitleClose: 'Close the detailed comparison',
      descriptionAmount: (aiKitAddonAmount) => `Your AI Kit is now a legacy add-on. While you can keep it on your legacy add-on at ${aiKitAddonAmount}, it won’t receive the latest updates of AI Kit features. Below are the key capabilities available only in the new AI Kit:`,
      description:
        'Your AI Kit is now a legacy add-on. While you can keep it on your legacy add-on, it won’t receive the latest updates of AI Kit features. Below are the key capabilities available only in the new AI Kit:',
      headerContent: {
        keyFeatures: 'Key features',
        currentVersionOfPlan: 'Current AI Kit version',
        updatedVersionOfPlan: 'Updated AI Kit version',
      },
      planRowLabels: {
        differentAIKits: '2 Different AI Kits',
        imageIntelligenceFeatures: 'Image Intelligence features:',
        visualSearchPro: 'Visual Search Pro',
        visualSearchBasic: 'Visual Search Basic',
        similarImagesSearch: 'Similar Images Search',
        faceRecognition: 'Face Recognition',
        imageCaptioning: 'Image Captioning',
        videoIntelligenceFeatures: 'Video & Audio Intelligence features:',
        imageAutoKeywording: 'Image Auto-Keywording',
        videoAutoKeywording: 'Video Auto-Keywording',
        videoAudioTranscription: 'Video/Audio Transcription',
        aiVideoSummary: 'AI Video summary',
        videoTextRecognition: 'Video text recognition',
        videoAudioChapters: 'Video/Audio chapters',
        videoActionRecognition: 'Video action recognition',
      },
    },
    updatePlanDialog: {
      title: 'Update subscription plan',
      description: (currentPrice, newPrice) => (
        <>
          <div>
            <span>
              Your current plan costs {currentPrice}, while the updated version
              is {newPrice}.
            </span>
          </div>
          <br />
          <div>
            <span>
              By updating the plan, you gain access to the latest updates and
              features outlined in the info block, all designed to boost
              efficiency, streamline workflows, and deliver greater value to
              your business.
            </span>
          </div>
          <br />
          <div>
            <span>Would you like to proceed with the update?</span>
          </div>
        </>
      ),
      textBtnOk: 'Yes',
      textBtnCancel: 'No',
    },
    imageAIKit: {
      basicInfoText: () => (
        <div className="d-flex ai-center">
          <span className="f-w-5 highlighted m-r-4">Basic:</span> Finds visually
          similar images by matching patterns, colors, and shapes.
        </div>
      ),
      proInfoText: () => (
        <div>
          <span className="f-w-5 highlighted">Pro:</span> Finds visually and
          semantically related images by using AI to understand the meaning of
          an image by its metadata and visuals.
        </div>
      ),
      indexingFeeInfoText: () => (
        <div className="d-flex ai-start">
          <span>
            A{' '}
            <span className="f-w-5 highlighted m-r-4">
              one-time indexing fee
            </span>{' '}
            applies to monthly plans. This fee is waived for yearly
            subscriptions.
          </span>
        </div>
      ),
      customTierInfoText: (onClick) => (
        <div>
          <>
            If none of the presented tiers meet your needs, you can{' '}
            <span className="picsioLink" onClick={onClick}>
              request a custom AI Kit
            </span>{' '}
            tailored to include only the specific services you require.
          </>
        </div>
      ),
      basic: 'Basic*',
      pro: 'Pro*',
      indexingFee: 'indexing fee required',
      indexingFeeIncluded: 'indexing fee included',
    },
    aiKitTierDisableTooltipText:
      'To use these features, need to upgrade the plan from the older version to the current one',
  },

  RESIZER: {
    showPanel: 'Show panel',
    hideOrResize: 'Hide or resize panel',
    expandFilters: 'Expand filters',
    collapseFilters: 'Minimize filters',
  },

  REORDER: {
    title: "Can't set custom sorting",
    text:
      'Your current sorting is <b>Best Match</b>. Please select other sorting and try again.',
  },

  CUSTOMFIELDS: {
    alertCantUpdateData: `Can't update data. Please try again. Contact <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support if the error repeats.`,
  },

  CUSTOMFIELDSSCHEMA: {
    configTypesString: 'Text',
    configTypesInt: 'Number',
    configTypesEnum: 'List',
    configTypesBoolean: 'Checkbox',
    configTypesDate: 'Date',
    configTypesSeparator: 'Group',

    configVisibilityHidden: 'Hidden',
    configVisibilityVisible: 'Visible',
    configVisibilityHiddenWhileEmpty: 'Hidden while empty',

    alertCantLoadData: `Can't load custom fields data. Please try again. Contact <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support if the error repeats.`,

    title: picsioConfig.isPim
      ? 'Custom Attributes Schema'
      : 'Custom Fields Schema',
    textReorder: 'To reorder drag and move',

    inputPlaceholderEnterTitle: 'Enter title',
    textButtonDelete: 'Delete',
    textButtonCancel: 'Cancel',

    textErrorNameEmpty: 'Name cannot be empty',
    textNameRequired: 'Name is required to save',
    textErrorTitleEmpty: '"Title" - is empty',
    textErrorTitleTaken: 'The "Title" you\'ve entered is already taken',
    textErrorDbCant: "db can't handle it",

    // textFieldEmpty: 'Field {field} is empty.',
    textErrorTitleName:
      'Only letters, numbers, underscore and dash are allowed',
    textErrorTitleNameSpace:
      'Only letters, numbers, underscore, dash, and space are allowed',
    textErrorTitleNameProductAttribute:
      'Only letters, numbers, dash, and space are allowed',
    textErrorComma: "Can't set comma in options name, please use another sign",
    textErrorLengthLimit: (limit) => `You have reached character limit (${limit})`,
    textErrorNameAlreadyExist: (name) => `Custom field name "${name}" already exist`,
    textErrorNameAlreadyExistProductAttribute: (name) => (
      `Product attribute name "${name}" already exists`
    ),
    textTooltipCustomSort: 'Drag & drop to reorder values in the list',

    type: 'Type',
    subType: 'Select sub-type',
    createGroup: 'Create new group',
    createField: picsioConfig.isPim
      ? 'Create new attribute'
      : 'Create new custom field',
    editGroup: 'Edit Group',
    editField: 'Edit Custom Field',
    edit: 'Edit',

    labelName: 'Name',
    placeholderName: 'Enter Name',
    captionName: 'Use Latin characters, do not put spaces and punctuation.',
    captionNameProductAttribute: (
      'Use letters, numbers, spaces and dash. Name must be unique among product attributes.'
    ),
    labelDescription: 'Description',
    placeholderDescription: 'Describe its purpose... (optional)',
    addNewItem: 'Add new item to the list',
    btnSave: 'Save',
    btnAdd: 'Add',

    uploadText: 'Select your .picsioconf for upload.',
    btnSubmit: 'Import scheme',
    btnExport: 'Export',
    btnImport: 'Import',
    textImportError: () => (
      <div>Schema cannot be imported. Refresh try again</div>
    ),
    textMoveFieldError: () => (
      <div>Custom field cannot be moved. Refresh and try again</div>
    ),
    deleteWarning: {
      title: 'Restricted custom field detected',
      text:
        "You're about to delete the required custom field for uploads and revisions. Are you sure you want to complete this action?",
      btnOk: 'Confirm',
      btnCancel: 'Cancel',
    },
    deleteConfirm: {
      titleField: picsioConfig.isPim
        ? 'Delete custom attribute'
        : 'Delete custom field',
      titleGroup: 'Delete group',
      textField: (name) => `Are you sure you want to delete "${name}"?`,
      textGroup: (name) => `Are you sure you want to delete the group "${name}" with all its fields?`,
    },
    changeTypeWarningDialog: {
      title: 'Warning',
      text: picsioConfig.isPim
        ? 'Values for this custom attribute were set on some products or variants. Do you want to proceed with changing the attribute type and reset those values?'
        : 'Values for this custom field were set for some assets. Do you want to proceed with changing the field type and reset those values for all assets?',
      textBtnOk: 'Reset',
    },
    changeTypeLimitDialog: {
      title: 'Error',
      text: picsioConfig.isPim
        ? 'Changing the type of the attribute will affect too many products which may cause performance and data integrity issues. To prevent this, we change attribute types only via our support engineers'
        : 'Changing the type of the field will affect too many assets which may cause performance and data integrity issues. To prevent this, we change field types only via our support engineers',
      textBtnOk: 'Write to support',
    },
    helpText: 'Learn how to configure custom fields',
    customFieldsInfoBlockText: (
      <>
        The custom fields visibility setting is now set relative to roles in
        team settings.
        <br />
        You can check it here{' '}
        <a className="picsioLink" href="/teammates?tab=roles" target="_blank">
          My team / Roles / Asset metadata fields configuration
        </a>
      </>
    ),
    tabCustomMediaAttributes: 'Custom media attributes',
    tabCustomProductAttributes: 'Custom product attributes',
    tabCustomVariantAttributes: 'Custom variant attributes',
    missingScopeWarning: (
      'Some product attributes are missing the required scope field. '
      + 'Update them manually before creating new attributes.'
    ),
  },

  DOWNLOADDIALOG: {
    titleDownload: 'Download',
    titleDownloadOptions: 'Download options',
    bulkDownloadTitle: 'Bulk download options',
    presetSelectorLabel: 'Download as',
    downloadWithAssetCount: (n) => `Download ${n} files`,
    textFilename: 'Filename:',
    textSize: 'Size:',
    textNumberOfFiles: 'Number of files:',
    textTotalSize: 'Total size:',
    labelQuality: 'Quality',
    qualityHiddenPngNote: 'PNG is a lossless format. Quality does not apply.',
    labelSize: 'Size',
    labelPixels: 'Pixels',
    labelResolution: 'Resolution',
    labelUnits: 'Units',
    labelDownloadAs: 'Compress to ZIP',
    labelDownloadWithoutWatermark: 'Download without watermark',
    labelOrganizeBy: 'Organize into folders by collection',
    textDownload: 'Download',

    textAsOriginal: 'As original',
    textSaveAsOriginal: 'Save as original',
    textLargestSide: 'largest side',
    textWidth: 'width',
    textHeight: 'height',

    tooltipOrganize: 'To choose this option, check “Compress to ZIP” first.',
    titleErrorCantCreateArchive: 'Error creating archive',
    errorCantCreateArchive: `Cannot compress to ZIP. Try again later or contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a>.`,
    errorDownloadingTitle: 'Download failed',
    errorDownloading: `Assets weren’t downloaded. Please try again. If the error persists, contact <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a>`,
    getDownloadPresetError: `Cannot get download preset list. <br> Try again later or contact <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}.</a>.`,
    createDownloadPreset: 'Create download preset',
    saveDownloadPreset: 'Save download preset',
    saveDownloadPresetError: `Cannot save download preset.<br> Try again later or contact<br> <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}.</a>.`,
    removeDownloadPreset: 'Delete download preset',
    removeDownloadPresetText: (presetName) => `You are about to delete ${presetName} preset`,
    removeDownloadPresetError: `Cannot remove download preset.<br> Try again later or contact <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}.</a>.`,
    originalPresetInfoText: () => (
      <>
        To edit image settings, select the <strong>Custom</strong> preset below.
      </>
    ),
    unsupportedFormatsWarning: (count) => (
      <>
        <strong>{count}</strong>
        {' '}
        {count === 1 ? 'asset has an unsupported format' : 'assets have unsupported formats'}
        {' '}for these settings and will be skipped. Only supported assets will be downloaded with the selected settings.
      </>
    ),
    lockedSettingTooltip: () => <span style={{ textAlign: 'center' }}>Select Custom preset under 'Download as'<br /> to unlock this setting.</span>,
    suggestImprovement: {
      title: 'Suggest improvement',
      text: 'Please suggest an improvement for the download options',
      placeholder: 'Enter your suggestion',
    },
    suggestImprovementLocation: 'Download',
    selectFormatFirstTooltip: 'Select format first',
  },
  COPY_ASSETS_DIALOG: {
    title: 'Copy options',
    bulkCopyTitle: 'Bulk copy options',
    presetSelectorLabel: 'Copy as',
    cropSectionTitle: 'Crop',
    cropRatioLabel: 'Crop ratio',
    cropAspectLabel: 'Aspect ratio',
    cropAspectOriginal: 'Original',
    cropAspectFree: 'Free',
    cropAspectFreeForm: 'Free form',
    cropAspect1_1: '1:1',
    cropAspect4_3: '4:3',
    cropAspect3_4: '3:4',
    cropAspect4_5: '4:5',
    cropAspect16_9: '16:9',
    cropAspect9_16: '9:16',
    cropWidthLabel: 'Crop width',
    cropHeightLabel: 'Crop height',
    transformationModeCrop: 'Crop',
    transformationModeResize: 'Resize',
    resizeWidthLabel: 'Resize width',
    resizeHeightLabel: 'Resize height',
    switchModeTitle: 'Switch editing mode?',
    switchModeText: 'You cannot apply both modes simultaneously. Switching will discard your current unsaved changes.',
    switchModeContinue: 'Switch mode',
    switchModeCancel: 'Cancel',
    presetSizeLabel: 'Size',
    presetSafeAreaLabel: 'Safe area inside',
    cropLoading: 'Loading preview…',
    cropLoadError: 'Preview could not be loaded. You can still copy without cropping.',
    cropBulkHint: 'Visual crop is available when a single image is selected. Bulk copies use format and resize options only.',
    btnCancel: 'Cancel',
    btnOk: 'Confirm',
    createCopyPreset: 'Create new copying preset',
    saveCopyPreset: 'Save copying preset',
    saveCopyPresetError: `Cannot save copying preset.<br> Try again later or contact <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}.</a>.`,
    removeCopyPreset: 'Delete copying preset',
    removeCopyPresetText: (presetName) => `You are about to delete ${presetName} preset`,
    removeCopyPresetError: `Cannot remove copying preset.<br> Try again later or contact <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}.</a>.`,
    originalPresetInfoText: () => (
      <>
        To edit image settings, select the <strong>Custom</strong> preset below. The{' '}
        <strong>Original</strong> preset creates an exact copy.
      </>
    ),
    unsupportedFormatsWarning: (count) => (
      <>
        <strong>{count}</strong>
        {' '}
        {count === 1 ? 'asset has an unsupported format' : 'assets have unsupported formats'}
        {' '}and will be skipped. Changes will be applied only to supported assets.
      </>
    ),
    lockedSettingTooltip: () => <span style={{ textAlign: 'center' }}>Select Custom preset under 'Copy as'<br /> to unlock this setting.</span>,
    suggestImprovement: {
      title: 'Suggest improvement',
      text: 'Please suggest an improvement for the copying options',
      placeholder: 'Enter your suggestion',
    },
    suggestImprovementLocation: 'Create asset copy',
    selectFormatFirstTooltip: 'Select format first',
  },
  DIRECT_LINK_DOWNLOAD_DIALOG: {
    TITLE: () => 'Download by direct link',
    TEXT: (assets, urls, logger) => (
      <div>
        {pluralize('This', assets.length, false)}{' '}
        {pluralize('file', assets.length, false)}{' '}
        {pluralize('is', assets.length, false)} over 40MB and can be downloaded
        only via a web link: <br />
        <ul className="simpleList">
          {assets.map((asset, index) => (
            <li key={asset._id}>
              <a
                href={urls[index]}
                download={asset.name}
                onClick={() => logger(asset._id, asset.fileSize)}
              >
                {asset.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    ),
    errorText: "Can't get a link for direct download.",
  },

  DOWNLOAD_PANEL: {
    titleDownloading: 'Downloading',
    textRetry: 'Retry',
    textCancel: 'Cancel',
    titleDialogConfirm: 'Confirm removing',
    btnOkDialogConfirm: 'Remove',
    textDialogConfirm:
      'Are you sure you want to remove all files from download queue?',
    btnRemoveAll: 'Remove all',
    textFilesLeft: 'files left',
    textTotal: 'Total: ',
    textDownloadingComplete: 'Download completed',
    textDownloaded: 'downloaded',
    textDownloadingProgress: 'files, downloading in progress',
    titleNotEnoughFreeSpace: 'Not enough free space',
    textNotEnoughFreeSpace: 'There is not enough free space on your device for this operation.',
  },

  HISTORY: {
    textAdded: 'added',
    textVisualMark: 'visual mark',
    textRevision: 'revision',
    textAddMarker: 'Add marker',
    textPullToResize: 'Pull to resize',
    textPostComment: 'Post a comment to start a discussion.',
    textCommentImageIsRestricted:
      'Images cannot be inserted in comments. Delete this image and leave text only',
    textPlaceholderGuest: 'Guest',
    textPlaceholderAddComment: 'Add comment',
    textShowMarkers: 'Show markers',
    textHideMarkers: 'Hide markers',
    textCopyLink: 'Copy link',
    textSaveButton: 'Save',
    textCancelButton: 'Cancel',
    textEdit: '(edited)',
    textDeleteComment: 'Delete comment',
    textDownloadRevision: 'Download revision',
    textMetadataUpdated: 'Asset metadata updated',
    textTechnicalRevision: 'technical revision',
    textSeeDifference: 'See the difference',
    textShowAllMarkers: 'Show all markers',
    textHideAllMarkers: 'Hide all markers',
    textRevertRevision: 'Set as current revision',
    textNoteRemovedSuccess: 'Your revision was successfully removed',
    textNoteRemovedWasnt:
      "Your revision wasn't removed. Please try a bit later",
    textNoteLoadedWasnt: "Your revision wasn't loaded. Please try a bit later",
    textRevisionLoading: 'Revision is loading...',
    switchDialogTitle: 'Warning',
    toggleActiveCommentTitle: 'Marker from a different revision',
    switchDialogText:
      'This marker(s) belongs to a different revision. <br />Switch revisions?',
    switchDialogOk: 'Ok',
    switchDialogCancel: 'Cancel',
    tooltipAddMarkers: 'Click to add new marker',
    tooltipAddMarkersLocked: 'You can add markers to the latest version only',
    initialRevisionDialogText:
      'This revision is unavailable because it’s deleted from your cloud storage',
    textInitialRevision: 'Initial revision',
    approved: 'approved',
    disapproved: 'disapproved',
    titleDialogError: 'Error',
    titleDeletingCommentError: 'Error deleting comment',
    titleApproveError: 'Error approving asset',
    addMarker: 'Add marker',
    approve: 'Approve',
    proofingCommentsPlaceholder: 'No comments yet',
    textCommentDeleted: 'comment deleted',
    textErrorDeletingComment:
      "Your comment wasn't deleted. Please try a bit later",
    textErrorRevertRevision:
      'Cannot set a revision as current. Please try again later.',
    switchDialogTitleError: 'Error',
    textCantShowRevisionButDownload:
      'Unfortunately, revisions for this file format can’t be displayed. But you still may download it from the Activity panel.',
    textCantShowRevision: `Sorry, ${appName} cannot process this request. Please contact us at <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}<a>`,
    textRevisionAdded: (revisionNumber, synced) => (
      <span className="revisionText">
        {synced ? 'synced' : 'added'}{' '}
        <span className="revision">
          revision <span className="revisionNumber">{revisionNumber}</span>
        </span>
      </span>
    ),
    textRevisionIsACopyOf: (revisionNumber) => (
      <span className="revisionCopyText">
        (copy of <span className="revision">revision</span>{' '}
        <span className="revisionNumber">{revisionNumber}</span>)
      </span>
    ),
    textAssetNotFound:
      'Comment cannot be added because this asset does not exist in the library anymore',
    textEditCommentApiError:
      'Unexpected error occurred and comment was not added. Refresh and try again',
    textCreateCommentApiError:
      'Unexpected error occurred and comment was not added. Refresh and try again',
    textCantUpdateComment:
      'Unexpected error occurred and comment was not added. Refresh and try again',
    textCantAddComment:
      'Unexpected error occurred and comment was not added. Refresh and try again',
    textBtnRefresh: 'Refresh',

    deleteCommentDialog: {
      title: 'Delete comment?',
      text: (username) => `You are about to delete <b>${username}</b> comment. It will be removed for all viewers and can’t be undone.`,
      textBtnOk: 'Delete',
      textBtnCancel: 'Cancel',
    },
  },

  HOTKEYS: {
    actionSelectDeselect: '(de)select all',
    actionImportpanel: 'upload panel',
    actionTreeCollections: 'tree collections',
    actionInfopanel: 'info panel',
    actionSearch: 'search',
    actionDialogHotkeys: 'dialog hotkeys',
    actionScrollUp: 'Scroll up',
    actionScrollDown: 'Scroll down',
    actionScrollUpPage: 'Scroll up one page',
    actionScrollDownPage: 'Scroll down one page',
    actionScrollToBegining: 'Scroll to the beginning of a catalogue',
    actionScrollToEnd: 'Scroll to the end of a catalogue',

    actionMassDownload: 'mass download',
    actionFlagApprove: 'flag approve',
    actionFlagReject: 'flag reject',
    actionUnflag: 'unflag',
    actionRating: 'rating 1-5',

    actionColorRed: 'color red',
    actionColorYellow: 'color yellow',
    actionColorGreen: 'color green',
    actionColorBlue: 'color blue',
    actionColorNone: 'color none',

    actionPrevImg: 'previous asset',
    actionNextImg: 'next asset',
    actionClosePreview: 'close preview',
    actionHistorypanel: 'activity panel',

    actionSelectOneAsset: '(de)select one asset',
    actionSelectSomeAssets: '(de)select random assets',
    actionSelectRangeAssets: '(de)select assets in sequence',
  },

  KEYWORDSTREE: {
    title: 'Keywords',
    description:
      'Failed to load keywords. Click the button below to try again.',
    sortByAlphabetEl: 'Sort by name',
    sortByDateEl: 'Sort by last used',
    sortByHotEl: 'Sort by most used',
    buttonText: 'Load keywords',

    textPlaceholderText:
      "You don't have any keywords yet. Start adding them now",
    placeholderNewKeyword: 'Keyword name',
    textButtonCreate: 'Create new',

    inputPlaceholderSearch: 'Search keywords',

    textTooltipCreate: 'Create keyword',
    textTooltipCreateSub: 'Create sub-keyword',
    textTooltipDelete: 'Delete keyword',
    textTooltipDeleteKeywords: (count) => `Delete selected ${pluralize('keyword', count)}`,
    textTooltipRename: 'Rename keyword',
    textTooltipRemove: 'Remove from favorites',
    textTooltipAddToFavorites: 'Add to favorites',
    textTooltipMerge: 'Merge selected keywords into this keyword',

    errorKeywordsDeleting: () => (
      <>Keywords cannot be deleted. Refresh and try again</>
    ),

    errorKeywordMerging: () => (
      <>Selected keywords cannot be merged. Refresh and try again</>
    ),

    textTitleGenerateKeywords: 'Generate keywords',
    textTextGenerateKeywords:
      'You are about to generate keywords for all assets in your library.',
    textGenerate: 'Generate',
    textEnoughCredits:
      'Unfortunately you have not enough credits to autofill keywords.',
    textGenerationgInBackground:
      'Keywords are generating in background... Refresh page in few minutes.',
    textAskTeamowner:
      ' Please ask your team owner / billing manger to buy credits.',
    textGoToBillingpage: ' Please go to billing page to buy credits.',
    textOpenBilling: 'Open Billing',
    placeholderFooterText: picsioConfig.isPim
      ? 'Import a pre-made list of tags to quickly categorize and enhance searchability for your media or products.'
      : 'or <br><br> Use AI to auto-generate keywords for your library assets or import a pre-made list.',
    tooltiopDisabledAddForm:
      'Your account does not have permission to create keywords',
    btnUploadDictionary: 'Import keyword list',
    tooltipUploadDictionary: 'Please use .csv or .txt files for uploading',
    tooltipDisabledUploadDictionary:
      'Your account does not have permission to import a keyword list',
    tooltipDisabledAIGeneration:
      'Your account does not have permission to use AI keyword generation',
    btnGenerateKeywords: 'Generate keywords',
    tooltipGenerateKeywords: 'Automatic keyword generation using AI',
    tooltipDisabledGenerateKeywords:
      'Your account does not have permission to generate keywords automatically using AI',
    tooltipControlledVocabularyEnabled:
      'Controlled Vocabulary enabled. Click to deactivate.',
    tooltipControlledVocabularyDisabled: 'Enable Controlled Vocabulary',
    tooltipControlledVocabularyEnabledAndNoPermission: () => (
      <div>
        <span>Controlled Vocabulary feature is enabled</span>
      </div>
    ),
    tooltipControlledVocabularyDisabledAndNoPermission: () => (
      <div>
        <span>Controlled Vocabulary feature is disabled.</span>
        <br />
        <span>Contact your team admins to turn it on.</span>
      </div>
    ),
    tooltipAiKeywords: 'Automatic keyword generation using AI',
    tooltipImportKeywordsList: 'Import keyword list',
    tooltipDisableControlledVocabularyToImport:
      'Disable Controlled Vocabulary to use the Import keyword list functionality',
    tooltipDisableControlledVocabularyToAI:
      'Disable Controlled Vocabulary to use AI keyword generation',
    tooltipExportKeywordsList: 'Export keyword list',
    tooltipEditMode: 'Edit mode',
    tooltipExitEditMode: 'Exit Edit mode',
    tooltipDeleteSelectedKeywords: 'Delete selected keywords',
    textForSpinner: 'Processing <br> keywords generation',
  },
  FACESTREE: {
    title: 'Persons',
    description: 'Failed to load faces. Click the button below to try again.',
    buttonText: 'Load persons',
    inputPlaceholderSearch: 'Search persons',
    textPlaceholderText: 'There are no persons recognized yet',
    textTooltipDelete: 'Delete person',
    textTooltipDeleteUnnamed: 'Delete all unnamed faces',
    textTooltipRename: 'Rename person',
    textTooltipRemove: 'Remove from favorites',
    textTooltipAddToFavorites: 'Add to favorites',
    textEditPerson: 'Rename person',
    modalDeleteUnnamed:
      'You are about to delete all unnamed faces. This action cannot be undone. Do you want to proceed?',
    renameButton: 'Rename',
    deleteUnnamedPersonsTitle: 'Delete unnamed faces',
    confirm: 'Delete',
    cancel: 'Cancel',
    textDialogBtnOk: 'Find persons',
    senCollectionRecognizeDialogTitle: 'Select collection',
    textForSpinner: 'Processing images and finding persons',
    error: 'Faces were not deleted, try again later.',
    mergePersone: 'Merge faces',
    mergeInto: (name) => `Into assets with a face of ${name}`,
    mergeCountFace: (count, name) => `Merge ${pluralize('asset', count, true)} with a face of ${name}`,
    errorMergeFace: '',
    errorDialog: `Something went wrong. Please try again. Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support, if the error persists.`,
  },

  TREE_PLACEHOLDER: {
    createNew: 'Create',
    enterNewName: 'Enter new name',
  },

  MARKERS: {
    removeMarkerTooltip: 'Remove marker',
    removeBoundingBoxFrameTooltip: 'Delete face region',
    selectPerson: 'Select person',
  },

  CLIPBOARD: {
    title: 'Confirm action',
    text:
      'Assets can be selected only across collections. If you want to go to another tab, current selection will be lost. Please confirm this action.',
    btnCancelText: 'Cancel',
    btnConfirmText: 'Confirm',
  },

  DETAILS: {
    new: 'New',
    tooltipReplicatorRunning:
      'This asset metadata is not synchronized with Cloud Storage Account',
    tooltipKeywordingWaiting: 'Waiting to parse keywords',
    tooltipKeywordingRunning: 'Parsing keywords',
    tooltipKeywordingError: 'Failed to parse keywords',
    tooltipMetadatingWaiting: 'Waiting to parse metadata',
    tooltipMetadatingRunning: 'Parsing metadata',
    tooltipMetadatingError: 'Failed to parse metadata',
    tooltipIndexingNotAvailable: (
      <span>
        Indexing coverage limit for Visual & Similar Images Search reached,
        <br />
        some assets aren't included in search results.
        <br />
        Upgrade AI Kit tier to expand coverage.
      </span>
    ),
    tooltipNotIndexed: (
      <span>
        Makes assets in this collection searchable
        <br /> by Visual Search and Find Similar Images.
        <br />
        Click to enable AI Search.
      </span>
    ),
    tooltipNotIndexedDisabled: (
      <span>
        Indexing coverage limit for Visual & Images Search
        <br /> is less than the size of this collection.
        <br /> Upgrade AI Kit tier to expand coverage.
      </span>
    ),
    labelNotIndexed: 'Not indexed',
    autogenerateError: 'Not sufficient funds',
    aiCredits: 'AI credits',
    tooltipRename: 'Rename',
    tooltipLockMenu: 'Locking changes',
    tooltipMoreActions: 'More actions',

    tooltipLock: (param) => `${param} details panel for editing`,
    tooltipGenerateKeywords: 'Generate keywords',
    tooltipFaceRecognize: 'Recognize face',
    tooltipCreateBoundingBox: 'Draw face region',
    tooltipAddToCollection: 'Add to collection',

    textLock: 'Lock',
    textUnlock: 'Unlock',
    textUnlockAlways: 'Always unlock',
    textUnlockLogout: 'Unlock until logout',
    textLockAlways: 'Always lock',

    textDownload: 'Download',
    textDuplicate: 'Duplicate',
    textExportToCSV: 'Export CSV',
    textDelete: 'Move to trash',
    textDeleteForever: 'Delete forever',
    textRename: 'Rename',

    textResetToDefaultView: 'Reset to default view',

    textNoFiles: 'No assets',
    textSelectedAll: 'Add all to selection',
    textSelectedAllCollection: 'Add to selection all',
    textMainInfo: 'Main info',
    textCreatedBy: 'Created by:',
    textCreatedAt: 'Created at:',
    textUpdatedAt: 'Updated at:',
    textSyncedAt: 'Synced at:',
    textIndexStatus: 'Index status:',
    textIndexedAndAvailable: 'AI Searchable:',
    textAssetCount: 'Asset count:',
    textSyncButton: 'Sync this collection',
    textDeselectAll: 'Remove all from selection',
    textDownloadFiles: 'Download assets',
    textRemoveFromCollections: 'Remove from collection',
    textAssetsInCollection: 'assets in collection',
    textAssetFound: 'asset found',
    textAssetsFound: 'assets found',
    textNoAssets: 'There are no files in this collection',
    textAssetDuplicateFail: () => (
      <div>Asset cannot be duplicated. Refresh and try again</div>
    ),
    textAssetsLimitExceededError:
      'Up to 50,000 assets can be uploaded during trial. Delete some assets to upload more',
    textCopyAssetsLimitError:
      'No more than 100 assets can be duplicated in one go. Select fewer assets and try again',
    textRestrictedAssetsError:
      'Some selected assets are restricted and cannot be duplicated. Only not restricted assets will be duplicated',

    textMarkFace: 'Draw face region',
    textRecognizeFace: 'Recognize Faces',
    textRecognizingFace: 'Recognizing Faces',
    textGetMoreCredits: 'Get more',
    textTagWithAI: 'Tag With AI',
    textTagging: 'Tagging',
    textBueMoreRuns: 'Get more',
    textTranscribe: 'Transcribe',
    textTranscribing: 'Transcribing',

    textSelectedFiles: (collectionLength) => `Selected ${collectionLength} assets`,
    placeholderMultipleSelection: 'Multiple selection',
    placeholderMultipleSelectionRestricted: 'Restricted assets selected',
    placeholderEnterTitle: 'Enter title',
    placeholderUneditabledTitle: 'Title',
    placeholderEnterDescription: 'Enter description',
    placeholderAIDescription:
      'Enter manually or use AI to generate description',
    placeholderUneditabledDescription: 'Description',
    placeholderKeywords: (count) => (
      <>
        {count === 1 ? "This asset doesn't" : "These assets don't"} have any
        keywords.
        <br />
        Start adding them now.
      </>
    ),
    placeholderProductVariants: (count) => (
      <>
        {count === 1 ? "This asset isn't" : "These assets aren't"} linked to any
        product variants.
      </>
    ),
    placeholderProductLinks: (count) => (
      <>
        {count === 1 ? "This asset isn't" : "These assets aren't"} linked to any
        products or variants.
      </>
    ),
    placeholderTranscribe: (
      <>
        Generate transcripts, identify key moments, create chapters, tag
        keywords and extract on-screen text automatically.
        <br />
        Turn your video into searchable data.
      </>
    ),
    placeholderFaces:
      'Scan this asset for faces to simplify finding other assets featuring these individuals by clicking the button below',
    placeholderFacesWithoutPermission:
      "This asset hasn't been scanned for faces yet",
    textTitleAndDescription: 'Title & Description',
    textTitleAndDescriptionText: 'All changes save automatically',
    tooltipExpandIconDescription: 'Expand to full view',
    textProcessing: 'Processing',
    textKeywordsSuccess: 'Keywords attached',
    placeholderCustomTextField: 'Input new value',
    textCantUpdateKeywords: () => (
      <div>Keywords cannot be updated. Refresh and try again</div>
    ),
    textCantUpdateAssignees: (length) => (
      <div>
        {pluralize('Assignee', length)} cannot be updated. Refresh and try again
      </div>
    ),
    textCantUpdateAssetName: () => (
      <div>Asset name cannot be updated. Refresh and try again</div>
    ),
    textCantRemoveAsset: (length) => (
      <div>
        {pluralize('Asset', length)} cannot be removed. Refresh and try again
      </div>
    ),
    textCantDeleteAsset: (length) => (
      <div>
        {pluralize('Asset', length)} cannot be deleted. Refresh and try again
      </div>
    ),
    textCantRestoreAsset: (length) => (
      <div>
        {pluralize('Asset', length)} cannot be restored. Refresh and try again
      </div>
    ),
    textNotPermissionRestoreAsset:
      "You don't have permissions to restore assets to the previous collections. Please select a different location to restore them",
    textCantSetSingleAssetSettings: (
      <span>Asset settings cannot be changed. Refresh and try again</span>
    ),
    ASSETS_SHARE: {
      textDontHavePermission:
        "You don't have permission to share some of the selected assets. Deselect these assets to continue",
      textTitle: "Some assets can't be shared",
    },
    textCantPublishAssets: 'Assets cannot be published. Refresh and try again',
    textCantUnPublishAssets:
      'Assets cannot be unpublished. Refresh and try again',
    textKeywords: 'Keywords',
    textFaces: 'Faces',
    textTranscript: 'Transcript',
    textVideoAnalysis: 'Video & Audio Intelligence',
    titleGenerating: 'Generating...',
    textKeywordsGeneration: 'AI keyword generation started',
    textAssetsNotAllSupported:
      'Unsupported asset formats detected: only image assets will be processed.',
    titleNotEnoughCredits: 'Insufficient AI assets',
    textNotEnoughtCredits:
      'Unfortunately you have not enough credits to autofill keywords.',
    textReachedAutokeywordingLimit: (canNotBuyApiCalls, usersToWrite) => (
      <>
        You don’t have enough AI assets to process this item. This can happen if
        your AI assets are used up, or if processing this item would exceed your
        remaining balance.
        <Choose>
          <When condition={canNotBuyApiCalls}>
            <>
              Please ask your team admins{' '}
              {usersToWrite.map((user) => (
                <Tag
                  key={user._id}
                  type="user"
                  avatar={user.avatar}
                  text={user.email}
                />
              ))}{' '}
              to subscribe to the <b>AI Kit add-on</b> to continue using
              AI-powered services.
            </>
          </When>
          <Otherwise>
            <>
              To continue, subscribe to the <b>AI Kit add-on</b> (Image
              Intelligence), which includes auto-generated keywords, image
              captions, and face recognition.
            </>
          </Otherwise>
        </Choose>
      </>
    ),
    textReachedAiCreditLimit: (canNotBuyApiCalls, usersToWrite) => (
      <>
        You reached the limit of assets available for AI processing. <br />
        <Choose>
          <When condition={canNotBuyApiCalls}>
            <>
              Please ask your team admins{' '}
              {usersToWrite.map((user) => (
                <Tag
                  key={user._id}
                  type="user"
                  avatar={user.avatar}
                  text={user.email}
                />
              ))}{' '}
              to subscribe to the <b>AI Kit add-on</b> to continue using
              AI-powered services.
            </>
          </When>
          <Otherwise>
            <>
              To continue, subscribe to the <b>AI Kit add-on</b> (Image
              Intelligence), which includes auto-generated keywords, image
              captions, and face recognition.
            </>
          </Otherwise>
        </Choose>
      </>
    ),
    textCantAutokeywordingForSelectedAssets: (
      onClickHandler,
      canNotBuyApiCalls,
      usersToWrite,
      assetsLengthAllowedToKeywording,
    ) => (
      <>
        The number of assets selected for AI Keywording exceeds your current AI
        processing limit. Please select up to {assetsLengthAllowedToKeywording}{' '}
        assets.{' '}
        <Choose>
          <When condition={canNotBuyApiCalls}>
            <>
              Or please ask your team admins{' '}
              {usersToWrite.map((user) => (
                <Tag
                  key={user._id}
                  type="user"
                  avatar={user.avatar}
                  text={user.email}
                />
              ))}{' '}
              to subscribe to the <b>AI Kit add-on</b> to continue using
              AI-powered services.
            </>
          </When>
          <Otherwise>
            <>
              Click “Subscribe” below to add the <b>AI Kit</b> to your plan and
              continue using Face Recognition, Transcription, AI Keywording, and
              Image Captioning
            </>
          </Otherwise>
        </Choose>
      </>
    ),
    textCantDescribingForSelectedAssets: (
      onClickHandler,
      canNotBuyApiCalls,
      usersToWrite,
      totalAssetsAllowedForDescribing,
    ) => (
      <>
        The number of assets selected for Image Captioning exceeds your current
        AI processing limit. Please select up to{' '}
        {totalAssetsAllowedForDescribing} assets.{' '}
        <Choose>
          <When condition={canNotBuyApiCalls}>
            <>
              Or please ask your team admins{' '}
              {usersToWrite.map((user) => (
                <Tag
                  key={user._id}
                  type="user"
                  avatar={user.avatar}
                  text={user.email}
                />
              ))}{' '}
              to subscribe to the <b>AI Kit add-on</b> to continue using
              AI-powered services.
            </>
          </When>
          <Otherwise>
            <>
              Click “Subscribe” below to add the <b>AI Kit</b> to your plan and
              continue using Face Recognition, Transcription, AI Keywording, and
              Image Captioning.
            </>
          </Otherwise>
        </Choose>
      </>
    ),
    textOpenBilling: 'Open Billing',

    textAskTeamowner:
      ' Please ask your team owner / billing manager to buy credits.',
    textGoToBillingpage: ' Please go to billing page to buy credits.',
    titleError: 'Error',
    textServiceUnavailable:
      'This service is unavailable now. Please try again later.',
    textAssignees: 'Assignees',
    textShare: 'Share',
    textShareLink: 'Sharing link',
    textDirectLink: 'Direct URL for embedding',
    tooltipTextCdn:
      'You can customize your CDN link by configuring a custom domain or adjusting the preview size — just edit the link’s ending to set the resolution. For custom domain setup, contact our Support team.',
    cdnSelectedAssetsCount: (selectedAssetsWithCdnLinks, selectedItemsLenght) => `(${selectedAssetsWithCdnLinks} of ${selectedItemsLenght} selected assets already published to CDN)`,
    cdnCheckboxText: (value) => `${value ? 'Unpublish' : 'Publish'} to CDN`,
    textCdn: 'CDN',
    tooltipCopyAssetLinksForCsv: 'Copy asset links for CSV',
    legacy: 'LEGACY',
    legacyTooltip:
      'Embedding via the legacy sharing mechanism is no longer supported and is replaced by Pics.io’s CDN add-on to ensure better performance, stability, and fair use. Please contact our support team for keeping your existing embedding links functional.',
    // legacyTooltip: () => <span style={{ textAlign: 'center' }}>Starting July 9th, embedding via the legacy sharing mechanism will no longer be supported and will be replaced by Pics.io’s CDN add-on to ensure better performance, stability, and fair use. Please contact our support team for keeping your existing embedding links functional.</span>,
    textRestrict: 'Restrict',
    textCollections: 'Collections',
    textLightboards: 'Lightboards',
    textProducts: 'Products',
    textAltText: 'Alt text',
    textProductVariants: 'Product variants',
    textProductLinksMaster: 'Master',
    textProductLinksUnknownChannel: 'Unknown channel',
    tooltipProductLinkDetach: 'Remove from selected assets',
    tooltipPublishedLayerReadOnly: () => (
      <>
        Published layers are read-only.
        <br />
        Create a draft to edit.
      </>
    ),
    confirmDetachFromMasterProduct: {
      title: 'Warning',
      text: 'Are you sure you want to remove selected assets from the product?',
      textBtnOk: 'Remove',
      checkboxLabel: 'Don\'t show it again',
    },
    confirmDetachFromTargets: {
      title: 'Warning',
      text: 'Are you sure you want to remove selected assets from the selected targets?',
      textBtnOk: 'Remove',
      checkboxLabel: 'Don\'t show it again',
    },
    confirmDetachFromVariant: {
      title: 'Warning',
      text: 'Are you sure you want to remove asset from the product variant?',
      textBtnOk: 'Remove',
      checkboxLabel: 'Don\'t show it again',
    },
    textCustomFields: 'Custom fields',
    titleArchive: 'Archive',
    titleWatermarks: 'Watermarks',
    labelArchiveReason: 'Archived asset reason message',
    defaultArchiveReason: 'Asset is moved to archive',
    titleRemove: 'Remove',
    titleRemoving: 'Remove from collection',
    titleRemovingFromLightboard: 'Remove from lightboard',
    textRemoveFilesFrom: (
      nameOrCount,
      collectionName,
      entity = 'collection',
    ) => (
      <>
        Remove{' '}
        <Choose>
          <When condition={typeof nameOrCount === 'number'}>
            <span className="highlight">{nameOrCount}</span>{' '}
            {pluralize('asset', nameOrCount)}
          </When>
          <Otherwise>
            asset <span className="highlight">{nameOrCount}</span>
          </Otherwise>
        </Choose>{' '}
        from {entity} <span className="highlight">{collectionName}</span>?
      </>
    ),
    textRemoveFilesFromLastCollection: (assetName) => (
      <>
        You are about remove <span className="highlight">{assetName}</span>{' '}
        asset from all collections and move it to the root collection
        <br />
        <br />
        <InfoBlock>
          If you would like to entirely delete it from the library, use “Move to
          trash” instead
        </InfoBlock>
      </>
    ),
    textFinishInBg:
      'This operation affects large amount of assets and will be finished on the background',
    textFinishDuplicationInBg: `Duplication has started. It will run in background. You can continue using ${appName}.`,
    textRemoveFilesFromLightboardAndDelete:
      'This operation will delete assets that do not belong to any lightboard and/or collection.',
    textCantUpdateTags: `Can't update tag(s). Please try again. Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
    textCantUpdateLightboards: `Can't update lightboard(s). Please try again. Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
    textAssetMarks: 'Asset marks',
    titleConfirm: 'Confirm',
    titleWarning: 'Warning!',
    textAreYouSure: (value) => `You’re about to change ${value} of assets. Are you sure?`,
    textAreYouRealySure: `You have selected more than 50 000 assets. It is not possible to make changes on them at once.<br><br>If you still want to proceed with updating information on more than 50 000 files, please contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> for further assistance.`,
    textCantUpdate: (value) => (
      <div>{value} cannot be updated. Refresh and try again</div>
    ),
    textDetachFromCollectionSomeAssetsFailed: ({ count, collection }) => (
      <div>
        For some reason {pluralize('asset', count, true)}{' '}
        {count > 1 ? 'were' : 'was'} not removed from collection "{collection}".
        Refresh and try again
      </div>
    ),
    textDetachFromLightboardSomeAssetsFailed: ({ count, lightboard }) => (
      <div>
        For some reason {pluralize('asset', count, true)}{' '}
        {count > 1 ? 'were' : 'was'} not removed from lightboard "{lightboard}".
        Refresh and try again
      </div>
    ),
    textAssetsRemovedFromCollection: ({ count, collectionName }) => (
      <div>{`${count} ${pluralize(
        'asset',
        count,
      )} have been removed from the collection "${collectionName}"`}
      </div>
    ),

    textRejectedFiles: 'Rejected assets',
    textDeselectFlags: 'Deselect flags',
    textUnflaggedFiles: 'Unflagged assets',
    textFlaggedFiles: 'Flagged assets',
    textLabeledRed: 'Labeled "red"',
    textLabeledYellow: 'Labeled "yellow"',
    textLabeledGreen: 'Labeled "green"',
    textLabeledBlue: 'Labeled "blue"',
    textDeselectColors: 'Deselect colors',
    textLabeledPurple: 'Labeled "purple"',
    textNoColorLabel: 'No color label',
    textMoveToTrash: 'Move to trash',

    panelPlaceholderNoLabels: 'No label is attached to this asset',
    panelPlaceholderNoKeywords: 'No keyword is attached to this asset',
    panelPlaceholderNoUsers: 'No teammate is assigned to this asset',
    panelPlaceholderAssetNoCollections:
      'This asset doesn’t belong to any collection',
    panelPlaceholderAssetsNoCollections:
      'These assets don’t belong to any collection',
    panelPlaceholderNoCoordinates:
      'To see the map, please specify GPSLatitude and GPSLongitude in the list of EXIF metadata fields.',
    panelPlaceholderNoLightboards:
      'This asset doesn’t belong to any lightboard',
    mixedField: 'You lack permission to edit some of selected files',

    labelCheckboxDontShow: "Don't show it again",

    editWidgets: 'Customize view',
    emptyEditWidgetText:
      'If you wish to view metadata fields, please contact your admin',
    emptyMetadataFieldsText: () => (
      <>
        Metadata fields are hidden. <br />
        Click Customize view to adjust and reveal field visibility.
      </>
    ),

    titleArchiveAssets: 'Move to archive',
    textArchiveAssets: (amount) => `You are about to archive ${amount} asset(s)`,
    textCopy: 'Copy',
    textInviteTeammates: 'Invite people to collaborate',
    textRequestDemo: 'Request a demo',
    textRequestTraining: 'Request a training',
    brandPageUrlCopied: 'Brand page URL has been copied',
    apiKeyCopied: 'API Key copied',
    inboxUrlCopied: 'Inbox link copied',
    disabledCopyWebsitesTooltipText: 'Publish a website to enable this link',
    disabledCopyInboxTooltipText: 'Publish a inbox to enable this link',
    disabledCopyAssetsTooltipText: 'Publish asset sharing to enable this link',
    textLinkCopied: 'Link copied!',
    textCopyLink: 'Copy link!',
    uploadDateTooltipText: 'Upload date',
    creationDateTooltipText: 'Create date',
    toastTextDescriptionGeneration: 'AI description generation started',
    describingBtnText: 'Generating description',
    generateDescriptionBtnText: 'Generate description',
    aiBadgeAssetsTooltipText: (tier, available, used, cn) => (
      <div className={cn}>
        {tier ? <div>{tier}</div> : null}
        <div>Assets available for processing: {available}</div>
        <div>Processed assets: {used}</div>
      </div>
    ),
    aiBadgeMinutesTooltipText: (tier, available, used, cn) => (
      <div className={cn}>
        {tier ? <div>{tier}</div> : null}
        <div>Available transcription time: {available}</div>
        <div>Transcription time used: {used}</div>
      </div>
    ),
    aiIconTooltipText: (
      field,
      available,
      cn,
      tooltipLabel,
      showPrefix = false,
    ) => (
      <div className={cn}>
        {field ? (
          <>
            <div>{field}</div>
          </>
        ) : null}
        <If condition={tooltipLabel}>
          <div className="aiIconTooltipText">
            <If condition={showPrefix}>
              Analyze selected assets to enrich them with{' '}
            </If>
            {tooltipLabel}
            <If condition={showPrefix}>.</If>
          </div>
        </If>
        <Choose>
          <When condition={Array.isArray(available)}>
            <Choose>
              <When
                condition={
                  available[0] !== undefined && available[1] !== undefined
                }
              >
                <span>
                  Assets/Minutes available for processing: {available[0]}/
                  {available[1]}
                </span>
              </When>
              <When condition={available[0] !== undefined}>
                <span>Assets available for processing: {available[0]}</span>
              </When>
              <When condition={available[1] !== undefined}>
                <span>Minutes available for processing: {available[1]}</span>
              </When>
            </Choose>
          </When>
          <Otherwise>
            <span>Assets available for processing: {available}</span>
          </Otherwise>
        </Choose>
      </div>
    ),
    aiIconMinutesTooltipText: (field, available, cn) => (
      <div className={cn}>
        {field ? (
          <>
            <div>{field}</div>
            <br />
          </>
        ) : null}
        <span>Available processing time: {available}</span>
      </div>
    ),
    aiIconUpdatePlanTooltipText: (name) => (
      <div className="aiIconUpdatePlanTooltipText">
        <If condition={name}>
          <div>{name}</div>
          <br />
        </If>
        <span>Add AI Kit to your plan to enable AI processing features</span>
      </div>
    ),
    aiIconNoPermissionTooltipText: () => (
      <>
        Video & Audio Intelligence feature is disabled.
        <br />
        Contact your team admins to turn it on.
      </>
    ),
  },
  TOOLBAR_ACTION_AI_ICON_MENU: {
    GENERATE_KEYWORDS: 'Generate Keywords',
    GENERATE_DESCRIPTION: 'Generate Description',
    RECOGNISE_FACES: 'Recognize Faces',
    TRANSCRIBE: 'Analyze Video & Audio',
  },
  TOOLBAR_ACTION_AI: {
    PROCESS_WITH_AI: 'Process with AI',
    PROCESSING_WITH_AI: 'Processing selected assets. Wait a bit.',
    ARROW_ICON: 'AI actions',
  },
  TOOLBAR_ACTION_ICONS: {
    ARROW_UP: 'Show action toolbar',
    ARROW_DOWN: 'Hide action toolbar',
  },

  RESTRICT: {
    TITLE: 'Warning',
    RESTRICTED_REASON: 'Asset is restricted. Use with caution',
    restrictReasonLabel: 'Reason for asset restriction',
    attachAssetTitle: 'Cannot move restricted assets',
    attachAssetToCollection:
      'You are planning to move the restricted asset. You do not have permission to move it. Please select only non-restricted assets and try again.',
    attachAssetsToCollection:
      'Some of the assets you are planning to move are restricted. You do not have permission to move them. Please unselect restricted assets and try again.',
    cantRestrict: (length) => (
      <div>
        {pluralize('Asset', length)} cannot be restricted. Refresh and try again
      </div>
    ),
    BTN_OK: 'Ok',
  },

  LinkedAssets: {
    title: 'Linked assets',
    buttonLinkAssets: 'Link assets',
    buttonUnlinkAssets: 'Unlink selected',
    textNoLinkedAssets: 'no linked assets',
    titleUnlinkFrom: 'Unlink all assets',
    titleUnlink: 'Unlink this asset',
    infoAlreadyLinked: 'All selected assets are already linked',
    infoAlreadyUnlinked: 'All selected assets are already not linked',
    placeholder: (allowedAssetsCount) => `Sorry, you can’t link more than ${allowedAssetsCount} assets at a time.`,
    errorMessage: "can't get selected assets, please try again",
  },

  RESOLVEDUPLICATESDIALOG: {
    titleFileAlreadyExists: 'Asset already exists',
    textKeepBoth: 'Keep both',
    textAddAsNewRevision: 'Add as a new revision',
    textReplace: 'Replace',
    textRename: 'Rename',
    textSkip: 'Skip',
    textApplyToAll: 'Apply to all',
    textKeepExistingForAll: 'Keep existing info for all',
    textFileAlreadyExists: `You’re about to upload the asset that already exists in ${appName}`,
  },

  EXPORT_TO_CSV_DIALOG: {
    title: 'Export as CSV',
    /** @param {number} numberOfAssets */
    text: (numberOfAssets) => `Export ${numberOfAssets} selected ${pluralize(
      'asset',
      numberOfAssets,
    )} as CSV. Include required asset metadata.`,
    textBtnCancel: 'Cancel',
    textBtnOk: 'Export',
    noPermissions:
      'Team administrator disabled access to this feature for your user account. Contact them to get this permission',
    validationError: 'Validation error',
    fileName: 'assets_data.csv',
    exportKeywordsFileName: 'keywords_data.txt',
    exportAllFields: 'All fields',
    exportSelectedFields: 'Select required fields',
    notAvailable: {
      title: 'Feature is not available',
      text: 'This feature is not available on mobile devices.',
      textBtnCancel: 'Ok',
    },
    assetsLimit: {
      title: 'Cannot export to CSV',
      text: (assetsLimit) => `It’s not possible to export data of more than ${assetsLimit} assets in one CSV. <br> Select fewer assets or contact us at <a class='picsioLink' href='mailto:${supportEmail}'>${supportEmail}</a> if you still need to export that number of assets.`,
      textBtnCancel: 'Ok',
    },
  },

  PRODUCTS_EXPORT_CSV: {
    title: 'Export products as CSV',
    processing: 'Generating CSV...',
    success: 'CSV exported successfully',
    failed: 'CSV export failed',
    tryAgain: 'Try again',
    textBtnCancel: 'Cancel',
    textBtnOk: 'Export',
    scopeSelection: (total, products, variants) => {
      const parts = [`${products} ${pluralize('product', products)}`];
      if (variants > 0) parts.push(`${variants} ${pluralize('variant', variants)}`);
      return `Selected: ${total} (${parts.join(', ')})`;
    },
    scopeAllMatching: (total) => `All ${total} ${pluralize('record', total)} matching the current search`,
    fieldsAll: 'All attributes',
    fieldsSelected: 'Select attributes',
    selectAtLeastOneAttribute: 'Select at least one attribute to export.',
    searchPlaceholder: 'Find an attribute...',
    lockedSectionTitle: (titles) => <>Always included: <span className="highlight">{titles.join(', ')}</span></>,
    lockedTooltip: 'Always included — required to re-import this file.',
    lockedRecordId: 'Toriut Record ID',
    lockedSku: 'SKU',
    lockedParentSku: 'Parent SKU',
    lockedParentRecordId: 'Toriut Parent Record ID',
    roundTripLimitation:
      'This CSV supports bulk updates to existing product data. Product Option columns and values must remain unchanged.',
    noPermissions: 'Team administrator disabled access to this feature for your user account. Contact them to get this permission',
    validationError: 'Validation error',
    unrecognizedFields: 'Some selected attributes are no longer available. Refresh the page and try again.',
    emptySearchResult: 'No attributes found',
    notAvailable: {
      title: 'Feature is not available',
      text: 'This feature is not available on mobile devices.',
      textBtnCancel: 'Ok',
    },
    recordsLimit: {
      title: 'Cannot export to CSV',
      text: (limit) => `You can export up to ${limit.toLocaleString('en-US')} records at a time. Reduce your selection and try again.`,
      inlineText: (limit) => `This search matches more than ${limit} records. Narrow it down to export all matching records.`,
      textBtnCancel: 'Ok',
    },
  },

  SEARCH_FILTERS_DIALOG: {
    title: 'Add filters',
    text: 'Selected: ',
    textNone: 'None',
    textBtnCancel: 'Cancel',
    textBtnOk: 'Confirm',
    placeholder: 'Search name of filter or metadata field',
  },

  REVISION_FIELDS_DIALOG: {
    title: 'Required fields',
    textBtnCancel: 'Cancel',
    textBtnOk: 'Upload',
    labelCommentRevision: 'Comment revision',
    labelTitleAndDescription: 'Title & Description',
    labelKeywords: 'Keywords',
    labelAssignees: 'Assignees',
    labelAssetMarks: 'Asset marks',
    labelCustomFields: 'Custom fields',
    description: (action) => `According to team policy, you are required to ${action} every time you upload a new revision.`,
    titles: {
      comments: 'Add a comment',
      titleAndDescription: 'Add title and description',
      keywords: 'Attach keywords',
      assignees: 'Assign users',
      flag: 'Set flag',
      rating: 'Set rating',
      color: 'Set color',
      customFields: 'Fill custom fields',
    },
  },

  SEARCH: {
    productLayer: {
      title: 'Product layer',
      master: 'Master',
      selectLayers: 'Select layers',
    },
    text: {
      // keep keys in alphabetical order
      asset: 'asset',
      assets: 'assets',
      'Click to add custom field': 'Click to add custom field',
      'Click to add keywords': 'Click to add keywords',
      Color: 'Color',
      'Custom field': 'Custom field',
      Flag: 'Flag',
      Keywords: 'Keywords',
      Faces: 'Persons',
      'Last changed': 'Last changed',
      'Learn more': 'Learn more',
      noProducts: 'No products',
      'No assets': 'No assets',
      Rating: 'Rating',
      Reset: 'Reset',
      'Save this search': 'Save this search',
      Search: 'Search',
      'Search in': 'Search in',
      'Select custom fields': 'Select custom fields',
      Type: 'Type',
      'Upload date': 'Upload date',
      Restricted: 'Restricted',
      'Restricted show': 'Show restricted assets',
      showArchivedAssets: 'Show archived assets',
      CustomFields: 'Custom fields',
      collection: 'Collection',
      placeholderLoadSearch: 'Searching for similar images...',
      placeholderEmptySearch: 'Find similar images',
    },
    mediaFilters: 'Media Filters',
    productFilters: 'Product Filters',
    trialTooltipText:
      'Click to see Search & Filter panel availability across plans',
    addMoreFilters: 'Add more filters',
    emptyPlaceholder: {
      cantOpenLink: (externalLink) => (
        <>
          {appName} can not open your{' '}
          <a href={externalLink} target="_blank" rel="noopener noreferrer">
            {' '}
            file.
          </a>
        </>
      ),
      clickLink: 'Click upward link to open in a browser tab.',
      // emptyCollection: (activeCollectionName) => (<>There are no files in collection <span className="act">{activeCollectionName}</span>.</>),
      emptyCollections: (collectionsName) => (
        <div>
          There are no files in{' '}
          {pluralize('collection', collectionsName.length)}{' '}
          {collectionsName.map((collectionName, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={collectionName + index} className="act">
              {collectionName}
              {collectionsName.length > 1
              && index !== collectionsName.length - 1
                ? ','
                : ''}
              &nbsp;
            </span>
          ))}
        </div>
      ),
      clickUpload:
        'You can start adding assets by selecting the suggested options',
    },
    tooltipContentSearchIsNotAllowed: 'Search in documents content is available starting Micro billing plan',
    noAssetsFound: (collectionNames, isVisualSearch, onCheckTeammatePermissions, onVisualSearchRequest, enableVisualSearchSetting, onContactSupport) => (
      <div>
        <div>
          No assets in the collection{' '}
          {collectionNames.map((collectionName, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={collectionName + index} className="act">
              {collectionName}
              {collectionNames.length > 1
              && index !== collectionNames.length - 1
                ? ','
                : ''}
              &nbsp;
            </span>
          ))}
          that match your search query
        </div>
        <br />
        <If condition={!picsioConfig.isPim}>
          <Choose>
            <When condition={isVisualSearch && enableVisualSearchSetting}>
              <p className="noAssetsFoundText">Try adjusting your filters or checking for typos</p>
            </When>
            <Otherwise>
              <p className="noAssetsFoundText">Try adjusting your filters, checking for typos
                <If condition={picsioConfig.isMainApp}>
                  , or requesting the
                  <span
                    className="picsioLink"
                    style={{ cursor: 'pointer' }}
                    aria-hidden="true"
                    onClick={isVisualSearch ? onCheckTeammatePermissions : onVisualSearchRequest}
                  > Visual & Similar Images Search
                  </span>{' '}
                  feature
                </If>
              </p>
            </Otherwise>
          </Choose>
        </If>
        <p className="noAssetsFoundText">If you still can’t find what you need, please{' '}
          <span
            className="picsioLink"
            style={{ cursor: 'pointer' }}
            aria-hidden="true"
            onClick={onContactSupport}
          >contact support
          </span>
        </p>
      </div>
    ),

    addCollectionButtonText: 'Add collection',

    searchButtonText: (text) => `Search whole library for: ${text}`,

    searchInRoot: 'Try searching in the root collection',

    fieldAny: 'All fields',
    fieldName: 'Filename',
    fieldContent: 'Content',
    fieldCollectionName: 'Collection name',
    fieldTitle: 'Title',
    fieldPersons: 'Persons',
    fieldDescription: 'Description',
    fieldKeywords: 'Keywords',
    fieldMeta: 'Custom fields',
    fieldTranscript: 'Transcription',
    fieldVideoAi: 'Video Intelligence',

    optionAny: 'Any',
    optionImages: 'Images',
    optionVideo: 'Video',
    optionAudio: 'Audio',
    optionText: 'Text documents',
    optionPDF: 'PDF documents',
    optionOfficeDocument: 'Office documents',
    optionSketch: 'Sketch files',
    optionRAW: 'DSLR RAW photos',
    optionPhotoshop: 'Photoshop documents',
    option3D: '3D models',
    optionLinks: 'External links',

    dialogTitleCreateSearch: 'Create saved search',
    dialogCreateSearchLabel: 'Name',
    dialogCreateSearchPlaceholder: 'Please enter the name',
    dialogCreateSearchLabelShare: 'Share with my team',
    dialogErrorNameEmpty: 'Name is empty',
    dialogTitleSearchHaveAlready: 'Name already in use',
    dialogTextSearchHaveAlready:
      'This name is already used for other saved search. Try another name.',
    saveSearch: 'Save this search',
    // Nested Saved Searches v2 — new "Save this search" modal
    dialogSaveSearchSelectGroup: 'Save to',
    dialogSaveSearchNewGroupLabel: 'New group name',
    dialogSaveSearchNewGroupCreate: 'Create',
    dialogSaveSearchShareNoPermission: 'Only team admins can create team saved searches',
    dialogSaveSearchPendingNewGroup: 'Finish creating the new group first or cancel it',
    dialogSaveSearchErrorCreateGroup: 'Failed to create group',
    resetFiltersBtn: 'Reset filters',
    resetFilterBtn: 'Reset filter',
    filterConfirmBtn: 'Confirm',
    disabled: 'Enter all required filters',
    addFiltersBtn: 'Add filters',
    saveFiltersTooltip: 'Save filter configuration',
    userSearchFilterPlaceholder: 'Select user',
    userSearchFilterLabel: 'Select user',
    sort: 'Change sorting',
    view: 'Change catalog view',
    notifications: 'Notifications',
    settings: 'Account settings',
  },

  COMPARE: {
    wrongParameters: {
      title: 'Comparison error',
      text: 'Make sure you compare assets of the same format and try again',
    },
  },

  REFERRAL: {
    title: 'Referral page',
    helpText: 'Learn how to use a referral program',
  },

  STORAGE: {
    title: getStorageTitle,
    alertCantLoadStat: () => (
      <>Storage statistics cannot be loaded. Refresh and try again</>
    ),
    textConnectedTo: (email) => (
      <div>
        Connected to <span className="pageStorageMail__mail">{email}</span>{' '}
        storage
      </div>
    ),
    textFolderConnectedTo: ({ name, linkToGoogleDriveFolder, storageType }) => {
      if (storageType === 's3') {
        return <span>Connected to {name} folder</span>;
      }
      return (
        <span>
          Connected to{' '}
          <a
            className="picsioLink"
            href={linkToGoogleDriveFolder}
            target="blank"
          >
            {name}
          </a>{' '}
          folder
        </span>
      );
    },
    textSizeTotal: (size, storageType) => {
      if (storageType === 's3') {
        return (
          <span>
            Amazon S3 <span>({size} total)</span>
          </span>
        );
      }
      return (
        <span>
          Google Drive <span>({size} total)</span>
        </span>
      );
    },
    textGDSizeUnlimited: 'Google Drive (Unlimited)',
    textUsed: 'used',
    textUsedWithoutTrash: 'used (without trashed)',
    textFree: 'free',
    textTrashed: 'trashed',
    textChange: 'Change',
    textAvailable: 'available',
    textCreditsBuySuccess: (amount) => `${amount} credits purchased`,
    textAICreditsBuySuccess: (amount) => `${amount} credits purchased`,
    textFacesBuySuccess: (amount) => `${amount} credits purchased`,
    textLabelMigration: 'Your plan also allows you to use other storage:',
    textMigrationRequestSent: () => (
      <span>
        Migration request sent.
        <br />
        Our support team will contact you shortly
      </span>
    ),
    textChangeStorage: 'Reset storage',
    textRequestChangeStorage: () => (
      <p>
        If you want to change a working folder connected to your account, it is
        possible: contact us at{' '}
        <a className="picsioLink" href={`mailto:${supportEmail}`}>
          {supportEmail}
        </a>{' '}
        and our representative will guide you through a step-by-step process, so
        there’s no data or files lost.
      </p>
    ),
    resetingStorage: 'Resetting storage',
    alertCantReset: () => <>Storage cannot be reset. Refresh and try again</>,
    DIALOG_RESET_STORAGE: {
      title: 'Storage Reset Confirmation Required',
      text:
        'Resetting a storage will result in removing all assets, collections, keywords, inboxes, and websites created until now.',
      textBtnOk: 'Confirm',
    },
    helpText: `Learn how about ${appName} integration with Team Drive`,
  },
  SYNC: {
    screenTitle: 'Sync Settings',
    textLoading: 'Loading sync settings...',
    textTitleCantStartSync: 'Sync running already',
    textTitleSyncLimitExceeded: 'Sync frequency limit reached',
    textTextCantStartSyncTemplate: (progress) => `Wait a sec, please. Another sync process was started recently and is still in ${progress}% progress.`,
    textManualSyncLimited: (minutesBeforeNextSync, planName) => `For your current ${planName} plan next sync will run in ${minutesBeforeNextSync} minute${
      minutesBeforeNextSync > 1 ? 's' : ''
    }. Upgrade your billing plan to speed up a syncing process.`,
    textTitleSyncFailed: 'Sync failed',
    textTextSyncFailed: `Sync has not finished. Please contact <a href='mailto:${supportEmail}?subject=Sync from GD failed'>${supportEmail}</a>.`,
    textTitleSyncStarted: 'Sync started',
    textTextSyncStarted:
      'Sync has started running in the background. This may take some time before new files appear in your library.',
    textTitleSyncRunning: 'Sync running',
    textTextSyncRunning:
      'Syncing process takes more than expected, we will notify you by email when the process is finished.',
    textTitleSyncCancelled: 'Attention!',
    textTitleDestructiveSync: 'Destructive sync warning',
    textTextSyncCancelledTemplate:
      'Sync cancelled.<br /><br />This sync will delete a lot of assets from your digital library. If you are aware of that and want to resume this sync, click Confirm.',
    textTextSyncDestructiveWebsitesTemplate: (websites) => `Sync process was stopped because we found websites that will be removed by this sync: ${websites} <br/> To fix this, do one of the following:<br/> - rename pics.io collections so they match your Cloud Storage folder names<br/> - rename your Cloud Storage folders, so they match pics.io collections' names<br/> - run 'Sync to your Cloud Storage'<br/> - or unpublish your collections in ${appName}<br/><br/>`,
    textTitleSyncNothing: 'Sync storage folder is empty',
    textTextSyncNothing: (goToStorageLink) => (
      <>
        <p>
          Syncing with an empty{' '}
          <span
            className="picsioLink"
            role="presentation"
            onClick={goToStorageLink}
          >
            storage folder
          </span>{' '}
          will remove original assets from {appName}.
        </p>
        <p>Unsure? Please, consult your team admin before proceeding.</p>
      </>
    ),
    textBtnOkSyncNothing: 'Proceed',
    textTitleGDS: 'Cloud Storage synchronization',
    textButtonSync: 'Sync',
    textButtonGoToGD: 'Check your connected folder',
    labelSyncToPicsio: `Sync from your Cloud Storage to ${appName}`,
    descriptionPull:
      'Pull all folders and files changes from your Cloud Storage working folder',
    labelSyncToGD: `Sync from ${appName} to your Cloud Storage`,
    descriptionPush:
      'Push collections and assets changes to your Cloud Storage working folders',

    textSyncingData: 'Syncing data...',
    textSyncFailed: 'Sync failed',
    textLatestSync: (timePeriod) => `The latest sync happened ${timePeriod} ago`,
    textSyncNow: 'Sync Now',
    textFirstSync: (storageName) => `Want to synchronize your ${storageName} storage with ${appName}? Press Sync now.`,
    textBigLibraryWarning:
      'Full library sync is not available because you have too many assets in it. You can instead perform a collection level sync.',
    textGetAccessDescription:
      'We have recently improved our Sync operations. If you want to get better experience with Autosync please provide additional permissions to access your Google Drive data.',
    textGiveAccess: 'Give access',
    errorWrongAccount: 'Wrong user account',
    helpText: `Learn more about how cloud storage syncs with ${appName}`,
  },

  TAGSTREE: {
    usePartialSync:
      'The collection is too large for full sync, please use partial sync',
    syncIsDisabled:
      'The collection is too large for sync operation, please contact picsio support to enable it',
    errorSomethingWrong: `Something went wrong. Please try again. Contact <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support if the error repeats.`,
    textRemoveCollectionAndSite: (collectionName, websiteAlias) => `You are about to delete <span class='highlight'>${collectionName}</span> collection and all its subcollections. ${
      websiteAlias
        ? `This operation will also remove website <a href='${websiteAlias}' target='_blank'>${websiteAlias}.</a><br />`
        : ''
    } Please choose how to handle the assets inside:`,
    textRemovingCollection: 'Removing collection...',
    textRemovingFilesInGD: 'Removing files in your Cloud Storage...',
    errorNameEmpty: 'Name is empty',
    errorNameAlreadyTaken:
      'This name is already taken at the current level. Please, enter another one',
    alertSearchAdded: (name) => `"${name}" added to "Saved searches"`,
    textDeleteCollection: 'Delete collection',
    textEnableSearchIndexing: 'Enable AI Search',
    textCreateCollection: 'Create collection',
    textCreateNestedCollection: 'Create nested collection',
    textRenameCollection: 'Rename collection',
    textUploadFiles: 'Add assets',
    textCopyWebsiteLink: 'Copy website link to clipboard',
    textRemoveFromFavorites: 'Remove from favorites',
    textAdToFavorites: 'Add to favorites',
    textMoveCollection: 'Move collection',
    textDownloadCollection: 'Download collection',
    textSave: 'Save',
    textCancel: 'Cancel',
    textSyncFolder: 'Sync collection',
    textSyncFolderSubtree: 'Sync subtree',
    textDuplicateCollection: 'Duplicate collection',
    textUpdateWebsite: 'Website settings',
    textCreateWebsite: 'Publish to web',
    textRemoveCollection: 'Delete collection',
    textRemoveFilesFromGD: 'Also remove nested assets',
    textRetryImportCollection: 'Retry import',
    textCantChangeOrder: () => (
      <div>Sort order cannot be changed. Refresh and try again</div>
    ),
    textCantCompleteSearch: () => (
      <div>Cannot complete search for collections. Refresh and try again</div>
    ),
    titleRemoveSavedSearch: 'Delete saved search?',
    textYouAreAboutRemoveSavedSearch: (name) => `You are about to delete the saved search <span class="highlight">${name}</span>.`,
    textHasBeenRemoved: (name) => `"${name}" deleted from "Saved searches"`,
    titleDeleteSavedSearchGroupWithContents: (groupName) => `Delete "${groupName}"?`,
    textDeleteSavedSearchGroupWithContents: (savedSearchCount, subgroupCount) => {
      const savedSearchPhrase = (n) => `${n} saved search${n === 1 ? '' : 'es'}`;
      const directSubgroupPhrase = (n) => `${n} direct subgroup${n === 1 ? '' : 's'}`;
      const n = savedSearchCount;
      const m = subgroupCount;
      if (m === 0 && n === 0) {
        return 'This group is empty. Are you sure you want to delete it?';
      }
      if (m === 0 && n > 0) {
        return `This group contains ${savedSearchPhrase(n)}. Deleting it will also delete all saved searches inside this group. Are you sure you want to delete it?`;
      }
      if (n === 0 && m > 0) {
        return `This group contains ${directSubgroupPhrase(m)}. Deleting it will also delete all nested subgroups and saved searches inside it. Are you sure you want to delete it?`;
      }
      if (n > 0 && m > 0) {
        return `This group contains ${savedSearchPhrase(n)} and ${directSubgroupPhrase(m)}. Deleting it will also delete all nested subgroups and saved searches inside it. Are you sure you want to delete it?`;
      }
      return 'Deleting this group will also delete all nested subgroups and saved searches inside it. Are you sure you want to delete it?';
    },
    btnDeleteGroup: 'Delete group',
    textHasBeenRemovedGroup: (name) => `Group "${name}" deleted from "Saved searches"`,
    placeholderSearch: 'Search collections',
    textAttachingCollection: 'Adding to collection',
    textAttachingToCollection: 'Adding to collection',
    textDetachingCollection: 'Removing from collection',
    textMovingCollection: 'Moving collection...',
    textMovingToCollection: 'Moving to collection',
    textAddAsShortcuts: 'Adding to collection',
    textMovedCollection: 'Collection moved',
    textUnableToMoveCollection: (errorMessage) => `Cannot move collection. ${errorMessage}`,
    textMoveToArchive: 'Move to archive',
    textMove: 'Move',
    removeSelectedOnlyRadioLabel: (collectionName) => `Remove from <span class="highlight">${collectionName}</span> collection only`,
    removeSelectedOnlyRadioLabelDescription:
      'The assets will remain in any other collections they are added to in the library',
    removeSelectedAndAttachedRadioLabel:
      'Delete from <span class="highlight">all</span> collections',
    removeSelectedAndAttachedRadioLabelDescription:
      'The assets will be deleted from all collections they are added to throughout the library',
    removeCollectionHelpLinkUrl:
      'https://help.pics.io/en/articles/2168102-removing-assets-from-collections',
    removeCollectionHelpLinkTitle: 'Removing assets from collections',
    removeCollectionAmplitudeData: {
      selectedOnly: 'RemoveFromCollection',
      selectedAndAttached: 'DeleteFromCollection',
    },
  },

  SAVEDSEARCHESTREE: {
    placeholderSearch: 'Search in saved searches',
    textDeleteSearch: 'Delete saved search',
    textFavorites: 'Favorites',
    textAddToFavoritesSearch: 'Add to favorites',
    textRemoveFromFavoritesSearch: 'Remove from favorites',
    textSavedSearches: 'Personal Saved Searches',
    textTeamSearches: 'Team Saved Searches',
    textErrorDescription:
      'Failed to load saved searches. Click the button below to try again.',
    textErrorButton: 'Load saved searches',
    textPlaceholderText: "You haven't saved any search<br> results yet",
    textCreateSubgroup: 'Create Subgroup',
    textCreateSubgroupTooltip: (maxDepth) => `You can create up to ${maxDepth} nested group levels.`,
    textCreateSubgroupTitle: (parentName) => `Create subgroup inside ${parentName || 'this group'}`,
    textCreateSubgroupPlaceholder: 'Enter subgroup name',
    textCreateGroupPlaceholder: 'Enter group name',
    textCreateRootGroup: 'New group',
    textCreateRootGroupTitle: (scopeName) => `Create ${scopeName === 'Team Saved Searches' ? 'Team' : 'Personal'} group`,
    textMoveToGroupTitle: 'Move to group',
    textNewGroupDefault: 'New group',
    textAddSavedSearchHere: 'Add saved search here',
    textAddSavedSearchHereDisabled: 'Run a search first to save it',
    textEmptyGroup: 'No saved searches in this group yet',
    textTeamManagedByAdmin: 'Managed by team admin',
    textDuplicateItemInLocation:
      'An item with this name already exists in this location. Please choose another name.',
    textDuplicateSavedSearchInLocation:
      'A saved search with this name already exists in this location. Please choose another name.',
    textDuplicateGroupInLocation:
      'A group with this name already exists in this location. Please choose another name.',
    textDuplicateSubgroupInLocation:
      'A subgroup with this name already exists in this location. Please choose another name.',
    textMoveGroupDepthExceeded: (maxDepth) => `Groups can only be nested up to ${maxDepth} levels. Move some items out or pick a higher folder.`,
    textMoveGroupInvalidTarget:
      'You cannot move a group into itself or into one of its subgroups.',
    textMoveGroupNoDocumentId:
      'Could not move this folder. Refresh the list or try again.',
    textMoveNoValidTargetsGroup:
      'There are no other groups to move this group into. Create another group first, or cancel.',
    textMoveNoValidTargetsItem:
      'There are no groups available to move this saved search into. Create a group first, or cancel.',
  },

  LIGHTBOARDSTREE: {
    title: 'Lightboards',
    placeholderSearch: 'Search lightboards',
    textDeleteLightboard: 'Delete lightboard',
    textErrorTitleNameSpace:
      'Only letters, numbers, underscore, dash, and space are allowed',
    placeholderNoLightboard: "You haven't created any lightboards yet",
    textUploadFiles: 'Upload assets',
    textRenameLightboard: 'Rename lightboard',
    textCreateLightboard: 'Create lightboard',
    textSave: 'Save',
    textButtonFailedToLoad: 'Load lightboards',
    textFailedToLoad:
      'Failed to load lightboards. Click the button below to try again.',
    textCancel: 'Cancel',
    errorUnableToRename: `Cannot rename lightboard. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a>`,
    errorUnableToCreate: `Cannot create lightboard. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a>`,
    errorUnableToDelete: `Cannot delete lightboard. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a>`,
    textAttachingToLightboard: 'Adding to lightboard',
  },

  PRODUCTSTREE: {
    title: 'Master products',
    placeholderSearch: 'Search products',
    textDelete: 'Delete master product',
    textDeleteVariant: 'Delete master variant',
    textErrorTitleNameSpace:
      'Only letters, numbers, underscore, dash, and space are allowed',
    placeholderNoProducts: "You haven't created any products yet",
    textRename: 'Rename product',
    textCreate: 'Create product',
    textSave: 'Save',
    textButtonFailedToLoad: 'Load products',
    textFailedToLoad:
      'Failed to load products. Click the button below to try again.',
    textCancel: 'Cancel',
    errorUnableToRename:
      'Cannot rename product. Please, contact <a class="picsioLink" href="mailto:support@toriut.com">toriut.com</a>',
    textAttachingToProduct: 'Adding to product',
    textClickToGlobalSearch: 'Click to global search',
  },

  INBOXESTREE: {
    title: 'Inboxes',
    placeholderSearch: 'Search inboxes',
    textDeleteInbox: 'Delete inbox',
    textErrorTitleNameSpace:
      'Only letters, numbers, underscore, dash, and space are allowed',
    textFailedToLoad:
      'Failed to load inboxes. Click the button below to try again.',
    textLoadInboxes: 'Load inboxes',
    placeholderNoInbox: "You haven't created any inbox yet",
    textUploadFiles: 'Upload assets',
    textRenameInbox: 'Rename inbox',
    textCreateInbox: 'Create inbox',
    textCreateInboxPim:
      'Inbox creation is limited in the beta version. Request full access to manage and publish more websites for your projects.',
    textSave: 'Save',
    textCancel: 'Cancel',
    errorUnableToRename: `Unable to rename inbox. Please, contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a>`,
    textCopyInboxLink: 'Copy inbox link to clipboard',
    textInboxSettings: 'Inbox settings',
    textDelete: 'Delete inbox',
    textRename: 'Rename inbox',
    errorHaveReachedLimit: 'You have reached a limit of inboxes on this plan',
    requestFullDialog: {
      title: picsioConfig.isPim ? 'Inboxes limit' : 'Request full access',
      text: (limit) => (
        picsioConfig.isPim ? (
          <>
            <span>
              Your trial includes up to {limit} inboxes. Request full access to
              increase your inbox limit and keep scaling content collection:
            </span>
            <br />
            <ul>
              <li>
                Create dedicated inboxes for suppliers, photographers, agencies,
                or internal teams.
              </li>
              <li>
                Keep incoming files separated and organized by project, source,
                or workflow.
              </li>
              <li>
                Collect content from more contributors without reusing the same
                inbox for different purposes.
              </li>
            </ul>
            <br />
            <span>
              Our support team will help you enable these options. Would you like
              to start a chat?
            </span>
          </>
        ) : (
          <>
            <span>
              With free beta access, you’re limited to{' '}
              {pluralize('inbox', limit, true)} and basic features.
              Request full access to:
            </span>
            <br />
            <ul>
              <li>Create and manage multiple Inboxes</li>
              <li>
                Remove the 100-asset monthly upload limit to accept unlimited
                contributions from external users
              </li>
              <li>
                Enforce required fields on upload, making sure external
                contributors add the needed metadata
              </li>
              <li>Protect Inboxes with passwords and consent forms</li>
            </ul>
            <br />
            <span>
              Our support team will help you enable these options. Would you like
              to start a chat?
            </span>
          </>
        )
      ),
      cancel: 'Cancel',
      ok: 'Proceed to chat',
    },
  },

  INBOXSETTINGS: {
    securityPasswordTooltip:
      'Setting a password for inbox is not available in the beta version. Request full access to protect inbox with a secure login.',
    securityConsentTooltip:
      'Visitor consent options are not available in the beta version. Request full access to display custom consent messages before viewing content.',
    disabledDefaultFieldsTooltip: (name) => `Setting a ${name.toLowerCase()} as required field for uploading assets to inboxes is not available in the beta version. Request full access to manage required fields.`,
    disabledCustomFieldsTooltip:
      'Displaying custom fields in inboxes is not available in the beta version. Full access is required to make them visible for external users.',
    title: 'Inbox settings',
    share: 'Share inbox',
    unshare: 'Stop sharing inbox',
    textMain: 'Main',
    textSecurity: 'Security',
    textPassword: 'Password',
    startShare: 'Share inbox',
    stopShare: 'Stop sharing inbox',
    textUrlNotValid: 'URL is not valid',
    textWordsCantBeUsed: (words) => `Words "${words}" can\'t be used at the url begging`,
    textPasswordConfirm: 'Password and confirm password are not equal',
    helpText: 'How to receive files via inbox',
    DEFAULT_FIELDS: {
      comment: 'Comment',
      titleAndDescription: 'Title & Description',
      flag: 'Flag',
      rating: 'Rating',
      color: 'Color',
    },
    ERRORS: {
      cantGetInboxes: () => (
        <div>Inboxes not loaded. Refresh and try again</div>
      ),
      cantChangeAlias: 'Can not change inbox alias',
      cantAddCustomField: () => (
        <div>Custom field cannot be added to inbox. Refresh and try again</div>
      ),
      cantRemoveCustomField: () => (
        <div>
          Custom field cannot be removed from inbox. Refresh and try again
        </div>
      ),
      inboxUpdatingError: 'Inbox updating was unsuccessful. Please, try again.',
    },
    UNPUBLISH: {
      title: 'Warning',
      text:
        'People with a link to this inbox will no longer be able to upload files in your library. Confirm that you want to unpublish this inbox.',
      textBtnCancel: 'Cancel',
      textBtnOk: 'Confirm',
    },
    DELETE: {
      title: 'Delete inbox',
      getText: (inboxName) => `You are going to delete the inbox ${inboxName}. This action cannot be undone. Continue?`,
      textBtnCancel: 'Cancel',
      textBtnOk: 'Delete',
    },
  },
  API_KEYS: {
    title: 'Personal access tokens',
    textCreate: 'Create token',
    textNoDescription: 'No description',
    NoApiKeys: memo(() => (
      <span>
        You have <strong>no personal tokens</strong>
      </span>
    )),
    createDialog: {
      title: 'Add a description',
      textBtnOk: 'Create',
    },
    limitExceeded:
      'You have reached a limit of personal access tokens. To create a new one, delete unused tokens, or reach out ot our support, if you need to expand that limit',
    saveDialog: {
      title: 'Copy this token to a local text file',
      text:
        'Remember this access token. You can see this token now and just once, so save it to your local text file',
      textBtnOk: 'Copy to clipboard and close',
      textBtnCancel: null,
    },
    removeDialog: {
      title: 'Deleting personal token',
      text: 'Are you sure you want to delete this personal access token?',
      textBtnOk: 'Delete',
    },
  },

  WATERMARKS: {
    errorNameEmpty: '"Name" - is empty',
    dialogTextWatermarkHaveAlready:
      'Watermark with this name already exists. Please try other name.',
    titleNewWatermark: 'New watermark',
    titleDeleteWatermark: 'Delete this watermark?',
    titleUpdateWatermark: 'Update this watermark?',
    titleAttachWatermark: (value) => `You have selected ${value} assets. Watermark will be laid only on JPG, JPEG, PNG formats.`,
    titleDetachWatermark: (value) => `Watermark will be removed from ${value} assets.`,
    applyWatermark: 'Apply this watermark?',
    removeWatermark: 'Removing watermark',
    textUpdateWatermark: (value) => `This watermark is used on ${value} assets. If you make changes to this watermark, they will reflect on those assets immediately.`,
    textDeleteWatermark: (value) => `This watermark is used on ${value} assets. If you delete this watermark, it will get removed from all those assets.`,
    btnOkWatermark: 'Confirm',
    btnOkRemoveWatermark: 'Remove',
    btnCreate: 'Create',
    titleEditName: (value) => `Edit "${value}"`,
    textCreateNewWatermark: 'Create new watermark',
    textPlaceholderTypeWatermark: 'Type a name here',
    labelSettingsWatermarkName: 'Name',
    labelSettingsWatermarkDescription: 'Description',
    watermarkImageUploadErrorTitle: 'Size or type is incompatible',
    watermarkImageUploadText:
      'Image must be transparent PNG only and less than 5MB',
    labelSettingsWatermarkSize: 'Size',
    labelSettingsWatermarkOpacity: 'Opacity',
    labelSettingsWatermarkMakeDefault: 'Make as default',
    errorUpdateWatermark: 'Failed to update watermark',
    errorDeletingWatermark: () => (
      <div>Watermark cannot be deleted. Refresh and try again</div>
    ),
    errorWatermarkName: 'Watermark name cannot be empty',
    errorWatermarkText: 'Watermark text cannot be empty',
    makeDefaultWatermark: 'Make default',
    errorMakeWatermarkDefault: () => (
      <div>Watermark cannot be set as default. Refresh and try again</div>
    ),
    tooltipUnsupportedFormat: 'Watermark is only available for image formats',
  },

  INTEGRATIONS: {
    directConnection: 'Direct connections',
    pluginBased: 'Plugin-based integrations',
    personalStorageConnections: 'Personal storage connections',
    mcp: {
      name: 'MCP Server',
      subtitle: `Connect AI assistants to your ${appName} library and let them search, access, and work with your assets directly.`,
    },
  },

  TEAMMATES: {
    btnOK: 'Add',
    btnCancel: 'Copy token & Close',
    titleAddDomainDialog: 'Add domain',
    textUrlNotValid: 'URL is not valid',
    errorUpdateOktaSettings: (name) => `Update Okta setting "${name}" error`,
    errorUpdateTeamSetting: 'Could not save team setting. Please try again.',
    errorUpdateDescribingLocaleSync: 'Generation language was only partly saved. Please try again or refresh the page.',
    errorOktaSettingsAlreadyExist: (name) => {
      const labels = {
        clientID: 'Client ID',
        oktaDomain: 'Okta domain',
      };
      return `${labels[name]} is already in use`;
    },
    toastAddDoaminToken:
      'Token copied. Add it to the DNS settings and get back here to add a verified domain.',
    textYourShouldVerifyDomain: (domain, tokenInfo) => (
      <>
        <p>
          Before adding the domain <strong>{domain}</strong>, verify your
          ownership by creating the txt record in its DNS settings using the
          following token:
        </p>
        <code>
          TXT {tokenInfo.txtName} {tokenInfo.token}
        </code>
      </>
    ),
    tooltipRoleGlobalAdmin:
      'Full access to all system features and settings, including user management, integrations, and security configurations.',
    tooltipRoleMediaAdmin:
      'Manages product media and digital assets, including uploading, editing, and categorizing media files. Media Admins can view product-related information necessary for managing media assets effectively without accessing or modifying product details.',
    tooltipRoleViewer:
      'Provides read-only access to product and media information for reference and reporting purposes without modification rights.',
    tooltipRoleCatalogAdmin:
      'Organizes and maintains product catalogs, categories, and attributes, ensuring data accuracy and consistency across all listings. Can view and edit media metadata to ensure proper association with products but cannot perform destructive actions on media assets.',
    permissionTitleUpload: 'Upload and duplicate assets',
    permissionTitleSync: ({
      isSyncAndDisallowedRootCollections,
      storageType,
    }) => {
      const defaultTitle = storageType === 's3'
        ? `Synchronize Amazon S3 Bucket with ${appName}`
        : 'Run a sync process for the storage';

      if (isSyncAndDisallowedRootCollections) {
        return 'Synchronization is restricted for users without permissions to manage team collection.';
      }
      return defaultTitle;
    },
    permissionTooltipDisabledSync:
      'Permission change is limited due to a conflict: access to the root collection is required to enable sync.',
    permissionTitleWebsites:
      'Create, edit or delete websites, perform single asset sharing',
    permissionTitleManageTeam:
      'Invite and remove teammates, edit permissions, manage team settings, receive team status emails',
    permissionTitleManageIntegrations:
      'Configure Slack and Webhooks integrations',
    permissionTitleManageBilling:
      'Choose and change subscription plans, add and remove payment methods, edit billing information',
    permissionTitleManageStorage: ({ storageType }) => (storageType === 's3'
      ? `Change Amazon S3 Bucket & working folder connected to ${appName}`
      : `Change storage account & a directory connected to ${appName}`),
    permissionTitleCollectionsManage: 'Manage collections',
    permissionTitleCollectionsCreate:
      'Create new collections & sub-collections',
    permissionTitleCollectionsMove:
      'Move collection into another one with the same permission enabled',
    permissionTitleCollectionsEdit:
      'Rename existing collections & sub-collections',
    permissionTitleCollectionsDelete: `Delete collections & sub-collections from ${appName}`,
    permissionTitleDownloadFiles: `Download assets from ${appName}`,
    permissionTitleEditImageAttributes: 'Manage assets attributes',
    permissionTitleEditAssetFilename: 'Change the filename of an asset',
    permissionTitleEditAssetTitle: 'Change the asset title',
    permissionTitleEditAssetDescription: 'Change the asset description',
    permissionTitleEditAssetKeywords:
      'Attach or remove keywords describing an asset',
    permissionTitleAutogenerateKeywords:
      'Automatically generate keywords for an asset',
    permissionTooltipDisabledAutogenerageKeywords:
      'Permission change is limited due to a conflict: keywords permissions are required to generate AI keywords.',
    permissionTooltipDisabledAutogenerageDescriptions:
      'Permission change is limited due to a conflict: description permission is required to generate AI descriptions.',
    permissionTooltipDisabledEditKeywords:
      'Enable “Keywords” permission in Team permissions tab first',
    permissionTooltipDisabledAiVideoAudio:
      'Enable “Video & Audio Intelligence” permission in Team permissions tab first',
    permissionTooltipDisabledKeywordsControlledVocabulary:
      'Enable “Keywords” permission first',
    permissionTooltipDisabledProductDataManagement:
      'Enable "Product Data Management" permission first',
    permissionTooltipDisabledAddComments: 'To allow adding comments, first enable "Comments" visibility in the Asset details panel.',
    permissionTooltipDisabledDeleteComments: 'To allow deleting comments, first enable "Comments" visibility in the Asset details panel.',
    permissionTooltipDisabledByPlan:
      'Add AI Kit to your plan to enable AI processing features',
    permissionTitleEditAssetCollections:
      'Attach or detach assets to the collections & from them',
    permissionTitleEditAssetAssignees: 'Assign assets to other teammates',
    permissionTitleEditAssetLinkedAssets: 'Create or edit linked assets',
    permissionTitleEditAssetMarks:
      'Change assets marks, including flag status, color labels, star rating, etc.',
    permissionTitleEditAssetMetadata: 'Create, remove or edit custom fields',
    permissionTitleManageKeywords:
      'Create, edit or remove keywords & upload Controlled Vocabulary',
    permissionTitleAddKeywords: 'Add keywords outside of Controlled Vocabulary',
    permissionDescrAddKeywords:
      'Make an exception for adding new keywords if the general setting “Enable Controlled Vocabulary” is active',
    permissionTitleManageTeamSavedSearches:
      'Add or remove saved searches for the team',
    permissionTitleEditCustomFieldsSchema:
      'Create, remove or edit custom fields',
    permissionTitleAllowEditor: `Use ${appName} image editor`,
    permissionTitleDeleteAssets: `Delete assets from ${appName} library`,
    permissionTitleApproveAssets: 'Approve or discard the asset revision',
    permissionManageInboxes: 'Create, configure and delete an inbox',
    permissionAuditTrail: 'See a lof of actions of all teammates ',
    permissionDuplicateAssets: 'Duplicate assets',
    permissionTitleManageWatermarks: 'Manage watermarks',
    permissionTitleCreateDeleteEditWatermarks:
      'Create, edit, delete watermarks',
    permissionTitleImportCsv: 'Import CSV',
    permissionTitleApplyRemoveWatermarkToAsset: 'Apply, remove from asset',
    permissionTitleDownloadWithoutWatermark: 'Download without watermark',
    permissionTitleManageCollectionsCustomSort: 'Custom collection sorting',
    permissionDescrManageCollectionsCustomSort:
      'Set and apply a custom order to collections',
    permissionTooltipDisabledManageCollectionsCustomSort:
      'Permission change is limited due to a conflict: access to the root collection is required to enable custom collection sorting.',
    textTitleSetPassword: 'Set password',
    textPlaceholderTypePassword: 'Type password here',
    textPlaceholderTypeRole: 'Type role name here',
    permissionDescrAutogenerateKeywords:
      'Gives access to the button “Tag with AI” that runs AI for keywords generation',
    permissionDescrAutogenerateDescriptions:
      'Gives access to the “Generate description” button that runs AI for description generation',
    permissionTitleManageTranscriptions:
      'Run AI analysis on team video and audio assets to generate transcripts, chapters, action items, keywords, and on-screen text, and a video summary',
    permissionTranscribe:
      'Gives access to a button that runs AI video & audio intelligence to generate transcripts, chapters, actions, keywords, on‑screen text, and a video summary',
    title: 'My team',
    tabTeammates: 'Teammates',
    tabRoles: 'Roles',
    tabSettings: 'Settings',
    tabIntegrations: 'Integrations',
    tabBranding: 'Branding',
    tabAnalytics: 'Analytics',
    shopifyStoreUrl: 'Shopify store URL',
    shopifyDisplayName: 'Shopify display name',
    tabSecurity: 'Security',
    tabColorLabels: 'Color labels',
    tabChannels: 'Channels',
    colorLabels: {
      title: 'Asset color labels',
      subtitle: 'Customize and organize labels. Changes apply team-wide.',
      namePlaceholder: 'Label name',
      nameAriaLabel: 'Color label name',
      slotsUsed: (used, total) => `${used} of ${total} slots used`,
      addLabel: '+ Add color label',
      addLabelMaxTooltip: 'Maximum color labels reached. Delete or edit existing ones.',
      emptyState: () => (
        <>
          <strong>No color labels</strong>
          <br />
          Add a new label, or click Reset to default to restore initial ones.
        </>
      ),
      duplicateColorWarning: 'Another label already uses this color',
      reorderAriaLabel: (name) => `Reorder ${name}`,
      chooseColorAriaLabel: (name) => `Choose color for ${name}`,
      deleteTooltip: 'Delete color label',
      deleteAriaLabel: (name) => `Delete ${name}`,
      newLabelAriaName: 'new label',
      errorNameRequired: 'Label name is required',
      errorNameTooLong: (max) => `Label name cannot exceed ${max} characters`,
      errorNameDuplicate: 'A label with this name already exists',
      resetDialog: {
        title: 'Reset color labels to defaults?',
        text: 'Custom names, colors, and order will be replaced. Asset assignments will not change.',
        textBtnCancel: 'Cancel',
        textBtnOk: 'Reset',
      },
      resetTooltip: 'Reset to default',
      resetToDefaults: 'Reset to default',
      deleteDialog: {
        title: (name) => `Delete "${name}" label?`,
        textUnknownUsage: 'Are you sure you want to delete this label?',
        textUnused: 'Are you sure you want to delete this label?',
        textUsed: (count) => `This label is assigned to ${count} ${count === 1 ? 'asset' : 'assets'}. Deleting it will remove the label from those assets and set their color to None.`,
        textTooMany: (count, limit) => `This label is used by ${count} assets, which is more than the ${limit} that can be updated at once. Reduce its usage in the catalog first, or contact support.`,
        textBtnTooMany: 'Got it',
        textBtnCancel: 'Cancel',
        textBtnOk: 'Delete',
      },
    },
    channelsDisconnectDialog: {
      title: (channelName) => `Disconnect ${channelName}?`,
      description:
        'Are you sure you want to disconnect this store from your Toriut workspace? This action cannot be undone.',
      removedTitle: 'What will be removed from Toriut:',
      removedItems: [
        'All listing data and channel settings related to this store.',
        'Prepared drafts and any pending changes for this channel.',
      ],
      safeTitle: 'What will remain safe:',
      safeItems: [
        {
          label: 'Master Products:',
          text: 'They will stay in Toriut untouched.',
        },
        {
          label: 'Media Assets:',
          text: 'Imported files will stay in the Toriut Media Library (you can delete them manually later).',
        },
        {
          label: 'Shopify Products:',
          text: 'Active products on your storefront will not be deleted.',
        },
      ],
      textBtnCancel: 'Cancel',
      textBtnOk: 'Disconnect channel',
    },
    channelsDisconnect: 'Disconnect',
    channelsCloseDialog: {
      title: 'Exit channel setup?',
      text: () => (
        <>
          You haven’t finished adding this channel. Exiting now will discard the
          setup. <br />
          <br />
          Are you sure you want to exit?
        </>
      ),
      textBtnCancel: 'Cancel',
      textBtnOk: 'Exit',
    },
    channelsSkipSetupDialog: {
      title: 'Skip connection and use sample data?',
      text: () => (
        <>
          You can explore Toriut with sample products now and connect a sales
          channel later whenever you’re ready.
        </>
      ),
      textBtnCancel: 'Cancel',
      textBtnOk: 'Explore with sample data',
      buildingToast: 'Building sample data…',
      failedToast: 'Couldn’t build sample data. Please try again.',
    },
    shopifyWizard: {
      stepTitle: (step, subTitle) => `Step ${step} / ${subTitle}`,
      displayNamePlaceholder: 'My best store',
      syncScopeNote: '* You can change this later in Channel → Sync settings. Already imported products will stay in Toriut',
      syncStrategyOptions: {
        title: 'Choose which Shopify products to import',
        active: {
          label: 'Active',
          description: 'Product currently available for sale',
        },
        draft: {
          label: 'Draft',
          description: 'Products being prepared in Shopify',
        },
        unlisted: {
          label: 'Unlisted',
          description: 'Products that can be sold by direct link but are hidden from search, collections, and catalog',
        },
        archived: {
          label: 'Archived',
          description: 'Discontinued or historical products that are no longer for sale',
        },
      },
      reviewDisplayNameLabel: 'Store display name:',
      reviewSyncLabel: 'Sync settings:',
      installAppInfo: (
        <>
          To sync products from this store, you’ll need to install the Toriut PIM Connector
          Shopify app.
          <br />
          <br />
          Once the app is installed, Toriut will import the products you selected and keep them in sync.
        </>
      ),
      configuringAppInfo: (
        <>
          We’re waiting for the Toriut PIM Connector app to be installed on your Shopify store.
          <br />
          <br />
          Complete the installation in the Shopify App Store tab, then return here.
        </>
      ),
      configuringAppLoading: 'Configuring custom Shopify app ...',
      appConfiguredSuccess: 'Custom Shopify app configured successfully',
      fieldMapping: {
        channelPlaceholder: 'Shopify',
        notMapped: 'Not mapped',
        searchAttributesPlaceholder: 'Search attributes',
        createCustomAttribute: '+ Create custom attribute',
        autoMappedTitle: 'Auto-mapped attributes',
        autoMappedTooltip: 'These core attributes are automatically linked by Toriut to ensure proper synchronization. To maintain integration stability, they cannot be modified manually.',
        customMappingTitle: 'Custom mapping',
        productFieldsSubtitle: 'Product attributes',
        variantFieldsSubtitle: 'Variant attributes',
        loading: 'Loading mapping scheme...',
        loadError: 'Could not load mapping scheme. Please try again.',
        retry: 'Retry',
        defaultSchemeTitle: (channelName) => `Default ${channelName} mapping scheme`,
        channelFieldColumnHeader: (channelName) => `${channelName} attribute`,
        toriutAttributeColumnHeader: 'Toriut attribute',
        attributeTypeMismatchTooltip: (expected, actual) => (
          `Type mismatch: expected ${expected}, this attribute is ${actual}`
        ),
        attributeAlreadyMappedTooltip: (fieldName) => `Already mapped to "${fieldName}"`,
        readonlyMappingLabel: 'Advanced',
        readonlyMappingTooltip: 'This Shopify metafield type cannot be mapped to a Toriut attribute.',
        saveError: 'Could not save field mapping. Please try again.',
        invalidMappingError: 'Some mapped attributes are invalid. Please fix the highlighted rows.',
      },
      importingProducts: 'Importing your products, this may take a few minutes',
      importFailed: 'Product import failed. Please check your connection and try again.',
      importSuccess: 'Products imported successfully',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      skip: 'Skip',
      installCustomApp: 'Install custom app',
      stageInstall: 'Install Stage PIM Connector app',
      stageInstallNotice: 'Available in Stage and Development mode only.',
      devShopDomainPlaceholder: 'artur-toriut-store.myshopify.com',
      retryImport: 'Retry import',
      exploreProducts: 'Explore products',
    },
    activeConnections: 'Active connections',
    connectChannel: 'Connect a channel',
    connectChannels: 'Connect another channel',
    comingSoonChannels: 'Coming soon',
    channelsBreadcrumb: 'Channels',
    channelSyncSettingsBreadcrumb: 'Channel sync settings',
    channelMappingFieldsBreadcrumb: 'Channel mapping fields',
    channelsConnectionLost: 'Connection lost',
    channelsConnectionLostTooltip: [
      'The Toriut app was removed from this channel.',
      'Go to three dot menu to reconnect.',
    ],
    channelsSyncNowTooltip: 'Sync now',
    channelsSyncStartedToast: (channelName) => `Sync started for ${channelName}`,
    channelsSyncSuccessToast: (channelName) => `${channelName} synced successfully. Refresh to see the latest data.`,
    channelsSyncFailedToast: (channelName) => `Failed to sync ${channelName}. Please try again.`,
    channelsSyncTryAgain: 'Try again',
    channelsMenu: {
      renameChannel: 'Rename channel',
      mappingSchema: 'Mapping Schema',
      syncSettings: 'Sync settings',
      disconnectChannel: 'Disconnect channel',
      reconnect: 'Reconnect',
      remove: 'Remove',
    },
    channelsRemoveDialog: {
      title: (channelName) => `Remove ${channelName}?`,
      description:
        'This channel is disconnected. Removing it will delete its listing data and channel settings from Toriut.',
      textBtnCancel: 'Cancel',
      textBtnOk: 'Remove',
    },
    channelsReconnectSuccessToast: 'Channel reconnected successfully',
    channelsReconnectErrorToast: 'Could not reconnect channel. Please try again.',
    channelsRenameDialog: {
      title: 'Rename channel',
      textBtnCancel: 'Cancel',
      textBtnOk: 'Save',
      nameEmpty: 'Channel name cannot be empty',
    },
    channelsSyncSettingsSave: 'Save',
    channelsSyncSettingsSavedToast: 'Sync settings updated',
    channelMappingFieldsSave: 'Save',
    channelMappingFieldsSaveDisabledTooltip: 'Modify at least one attribute to save changes.',
    channelMappingFieldsSavedToast: 'Mapping settings updated',
    channelMappingFieldsUnsavedDialog: {
      title: 'Save mapping settings?',
      text: 'You’ve modified the attribute mapping for this channel, but haven’t saved yet. Do you want to save your changes before exiting?',
      discard: 'Discard changes',
      save: 'Save changes',
    },
    channelsLastSynced: (formatted) => `Last synced: ${formatted}`,
    shopifyDisplayNameTooltip:
      'This is the name that will be displayed in the Shopify channel. It can be changed later.',
    qqcomTitle: 'Error',
    qqcomText: `Sorry, you can’t invite users from "qq.com".<br />If you have a reason to do that, please contact us at <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}<a>`,

    errorEmailEmpty: '"Email" - is empty',
    errorCantAddYourself:
      "You can't add yourself to your team. Please pick someone else",
    errorEmailInvalid: (email) => `${email} isn't valid`,
    errorHaveReachedLimit:
      'You have reached a limit of teammate seats on this plan',
    requestFullRolesAccessDialog: {
      title: 'Request full access',
      text: () => (
        <>
          <span>
            With free beta access, you're limited to default user roles. Request
            full access to:
          </span>
          <br />
          <ul>
            <li>
              Create custom roles from scratch (e.g., 'Photographer,' 'Product
              Copywriter').
            </li>
            <li>
              Assign specific permissions to control who can view, edit, or
              create.
            </li>
            <li>
              Protect your product data by limiting access for external partners
              or contractors.
            </li>
            <li>
              Streamline workflows by creating focused workspaces for each team
              member.
            </li>
          </ul>
          <br />
          <span>
            Our support team will help you enable these options. Would you like
            to start a chat?
          </span>
        </>
      ),
      cancel: 'Cancel',
      ok: 'Proceed to chat',
    },
    requestFullTeammatesAccessDialog: {
      title: picsioConfig.isPim ? 'Teammates limit' : 'Request full access',
      text: (limit) => (
        picsioConfig.isPim ? (
          <>
            <span>
              Your trial includes up to {limit} teammates. Request full access to
              increase your team limit and keep growing your workspace:
            </span>
            <br />
            <ul>
              <li>Invite more teammates as your content operations grow.</li>
              <li>
                Bring more teams and stakeholders into the same workspace.
              </li>
              <li>
                Keep product, media, and collaboration workflows centralized as
                your team scales.
              </li>
            </ul>
            <br />
            <span>
              Our support team will help you enable these options. Would you like
              to start a chat?
            </span>
          </>
        ) : (
          <>
            <span>
              With free beta access, you’re limited to{' '}
              {pluralize('teammate', limit, true)}. Request full access to:
            </span>
            <br />
            <ul>
              <li>Build your entire team and invite more collaborators.</li>
              <li>
                Assign granular roles and permissions to control team access.
              </li>
              <li>Centralize all content-related communication in one place.</li>
              <li>
                Collaborate faster with unlimited internal comments and asset
                approvals.
              </li>
            </ul>
            <br />
            <span>
              Our support team will help you enable these options. Would you like
              to start a chat?
            </span>
          </>
        )
      ),
      cancel: 'Cancel',
      ok: 'Proceed to chat',
    },

    roleInUse: (users, usersList, usersMore) => (users.length > 1 ? (
      <div className="removeRoleDialog">
        The role can't be removed because it is in use by {users.length}{' '}
        users: {usersList}
        {usersMore}.<br />
        <br /> Please detach the role from those users first.
      </div>
    ) : (
      <div className="removeRoleDialog">
        The role can't be removed because it is in use by {usersList}.<br />
        <br /> Please detach the role from this user first.
      </div>
    )),
    usersWithRole: (roleName) => (
      <>
        {'Teammates in '}
        <span className="pageItemTitleColor">{roleName}</span>
        {' role'}
      </>
    ),
    noUsersWithRole: 'No users assigned for the role',

    titleDeleteRole: 'Delete this role?',
    textDeleteRole:
      'You cannot undo this action and restore the role your are about to delete.',
    btnOkDeleteRole: 'Delete',

    textTitleRemoveTeammate: 'Remove teammate',
    textTeammateWillRemoved:
      'Teammate will be removed from the team. Are you sure?',
    textCantRemoveTeammate: 'Cannot remove teammate',
    textCantConfirmTeammate: 'Cannot confirm teammate',
    textCantRejectTeammate: 'Cannot reject teammate',
    textCantUpdateTeammate: 'Cannot update teammate',
    textCantReinviteTeammate: 'Cannot reinvite teammate',

    textPasswordSet: 'Password for teammate created',
    errorCantSetPassword: 'Can not set teammate password',
    errorNameEmpty: '"Name" - is empty',
    titleNewRole: 'New role',
    titleCantRemoveRole: 'Cannot delete role',
    textCantRemoveRole: 'The role is in use. Detach the users from it first.',
    titleWarning: 'Warning!',
    titleCantDeleteDefaultRole: 'Cannot delete default role',
    textRemoveOnlyOneRole: `<p>Sorry, you can’t do that.</p><p>You must have at least 1 active team role in ${appName}.</p>`,
    titleEditName: (value) => `Edit "${value}"`,
    dialogTextRoleHaveAlready:
      'The role with such name already exists. Please try the other name.',
    textRemoveAutoinviteRole: (onClickHandler) => (
      <span>
        This role cannot be deleted as it’s used as the default one to
        auto-invite new users. Please{' '}
        <span
          className="picsioLink"
          role="presentation"
          onClick={onClickHandler}
        >
          choose another role for auto-inviting
        </span>{' '}
        and try again.
      </span>
    ),
    titleRestrictReason: 'Default restricted asset reason message',
    labelRestrictReason:
      'Change the default reason message for restricted assets',
    tooltipMessageAllows:
      'Allows the team to use existing keywords only. Blocks any changes, i.e. add, edit and remove keywords.',
    tooltipMessageVisualSearch:
      'Turns on AI-powered image discovery for your team: type what you’re looking for (natural-language search) or use an image to find similar assets across your DAM library.',
    textKeywords: 'Keywords',

    titleRequiredFields: 'Required fields for uploads and revisions',
    titleMetadataFields: 'Metadata fields',
    titleCustomFields: 'Custom fields',
    actionRequired: 'Required for upload',
    labelCommentRequired: 'Comment',
    labelTitleAndDescriptionRequired: 'Title & Description',
    labelTitleRequired: 'Title',
    labelDescriptionRequired: 'Description',
    labelKeywordsRequired: 'Keywords',
    labelAssigneesRequired: 'Assignees',
    labelFlagRequired: 'Flag',
    labelRatingRequired: 'Rating',
    labelColorRequired: 'Color',

    labelUseControlled: 'Enable Controlled Vocabulary',
    labelVisualSearch: 'Enable Visual & Similar Images Search',
    labelFacesAutofill: 'Face recognition',
    labelAutomaticallyAllRelevant: 'Enable all AI services',
    labelAutomaticallyImageAllRelevant:
      'Enable all Image Intelligence features',
    labelKeywordsAutofill: 'Keyword tagging',
    labelTranscribingAutofillLegacy: 'Video & audio analysis',
    labelTranscribingAutofill: 'Enable Video & Audio Intelligence features',
    textUploadDictionary: 'Import keyword list',
    textKeywordingEngines: 'Keyword Generation Engine',
    textKeywordingConfidence: 'Recognition precision',
    textKeywordingLocale: 'Language to recognize keywords in',
    textDescribingLocale: 'Generation language',
    textTranscribingLocale: 'Default transcription language',
    textKeywordingTabTitle: 'Autotagging with keywords',
    textFacialRecognitionTabTitle: 'Person recognition',
    textAICredits: 'Artificial Intelligence Credits',
    textKeywordSettings: 'Keywords settings',
    textGeneralAi: 'Automatic AI processing for new uploads',
    aiUsageProgressTitle: 'AI usage',
    aiUsageAssetsUnit: 'AI assets',
    aiUsageMinutesUnit: 'AI minutes',
    aiUsageUsedLine: (used, limit, unit, percent) => `${used} / ${limit} ${unit} used (${percent}%)`,
    aiUsageAssetsRemaining: (remaining) => `${remaining} AI assets remaining`,
    aiUsageAssetsRemainingBeforeTier: (remaining, nextTier) => `${remaining} AI assets remaining before ${nextTier}`,
    aiUsageMinutesRemaining: (remaining) => `${remaining} AI minutes remaining`,
    aiUsageMinutesRemainingBeforeTier: (remaining, nextTier) => `${remaining} AI minutes remaining before ${nextTier}`,
    aiUsageAssetsWarning: (percent) => `You’ve used ${percent}% of your AI assets limit.`,
    aiUsageMinutesWarning: (percent) => `You’ve used ${percent}% of your AI minutes limit.`,
    aiUsageAssetsCritical: 'You have reached the limit of your current AI Tier. Further AI usage may require moving to the next AI Tier.',
    aiUsageMinutesCritical: 'You have reached the limit of your current AI Tier. Further AI usage may require moving to the next AI Tier.',
    aiUsageDataUnavailable: 'AI usage data is temporarily unavailable.',
    faceRecognitionSettings: 'Face recognition settings',
    transcriptionSettings: 'Transcription settings',
    textBuyMoreKeywordCalls: 'Buy more calls',
    textBuyMoreAICredits: 'Purchase credits',
    textKeywordingTabControlledVocabularyTitle:
      'Generate keywords only from my vocabulary',
    titleInvalidFileType: 'Invalid file type',
    textOnlyTXTAndCSV: 'You can only upload dictionary as txt or csv file',
    descriptionSettings: 'Description settings',
    visualSearchSettings: 'Visual & Similar Images Search',
    labelDescribingAutofill: 'Description generation',
    labelDescribingSelect: 'Default action for pre-existing descriptions',
    descriptionMergeSelectOption: 'Merge (Combine with AI’s)',
    descriptionReplaceSelectOption: 'Replace (Use AI’s only)',

    titleUploadDictionary: 'Import keyword list',
    descriptionUploadDictionary:
      "We found discrepancies between the system's keyword list and your uploaded one. Please decide how to proceed:",
    labelMerge:
      'Combine imported keyword list with the existing one in the system',
    labelReplace:
      "Replace the system's existing keyword list with the one imported from your file <span>(Any not listed in the file will be deleted)</span>",
    btnUpload: 'Confirm',
    titleDictionaryUploaded: 'Keyword Import Complete',
    textWeFoundInFile: ({ total }) => `We found ${total} keywords in the uploaded file. All of them have been successfully added to your keyword list.`,
    titleDictionaryUploadFailed: 'Upload of the dictionary failed',
    textErrorTryAgain: 'Error, please try again later',
    titleKeywordsAutogeneration: 'Confirm action',
    titleTranscriptAutogeneration: 'Confirm action',
    titleDescriptionAutogeneration: 'Confirm action',
    titleEnableVisualSearch: 'Enable Visual & Similar Images Search',
    titleEnableVisualSearchIsDisabled: 'Search indexing fee required',
    titleEnableVisualSearchPro: 'Visual Search Pro Version Setup',
    textEnableVisualSearch: () => (
      <>
        Similar Images Search analyzes visual characteristics—composition, color
        palette, shapes, and patterns—to help you find related assets instantly.
        <br />
        <br />
        Visual Search understands natural language queries, letting you search
        by describing what's in the image. The AI analyzes image content to
        deliver accurate results without depending on metadata.
        <br />
        <br />
        Both features are included in your AI Kit tier at no additional cost.
      </>
    ),
    textEnableVisualSearchIsDisabled: () => (
      <>
        <p>
          You’re about to enable{' '}
          <strong className="f-w-5">Visual & Similar Images Search</strong> for
          your library.
        </p>
        <p>
          For this feature to work, your existing assets must go through a{' '}
          <strong className="f-w-5">one-time AI indexing</strong>. Because this
          is a resource-intensive process:
        </p>
        <ul>
          <li>
            With a <strong className="f-w-5">AI Kit Yearly</strong>, the initial
            indexing is included.
          </li>
          <li>
            With <strong className="f-w-5">AI Kit Monthly</strong>, indexing is
            billed separately at $0.016 per asset
          </li>
        </ul>
        <p>
          (≈ <strong className="f-w-5">$160</strong> for 10k,{' '}
          <strong className="f-w-5">$400</strong> for 25k,{' '}
          <strong className="f-w-5">$800</strong> for 50k assets).
        </p>
        <p>
          Your library hasn’t been indexed yet, so it must be processed before
          we can enable this feature.
        </p>
        <p>
          To proceed, please contact support. They’ll calculate the exact
          amount, handle a one-time manual payment, and arrange indexing. After
          that, Visual & Similar Images Search will be enabled, and all new
          uploads will be indexed automatically at no extra cost.
        </p>
        <p>
          Alternatively, you can switch to a{' '}
          <strong className="f-w-5">AI Kit Yearly</strong>, where the initial
          indexing is included.
        </p>
      </>
    ),
    textEnableVisualSearchPro: () => (
      <>
        Pro Visual Search (included in your AI Kit) delivers higher-precision
        results via advanced semantic matching — combining visual analysis, text
        embeddings, and contextual understanding.
        <br />
        <br />
        <strong>Get the best results with a custom prompt</strong>
        <br />
        Our support team can help define a tailored AI context for your library.
        <br />
        <br />
        <strong>Benefits of a custom prompt:</strong>
        <br />
        <br />
        <span className="visual-search-benefits">
          <CheckMark className="check-mark-icon" /> Results aligned with your
          industry and content types
        </span>
        <span className="visual-search-benefits">
          <CheckMark className="check-mark-icon" /> Better handling of your
          terminology and workflows
        </span>
        <span className="visual-search-benefits">
          <CheckMark className="check-mark-icon" /> Optimized accuracy from day
          one
        </span>
        <br />
        Important: Initial prompt setup is included at no extra charge. Changing
        the prompt later requires re-indexing your library and may incur
        additional fees.
        <br />
        <br />
        You can start now with a general-purpose prompt; it works well but may
        be less precise for your specific use cases.
        <br />
        <br />
      </>
    ),
    btnEnableVisualSearch: 'Enable AI Search',
    btnEnableVisualSearchPro: 'Proceed with default configuration',
    btnTalkToSupport: 'Talk to support',
    btnGoToBilling: 'Go to Billing',
    textThisWillCost:
      'Enabling this setting, you confirm that all newly created assets in your library will be processed by AI, which uses up your available AI processing balance.',
    btnActivate: 'Activate',
    btnConfirm: 'Confirm',
    btnRequestUpdate: 'Request update',
    btnEditPrompt: 'Edit prompt',
    titleFacesAutogeneration: 'Confirm action',

    textCreateNew: 'Create new role',
    textTooltipDuplicate: (entity) => `Duplicate ${entity}`,
    textTooltipEdit: (entity) => `Rename ${entity}`,
    textTooltipDelete: (entity) => `Delete ${entity}`,
    textAllowedCollections1: 'Permissions for ',
    textAllowedCollections2: ' collection',
    textNotCreatedAllowedCollection: `Teammates with this role have no access to any of your collections in ${appName}.`,
    textPressPaperclip:
      'Press ‘paperclip’ to choose collections & select permissions.',
    textTeamCollections: 'Collection permissions',
    textMediaPermissions: 'Media Management',
    textAssetDetailsPanel: 'Asset details panel',
    textPermissions: 'Team permissions',
    textGlobalPermissions: 'General Permissions',
    textNoteAllowedCollectionsSelect: () => (
      <>
        To set similar permissions to several collections, hold{' '}
        <em>cmd/ctrl</em> and select several collections, then tick necessary
        checkboxes.{' '}
      </>
    ),
    learnMoreAboutAllowedCollection: 'Learn more about Collection Permissions',

    textInviteNewTeammate: 'Add new teammates',
    academyBannerTitle: 'Pics.io Academy',
    academyBannerHeadline: 'Help your team work smarter in Pics.io.',
    academyBannerDescription: 'Give teammates a clear, hands-on way to learn Pics.io workflows, build better DAM habits, and discover features they may not be using yet.',
    academyBannerCta: 'Go to Pics.io Academy',
    academyStatusLabel: 'Pics.io Academy',
    textNewTeammate: 'Add new teammates',
    textInvite: 'Add',
    placeholderEmail: 'email',
    labelSelectRole: 'Role',
    labelSelectEmail: 'Email',
    errorPasswordMin: 'Password needs to be at least 8 characters long',
    errorPasswordMax: 'Password can contain up to 128 characters',

    titleInviteFromEmail: 'Invite from email',
    titleUsersFromGSuite: 'Import user list from Google Workspace',
    textSelectGSuiteUsers: 'Select Google Workspace users to invite',
    addUsersFromGSuite: 'Add users from Google Workspace',
    inviteInfoBlock: () => (
      <p>
        Add teammates instantly by entering your corporate domain. Go to{' '}
        <a
          href="/teammates?tab=settings"
          target="_blank"
          className="picsioLink"
        >
          Settings
        </a>{' '}
        to set it up now.
      </p>
    ),
    labelAddNewTeammatesTooltip: () => (
      <>
        <p>
          Invited teammates will receive direct {appName} login link via email.
        </p>
        <p>
          Users without verified domains will be shown on the <b>Invited</b>{' '}
          list before they click the link.
        </p>
        <p>
          Users with verified domains are instantly shown on the{' '}
          <b>Teammates</b> list right after adding them.
        </p>
      </>
    ),
    gSuiteNotAllowed:
      'You are not allowed to invite Google Workspace users to your team. Please activate your Google Workspace account to perform this action.',
    notAuthorizedToGetResourceFromGSuite:
      'Your account does not have sufficient permissions to access Google Workspace users list. Please contact your Google Workspace administrator for authorization to access.',
    reset: 'reset',
    succesfulyInvited: 'Successfully invited:',
    notInvited: 'Not invited:',
    availableUsersExceeded: 'You have exceeded the available number of users.',
    updatePlan: 'Update plan',

    textTeamOwner: 'Team owner',
    textLastVisit: 'Last visit:',
    textNoAnswer: 'n/a',
    labelPassword: 'Password',
    statusInvited: 'Invited',
    statusRequested: 'Requested',
    statusRejected: 'Rejected',
    statusAccepted: 'Accepted',
    statusReinvited: 'Reinvited',
    textStatus: 'status:',
    textClickToReinvite: 'Click to reinvite',

    webhooks: 'Webhooks',
    introWebhooksText: `Use webhooks to be notified about events that happen in your ${appName} account.`,
    enterUrl: 'Enter url',
    addWebhook: 'Add webhook',
    editWebhook: 'Edit webhook',
    btnAdd: 'Add',
    btnSave: 'Save',
    btnSend: 'Send',
    sendAllTypes: 'Send all event types',
    sendSelectedTypes: 'Select types to send',
    errorUrlNotValid: 'Please enter a valid URL.',
    errorUrlExists: 'This URL is already in use. Please choose another one.',
    testWebhook: 'Test webhook',
    eventType: 'event type',
    testRequestSent: 'Test request sent',
    testRequestNotSent: "Can't send test request. Please try again.",
    tooltipSendTest: 'Send test',
    tooltipEdit: 'Edit',
    tooltipRemove: 'Remove',

    textTitleRemoveWebhook: 'Remove webhook',
    textWebhookWillRemoved: 'Webhook will be removed. Are you sure?',
    textCantCreateWebhook: `Can\'t create webhook. Please try again.<br> Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
    textCantRemoveWebhook: `Can\'t remove webhook. Please try again.<br> Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
    textCantUpdateWebhook: `Can\'t update webhook. Please try again.<br> Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
    learnMoreAboutWebhooks: 'Learn more about webhooks',
    unableToLoadTypes: 'Unable to load event type list',
    descrManageWebhooks: "You don't have permission to create or edit webhooks",
    descrManageApiKey:
      'Ask your admin for the permission to view or copy API Key',
    apiKey: `Your individual API key for integrating ${appName} with Zapier and other services`,
    learnMoreAboutZapier: `How to integrate ${appName} and Zapier`,
    copy: 'Copy',

    titleSettingsName: 'Name',
    labelSettingsYourTeamName: 'Your team name',

    labelProfileYourTeamName: 'Your team name',
    labelProfileYourWebsite: 'Website',
    labelProfileYourDomains: 'Company domains',

    titleSettingsDomain: 'Domain',
    placeholderEnterDomain: 'Enter new domain',
    inviteSettingsTitle: 'Users on team domains',
    inviteSettings: {
      none: 'Can join my team only by invite',
      optional: 'Are offered to join my team after signup',
      auto: 'Automatically join my team after signup',
    },
    labelSettingsYourDomains: 'Your domains',
    labelSetDefaultRole: 'Set default role for new users',

    titleSecurity: 'Two-factor authentication (2FA)',
    titleSecurityOktaSSO: 'Okta SSO',
    labelOktaDomain: 'Okta domain',
    labelOktaClientID: 'Client ID',
    labelOktaClientSecret: 'Client Secret',
    labelOktaClientBaseUrl: 'Custom Auth Server URL',
    oktaSSOLink: 'Okta sign-in link',
    oktaSSOLinkPlaceholder: 'Type your okta domain to generate sign-in link',
    oktaSSOLinkCopiedToast: 'Okta sign-in link copied',
    oktaPlaceholders: {
      oktaDomain: 'Type okta domain',
      clientID: 'Type client ID',
      clientSecret: 'Type client secret',
      oktaAuthServerBaseUrl: 'Type Custom Auth Server URL',
    },
    labelOktaForMobileApp: 'Is mobile app',
    labelAuthentication:
      'Activate Two-factor authentication (2FA) for all teammates',
    labelAuthenticationTooltip:
      'Switch on the Two-factor authentication (2FA) for the entire team. Teammates will get an email with instructions.',
    setup2FANow: 'Set up Two-factor authentication (2FA) for my account',
    reset2FASuccess: 'Two-factor authentication (2FA) for a teammate reset',
    status2FASuccess: 'Teammate set up Two-factor authentication (2FA)',
    status2FAInProgress:
      'Teammate is yet to set up Two-factor authentication (2FA)',
    status2FAReset: 'Reset',
    titleSecurityAuthMethods: 'Authentication methods',
    btnSecurityCancelAllSessions: 'End all sessions',
    btnCancelUserSession: 'End User Session',
    labelAllowedAuthMethodsTooltip:
      'Select authentication methods for your teammates Sign In',
    labels2FA: {
      disabled: 'Allow teammates to login without 2FA',
      optional: 'Optional 2FA setup for team members',
      force: 'Forced 2FA setup for team members',
    },
    statuses2FA: {
      notActive: 'Inactive',
      active: 'Active',
      pending: 'Pending',
    },
    security2FATeammatesList: {
      teammates: 'Teammates',
      status: '2FA Status',
    },
    security2FAResetDialog: {
      title: 'Reset two-factor teammate authentication',
      text: (name) => `<span>You are about to reset two-factor authentication for teammate <b>${name}</b></span>`,
      btnReset: 'Reset',
    },
    security2FAToast: {
      disabled:
        'You selected the option to allow teammates to log in without 2FA. This method provides basic login security. Consider other options for better protection.',
      optional:
        'You activated optional 2FA setup for all teammates. Each teammate will shortly receive further instructions on how to enable 2FA on their accounts.',
      force:
        'You activated a mandatory 2FA setup for all teammates. Each teammate will shortly receive further instructions on how to enable 2FA on their accounts.',
    },
    textAlwaysVisibleFieldTooltip: 'This metadata field is always visible',
    textRequiredNotHiddenTooltip:
      "Metadata fields marked as required for upload won't be hidden",
    textRequiredForUploadTooltip:
      'This field is marked required for upload and cannot be hidden',

    BRANDING: {
      logoUploader:
        "It's better to use small square images 200-400 pixels on a transparent background: PNG or SVG. Or small progressive JPG.",
      backgroundUploader: 'The image will be used for login and signup pages.',
      faviconUploader:
        'You can use the image 512x512px, best to use a PNG with transparent background',
      titleAccentColor: 'Accent color',
      descriptionAccentColor: `Use your accent color in the ${appName} UI.`,
      titleBackgroundColor: 'Background color',
      descriptionBackgroundColor: `Use your pages background color in the ${appName} UI.`,
      titleAppLogo: 'App logo',
      labelBrandedLogo: 'Enable branded app logo',
      titleCopyright: 'Copyright',
      descriptionCopyright: 'Content will be visible at websites footer',
      titlePages: 'Pages',
      errorSavingSettings: `Can't save settings. Please try again.<br> Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
      labelBrandedDownloadPage: 'Enable branded download page',
      labelBrandedBanner: 'Remove the promotional banner',
      dialogWarningTitle: 'Warning',
      dialogWrongLoginPath:
        'Do not use the word "login" as your customized login. Input the other word in this field.',
      errorDomainMessage: (value) => `Domain name ${value} is already used in ${appName} in another account. Please pick a different domain name.`,
    },
    AUTH_METHODS: {
      plain: 'Plain password',
      google: 'Google SSO',
      microsoft: 'Microsoft SSO',
      okta: 'Okta SSO',
    },
    CANCEL_ALL_SESSIONS_DIALOG: {
      title: 'End the session for all teammates?',
      text: (count) => `You are about to end active sessions for all ${
        count ? `(${count})` : ''
      } teammates except yourself`,
      errorText: 'Failed to end all sessions. Please try again.',
      toastText: (usersCount) => `Session for ${usersCount} user${
        usersCount > 1 || !usersCount ? 's' : ''
      } was ended successfully`,
    },
    CANCEL_USER_SESSION_DIALOG: {
      title: 'End user session',
      text: (userName) => `Are you sure you want to end ${userName} session?`,
      errorText: (userName) => `Failed to end ${userName} session. Please try again.`,
      toastText: (userName) => `Session for ${userName} was ended successfully`,
    },
    helpText: {
      teammates: 'Learn how to invite new teammates',
      roles: 'Learn how to assign roles to teammates',
      integrations: 'Integrations',
      settings: 'Learn how to set up team policies',
      analytics: `Explore how to work with ${appName} analytics&reporting`,
      branding: 'Learn how to set up team branding',
      profile: 'Learn how to set up team profile',
      security: 'Learn how to set up 2FA',
      watermarking: 'Learn more about watermarks',
      ai: `Learn more about AI capabilities in ${appName}`,
    },
    toastMessageVisualSearchRootCollection:
      'The processing of your team library for Visual Search has started. This may take some time, depending on its size.',
    toastMessageVisualSearchAnyCollection: (collectionPath) => `The processing of your collection "${collectionPath}" for Visual Search has started. This may take some time, depending on its size.`,
    assetDetailsPanelInfoBlockText:
      "These metadata fields will be only visible on asset details panel and during uploading assets. Visibility of these metadata fields won't be affected in other parts of the system.",
    activePromptLabel: 'Active prompt',
    activePromptButton: 'Edit prompt',
    requiresImageAIKitTier: 'Requires Image Intelligence Kit (Tiers 1–5).',
    requiresVideoAiKitTier:
      'Requires Video & Audio Intelligence Kit (Tiers 1–5).',
    requiresAnyAIKitTier: 'Requires AI Kit (Tiers 1–5).',
    requiresAdvancedAIKitTier: 'Requires AI Kit (Tiers 3–5).',
    supportRequestTemplateText: (key) => `Hello, I would like to request an update to my team's default prompt for AI ${key} generation. Please review the new version I've submitted below:`,
    promptKeys: {
      keyword: 'keyword',
      description: 'description',
    },
    editPromptModal: {
      title: 'Edit prompt',
      text: () => (
        <>
          <p className="m-t-0">
            Please make your desired changes to the prompt below.
          </p>
          <p>
            The requested changes will be sent to our support team for a manual
            review and performance test.
          </p>
          <p>
            This validation step ensures your prompt works effectively. The new
            prompt will be applied to your account after our team has approved
            it.
          </p>
        </>
      ),
    },
    inputLabel: <span className="f-s-14 f-w-5 m-b-10">Active prompt</span>,
    AI: {
      visualSearch: {
        textAssetsCountLabel: 'Indexed / Available:',
        textInfoBlock:
          'To index the necessary collections, go to their details panel and mark them as indexable.',
        textInfoBlockEmpty:
          'No collections have been indexed by AI Search yet. To include a collection, open its Details panel and enable indexing.',
        textWarningBlock:
          'Indexing limit for Visual & Similar Images Search reached, some assets aren’t included in search results. Upgrade AI Kit tier to expand coverage.',
        upgradeButton: 'Upgrade AI KIt',
      },
    },
  },

  TRANSCRIPT: {
    promoBlock: {
      title: 'Explore AI for video & audio (Beta)',
      description:
        'Try new features from the dropdown menu and share your feedback.',
    },
    suggestImprovement: {
      title: 'Help improve Video & Audio Intelligence',
      text:
        'Have an idea or found an issue with Video & Audio Intelligence? Share it below — it goes straight to our product team.',
      placeholder: 'Your feedback about Video & Audio Intelligence…',
    },
    placeholderTitle: 'Let AI analyze this asset',
    placeholderErrorTitle: ([firstLetter, ...rest]) => `${firstLetter.toUpperCase()}${rest.join('')} analysis failed`,
    placeholderRunningTitle: ([firstLetter, ...rest]) => `Processing ${firstLetter.toUpperCase()}${rest.join('')} ...`,
    placeholderDecsription:
      'Identify key moments, create chapters, tag keywords and extract on-screen text automatically. Turn your video or audio into searchable data.',
    placeholderErrorDescription:
      'An unexpected error occurred during AI analysis. Please contact support to resolve the problem.',
    placeholderErrorTitleNoAudioStream: 'No audio track detected',
    placeholderErrorDescriptionNoAudioStream: (
      <>
        This video does not include an audio track, so a transcript cannot be generated.
        <br />
        Other Video Intelligence results may still be available.
      </>
    ),
    itemErrorNoAudioStream: 'No audio track detected: transcript not available.',
    placeholderButton: 'Analyze',
    dropdownOptionText: 'Transcribe in',
    tooltipSearch: 'Search',
    tooltipCopy: (copied, view) => (copied ? 'Copied!' : `Copy ${view || 'transcript'}`),
    tooltipCopied: 'Copied!',
    tooltipMoreActions: 'More actions',
    tooltipSuggestImprovement: 'Suggest improvement',
    DIALOGS: {
      titleUpgradePlan: 'Upgrade plan',
      textUpgradePlan:
        'Transcribing speech to text is not available for the current plan',
      btnUpgradePlan: 'See all plans',
      titleNotEnoughAICredits:
        'Insufficient Video & Audio Intelligence Minutes',
      textNotEnoughAICredits: (canNotBuyApiCalls, usersToWrite) => (
        <>
          You don’t have enough AI minutes to process this asset. This can
          happen if your minutes are used up, or if processing this asset would
          exceed your remaining balance.
          <br />
          <p>
            Please ask your team admins{' '}
            {usersToWrite.map((user) => (
              <Tag
                key={user._id}
                type="user"
                avatar={user.avatar}
                text={user.email}
              />
            ))}{' '}
            to subscribe to the <b>Video & Audio Intelligence Kit add-on</b> to
            continue using AI-powered services.
          </p>
        </>
      ),
      btnNotEnoughAICredits: 'Subscribe to AI Kit',
      titleBulkTranscribing: 'Video & Audio analysis',
      textBulkTranscribing: (counfOfAssets) => `You're about to send ${counfOfAssets} assets for video & audio analysis, which will use up your processing minutes balance. Please confirm this action.`,
      btnCongirmBulkTranscribing: 'Confirm',
      btnCancelBulkTranscribing: 'Cancel',
      titleExistingTranscript: 'Re-run Video & Audio analysis?',
      textExistingTranscript: () => (
        <>
          This will permanently overwrite your existing results, including
          transcript, keywords, actions, recognized texts and chapters.
        </>
      ),
    },
    DIALOG_OVERWRITE_EXISTING: {
      TITLE: 'Overwrite existing transcript?',
      TEXT: () => (
        <div>
          The current transcript will be deleted and replaced.
          <br />
          <br />
          Do you want to continue?
        </div>
      ),
      BTN_OK: 'Transcribe',
    },
    DIALOG_DELETE_TRANSCRIPT: {
      TITLE: 'Delete transcript',
      TEXT: () => (
        <p>
          Are you sure you want to delete the current transcript?
          <br />
          <br />
        </p>
      ),
      BTN_OK: 'Delete',
    },
    DIALOG_COPY_SETTINGS: {
      TITLE: 'Copying settings',
      TEXT: 'Set transcript copy preferences',
      CHECKBOX_SPEAKER: 'Display speakers',
      CHECKBOX_TIMESTAMPS: 'Display timestamps',
      CHECKBOX_DONT_SHOW_AGAIN: "Don't show again",
      BTN_CANCEL: 'Cancel',
      BTN_OK: (isSettingsMode) => (isSettingsMode ? 'Save' : 'Copy'),
    },
    TOASTS: {
      textTranscribeTPanelInProgress: `Video & Audio Intelligence is in progress. It's a background operation, you can continue using ${appName}.`,
      unsupportedFormats: {
        text: 'Unsupported format(s) skipped',
        btnOk: 'View formats',
        link:
          'https://help.pics.io/en/articles/13239269-video-intelligence-in-pics-io',
      },
      textTranscribeIPanelInProgress: (counfOfAssets) => `Video & Audio Intelligence is in progress for ${counfOfAssets} assets`,
      textTranscribingHonSupported:
        'Video & Audio Intelligence is not supported for this file format',
      transcribingComplete: (assetName, onClick) => (
        <>
          Transcribing for{' '}
          <span
            aria-label="link to asset"
            className="picsioLink"
            role="presentation"
            onClick={onClick}
          >
            {assetName}
          </span>{' '}
          complete
        </>
      ),
      transcribingCompleteMultiple: (count) => (
        <>Transcribing for {count} assets complete</>
      ),
      videoAnalyzingComplete: (assetName, onClick) => (
        <>
          Video & Audio Intelligence for{' '}
          <span
            aria-label="link to asset"
            className="picsioLink"
            role="presentation"
            onClick={onClick}
          >
            {assetName}
          </span>{' '}
          complete
        </>
      ),
      videoAnalyzingCompleteMultiple: (count) => (
        <>Video & Audio Intelligence for {count} assets complete</>
      ),
      copyTranscript: 'Transcript copied to clipboard',
      textTranscriptionDeleted: 'Asset transcript has been deleted',
      textTranscriptionNotDeleted: "Transcript hasn't been deleted",
    },
  },

  IMPORT: {
    inboxAssetsLimitExceeded: (assetsCount) => `Inbox limit exceeded. Remove ${assetsCount} assets from your selection to continue, or ask the inbox owner to increase the upload limit.`,
    textTotalFilesCount: (filesCount) => `${pluralize('asset', filesCount, true)} to upload`,
    textUploadErrorsCount: (errorsCount) => ` / ${pluralize('asset', errorsCount, true)} with errors`,
    textDoNotCloseAppWhileUploading:
      'Keep the app open - closing or hiding it will stop uploads',
    textImagesWasntUploadToGD: "Assets weren't upload to your cloud storage",
    titleFileAlreadyExists: 'Asset already exists',
    textFileAlreadyExists: `You’re about to upload the asset that already exists in ${appName}`,
    textRemoveSelected: (count) => `Remove ${count} selected ${pluralize('file', count)}`,
    textKeepBoth: 'Keep both',
    textAddAsNewRevision: 'Add as new revision',
    textReplace: 'Replace',
    textRetry: 'Retry',
    textRetryAll: 'Retry all',
    textSkip: 'Skip',
    textApplyToAll: 'Apply to all',
    // textUploadedFiles: 'Uploaded {uploadedValue} new assets',

    // textFormatIsntSupported: 'Format ."{fileExtensionValue}" is not supported yet!',
    textFileRevisionUpdated: 'Your asset revision was updated',
    textCantSaveImageToDB: "Can't save uploaded asset into database",
    textCantCheckDuplicates: "Can't check duplicates",
    textCantSaveImageToGD: "Can't save uploaded asset into your cloud storage",
    textCantSaveImageToStorage: "Can't save uploaded asset into storage",
    textDontHavePermissionToUpload:
      "You don't have permission to upload to this folder",

    corruptedFiles: {
      title: (num) => `${num > 1 ? 'These' : 'This'} file${num > 1 ? 's' : ''} ha${
        num > 1 ? 've' : 's'
      } 0 bytes`,
      text: (names) => `File${names.length > 1 ? 's' : ''} ${
        names.length > 1 ? 'are' : 'is'
      } corrupted: ${names.join(', ')}
 <br />
 <br />
There is no content to preview in it. Check this file in a software it was generated by`,
    },
    blackListedFiles: {
      title: (num) => `${num > 1 ? 'These' : 'This'} file${num > 1 ? 's' : ''} ha${
        num > 1 ? 've' : 's'
      } not allowed extension`,
      text: (names) => `File${names.length > 1 ? 's' : ''} ${
        names.length > 1 ? 'are' : 'is'
      } not allowed: ${names.join(', ')}`,
    },
    hiddenFiles: {
      title: (num) => `${num > 1 ? 'These' : 'This'} file${num > 1 ? 's' : ''} ${
        num > 1 ? 'are' : 'is'
      } hidden`,
      text: (names) => `File${names.length > 1 ? 's' : ''} ${
        names.length > 1 ? 'are' : 'is'
      } hidden: ${names.join(', ')}`,
    },
    duplicateCollections: {
      title: (num) => `Folder ${pluralize('name', num)} already exist${num > 1 ? '' : 's'}`,
      text: (names) => `${pluralize('Folder', names.length)} <b>[${names.join(
        ', ',
      )}]</b> already exist${
        names.length > 1 ? '' : 's'
      }. You can rename it or select a different export location`,
    },

    toManyAssetsForAnalysis: {
      title: 'Duplicates check limit is 10,000',
      text: `<p>Every time you make a new upload to ${appName}, we check your files for duplicates. We cannot check more than 10 000 files in one go.</p><p>But you can still proceed with uploading. If there are duplicates found, we’ll upload them as new assets.</p>`,
      textS3: `<p>Please note that ${appName} cannot process more than 10 000 assets at a time due to the duplicates check.</p><p>Please select less than 10 000 files at once and perform the action again.</p>`,
      btnCancel: 'Cancel',
      btnCancelS3: 'Ok',
      btnOk: 'Continue uploading',
    },

    toManyAssetsForUpload: {
      title: 'Sorry, too many assets processed for upload',
      text: `<p>${appName} is powerful, but apparently, not powerful enough to process so many files at a time.</p><p>Please make a smaller selection for upload. Thanks.</p>`,
      btnOk: 'Ok',
    },

    restoreUpload: {
      title: 'Some assets were not uploaded',
      /** @param {string[]} filenames */
      list: (filenames) => {
        const showMore = filenames.length > 30;
        const namesToShow = showMore ? filenames : filenames.splice(0, 30);
        return (
          <>
            <p>
              For some reason, your latest upload ran into a problem and some
              assets were not uploaded to {appName}.
            </p>
            <ul>
              {namesToShow.map((name) => (
                <li key={name}>{name}</li>
              ))}
            </ul>
            <If condition={showMore}>
              <div>...and {filenames.length - 30} more</div>
            </If>
          </>
        );
      },
      btnClose: 'Close',
      text: `<p>For some reason, your latest upload ran into a problem and some assets were not uploaded to ${appName}.</p><p>Do you want to resume uploading?</p>`,
      btnCancel: 'Discard',
      btnOk: 'Resume',
    },

    wrongFileChoosen: {
      title: 'Error',
      text: 'You might have selected a wrong file - filenames do not match.',
      btnCancel: 'Cancel',
      btnOk: 'Replace file',
    },

    cantCreateCollections: {
      title: 'Sorry',
      text: `<p>For some reason, ${appName} failed to create the following collection(s):</p><ul>{$list}</ul>`,
      btnCancel: 'Skip',
      btnOk: 'Retry',
    },

    unsafeCharactersError: (collectionName) => `Cannot create a collection "${collectionName}" with invalid characters. Allowed: numbers (0-9), letters (a-z, A-Z), slash (/), exclamation mark (!), dashes (-, –, —), underscore (_), dot (.), asterisk (*), single quote (’), and parentheses ()`,

    collectionAlreadyExistsInArchiveApiError: (collectionName) => `Collection with the name "${collectionName}" already exists. Change the name of the folder on your computer or the name of target collection.`,

    cantHandleDroppedFiles: {
      title: 'Error',
      text: `<p>For some reason, ${appName} failed to process your files.</p><p>Try uploading them again. If the error persists, contact us at <a class="picsioLink" href="mailto:${supportEmail}">${supportEmail}<a>.</p>`,
      btnCancel: 'Ok',
    },

    MENU: {
      mobileDialogTitle: 'Add assets',
      upload: 'Upload file',
      uploadFolder: 'Upload folder',
      uploadViaInbox: 'Upload via inbox',
      addExternal: 'Add external links',
      importDropbox: 'Import from Dropbox',
      importGD: 'Import from Google Drive',
      importOneDrive: 'Import from OneDrive',
      importBox: 'Import from Box',
      importSharePoint: 'Import from SharePoint',
      importExternalDAM: 'Import from a DAM platform',
    },

    ITEM: {
      removeAll: 'Remove all',
      selectFile: 'select file',
      /** @type {string[]} fields */
      validationFieldsError: (fields) => `Fill out these fields: ${fields.join(', ')}`,
      /**
       * Standalone one-line versions of the Google Drive quota errors. The server's own
       * message ends in "Here are possible solutions:" and its remedies only reach the
       * dialog, so reusing it on this single-line row reads as truncated.
       */
      gdStorageQuotaExceeded: 'Google Drive is out of space',
      gdDailyUploadLimit: 'Google Drive daily upload limit reached',
    },

    // textUploadFilesTo: 'Upload {countFiles} assets to',
    additionalFieldsHeader: (count) => `Add metadata for ${pluralize('asset', count, true)}`,
    textKeywords: 'Keywords',
    textUpload: 'Import',
    textNeedRequiredFields: 'Fill in the fields highlighted with red to upload',
    textBrowse: 'Browse files to add',
    textAdd: 'Add more',
    textClear: 'Clear all',
    textSelectAll: 'Select all',
    textDeselectAll: 'Deselect all',
    textCancel: 'Cancel',
    textSelectMedia: 'Add files from device or drag&drop here',
    textSelectFile: 'Upload file',
    textSelectFolder: 'Upload folder',
    textAddFile: 'Add file',
    textAddFolder: 'Add folder',
    textDragNDrop: 'or drag&drop it',
    textAddExternal: 'Add external links',
    textAddFromCloudStorages: 'Import from other platforms',
    textAddViaInbox: 'Upload via Inbox',
    flatFilesStructure: {
      title: 'Uploading files from folder',
      text: (uploadTo) => (
        <>
          <p>
            {pluralize(uploadTo[0].toUpperCase() + uploadTo.substring(1), 2)}{' '}
            don’t support nested folders. All files inside your chosen folder
            (including subfolders) will be merged into a single-level list, and
            the original folder structure won’t be retained here.
          </p>
          <p>Would you like to continue with the flattened upload?</p>
        </>
      ),
      dontShow: 'Don’t show it again',
    },

    textFilesUploaded: ({
      filesCount,
      foldersCount,
      totalSize,
      collections,
    }) => {
      if ((filesCount && foldersCount) || (foldersCount && !filesCount)) {
        return (
          <div>
            {pluralize('item', filesCount + foldersCount, true)}{' '}
            {filesCount + foldersCount > 1 ? 'were' : 'was'} added to{' '}
            <span className="highlight">{collections}</span>
          </div>
        );
      }
      return (
        <div>
          {pluralize('item', filesCount, true)}, {totalSize}{' '}
          {filesCount > 1 ? 'were' : 'was'} added to{' '}
          <span className="highlight">{collections}</span>
        </div>
      );
    },
    textCantUploadFiles: `Can't upload assets. Contact ${supportEmail}.`,
    textYouCannotUpload: (collectionName) => `You can't upload assets into ${collectionName}`,
    textFieldIsRequired:
      "This field was set as required by your team's admin, please fill it",
    textRequiredFieldError: 'required field error',
    textRequiredFieldWarning: 'required field warning',
    textImportingRequiredFieldFileWarning:
      'Team policy requires filling in metadata for this file after import',
    textImportingRequiredFieldFolderWarning:
      'Team policy requires filling in metadata for this folder’s contents after import',
    flagAndRating: 'Flag and rating',
    flagAndColor: 'Flag and color',
    colorAndRating: 'Color and rating',
    flagOnly: 'Flag',
    colorOnly: 'Color',
    ratingOnly: 'Rating',
    title: 'Title',
    description: 'Description',

    titleNotification: 'Notification',
    textPreviewMode: 'Preview mode works only for less than 50 assets.',

    titleTheUserExceededQuota:
      'The user has exceeded their Drive storage quota',
    textNoFreeSpaceGD:
      'It seems that you have no free space in your cloud storage. Consider freeing up some space or <a target = "_blank" href = "https://www.google.com/settings/storage">purchasing</a> additional storage from your Cloud Storage.',
    titleSelectCollection: 'Uploading to the root collection',
    textItBetterToUpload: (rootCollection) => `You’re uploading assets into ${rootCollection} where they may not be seen by your teammates. Upload to the root anyway?`,
    textContinue: 'Continue',
    btnConfirm: 'Confirm',

    textErrorRevisionUploadType: (extension) => `You've tried to upload the revision with a type different from original. The new revision should be a ${extension} type`,
    commentsTitle: (isAllowed) => (isAllowed ? 'Comment revision' : 'Comment (read only)'),
    placeholderInputComment: 'Add a comment',
    helpLink: 'Details on how to upload new files',
    uploadPanelOfferText: 'Click to request import from GDrive, Dropbox, FTP',
    titleSelectStorages:
      'Select the cloud storage you want to import files from',
    beta: 'beta',
    assisted: 'ASSISTED',
    labelImportFromDropbox: 'Import from Dropbox',
    labelImportFromGD: 'Import from Google drive',
    labelImportFromOneDrive: 'Import from OneDrive',
    labelImportFromBox: 'Import from Box',
    labelImportFromSharePoint: 'Import from Sharepoint',
  },
  DROPBOX_CHOOSER: {
    dialogTitle: 'Import from Dropbox',
    dialogDescription: `Select files or folders you want to copy from Dropbox to ${appName}`,
    dialogBtnCancel: 'Cancel',
    dialogBtnOk: 'Proceed',
    rootBreadcrumb: 'All files',
    toastFailedGetList:
      'Failed to get the list of files and folders from dropbox',
    toastFailedAuthentication:
      'Failed authentication to Dropbox. Please try again to connect your Dropbox account.',
    toastCalculatingDifferenceStorageFailed:
      'Error calculating the difference between available space on storage and downloaded files from dropbox',
    spinnerTextDisconnect: 'Dropbox disconnecting...',
    toastDisconnectSuccess: 'Dropbox account has disconnected',
    toastDisconnectFailed: "Dropbox account hasn't disconnected",
    tooltipDisconnect: 'Disconnect your account',
    tooltipForDisabledFolder:
      'Importing whole folders is available to subscribed users only.<br> Trial users can only import individual files.',
    labelName: 'Name',
    labelSize: 'Size',
    labelLastModified: 'Last Modified',
    textFolderEmptyState: 'Folder is empty',
    textWarningStorageLimit: (onClick, excessStorageSize, storageType) => (
      <span>
        The total size of imported files and folders exceeds the available space
        in your storage. Please, deselect some of them {excessStorageSize}{' '}
        excess to proceed{storageType !== 'picsio' ? ' ' : ''}
        <Choose>
          <When condition={storageType === 'picsio'}>
            or{' '}
            <span className="picsioLink" role="presentation" onClick={onClick}>
              purchase additional space
            </span>{' '}
            for your storage.
          </When>
          <Otherwise>.</Otherwise>
        </Choose>
      </span>
    ),
  },
  TOOLBARS: {
    titleClosePreview: 'Close preview [Esc]',
    titleClose: 'Close [Esc]',
    titleDetails: 'Details',
    titleActivity: 'Activity',
    titleLiveSupport: 'Live support',
    titleUpgradePlanForSupport: (planName) => (
      <p>
        Unfortunately, chat support is not included in the {planName} plan. To
        get access to chat support, please consider upgrading to one of our
        higher plans. Now, you can contact our support team at{' '}
        <a className="picsioLink" href={`mailto:${supportEmail}`}>
          {supportEmail}
        </a>
      </p>
    ),
    titleSettings: 'Settings',
    titleView: 'View mode',
    titleSorting: 'Sort mode',
    titleHelpCenter: 'Help center',
    titleAnalytics: 'Analytics',
    titleTranscriptions: 'Video & Audio Intelligence (Beta)',
    titleUpload: 'Import',
    titleAddAssets: 'Add assets',
    titleAddLightboard:
      "To add assets to a Lightboard, hover over it in the Lightboards tree and click the 'Add Assets' icon. To add assets to Collections, switch to the Collection tree and select a collection.",
    titleAddInbox:
      'Uploading to inboxes is only possible via inbox links. To add assets to Collections, switch to the Collection tree and select a collection.',
    titleCollections: 'Collections',
    titleMedia: 'Media library',
    titleKeywords: 'Keywords',
    titleSearches: 'Searches',
    titleLightboards: 'Lightboards',
    titleInbox: 'Inboxes',
    titleDownloadAssets: 'Download assets',
    titleDownloadSelectedAssets: (count) => `Download selected ${pluralize('asset', count)}`,
    titleDownloadAssetsAsArchive: 'Download all assets as an archive',
    titleRemoveAssets: 'Move to trash',
    titleCompareAssets: 'Compare assets',
    titleDownloadDialog: 'Download list',
    titleArchive: 'Archive',
    titlePersons: 'Persons',
    titleShare: 'Share asset',
    titleFindImages: 'Find similar images',
    titleAddRevision: 'Add revision',
    titleDownload: 'Download',
    titleRemove: 'Move to trash',
    titleRemoveFromCollections: 'Remove from collection',
    titleRetryImporting: 'Retry Import',
    titleRemoveForever: 'Delete forever',
    titleRotateCW: 'Rotate CW',
    titleRotateCCW: 'Rotate CCW',
    titleHorizontalFlip: 'Horizontal flip',
    titleVerticalFlip: 'Vertical flip',
    titleEdit: 'Edit',
    titleZoom: 'Zoom to 100%',
    titleFit: 'Fit to screen',
    titleHideMultipagePanel: 'Hide multipage panel',
    titleShowMultipagePanel: 'Show multipage panel',

    textMyAccount: 'My account',
    textSync: 'Sync',
    textBilling: 'Billing',
    textGoogleDrive: 'Google Drive',
    textStorage: 'Storage',
    textCustomFields: picsioConfig.isPim ? 'Custom Attributes' : 'Custom Fields',
    textMyTeam: 'My team',
    textAuditTrail: 'Audit trail',
    textReferralProgram: 'Referral program',
    textPicsioAcademy: 'Pics.io Academy',
    textNew: 'New',
    academyNotificationLevel: (level) => `Level ${level}`,
    academyNotificationExam: 'Certification exam',
    academyNotificationCta: 'Continue',
    textTutorials: 'Help center',
    textWhatsNew: "What's new",
    shortcuts: 'Shortcuts',
    textSwitchAccount: 'Switch account',
    textLogOut: 'Log out',
    textDetails: 'Details',
    textNewFirst: 'New first',
    textOldFirst: 'Old first',
    textAtoZ: 'A to Z',
    textZtoA: 'Z to A',
    textCustom: 'Custom',
    textGrid: 'Grid',
    textList: 'List',
    textListSize: {
      textListx1: 'x1',
      textListx1_5: 'x1.5',
      textListx2: 'x2',
    },
    textMap: 'Map',
    tooltipMapNotAllowed:
      'Clipboard does not support map view. Use grid or list view instead.',
    textDownloadAll: 'Download all',
    textIntegrations: `Check all products that integrate with ${appName}`,
    revisionsDropdown: {
      textAddNewRevision: 'Add new revision',
    },
    textLiveSupportSpeech:
      'Click here to connect with our live support, when you have questions or issues to report.',
    TRIAL_DEMO_CONTROL: {
      endsInDays: (n) => `Trial ends in ${n} days`,
      endsTomorrow: 'Trial ends tomorrow',
      endsToday: 'Trial ends today',
      bookDemo: 'Book a Demo',
      defaultOffer: 'Get 20% off',
    },
  },

  WEBSITES: {
    textYouCanUseImage300x300:
      'You can use the image 300x300px, best to use a monochrome PNG with a transparent background',
    textUploadLogo: 'Upload logo',
    textBestUseImage500x1000: 'It is best to use 500-1000px image',
    titleUploadThumbnail: 'Thumbnail',
    textBestUseImage500x500: 'It is best to use 500x500px image',
    textUploadYourPhoto: 'Upload your photo',
    textImageWillBeUsed: 'The image will be used for login page',
    textUploadBackground: 'Upload background',
    textUploadThumbnail: 'Upload thumbnail',
    textUploadFavicon: 'Upload favicon',
    titleContacts: 'Contacts',
    labelShowFacebook: 'Facebook',
    labelShowTwitter: 'Twitter',
    labelShowInstagram: 'Instagram',
    labelShowPhone: 'Phone',
    labelShowEmail: 'Email',
    labelShowBlog: 'Blog',
    titleFileSettings: 'File settings',
    labelShowFlaggedImages: 'Only flagged assets on home page',
    labelShowFilename: 'Filename',
    labelShowDescription: 'Title & Description',
    titleWebsitePages: 'Website pages',
    labelEnableAboutPage: 'About page',
    labelEnableContactsPage: 'Contacts page',
    titleSearch: 'Search',
    labelAllowSearchAssets: 'Search bar',
    labelAllowSearchTags: 'Collections tree',
    labelUnfoldAllCollections: 'Unfold all collections',
    unfoldAllCollectionsTooltipText:
      'Enabling the ‘Unfold all collections’ setting may slow down performance due to the number of requests needed to load and display all content. Consider enabling this option for websites with no more than 20 collection levels to maintain optimal speed.',
    titleDownloads: 'Downloads',
    labelAllowDownloadArchive: 'Download archive with all assets',
    labelAllowDownloadFile: 'Download one asset',
    labelAllowDownloadFiles: 'Download assets',
    labelDownloadAsOriginalOnly: 'Download as original format only',
    titleHistory: 'Collaboration & History',
    labelRevisions: 'Revisions',
    labelRevisionsDisabled: 'Revisions are disabled',
    labelComments: 'Comments',
    tooltipComments: (
      <>
        Check to allow external users to add comments.
        <br />
        Use the eye icon to control comment visibility.
      </>
    ),
    labelCommentsDisabled: 'Comments are disabled',
    labelCommentsHideInternal: 'Restrict access to internal comments',
    tooltipCommentsHideInternal: (
      <>
        When enabled, internal comments added by your {appName} teammates
        <br />
        will be hidden from external viewers
      </>
    ),
    titleInfopanel: 'Infopanel options',
    labelTitle: 'Title',
    labelDescription: 'Description',
    labelKeywords: 'Keywords',
    labelCustomFields: 'Custom fields',
    labelCustomFieldsDisabled: 'Custom fields are disabled',
    titleThumbnail: 'Thumbnail options',
    labelFilename: 'Filename',
    labelFlag: 'Flag',
    labelRating: 'Rating',
    labelColor: 'Color',
    titleCollections: 'Collections',
    titleCustomization: 'Customization',
    titleHomeScreen: 'Home screen layout',
    titleExpires: 'Expires at',
    titleUiScheme: 'UI color scheme',
    titleSort: 'Assets sort order',
    titleCollectionSort: 'Collections sort',
    homeScreenCollection: 'Select collection for the home screen layout',
    titleRestrictedSettings: 'Restricted assets',
    labelRestrictedWarning: 'Additional restricted warning on assets preview',

    titleSocialButtons: 'Social buttons',
    textDontShow: "Don't show",
    textLeft: 'Left',
    textRight: 'Right',

    textChange: 'Change',
    textAllow: 'Allow',
    textAdd: 'Add',
    textShow: 'Show',

    textHttpsNotValid: 'https is not valid, please use http',
    textUrlNotValid: 'URL is not valid',
    textWordsCantBeUsed: (words) => `Words "${words}" can\'t be used at the url begging`,
    textTopLevelFolders: 'URL should contain only top-level folders',
    textUrlInUse: 'URL is already in use',
    textGoogleAnalIsntValid: 'This Google analytics identifier is not valid',
    textMain: 'Main',
    textSecurity: 'Security',
    textPassword: 'Password',
    textNotifications: 'Notifications',
    textCustomization: 'Customization',
    textSEO: 'SEO',
    textAnalytics: 'Analytics',

    textCreateWebsite: 'Website settings',
    textUpdateWebsite: 'Website settings',
    textCreate: 'Publish',
    textDelete: 'Unpublish',
    textLoading: 'Loading',

    titleError: 'Error',
    textWebsiteWasntFound: "Website wasn't found",

    titleErrors: 'Errors',

    titleAttention: 'Attention!',

    textNorecord:
      "The domain name you specified couldn't be resolved. That might be because of a typo. Please, check the domain name carefully. If you just bought the domain, probably, DNS changes still haven't been propagated, it takes up to 48 hours. Press OK to proceed anyway.",
    textAnotherip:
      "Domain name you specified points to the different ip address. Should be: 54.243.40.217. That might be because of a typo. Please, check the domain name carefully. If the name is correct and you just changed DNS records, probably, DNS changes still haven't been propagated, it takes up to 48 hours. Press OK to proceed anyway.",

    textDomainCantVerified: 'Failed to verify this domain',

    titleWarning: 'Warning',
    textSavingAsseets: 'Saving assets...',
    textSavingWebsite: 'Preparing website...',
    textCreatingWebsite: 'Creating website...',

    alertWebsiteCreated:
      'Website <span class="highlight">published</span>. We\'re preparing thumbnails now. You will receive an email when the website is ready',
    applyTemplateChanges: 'Applying template changes and preparing to publish…',
    textVisitWebsite: 'Visit website',
    textWebsiteCreationUnsuccessful:
      'Website publishing was unsuccessful. Please, try again.',
    textWebsiteUpdatingUnsuccessful:
      'Website updating was unsuccessful. Please, try again.',
    textWebsiteSomeImagesUnsuccessful:
      'Some images for website settings not uploaded. Please, try again.',
    textWebsiteImageFieldsUnsuccessful: (fields) => (
      `Some images for website settings not uploaded (${fields}). Please, try again.`
    ),
    websiteImageFieldLabels: {
      avatarUrl: 'favicon',
      backgroundLoginPageUrl: 'login background',
      thumbnailUrl: 'thumbnail',
      logoUrl: 'logo',
    },
    textWebsiteDeleteImagesUnsuccessful:
      'Some images for website settings not deleted. Please, try again.',
    alertErrorHappened:
      'Unpublishing/deleting website failed. Refresh and try again ',

    titleWarningChangePlan: 'Websites functionality is restricted',
    descriptionWarningChangePlan: (onClickHandler) => (
      <div>
        Websites functionality is not available for your current plan. Please
        upgrade your{' '}
        <span
          className="picsioLink"
          role="presentation"
          onClick={onClickHandler}
        >
          subscription
        </span>{' '}
        to use this feature.
      </div>
    ),

    textContact: 'Contact',
    textSiteWillBeDeleted:
      'Website will be unpublished and ALL analytics data will be lost! Are you sure?',
    textPasswordConfirm: 'Password and confirm password are not equal',
    titleMainOptions: 'Main options',
    labelYourSiteLink: 'Your new website link',
    labelSelectTemplate: 'Select your template',
    labelTypePassword: 'Type password',
    labelConfirmPassword: 'Confirm password',
    titleSeo: 'SEO',
    labelGoogleAnalIdentifier: 'Google Analytics identifier',
    labelCustomGalleryTitle: 'Custom gallery title',
    placeholderTitle: 'Title',
    titleRobots: 'Search robots indexing',
    labelNoIndex: 'No index',
    labelNoFollow: 'No follow',

    titleNotificationsEmail: 'Email for notifications',
    placeholderEnterEmail: 'Enter email',
    labelSelectEmail: 'Email',
    shareAssetsDialog: {
      title: 'Name shared collection (website)',
      text:
        'You are about to create a new website with selected files. These files will stay in their original collections and will also be attached to the new one.',
      textBtnOk: 'Continue',
      label: 'Collection name',
      placeholder: 'Type a name of a shared collection',
    },
    requestFullAccessDialog: {
      title: picsioConfig.isPim ? 'Websites limit' : 'Request full access',
      text: (limit) => (
        picsioConfig.isPim ? (
          <>
            <span>
              Your trial includes up to {limit} websites. Request full access to
              increase your website limit and keep scaling external sharing:
            </span>
            <br />
            <ul>
              <li>
                Create dedicated websites for more clients, campaigns, product
                lines, or audiences.
              </li>
              <li>
                Keep different sharing workflows organized in separate websites.
              </li>
              <li>
                Expand external sharing without replacing or consolidating your
                existing websites.
              </li>
            </ul>
            <br />
            <span>
              Our support team will help you enable these options. Would you like
              to start a chat?
            </span>
          </>
        ) : (
          <>
            <span>
              With free beta access, you’re limited to{' '}
              {pluralize('website', limit, true)} and basic features.
              Request full access to:
            </span>
            <br />
            <ul>
              <li>Create and manage multiple websites</li>
              <li>Protect sites with passwords and consent forms</li>
              <li>
                Enable collaboration tools (comments, revisions, internal notes)
              </li>
              <li>
                Customize how assets are displayed (info panels, thumbnails,
                custom fields)
              </li>
              <li>Download complete archives of shared assets</li>
            </ul>
            <br />
            <span>
              Our support team will help you enable these options. Would you like
              to start a chat?
            </span>
          </>
        )
      ),
      cancel: 'Cancel',
      ok: 'Proceed to chat',
    },
    limitError: {
      title: <span className="f-w-4">Website limit reached</span>,
      text: (limit, onClick) => (
        <div>
          Your current discontinued plan allows up to {limit} shared collections
          (websites), and you’ve reached this limit. To continue sharing
          collections, you can:
          <ul>
            <li>
              <span className="f-w-5">Unpublish</span> unused websites to free
              up space.
            </li>
            <li>
              <span className="f-w-5">Update</span> to the latest plan for
              unlimited websites.
            </li>
          </ul>
          <Button variant="text" color="primary" onClick={onClick}>
            <Icon color="primary" size="lg">
              <Question />
            </Icon>
            <span className="m-l-7">
              Learn more about your plan limits here
            </span>
          </Button>
        </div>
      ),
      okText: 'Ok',
    },
    errorHaveReachedLimit: 'You have reached a limit of websites on this plan',
    titlePresetsPanel: 'Presets',
    textPresetsDefault: 'Сurrent website settings',
    textPresetsSave: 'Save as a new preset',
    textPresetsDelete: 'Delete',
    textPresetsRename: 'Rename',
    textPresetRollbackFailed: 'Saving the preset failed and the incomplete preset could not be removed automatically. Please refresh the presets list and delete it manually if it appears.',
    helpText: 'How to share collections (websites)',
    embeddedHelpText: `How to embed ${appName} content into third-party pages?`,
    disabledStateText:
      'Editing search indexing settings is unavailable for Pics.io websites using the default show.pics.io domain. Set a custom domain to configure SEO settings.',
    unableApplyTemplateSettings: {
      title: 'Update template settings',
      text: () => (
        <div className="p-b-20">
          <p>
            This website template includes SEO settings that allow search engine
            indexing and following.
          </p>
          <p>
            Since Pics.io no longer supports these settings for portals
            published under default URLs (like show.pics.io), we won’t be able
            to apply them.
          </p>
          <p>
            To use the current template, you need to update the SEO settings to
            disable indexing and following.
          </p>
        </div>
      ),
      btnUpdate: 'Update template & Publish',
    },
  },

  COLLECTIONS: {
    titleAddKeyword: 'Add keyword',
    textApply: 'Apply',
    textPlaceholderName: 'Name',
    textCantRemoveKeyword: `Can't remove keyword. Please try again. Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
    textCantUpdateKeyword: () => (
      <>
        Cannot update keywords. Refresh the browser tab and try again. If the
        error persists, contact us at{' '}
        <a className="picsioLink" href={`mailto:${supportEmail}`}>
          {supportEmail}
        </a>
      </>
    ),
    titleRenameKeyword: 'Rename keyword',
    textYouAreGoingToRenameKeyword:
      'You are going to rename keyword. Continue?',
    textPlaceholderNewName: 'New name',
    textAddedTo: 'added to',
    textRemovedFrom: 'removed from',
    // textHasBeenFavorites: 'has been {actionValue} Favorites',
    titleFavorites: 'Favorites',
    titleKeywords: 'Keywords',
    textCantGetKeywords: `Can't get keywords. Please try again. Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,

    errorTeammatesWasntAdded:
      'Teammates were not added. Looks like they are already on your team.',
    errorTeammateWasntAdded: `Teammate wasn't added because he is already on other team account in ${appName} Using the same email for being on more than one team in ${appName} is not technically possible.`,
    errorUnableToAddTeammates: 'Unable to add teammates. Please try again.',
    textSearching: 'Searching...',
    textProcessingFiles: 'Processing assets...',
    titleAssetInCollectionAllreadyExists: 'File already exists',
    textAssetInCollectionAllreadyExists:
      'This file already exists in this collection, it is not possible to add an identical duplicate to the same collection. Change a name of a new file and try again.',

    textFilesAddedToCollection: (count, collectionName) => `${pluralize('asset', count, true)} ${
      count > 1 ? 'were' : 'was'
    } added to collection "${collectionName}"`,
    textFilesNotAddedToCollection: (count, collectionName) => `${count} ${pluralize(
      'asset',
      count,
    )} haven't been added to collection "${collectionName}". Please contact ${supportEmail}`,
    textFilesAddedToLightboard: (lightboardName) => `Assets added to lightboard "${lightboardName}"`,
    textFilesNotAddedToLightboard: (lightboardName) => `Assets haven't been added to lightboard "${lightboardName}". Please contact ${supportEmail}`,
    textLightboardFolderNotFound: `Your lightboards folder is not found in your cloud storage. Please contact <a href="mailto:${supportEmail}?subject=Lightboards folder is not found in Google Drive">${supportEmail}</a>`,
  },

  LIGHTBOARDS: {
    title: 'Lightboards',
    buttonAddLightboard: 'Create lightboard',
    titleAddLightboard: 'Add new lightboard',
    textDeleteLightboard: 'Delete lightboard',
    textDeleteName: (name) => `You are about to delete a lightboard <span class="highlight">${name}</span>. Continue?`,
    // textRenameName: name => `Rename "${name}"?`,
    textEnterNewName: 'Enter new name',
  },

  CATALOG_VIEW: {
    textError: 'Error',
    cantLoadData: `Can't load data. Please try again. Contact <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support if the error repeats`,
    collectionNotFound: 'Collection not found',
    errorCheckSearchQueryTitle: 'Incorrect search query',
    errorCheckSearchQuery:
      "It seems there’s an error in your search query.<br>Please review your syntax for mistakes or typos.<br>If the issue persists, visit our <a href='https://help.pics.io/search-engine' target='_blank'>Help Center</a> or contact support for assistance.",
    notifications: {
      collectionUpdated:
        'This collection has been updated. Refresh to see changes.',
      inboxUpdated: 'This inbox has been updated. Refresh to see changes.',
      searchByLocationEnabled:
        'Only assets with geolocation are displayed. To see all assets please press the refresh button.',
    },
  },

  PREVIEW_VIEW: {
    generateSubtitles: 'Generate subtitles',
    errorLoadFile: "Can't load asset",
    noPreview: 'no preview available',
    textDropFile: 'Drop file to add a new revision',
    movedToTrash: 'moved to trash',
    restore: 'restore',
    errorFilesCount: 'To add a new revision drop one file',
    editingNotSupportedInSafariTitle: 'Editor not working in Safari',
    editingNotSupportedInSafari: `${appName} editor is temporarily unavailable in Safari. Please use another browser (e.g. Google Chrome or Firefox) to edit assets.`,
    titleEditingNotSupported: 'Unsupported file format',
    editingNotSupported: `This file format is not supported in ${appName} editor yet`,
    fileNotFound: 'File not found',
    externalNoPreviewText: () => (
      <>
        <p>This URL does not allow to be viewed within other web-resources.</p>
        <p>You can view it by opening in a new browser tab.</p>
      </>
    ),
    externalCrawlingDataText: () => (
      <>
        <p>Reading content from the external link</p>
        <p>You can view it by opening in a new browser tab.</p>
      </>
    ),
    externalNoPreviewBtnText: 'Open in new tab',
  },

  INPUT_DATE_RANGE: {
    any: 'Any time',
    today: 'Today',
    yesterday: 'Yesterday',
    lastweek: 'Last 7 days',
    lastmonth: 'Last 30 days',
    last90days: 'Last 90 days',
    custom: 'Customized...',
  },

  ASSING_USER: {
    title: 'Assign users',
    placeholder: 'You have not invited',
    filterText: 'Assign users',
  },

  DROPDOWN: {
    create: 'Create',
    createKeyword: 'Create keyword',
    createFace: 'Create person',
    chooseKeywords: 'Add or paste keywords',
    chooseKeywordsCV: 'Add keywords from CV',
    chooseFaces: 'Select person',
    chooseCustomFields: 'Choose custom fields',
    placeholderKeywords: 'You have no keywords yet',
    placeholderFaces: 'You have no persons yet',
    placeholderKeywordsCreate: 'Start typing to create a keyword',
    noResults: 'No results found for',
    tooltipItemsCopied: 'Items copied to clipboard',
  },

  AUTH_ERROR: {
    title: 'Error',
    text: `Email address or password is incorrect. Please, double-check your details and try again. <br><br> If this issue persists, contact us at <a href="mailto:${supportEmail}" target="_blank">${supportEmail}</a>.`,
  },

  SERVER_ERROR: {
    title: 'Something went wrong.',
    text: `Refresh the browser tab. If the error persists, contact us at <a href="mailto:${supportEmail}" target="_blank">${supportEmail}</a>.`,
  },

  INPUT_FILE: {
    placeholder: 'No file is chosen',
    btnText: 'Choose',
  },

  SORT: {
    alphabetical: 'File name',
    uploadTime: 'Upload time',
    updateTime: 'Update time',
    createTime: 'Create time',
    rating: 'Rating',
    color: 'Color',
    fileSize: 'File size',
    duration: 'Duration',
    pageNumber: 'Page number',
    fileType: 'File type',
    creator: 'Creator',
    copyright: 'Copyright',
    custom: 'Custom',
    imageResolution: 'Image resolution',
    assetNumber: 'Assets number',
    score: 'Best match',
    maxCustomFieldsCountReached: 'You can add only three custom fields here',
  },

  SCREEN_ASSET_SHARING: {
    title: 'Asset sharing settings',
    titleBulk: 'Bulk sharing settings',
    textBulkSubheader: (shared, total) => (
      <>
        <Choose>
          <When condition={!shared}>
            <p>
              You're about to share {total} assets from the current selection.
              <br />
              Configure the required sharing settings and publish.
            </p>
          </When>
          <Otherwise>
            <p>
              {shared} of {total} selected assets already shared may have
              different sharing settings.
            </p>
            <p>
              You can export links without overriding their share settings. If
              you need to change some share parameters it will be override to
              whole selection.
            </p>
          </Otherwise>
        </Choose>
      </>
    ),
    textMain: 'Main',
    textSecurity: 'Security',

    textChange: 'Change',
    textShow: 'Show',
    textAllow: 'Allow',
    textAdd: 'Add',
    share: 'share',
    unshare: 'stop sharing',

    titleLink: 'Link',
    titlePassword: 'Password',
    placeholderEnterPassword: 'Enter Password',
    placeholderEnterPasswordRetype: 'Retype Password',

    titleDownloads: 'Downloads',
    labelAllowDownloadFile: 'Download asset',
    titleHistory: 'Collaboration & History',
    labelRevisions: 'Revisions',
    labelRevisionsDisabled: 'Revisions are disabled',
    labelComments: 'Comments',
    tooltipComments: (
      <>
        Check to allow external users to add comments.
        <br />
        Use the eye icon to control comment visibility.
      </>
    ),
    labelCommentsDisabled: 'Comments are disabled',
    labelCommentsHideInternal: 'Restrict access to internal comments',
    tooltipCommentsHideInternal: (
      <>
        When enabled, internal comments added by your {appName} teammates
        <br />
        will be hidden from external viewers
      </>
    ),
    titleInfopanel: 'Infopanel options',
    labelTitle: 'Title',
    labelDescription: 'Description',
    labelKeywords: 'Keywords',
    labelCustomFields: 'Custom fields',
    titleMarks: 'Asset marks',
    labelFlag: 'Flag',
    labelRating: 'Rating',
    labelColor: 'Color',
    helpText: 'How to share a single asset',
    titleRestrictedSettings: 'Restricted assets',
    labelRestrictedWarning: 'Additional restricted warning on assets preview',
  },

  RECURSIVE_SEARCH: {
    labelOnTreeDontShow: "Don't show assets in nested collections",
    labelOnCatalogPanelDontShow:
      'Assets from nested collections are NOT included in the search results. Switch the toggle to include them into the search.',
    labelOnCatalogPanelShow:
      'Assets from nested collections are included in the the search results. Switch the toggle to exclude them from the search.',
  },

  BEST_MATCH_SEARCH: {
    infoText: 'Use Best Match sorting for more relevant search results',
    buttonText: 'Apply Best match sorting',
  },

  VISUAL_SEARCH_LIMIT: {
    warningText:
      'Indexing limit for Visual & Similar Images Search reached, some assets aren’t included in search results. Upgrade AI Kit tier to expand coverage.',
    textPro:
      'Fine-tune Visual Search: configure a custom prompt for more accurate matches with Pro version of AI Search',
    buttonText: 'Upgrade AI KIt',
  },

  SHORTCUTS: {
    title: 'Shortcuts',
  },

  SETTINGS: {
    errorTitle: 'Error save settings',
    errorText: `Can't update settings. Please try again. Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
  },

  CATALOG_ITEM: {
    tooltipCopyAsset: 'Copy asset link',
    // tooltipFoundWithVisualSearch: () => 'Found with Visual Search', //@TODO  The lower text is only for testing on staging. This text should be uncommented before release to production
    tooltipFoundWithVisualSearch: (
      foundWithVisualSearchText,
      foundWithVisualSearchCLIP,
    ) => {
      const hasPro = Boolean(foundWithVisualSearchText);
      const hasBasic = !hasPro && Boolean(foundWithVisualSearchCLIP); // only if Pro is absent

      // eslint-disable-next-line no-nested-ternary
      const label = hasPro ? 'Pro' : hasBasic ? 'Basic' : '';

      return `Found with Visual Search${label ? ` (${label})` : ''}`;
    },
    tooltipFindSimilarImage: 'Find similar images',
    tooltipDelete: 'Move to trash',
    tooltipEdit: 'Edit',
    tooltipDownload: 'Download',
    tooltipAddRevision: 'Add revision',
    tooltipAddComment: 'Add comment',
    tooltipEditCollections: 'Edit collections',
    tooltipShareAsset: 'Share asset',
    tooltipShareAssetSettings: 'Sharing settings',
    tooltipRestore: 'Restore',
    tooltipDeleteForever: 'Delete forever',
    tooltipRemoveFromCollections: 'Remove from collection',
    tooltipRemoveFromLightboard: 'Remove from lightboard',
    tooltipGoToComments: 'Go to comments',
    tooltipGoToTranscription: 'Go to transcription',
    tooltipGoToRevisions: 'Go to revisions',
    busyStatus: {
      isGoingToTrash: 'Deleting an asset',
      isGoingToDelete: 'Permanently deleting an asset',
      isGoingToRestore: 'Restoring an asset',
      isGoingToMove: 'Moving an asset',
      isGoingToCopy: 'Copying an asset',
      isGoingToCopyConvert: 'Copy-converting an asset',
    },
    tooltipDuplicate: 'Create asset copy',
    tooltipDuplicateDisabled:
      'You can duplicate up to 500 assets at once. Select fewer to use this feature',
    colorLabels: {
      manageTooltip: 'Manage color labels',
    },
  },

  ACTIONS_TOOLBAR: {
    PRODUCTS: {
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      exportCsv: 'Export CSV',
      noPermission: 'Team administrator disabled access to this feature for your user account. Contact them to get this permission',
      selectedCounter: (products, variants) => {
        const parts = [`${products} ${pluralize('product', products)}`];
        if (variants > 0) parts.push(`${variants} ${pluralize('variant', variants)}`);
        return parts.join(' · ');
      },
    },
    ASSETS: {
      share: 'Share',
      download: 'Download',
      copyAssetLinks: 'Copy asset links',
      assetLinksCopied: 'Copied!',
      addRevision: 'Add revision',
      addRevisionDisabled:
        'Revisions can only be added to single selected assets, excluding external links',
      attachCollection: 'Add to collection',
      attachToCollection: 'Add to collection',
      removeFromCollections: 'Remove from collection',
      delete: 'Move to trash',
      restore: 'Restore',
      deleteForever: 'Delete forever',
      archive: 'Archive',
      unarchive: 'Unarchive',
      compare: 'Compare',
      compare1asset: 'Select a second asset to enable comparison tool',
      compare3asset: 'Select only two assets to enable comparison tool',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      selectedAssetsDisabled:
        'List of selected assets are not available in the map view. Please change the view to the list or grid views',
    },
    COLLECTIONS: {
      upload: 'Add assets',
      createWebsite: 'Publish to web',
      websiteSettings: 'Website settings',
      move: 'Move collection',
      download: 'Download collection',
      archive: 'Archive collection',
      unarchive: 'Unarchive collection',
      delete: 'Delete collection',
    },
    INBOXES: {
      settings: 'Inbox settings',
      delete: 'Delete inbox',
    },
    LIGHTBOARDS: {
      upload: 'Add assets',
      delete: 'Delete lightboard',
    },
    KEYWORDS: {
      delete: (count) => `Delete selected ${pluralize('keyword', count)}`,
      merge: (count) => `Merge selected ${pluralize('keyword', count)}`,
    },
  },

  HELP_CENTER: {
    previewView: {
      url: 'general-info/help-center-index',
      tooltip: 'Suggest improvement',
    },
    catalogView: {
      url: 'general-info/help-center-index',
      tooltip: 'Suggest improvement',
    },
    auditTrail_audit: {
      url: 'teamwork-in-pics-io/settings-audit-trail',
      tooltip: 'Learn more about Audit Trail log',
    },
    auditTrail_analytics: {
      url: 'en/articles/4097770-analytics',
      tooltip: 'Explore how to work with Pics.io analytics&reporting',
    },
    customFieldsSchema: {
      url: 'working-with-metadata/settings-custom-fields',
      tooltip: 'Learn how to configure custom fields',
    },
    myAccount_account: {
      url: 'pics-io-settings/edit-user-account-information',
      tooltip: 'Learn how to edit your account info',
    },
    myAccount_settings: {
      url: 'pics-io-settings/edit-user-account-information',
      tooltip: 'Learn how to edit your account info',
    },
    myAccount_notifications: {
      url: 'pics-io-settings/edit-user-account-information',
      tooltip: 'Learn how to edit your account info',
    },
    myAccount_security: {
      url: 'en/articles/5406508-two-factor-authentication-2fa',
      tooltip: 'Learn how to edit your account info',
    },
    myAccount_legal: {
      url: 'en/articles/4514944-login-consent-for-support-team',
      tooltip: 'Learn more about Personal Data Protection in Pics.io',
    },
    myBilling_overview: {
      url: 'pics-io-settings/billing',
      tooltip: 'Learn how to set up billing in Pics.io',
    },
    myBilling_info: {
      url: 'pics-io-settings/billing',
      tooltip: 'Learn how to set up billing in Pics.io',
    },
    myBilling_invoices: {
      url: 'pics-io-settings/billing',
      tooltip: 'Learn how to set up billing in Pics.io',
    },
    myBilling_card: {
      url: 'pics-io-settings/billing',
      tooltip: 'Learn how to set up billing in Pics.io',
    },
    myTeam_teammates: {
      url: 'teamwork-in-pics-io/inviting-new-teammates',
      tooltip: 'Learn how to invite new teammates',
    },
    myTeam_roles: {
      url: 'teamwork-in-pics-io/assigning-roles-to-teammates',
      tooltip: 'Learn how to assign roles to teammates',
    },
    myTeam_integrations: {
      url: 'integrations',
      tooltip: 'Learn more about Pics.io integrations',
    },
    myTeam_settings: {
      url: 'teamwork-in-pics-io/team-policies',
      tooltip: 'Learn how to set up team policies',
    },
    myTeam_analytics: {
      url: 'en/articles/4097770-analytics',
      tooltip: 'Explore how to work with Pics.io analytics&reporting',
    },
    myTeam_branding: {
      url: 'en/articles/3738906-branding-for-teams',
      tooltip: 'Learn how to set up team branding',
    },
    myTeam_profile: {
      url: 'teamwork-in-pics-io/team-policies',
      tooltip: 'Learn how to set up team profile',
    },
    myTeam_security: {
      url: 'en/articles/5406508-two-factor-authentication-2fa',
      tooltip: 'Learn how to set up Two-factor authentication (2FA)',
    },
    myTeam_watermarking: {
      url: 'en/articles/5695407-watermarking',
      tooltip: 'Learn more about watermarks',
    },
    myTeam_ai: {
      url: 'en/?q=artificial+intelligence',
      tooltip: 'Learn more about AI capabilities in Pics.io',
    },
    storage: {
      url: 'integration-with-google-drive/integration-with-team-drive',
      tooltip: 'Learn more about Pics.io integration with Team Drive',
    },
    syncDialog: {
      url:
        'integration-with-google-drive/synchronizing-google-drive-with-picsio',
      tooltip: 'Learn more about how cloud storage syncs with Pics.io',
    },
    sync: {
      url:
        'integration-with-google-drive/synchronizing-google-drive-with-picsio',
      tooltip: 'Learn more about how cloud storage syncs with Pics.io',
    },
    uploadPanel: {
      url: 'en/articles/1269153-uploading-new-files',
      tooltip: 'Details on how to upload new files',
    },
    websites: {
      url:
        'en/articles/6422126-sharing-assets-via-shared-collections-websites-in-pics-io',
      tooltip: 'Learn how to share assets outside Pics.io',
    },
    websitesPIM: {
      url:
        'en/articles/12086597-sharing-assets-via-shared-collections-websites-in-toriut',
      tooltip: 'Learn how to share assets outside Toriut.com',
    },
    singleAssetSharing: {
      url:
        'sharing-assets-to-non-pics-io-members-websites/single-asset-sharing',
      tooltip: 'Learn how to share individual assets outside Pics.io',
    },
    webhooks: {
      url: 'integrations/webhooks',
    },
    slack: {
      url: 'en/articles/1278682-integration-with-slack',
    },
    api: {
      url: 'en/articles/5246748-pics-io-api',
      tooltip: 'Learn how to use Pics.io API',
    },
    zapier: {
      url: 'integrations/zapier',
      openUrl: 'https://zapier.com/apps/pics-io/integrations',
    },
    mcp: {
      url: 'en/articles/15868514-pics-io-mcp-connect-your-ai-assistant-to-your-pics-io-library',
      openUrl: 'https://claude.ai/settings/connectors',
    },
    adobe: {
      url: 'en/articles/2902055-pics-io-integration-with-adobe-creative-cloud',
      photoshop: {
        url:
          'en/articles/2902055-pics-io-integration-with-adobe-creative-cloud',
        openUrl:
          'https://exchange.adobe.com/apps/cc/bcd6e7f2/picsio-digital-asset-management-uxp',
      },
      illustrator: {
        url:
          'en/articles/2902055-pics-io-integration-with-adobe-creative-cloud',
        openUrl:
          'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
      },
      afterEffects: {
        url:
          'en/articles/2902055-pics-io-integration-with-adobe-creative-cloud',
        openUrl:
          'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
      },
      premierePro: {
        url:
          'en/articles/2902055-pics-io-integration-with-adobe-creative-cloud',
        openUrl:
          'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
      },
      indesign: {
        url:
          'en/articles/2902055-pics-io-integration-with-adobe-creative-cloud',
        openUrl:
          'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
      },
    },
    google: {
      url: 'en/articles/2732164-pics-io-add-ons-for-google-workspace-tools',
      docs: {
        url: 'en/articles/2732164-pics-io-add-ons-for-google-workspace-tools',
        openUrl:
          'https://workspace.google.com/marketplace/app/picsio_for_google_docs/269666192732',
      },
      sheets: {
        url: 'en/articles/2732164-pics-io-add-ons-for-google-workspace-tools',
        openUrl:
          'https://workspace.google.com/marketplace/app/picsio_for_google_spreadsheets/146804572324?flow_type=2',
      },
      forms: {
        url: 'en/articles/2732164-pics-io-add-ons-for-google-workspace-tools',
        openUrl:
          'https://workspace.google.com/marketplace/app/picsio_for_google_forms/625235058864?flow_type=2',
      },
      slides: {
        url: 'en/articles/2732164-pics-io-add-ons-for-google-workspace-tools',
        openUrl:
          'https://workspace.google.com/marketplace/app/picsio_for_google_slides/76113023368?flow_type=2',
      },
    },
    shopify: {
      url:
        'en/articles/5682129-how-to-upload-images-for-shopify-products-from-pics-io-in-bu',
      openUrl: 'https://apps.shopify.com/pics-io-import-plugin ',
    },
    wordpress: {
      url: 'en/articles/6443987-pics-io-integration-with-wordpress-cms',
      openUrl: 'https://wordpress.org/plugins/pics-io/',
    },
    referralProgram: {
      url: 'en/articles/4097656-pics-io-referral-program',
      tooltip: 'Learn how to use a referral program',
    },
    inboxes: {
      url: 'en/articles/4066282-inbox',
      tooltip: 'Learn how non-Pics.io users can upload files to your library',
    },
    importCsv: {
      url: 'en/articles/6151893-export-and-import-metadata-in-pics-io',
      tooltip: 'Details on how to import metadata',
    },
    embeddedGallery: {
      url:
        'en/articles/6482857-how-can-i-embed-content-from-pics-io-into-another-online-page-via-iframe',
      tooltip: 'How to embed Pics.io content into third-party pages?',
    },
  },

  HELP_CENTER_TORIUT: {
    previewView: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn more about Toriut.com features',
    },
    catalogView: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Suggest improvement',
    },
    customFieldsSchema: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to configure custom fields',
    },
    myAccount_account: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to edit your account info',
    },
    myAccount_settings: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to edit your account info',
    },
    myAccount_notifications: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to edit your account info',
    },
    myAccount_security: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to edit your account info',
    },
    myAccount_legal: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn more about Personal Data Protection in Toriut.com',
    },
    myBilling_overview: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to set up billing in Toriut.com',
    },
    myBilling_info: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to set up billing in Toriut.com',
    },
    myBilling_invoices: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to set up billing in Toriut.com',
    },
    myBilling_card: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to set up billing in Toriut.com',
    },
    myTeam_teammates: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to invite new teammates',
    },
    myTeam_roles: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to assign roles to teammates',
    },
    myTeam_settings: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to set up team policies',
    },
    myTeam_analytics: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Explore how to work with Toriut.com analytics&reporting',
    },
    myTeam_profile: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to set up team profile',
    },
    myTeam_security: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to set up Two-factor authentication (2FA)',
    },
    myTeam_ai: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn more about AI capabilities in Toriut.com',
    },
    storage: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn more about Toriut.com integration with Team Drive',
    },
    uploadPanel: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Details on how to upload new files',
    },
    webhooks: {
      url: '/', // @TODO We need to insert a link
    },
    referralProgram: {
      url: '/', // @TODO We need to insert a link
      tooltip: 'Learn how to use a referral program',
    },
    importCsv: {
      url: 'en/articles/6151893-export-and-import-metadata-in-pics-io',
      tooltip: 'Details on how to import metadata',
    },
    embeddedGallery: {
      url:
        'en/articles/6482857-how-can-i-embed-content-from-pics-io-into-another-online-page-via-iframe',
      tooltip: 'How to embed Toriut.com content into third-party pages?',
    },
  },

  ANALYTICS: {
    axisXDays: 'days',
    titleSummOfVisitors: 'Number of visitors',
    axisYSummOfVisitors: 'Visitors',
    titleWebsiteDownloadedByWEbUsers: 'Assets downloads',
    AxisYWebsiteDownloadedByWEbUsers: 'Asset downloads',
    titleTeammates: 'Number of teammates',
    axisYTeammates: 'Teammates',
    titleUserLoginStats: 'Number of teammates logged in',
    axisYTitleUserLoginStats: 'Logged in',
    titleAssetDownloadedByTeam: 'Asset downloaded by team',
    axisYAssetDownloadedByTeam: 'Asset downloaded',
    titleAssetDownloadedByWebUsers: 'Asset downloaded by web users',
    axisYAssetDownloadedByWebUsers: 'Asset downloaded',
    titleAssetChanged: 'Number of asset revisions',
    titleMetadataChangedData: 'Total asset metadata changes',
    titleAssetsUploaded: 'assets in the library',
    axisYAssetsUploaded: 'Assets',
    titleAssetsDownloadedByTeam: 'Assets downloads',
    axisYAssetsDownloadedByTeam: 'Assets downloads',
    titleWebsitesDownloadedByWebUsersData: 'Assets downloads from websites',
    axisYwebsitesDownloadedByWebUsersData: 'Asset downloads',
    titleRatingTableGraph: 'Top assets downloads',
    axisYRatingTableGraph: '',
    titleMetadataChanged: 'Total metadata changes on all assets',
    axisYMetadataChanged: 'Metadata changed',
    titleAssetsCommented: 'Assets commented',
    axisYAssetsCommented: 'Assets commented',
    titleActiveWebSites: 'active websites',
    axisYActiveWebSites: 'active websites',
    titleAssetsInTheLibrary: ' assets in the library',
    placeholder: {
      fetching: 'Processing...',
      noAvailable: 'You have no data yet',
      noSupported: 'This data is not available on your plan',
    },
  },

  NOTIFICATION_SETTINGS: {
    titleNotificationsByCollection: (collectionName) => (
      <>
        Settings for{' '}
        <span className="pageItemTitleColor">"{collectionName}"</span>{' '}
        collection
      </>
    ),
    enableAll: 'Send all event types',
    disableAll: 'Do not send anything',
    sendSelected: 'Select event types to send',
    loading: 'Event type list is loading...',
    errorGetSettingsTypes: `Can\'t load data. Please try again.<br> Contact <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a> support if the error repeats.`,
    errorSavingSettings: `Cannot save settings. Refresh the browser tab. If the error persists, contact us at <a class="picsioLink" href="mailto:${supportEmail}">${appName}</a>.`,
    errorGetSettingsCollections: (
      <span>
        Can't load collections data. Please try again.
        <br /> Contact{' '}
        <a className="picsioLink" href={`mailto:${supportEmail}`}>
          {appName}
        </a>{' '}
        support if the error repeats.
      </span>
    ),

    emailNotifications: {
      title: 'Notification emails',
      description: 'Manage the email addresses where you receive your updates',
      sharedMailboxNote: 'Shared mailboxes need someone to open the confirmation email.',
      pendingTooltip: 'Confirmation email sent. Notifications start after the recipient confirms.',
      expiredTooltip: 'Confirmation expired. Resend the confirmation email or remove this address.',
      listEmails: 'Emails',
      listStatus: 'Status',
      accountEmailLabel: 'Account email',
      accountEmailTooltip: `Notifications are always on for your ${appName} account email.`,
      statuses: {
        confirmed: 'Active',
        pending: 'Pending',
        expired: 'Expired',
      },
      resend: 'Resend',
      resendExpired: 'Resend',
      add: 'Add',
      remove: 'Remove',
      maxReached: 'You can add up to 5 email addresses',
      errorSavingEmails:
        `Cannot save settings. Refresh the browser tab. If the error persists, contact us at ${supportEmail}.`,
      removeDialog: {
        title: 'Remove email address?',
        text: (email) => (
          <>
            <b>{email}</b>
            {' '}
            will no longer receive activity notifications from {appName}. If you want to add it back later, you will need to verify it again.
          </>
        ),
        btnRemove: 'Remove',
      },
      collectionTitle: (collectionName) => (
        <>
          <span className="pageItemTitleColor">"{collectionName}"</span> email
          notifications
        </>
      ),
    },

    slackNotifications: {
      title: 'Slack Notifications',
    },

    socketNotifications: {
      title: 'Global browser push notifications',
      collectionTitle: (collectionName) => (
        <>
          <span className="pageItemTitleColor">"{collectionName}"</span> browser
          push notifications
        </>
      ),
      descriptionNotSupportedNotificationsApi:
        'Your browser does not support Notifications API.',
      descriptionPushNotificationsEnabled: `Push notifications are allowed for ${appName}.`,
      descriptionPushNotificationsBlocked: `Push notifications are blocked for ${appName}.`,
      descriptionPushNotification1: `Push notifications are disabled for ${appName}. `,
      descriptionPushNotification2: ' to enable.',
      textClickButton: 'Click',
      howToEnableOrDisablePushNotifications:
        'How to enable or disable Push Notifications on browsers',
    },

    notificationCenter: {
      title: 'Global notification center',
      collectionTitle: (collectionName) => (
        <>
          <span className="pageItemTitleColor">"{collectionName}"</span>{' '}
          notification center
        </>
      ),
    },

    allowMentions: 'Allow notifications about mentions in any case',

    matrix: {
      eventType: 'Event type',
      inApp: 'In app',
      email: 'Email',
      groups: {
        tasks: 'Asset Activity',
        assets: 'Assets & Collections',
        team: 'Team & Account management',
        system: 'System alerts & Errors',
      },
      groupHints: {
        tasks: 'Stay updated on asset assignments, approvals, and mentions',
        assets: 'Track new uploads, deletions, and sharing settings across your library',
        team: 'Monitor team changes, storage limits, and subscription updates',
        system: 'Get notified about background processing and cloud sync messages',
      },
      watched: 'Watched collections',
      watchedTooltip: 'Settings applied to specific collections will override your All collections default rules.',
      allCollections: 'All collections',
      allCollectionsTooltip: 'Global settings.',
      addCollection: '+ Add collection',
      rows: {
        mention: (
          <>
            I am <span className="mentionHighlight">@mentioned</span> in a comment
          </>
        ),
        mentionCollection: (
          <>
            I am <span className="mentionHighlight">@mentioned</span> in this collection
          </>
        ),
        assigned: 'An asset is assigned to me',
        approved: 'My asset is approved',
        rejected: 'My asset is rejected',
        revisionAdded: 'A new revision is added to my asset',
        assetsUploaded: 'New assets are uploaded or imported',
        assetsDeleted: 'Assets are deleted or trashed',
        collectionShared: 'A collection is shared / unshared',
        inboxChanged: 'A new inbox is created / deleted',
        joinRequest: 'New user requests to join the team',
        invitation: 'User accepts or rejects an invitation',
        storageWarnings: 'Storage limits & warnings',
        subscriptionAi: 'Subscription & AI tier upgrades',
        websitePresets: 'Website settings presets changed',
        syncFailed: 'Cloud storage sync failed',
        processingFailed: 'Asset processing or metadata failed',
        aiFailed: 'AI processing failed',
        syncCompleted: 'Cloud storage sync completed',
        aiCompleted: 'AI processing successfully completed',
      },
    },
  },

  VIDEO: {
    playVideo: 'Play video',
    pauseVideo: 'Pause video',
    muteSound: 'Mute sound',
    unmuteSound: 'Unmute sound',
    takeSnapshot: 'Take a snapshot',
    createThumbnail: 'Create custom thumbnail',
    cropVideo: 'Crop video',
    cropVideoTooltip: 'Download',
    enterFullscreenMode: 'Enter fullscreen mode',
    errorCreatingScreenshot: `Cannot create screenshot.<br> Please try again later or contact <a className="picsioLink" href="mailto:${supportEmail}">${appName}</a>.`,
    errorProxyResponding: `Server is not responding.<br> Please try again later or contact <a className="picsioLink" href="mailto:${supportEmail}">${appName}</a>.`,
    warningThumbnailGeneratingTitle: 'Please wait',
    spinnerCreatingThumbnail: 'Creating video thumbnail',
    spinnerCreatingScreenshot: 'Creating video screenshot',
    safariErrorTitle: 'Feature is not available',
    safariErrorTxt:
      'This feature is not available in Safari.<br> Please try to use Google Chrome or Firefox.',
    iosErrorTxt: 'This feature is not available on iOS devices.',
  },

  PROCESSING: {
    title: 'The number of assets under processing:',
    keywording: 'Generating keywords',
    faceRecognizing: 'Image is being processed by face recognition',
    embedding: 'Indexing assets for AI-powered search',
    replicating: 'Saving XMP/EXIF metadata to your cloud storage',
    metadating: 'Reading XMP/IPTC metadata',
    transcribing: 'Creating a text from audio track',
    videoAnalyzing: 'Running Video & Audio Intelligence analysis',
    Transcript: 'Processing transcript',
    Chapters: 'Processing chapters',
    Actions: 'Processing actions',
    'Recognized text (OCR)': 'Processing OCR',
    importing: 'in the process of importing from cloud storage',
    textImportingMedia: (count) => `${pluralize('media file', count, true)} ${
      count > 1 ? 'are' : 'is'
    } being imported from Shopify`,
    textProductAttaching: (count) => `${pluralize('media file', count, true)} ${
      count > 1 ? 'are' : 'is'
    } being added to products`,
    productAttaching: 'Attaching to product',
    contenting: 'Indexing document’s content for search',
    thumbnailing: 'Generating thumbnails',
    converting: 'Preparing and optimizing an asset for preview',
    trashing: 'Moving to trash',
    crawling: 'Reading content from the external link',
    untrashing: 'Restoring',
    deleting: 'Deleting forever',
    moving: 'Moving',
    transcoding: 'Converting videos',
    syncing: 'Sync is running',
    describing: 'Generating description',
    failed: {
      keywording: <span>Keyword generation ran into a problem. Please shoot an email to <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> if you want to have this issue resolved.</span>,
      replicating: <span>Saving XMP/EXIF metadata to your cloud storage ran into a problem. Please shoot an email to <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> if you want to have this issue resolved.</span>,
      metadating: <span>Reading XMP/IPTC metadata ran into a problem. Please shoot an email to <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> if you want to have this issue resolved.</span>,
      contenting: <span>Preparing content for text search ran into a problem. Please shoot an email to <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> if you want to have this issue resolved.</span>,
      crawling: <span>Reading content from the external link ran into a problem. Please shoot an email to <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> if you want to have this issue resolved.</span>,
      faceRecognizing: <span>Face recognizing ran into a problem. Please shoot an email to <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> if you want to have this issue resolved.</span>,
      describing: <span>Description generation ran into a problem. Please shoot an email to <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> if you want to have this issue resolved.</span>,
      embedding: <span>Visual Search indexing for this asset failed. Please email <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> so we can help you troubleshoot and make it searchable.</span>,
      transcribing: <span>Transcript processing ran into a problem. Please shoot an email to <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> if you want to have this issue resolved.</span>,
      videoAnalyzing: <span>Video &amp; Audio Intelligence analysis for this asset failed. Please email <a className="picsioLink" href="mailto:support@pics.io">support@pics.io</a> so we can help you troubleshoot and make it searchable.</span>,
    },
    rerun: {
      metadating: 'Re-run metadata parsing',
      replicating: 'Re-run metadata saving',
      thumbnailing: 'Re-run generating thumbnail',
      crawling: 'Re-run reading content from the external link',
      describing: 'Re-run generating description',
    },
  },

  MAPVIEW: {
    placeholderNoAssets: 'There are no assets with Geo data in this collection',
    spinnerLoadingAssets: 'Loading assets...',
  },

  TEAMMATES_DIALOG: {
    title: 'My team',
    btnOk: 'Ok',
    text: (managers = 'owner') => (
      <>
        You do not have permissions to manage your team settings. Please contact
        your team {managers} if you need to add or delete teammates.
      </>
    ),
  },

  GLOBAL: {
    tooltipMinimize: 'Minimize',
  },

  UPGRADE_PLAN: {
    text: 'Upgrade plan',
    textForHigherPlan: 'For higher plan',
    tooltipBasic: 'Upgrade plan to use this feature.',
    tooltip: 'Upgrade to use this feature. Click to learn more.',
    tooltipPlanLimitations:
      'Please note that this functionality is available on higher plan',
    tooltipForButtons: (text) => (
      <span
        style={{ cursor: 'pointer' }}
        aria-hidden="true"
        onClick={(e) => {
          e.stopPropagation();
          const tooltipEl = document.querySelector('.tooltip-container');
          tooltipEl.style.display = 'none';
          navigate('/billing?tab=overview');
        }}
      >
        {text || 'Add to plan'}
      </span>
    ),
    textForMobileApps: 'Not available on your plan',
  },

  DONE: 'Done',

  CONSENT: {
    title: 'Consent',
    WEBSITE: {
      VISITING: {
        labelStatus: 'Show consent when visiting',
        labelTitle: 'Title for consent when visiting',
        labelMessage: 'Message for consent when visiting',
        defaultTitle: 'Copyright consent',
        defaultMessage:
          "The contents of this website, including (but not limited to) all written materials, images, photos, videos are protected under international copyright and trademarks laws. Please confirm that you will not copy, reproduce, modify, republish, transmit or distribute any material from this site without the owner's permission.",
      },
      ACTION: {
        labelStatus: 'Show consent when downloading',
        labelTitle: 'Title for consent when downloading',
        labelMessage: 'Message for consent while downloading',
        defaultTitle: 'Copyright consent',
        defaultMessage:
          "Please note that you are not allowed to copy, reproduce, modify, republish, transmit or distribute any material from this site without the owner's permission.",
      },
    },

    SAS: {
      VISITING: {
        labelStatus: 'Show consent when visiting',
        labelTitle: 'Title for consent when visiting',
        labelMessage: 'Message for consent when visiting',
        defaultTitle: 'Copyright consent',
        defaultMessage:
          "The contents of this website, including (but not limited to) all written materials, images, photos, videos are protected under international copyright and trademarks laws. Please confirm that you will not copy, reproduce, modify, republish, transmit or distribute any material from this site without the owner's permission.",
      },
      ACTION: {
        labelStatus: 'Show consent when downloading',
        labelTitle: 'Title for consent when downloading',
        labelMessage: 'Message for consent while downloading',
        defaultTitle: 'Copyright consent',
        defaultMessage:
          "Please note that you are not allowed to copy, reproduce, modify, republish, transmit or distribute any material from this site without the owner's permission.",
      },
    },

    INBOX: {
      VISITING: {
        labelStatus: 'Show consent when visiting',
        labelTitle: 'Title for consent when visiting',
        labelMessage: 'Message for consent when visiting',
        defaultTitle: 'Copyright consent',
        defaultMessage:
          'Please note that materials from this website are accessible to third parties. Accept the consent if you still need to upload your files.',
      },
      ACTION: {
        labelStatus: 'Show consent when uploading',
        labelTitle: 'Title for consent when uploading',
        labelMessage: 'Message for consent while uploading',
        defaultTitle: 'Copyright consent',
        defaultMessage:
          'Please note that you are going to upload the assets that will be accessible to third parties. Accept the consent if you still need to upload your files.',
      },
    },
  },

  MODIFIED_FIELD: {
    tooltip: (userName) => `This field was edited by ${userName}. ${appName} will not overwrite this field even in case metadata is found in the original file. Please click this mark to allow overwriting.`,
    currentUser: 'you',
    teammate: 'your teammate',
  },

  SUPPORT: {
    ACCESS_TO_YOUR_ACCOUNT: 'Access to your account',
    CONSENT: `You grant ${appName} team access to your account for the next 24 hours to use your information in accordance to their terms of service.`,
  },

  MOBILE_APP: {
    IS_NOT_AVAILABLE:
      'Note: This functionality is not available in mobile app. Please use the desktop version to access it.',
  },

  WARNING: 'Warning',
  ERROR: 'Error',
  SOMETHING_WENT_WRONG: {
    TITLE: 'Oops! Something went wrong',
    TEXT: `Please try again and contact <a class='picsioLink' href='mailto:${supportEmail}'>${appName}</a> support if the error repeats.`,
  },

  EMPTY_SEARCH: {
    SAVED_SEARCHES: {
      assigned: (displayName) => `This saved search shows all assets that were assigned to a user ${displayName}`,
      restricted:
        'This saved search shows all assets that were restricted for download or any other action by somebody on your team',
      uncategorized:
        'This saved search shows all assets that are not attached to any collection',
      corrupted: `This saved search shows all files that cannot be previewed within ${appName} because there are damaged or corrupted in some way`,
      spreadsheets:
        'This saved search shows all assets that have .xlsx extension',
      jpg:
        'This saved search shows all assets that have .jpg or .jpeg extension',
      text: () => (
        <>This saved search shows all assets that are .rtf, .docs, or .txt.</>
      ),
      pdf: 'This saved search shows all assets that have PDF extension',
      ai:
        'This saved search shows all assets that were generated with Adobe Illustrator',
      photoshop:
        'This saved search shows all assets that were generated with Adobe Photoshop',
      gps:
        'This saved search shows all assets that have GPS coordinates in their metadata',
      gpsno:
        "This saved search shows all assets that don't have GPS coordinates in their metadata",
      video:
        'This saved search shows all assets that have any of video extension types (like mp4, mpv, mov etc)',
      createdToday:
        'This saved search shows all assets that were created within current date',
      createdWeek:
        'This saved search shows all assets that were uploaded during current calendar week',
      createdMonth:
        'This saved search shows all assets that were uploaded during current calendar month',
      dublicates:
        'This saved search shows all assets that are identical copies of each other',
      raw: 'This saved search shows all assets that have a RAW extension',
      shared:
        'This saved search shows all assets that were shared publicly to the web',
      watermarked:
        'This saved search shows all assets that have a watermark applied on them.',
    },
  },
  PAGE403: {
    title: 'Access denied',
    text: (
      <p>
        Team manager limited access to this page for your user role. <br />
        If you think you need to have access here, contact your team manager.
      </p>
    ),
  },
  AUTH_METHODS: {
    TEXT:
      'All authentication methods are disabled. Leave at least one method enabled.',
  },
  offlineToastText:
    'Seems you are offline. Please check your internet connection.',
  UNKNOWN: 'unknown',
  VISUAL_SEARCH_BANNER: {
    REQUEST: 'Request',
    ENABLE: 'Enable',
    AUTOCOMPLETE_BANNER_TEXT: (actionText) => (
      <>
        <span className="visual-search-banner-text">
          {actionText} AI Visual Search
        </span>
        <span>
          Search with natural language or find visually similar assets
        </span>
      </>
    ),
    LIST_BANNER_TEXT:
      'Not finding what you need? Try AI Visual Search - type your query in plain language or use an example image to find lookalikes.',
    LIST_BANNER_ACTION_TEXT: 'Request feature',
    LIST_BANNER_ACTION_TEXT_ENABLE: 'Enable feature',
    SEARCH_IS_ON_INDEXING: (countIndexingAssets) => (
      <>
        {' '}
        Visual Search is enabled. Results will improve as indexing completes (
        <span className="color-brand">{countIndexingAssets}</span> assets in
        progress).{' '}
      </>
    ),
    SEARCH_IS_ON:
      'Visual Search is enabled. Search with natural language or find similar images.',
  },

  PROMOTIONAL_BANNER: {
    SEARCH: {
      title: 'The Advanced Filter Panel is Here!',
      description:
        'A redesigned search experience now available on the latest plans. Click to explore the details.',
    },
    COLLECTION_TREE: {
      title: 'Get Unlimited Websites',
      description: (usedCount, limit) => `Update your plan and remove website limits. ${usedCount} of ${limit} already in use.`,
    },
    WEBSITE_SETTINGS: {
      description: (usedCount, limit) => `Get Unlimited Websites by updating to the latest plan. Your current discontinued plan allows ${limit} websites, and ${usedCount} are already in use. Click to learn more about your plan limits.`,
    },
  },
  AI_KIT_ADD_ON_PROMO_BLOCK: {
    title: <h3 className="f-s-20">AI Kit add-on</h3>,
    legacyAiDescription:
      'Enhance your workflow with AI-powered features, including automatic keyword tagging, person recognition, audio and video transcription, AI-generated descriptions, and natural language search. Add the AI Kit to your subscription to start using these capabilities.',
    imageOrVideoAiDescription: () => (
      <div>
        <p>
          Enhance your media workflow with AI-powered Image and Video
          Intelligence.
        </p>
        <p>
          Automatically generate keywords and descriptions, detect people, run
          Visual & Similar Images Search, and turn your video & audio files into
          searchable transcripts, key moments, and insights.
        </p>
        <p>
          Add the AI Kit to your subscription to start using these capabilities.
        </p>
      </div>
    ),
    html: (onLearnMoreClick, onAddToPlanClick) => (
      <div className="d-flex ai-center jc-sb m-t-24 m-b-10">
        <Button variant="text" color="primary" onClick={onLearnMoreClick}>
          <Icon color="primary" size="lg">
            <Question />
          </Icon>
          <span className="m-l-5">
            Learn more about AI-powered features in Pics.io
          </span>
        </Button>
        <Button
          variant="contained"
          size="md"
          color="primary"
          onClick={onAddToPlanClick}
        >
          Add to plan
        </Button>
      </div>
    ),
  },
  PROMOTIONAL_BLOCK: {
    title: 'Billing Access Required',
    text: (adminRoles) => (
      <div>
        <span>
          You don’t have permission to manage billing settings. For
          billing-related changes, please contact your team's billing admins:
        </span>
        {adminRoles && <div>{adminRoles}</div>}
      </div>
    ),
  },
  ASSET_AVAILABILITY_INTEGRATIONS: {
    TOOLTIPS: {
      ADOBE_ILLUSTRATOR: 'Browse in Adobe Illustrator',
      ADOBE_PHOTOSHOP: 'Browse in Adobe Photoshop',
      ADOBE_PREMIERE: 'Browse in Adobe Premiere Pro',
      ADOBE_AFTER_EFFECTS: 'Browse in Adobe After Effects',
      ADOBE_INDESIGN: 'Browse in Adobe InDesign',
      ADOBE_CREATIVE_CLOUD: 'Browse in Adobe Creative Cloud',
      GOOGLE_WORKSPACE: 'Browse in Google Workspace',
      WORDPRESS: 'Browse in WordPress',
      MORE_INTEGRATIONS: 'More integrations',
      GOOGLE_DRIVE: 'Open in Google Drive',
    },
  },
  PROMPT_ICON: {
    MENU_ITEMS: {
      ACTIVE_AI_PROMPT: 'See active AI prompt',
      EDIT_AI_PROMPT: 'Edit AI prompt',
    },
    DIALOG: {
      TITLE: 'Active AI prompt',
      EDIT_TITLE: 'Edit AI prompt',
      text: (adminRoles) => (
        <div>
          You do not have permissions to manage Artificial Intelligence
          settings. Please contact your team managers{' '}
          {adminRoles && <>{adminRoles}</>} if you need to change the active
          prompt.
        </div>
      ),
    },
  },
  IMPORT_INBOX_PROMO_BANNER: {
    PICSIO: {
      title: 'Collect files from external partners with Pics.io',
      description: 'Organize, receive, and manage assets in one place',
    },
    TORIUT: {
      title: 'Collect files from external partners with Toriut',
      description: 'Organize, receive, and manage assets in one place',
    },
    BUTTON_TEXT: 'Try now',
  },
  VIDEO_ANALYZING_STATUS_TOAST: {
    UNSAFE_REJECT: () => (
      <>
        <div className="f-w-5">Video & Audio Intelligence failed</div>
        <div className="f-s-13">
          This asset may contain sensitive content that cannot be processed by
          AI
        </div>
      </>
    ),
  },
  PRODUCT_GRID_ITEM: {
    productLayerLabel: 'Product layer:',
    priceLabel: 'Price:',
    skuLabel: 'SKU:',
    thumbnailPublishedViewTooltip: 'Thumbnail info displays published view data',
  },

  PRODUCT_INFO: {
    PREPARE_CHANNEL_VERSION: 'Prepare channel version for publishing',
    TO_PUBLISH_A_PRODUCT_TEXT:
      'To publish a product, add a distribution channel',
    ADD_CHANNEL: 'Add channel',
    SYNC_TO_CHANNEL: 'Sync to channel',
    publishedLayerConnectionLostTooltip:
      'Published layer is unavailable. Connection lost because the Toriut app was removed from this channel. Go to channel settings to reconnect.',
    publishedReadOnlyFieldTooltip:
      'Read-only. Use "Edit attributes" to create a draft.',
    variantNotOnChannelPreviewTooltip:
      'This variant exists in Master but is not on the channel yet. Showing Master data.',
    draftTabTooltip:
      'Draft view is designed for preparing channel-specific changes before they are applied to Shopify. Nothing changes in Shopify until this draft is published.',
    publishedTabTooltip:
      'Published view reflects the current Shopify data for this channel, including updates that may have been made directly in Shopify.',
    ICON: '→',
    metafields: 'Metafields',
    customAttributes: 'Custom attributes',
    noMetaFields: 'No meta fields',
    shopifyMetafields: 'Shopify metafields',
    themeTemplate: 'Theme template',
    inventory: {
      taxCode: 'Tax code',
      countryCodeOfOrigin: 'Country of origin',
      countryCodeOfOriginPlaceholder: 'US',
      countryCodeOfOriginTooltip:
        'Two-letter ISO 3166-1 country code required by Shopify (for example US, DE, GB).',
      countryCodeOfOriginInvalid: 'Enter a valid two-letter country code (for example US).',
      harmonizedSystemCode: 'HS code',
      harmonizedSystemCodePlaceholder: '610910',
      harmonizedSystemCodeTooltip:
        'Harmonized System code for Shopify: 6 to 13 digits only (for example 610910).',
      harmonizedSystemCodeInvalid: 'Enter 6 to 13 digits (for example 610910).',
      customs: 'Customs',
      availableForSale: 'Available for sale',
    },
    seo: {
      sectionTitle: 'SEO & URL',
      seoTitle: 'SEO Title',
      seoDescription: 'SEO Description',
      handle: 'Handle',
      characterCounter: (current, max) => `${current} / ${max}`,
      titleLengthExceeded: 'Recommended length exceeded. The title may be truncated in search results.',
      descriptionLengthExceeded: 'Recommended length exceeded. The description may be truncated in search results.',
      titleFallbackHint: (productName) => `Uses product name: ${productName}`,
      descriptionFallbackHint: (description) => `Uses product description: ${description}`,
      handleNormalizesToEmpty:
        'This value cannot be converted to a URL handle. Enter letters or numbers.',
    },
    variantTitle: 'Title',
    variantDescription: 'Description',
    entityTypeVariant: 'Variant',
    parentProduct: 'Parent product',
    parentSku: 'Parent SKU',
    variantSku: 'Variant SKU',
    skuCodesBlockTitle: 'SKU & codes',
    variantStructure: 'Variant structure',
    shippingCompliance: 'Shipping / Compliance',
    statusLabel: 'Status',
    masterStatusLabel: 'Master status',
    /** Toriut labels for auto-mapped core fields in the sales-channel field-mapping wizard (StagingTab / listing UI). */
    autoMappedFieldLabels: {
      title: 'Product name',
      vendor: 'Vendor',
      productType: 'Product type',
      category: 'Category',
      status: 'Status',
      sku: 'SKU',
      barcode: 'Barcode (ISBN, UPC, GTIN, etc.)',
      weight: 'Weight',
      description: 'Description',
      keywords: 'Keywords',
      price: 'Price',
      compareAtPrice: 'Compare-at price',
      cost: 'Cost per item',
      handle: 'Handle',
      seoTitle: 'SEO Title',
      seoDescription: 'SEO Description',
      countryCodeOfOrigin: 'Country of origin',
      harmonizedSystemCode: 'HS code',
      assets: 'Product media',
      assetId: 'Variant media',
    },
    masterStatusTooltip:
      'Status stored on the Master Product. It can be used when syncing this product to channels, while existing channel records can keep their own status.',
    inheritedStatusTooltip: 'Status is inherited from the parent Toriut Master Product.',
    optionsLabel: 'Options',
    optionsManageOnMasterTooltip: 'Variant options can only be modified on the Master layer',
    optionExists: 'This option already exists',
    optionValueExists: 'This value already exists',
    lastPublished: (time) => `Last published: ${time}`,
    lastUpdated: (time) => `Last updated: ${time}`,
    category: {
      searchCategories: 'Search categories',
      loadingCategories: 'Loading categories...',
      noCategoriesFound: 'No categories found',
      unableToLoadCategories: 'Unable to load categories',
      categoriesBeingPrepared: 'Categories are being prepared. Try again later.',
      back: 'Back',
      change: 'Change',
    },
    productType: {
      label: 'Product type',
      placeholder: 'Select product type or type new',
      searchPlaceholder: 'Search product types',
      loadingProductTypes: 'Loading product types...',
      noProductTypesFound: 'You have no product types yet',
      noProductTypesFoundCreate: 'Start typing to create a product type',
      manageTitle: 'Product types management',
      renameTooltip: 'Rename',
      deleteTooltip: 'Delete',
      clearTooltip: 'Clear product type',
      okTooltip: 'Ok',
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
      emptyList: 'No product types yet.',
      emptySearchList: 'No matching product types found',
      createFailed: 'Product type is not created. Refresh and try again',
      renameFailed: 'Product type is not renamed. Refresh and try again',
      deleteFailed: 'Product type is not deleted. Refresh and try again',
    },
    vendor: {
      label: 'Vendor',
      placeholder: 'Select vendor or type new',
      searchPlaceholder: 'Search vendors',
      loadingVendors: 'Loading vendors...',
      noVendorsFound: 'You have no vendors yet',
      noVendorsFoundCreate: 'Start typing to create a vendor',
      manageTitle: 'Vendors management',
      renameTooltip: 'Rename',
      deleteTooltip: 'Delete',
      clearTooltip: 'Clear vendor',
      okTooltip: 'Ok',
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
      emptyList: 'No vendors yet.',
      emptySearchList: 'No matching vendors found',
      renameFailed: 'Vendor is not renamed. Refresh and try again',
      deleteFailed: 'Vendor is not deleted. Refresh and try again',
      loadMore: 'Load more',
    },
    fieldHelpers: {
      url: 'Single text input validated for links and protocols (e.g., https, mailto, tel).',
      link: 'Two inputs to create a complete hyperlink: "Link text" (the visible label) and "URL" (the validated destination address).',
      money: 'Numeric input for the amount with a currency dropdown (e.g., USD, EUR). Note: Stores a single value. To record multi currency list, you must create separate fields.',
      weight: 'Numeric input paired with a unit dropdown for mass (oz, lb, g, kg).',
      dimension: 'Numeric input with a unit dropdown (mm, cm, m, in, ft, yd). Note: Stores a single measurement. To record Length, Width, and Height, you must create three separate fields.',
      volume: 'Numeric input with a unit dropdown covering metric, US, and Imperial measures (ml, l, m³, fl oz, gal, etc.).',
    },
    placeholders: {
      inputValue: 'Input new value',
      linkText: 'Link text',
      linkUrl: 'https://',
      selectValue: 'Select a value',
      selectValues: 'Select values',
      imageName: 'Image name',
      videoName: 'Video name',
      fileName: 'File name',
    },
    validation: {
      enterWholeNumber: 'Enter a whole number.',
      enterValidNumber: 'Enter a valid number.',
      ratingRange: (min, max) => `Rating must be between ${min} and ${max}.`,
      ratingPositive: 'Rating must be a positive number.',
      minValue: (min) => `Value must be greater than or equal to ${min}.`,
      maxValue: (max) => `Value must be less than or equal to ${max}.`,
      maxLength: (max) => `Value must be ${max} characters or fewer.`,
      enterValidDate: 'Enter a valid date.',
      enterValidDateTime: 'Enter a valid date and time.',
      enterValidUrl: 'Enter a valid URL.',
      enterLinkText: 'Enter link text.',
      enterValidAmount: 'Enter a valid amount.',
      selectCurrency: 'Select a currency.',
      enterValidValue: 'Enter a valid value.',
      selectUnit: 'Select a unit.',
      nonNegativeNumber: 'Value must be a non-negative number.',
      enterValidJson: 'Enter valid JSON.',
      enterValidColor: 'Enter a valid color value.',
      fieldRequired: 'This field is required.',
      productNameRequired: 'Product name is required',
      fieldRequiredLabel: (label) => `${label} is required.`,
      fieldMaxLengthLabel: (label, max) => `${label} must be ${max} characters or fewer.`,
      fieldMinLengthLabel: (label, min) => `${label} must be at least ${min} characters.`,
      fieldInvalidNumberLabel: (label) => `${label}: enter a valid number.`,
      fieldInvalidBooleanLabel: (label) => `${label}: enter true or false.`,
      fieldInvalidOptionLabel: (label) => `${label}: select a valid value.`,
      fieldInvalidValueLabel: (label) => `${label}: could not save this value.`,
      updateFailed: 'Could not save changes.',
    },
  },

  TORIUT_TRIAL_FLOW: {
    TRIAL_EXPIRED: {
      title: 'Your Toriut trial has ended',
      descriptionBeforeDate: 'Thanks for giving Toriut a try. Your workspace is paused for now, but everything you\u2019ve created is still here. We\u2019ll keep your data until ',
      descriptionAfterDate: ', so you have time to decide whether you\u2019d like to continue.',
      descriptionWithoutDate: 'Thanks for giving Toriut a try. Your workspace is paused for now, but everything you\u2019ve created is still here, so you have time to decide whether you\u2019d like to continue.',
      getFullAccessCta: 'Get full access',
      dontContinueCta: 'I don\u2019t want to continue',
    },
    GET_FULL_ACCESS: {
      title: 'Get full access to Toriut',
      description: 'Whether you\u2019re ready to continue or still figuring out if Toriut is right for your team, we\u2019re here to help. Toriut access is tailored to your setup and requirements, so pricing may vary depending on what you need.',
      backCta: 'Back',
      talkThroughSetup: {
        title: 'Talk through your setup',
        description: 'Book a short call to review your workflow, questions, and requirements.',
        cta: 'Book a demo',
      },
      chatWithTeam: {
        title: 'Chat with our team',
        description: 'Have a quick question or already know what you need? Start a chat about access.',
        cta: 'Start a chat',
      },
    },
    SELECT_REASONS: {
      title: 'Before you go',
      subtitle: 'Help us understand what got in the way. Your feedback helps us decide what to improve next.',
      sectionTitle: 'What\u2019s the main reason you\u2019re not continuing with Toriut?',
      tooltipMaxReasons: 'You can select up to 3 reasons. Uncheck one to select another.',
      continueCta: 'Continue',
      backCta: 'Back',
      options: {
        missing_capability: 'Toriut doesn\u2019t support something I need',
        setup_effort: 'Setting up or using Toriut took too much effort',
        product_data: 'Importing or organizing my product data was too difficult',
        shopify_workflow: 'Shopify connection, sync, or publishing didn\u2019t work as expected',
        workflow_fit: 'Toriut doesn\u2019t fit the way my team works',
        pricing_setup: 'The pricing or available setup doesn\u2019t work for me',
        evaluation_time: 'I need more time to evaluate Toriut',
        alternative: 'I\u2019m choosing another tool or approach',
        not_ready: 'I\u2019m not ready to adopt Toriut right now',
        other: 'Other',
      },
    },
    DETAILED_FEEDBACK: {
      selectedReasonsLabel: 'Selected reasons:',
      subtitle: 'Help us understand what got in the way. Your feedback helps us improve Toriut.',
      sectionTitle: 'Tell us a bit more about these issues',
      optionalBadge: 'Optional',
      feedbackPlaceholder: 'Share any specific context, features you were looking for, or details about what didn\u2019t work...',
      continueCta: 'Continue',
      skipCta: 'Skip feedback',
      backCta: 'Back',
    },
    FEEDBACK_CALL: {
      giftCardBadge: '$50',
      title: 'Would you be open to sharing a little more?',
      descriptionBeforeGiftCard: 'A short conversation about your experience can help us understand what Toriut should do better. Book a 20-minute call with our product team, and we\u2019ll send you a ',
      giftCardHighlight: '$50 gift card',
      descriptionAfterGiftCard: ' to thank you for your time.',
      bookCallCta: 'Book a feedback call',
      declineCta: 'No thanks, continue',
      backCta: 'Back',
    },
    CLOSE_ACCOUNT: {
      title: 'Close your Toriut account',
      descriptionBefore: 'Your Toriut workspace is no longer active. We\u2019ll keep your data until ',
      descriptionAfter: ' and automatically delete it after that. You don\u2019t need to do anything else if you\u2019d prefer to wait. You can also download or manage your data below.',
      alsoDoLabel: 'You can also do the following:',
      restrictProcessingCta: 'Restrict processing',
      deletePersonalDataCta: 'Delete all personal data',
      shopifyNoteDescription: 'Your Shopify store may still be connected to Toriut after your trial ends. To disconnect it, uninstall the Toriut app from your Shopify admin.',
      shopifyNoteInstruction: 'Go to Shopify Settings \u2192 Apps and sales channels \u2192 Toriut \u2192 Uninstall.',
    },
    DATA_REQUEST_SUBMITTED: {
      logoutCta: 'Log out',
      deletion: {
        title: 'Your data deletion request has been submitted',
        descriptionBefore: 'Our support team will manually process your request and delete your personal data within the ',
        descriptionBold: 'next 30 days',
        descriptionAfter: '. We will send you an email notification as soon as this irreversible action is completed.',
      },
      restriction: {
        title: 'Your data restriction request has been submitted',
        descriptionBefore: 'Our support team will manually process your request and restrict Toriut.com from using your personal data within the ',
        descriptionBold: 'next 30 days.',
        descriptionAfter: ' We will send you an email notification once the process is complete.',
      },
    },
    WORKSPACE_DATA_DELETED: {
      title: 'Your Toriut workspace data has been deleted',
      descriptionBefore: 'The retention period ended, so your Toriut catalog and workspace content were permanently removed. Your account still works if you want to talk about getting access again. ',
      descriptionBold: 'Your live Shopify store was not changed',
      descriptionAfter: ' by this cleanup.',
      talkThroughSetup: {
        title: 'Talk through your setup',
        description: 'Book a short call if you\u2019d like to continue with Toriut on a fresh workspace.',
        cta: 'Book a demo',
      },
      chatWithTeam: {
        title: 'Chat with our team',
        description: 'Have a quick question about access or next steps? Start a chat.',
        cta: 'Start a chat',
      },
    },
  },

  NOTIFICATION_CENTER: {
    tabAll: 'All',
    tabMentions: 'Mentions',
    markAllAsRead: 'Mark all as read',
    emptyAll: 'All caught up!',
    emptyMentions: 'No mentions or assignments',
    restrictedAsset: 'Unavailable asset',
    restrictedTitle: 'Asset unavailable',
    restrictedText: 'You no longer have permission to view this asset.',
    you: 'you',
    loadFailed: 'Notifications failed to load',
    pageLoadFailed: 'Could not load more notifications',
    retry: 'Try again',
    readMore: 'Read more',
    settings: 'Notification settings',
    settingsTooltip: 'Go to notification settings',
    overflowMore: (count) => `+${count}`,
    noPreview: 'no preview available',
    timeMinutesAgo: (count) => `${count}m ago`,
    timeHoursAgo: (count) => `${count}h ago`,
    timeYesterday: 'Yesterday',
  },
};
